import React, { useState, useEffect, useCallback, useMemo, Suspense, useRef, Fragment, useImperativeHandle } from 'react';
import { Transition, Menu, Listbox, Switch, Disclosure } from '@headlessui/react';
import ReactTooltip from 'react-tooltip';
import dayjs from 'dayjs';
import Markdown from 'markdown-to-jsx';
import { motion } from 'framer-motion';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var _excluded = ["className", "color", "id", "as"];
var Color = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    color = _ref.color,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'color-el' : _ref$id,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return React.createElement(Component, Object.assign({
    className: className + " text-primary font-semibold p-4",
    "data-testid": id,
    ref: ref
  }, rest), React.createElement("p", null, color == null ? void 0 : color.title), React.createElement("br", null), React.createElement("div", {
    className: "grid gap-x-8 gap-y-4 grid-cols-3 mb-4"
  }, color && Object.keys(color.codes).map(function (code) {
    return React.createElement("div", {
      className: "p-4 rounded shadow-broad " + code + " flex justify-between",
      key: code
    }, React.createElement("small", null, code), React.createElement("small", null, color.codes[code]));
  })));
});
Color.displayName = 'Color';

var GridContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    role = _ref.role,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    is_always_mobile = _ref.is_always_mobile;
  var classes = "grid grid-cols-4 " + (is_always_mobile ? '' : 'md:grid-cols-12') + " " + className;
  return React.createElement(Component, {
    className: classes,
    "data-testid": id,
    ref: ref,
    role: role
  }, children);
});
GridContainer.displayName = 'Grid';
var GridItem = function GridItem(_ref2) {
  var children = _ref2.children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? '' : _ref2$className,
    role = _ref2.role,
    _ref2$as = _ref2.as,
    Component = _ref2$as === void 0 ? 'div' : _ref2$as;
  return React.createElement(Component, {
    className: "self-center " + className,
    role: role
  }, children);
};
GridItem.displayName = 'GridItem';
var Grid = /*#__PURE__*/Object.assign(GridContainer, {
  Item: GridItem
});

var SVGS = {
  'thick-clock': function thickClock(_ref) {
    var className = _ref.className,
      id = _ref.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none"
    }, React.createElement("g", {
      "clip-path": "url(#clip0_8025_22556)"
    }, React.createElement("path", {
      d: "M8.00016 15.1629C11.6821 15.1629 14.6668 12.1782 14.6668 8.49626C14.6668 4.81436 11.6821 1.82959 8.00016 1.82959C4.31826 1.82959 1.3335 4.81436 1.3335 8.49626C1.3335 12.1782 4.31826 15.1629 8.00016 15.1629Z",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }), React.createElement("path", {
      d: "M8 4.49634V8.49634L10.6667 9.82967",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })), React.createElement("defs", null, React.createElement("clipPath", {
      id: "clip0_8025_22556"
    }, React.createElement("rect", {
      width: "16",
      height: "16",
      fill: "white",
      transform: "translate(0 0.496338)"
    }))));
  },
  users: function users(_ref2) {
    var className = _ref2.className,
      id = _ref2.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "17",
      viewBox: "0 0 16 17",
      fill: "none"
    }, React.createElement("g", {
      clipPath: "url(#clip0_8025_22549)"
    }, React.createElement("path", {
      d: "M11.3332 14.4963V13.163C11.3332 12.4558 11.0522 11.7775 10.5521 11.2774C10.052 10.7773 9.37375 10.4963 8.6665 10.4963H3.33317C2.62593 10.4963 1.94765 10.7773 1.44755 11.2774C0.947456 11.7775 0.666504 12.4558 0.666504 13.163V14.4963",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M6.00016 7.82967C7.47292 7.82967 8.66683 6.63576 8.66683 5.163C8.66683 3.69025 7.47292 2.49634 6.00016 2.49634C4.5274 2.49634 3.3335 3.69025 3.3335 5.163C3.3335 6.63576 4.5274 7.82967 6.00016 7.82967Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M15.3335 14.4963V13.163C15.3331 12.5722 15.1364 11.9982 14.7744 11.5312C14.4124 11.0642 13.9056 10.7307 13.3335 10.583",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M10.6665 2.58301C11.2401 2.72988 11.7485 3.06348 12.1116 3.53121C12.4747 3.99895 12.6717 4.57423 12.6717 5.16634C12.6717 5.75845 12.4747 6.33373 12.1116 6.80147C11.7485 7.26921 11.2401 7.60281 10.6665 7.74967",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), React.createElement("defs", null, React.createElement("clipPath", {
      id: "clip0_8025_22549"
    }, React.createElement("rect", {
      width: "16",
      height: "16",
      fill: "white",
      transform: "translate(0 0.496338)"
    }))));
  },
  'play-arrow': function playArrow(_ref3) {
    var className = _ref3.className,
      id = _ref3.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "16",
      height: "18",
      viewBox: "0 0 16 18",
      fill: "none"
    }, React.createElement("path", {
      d: "M15 7.26795C16.3333 8.03775 16.3333 9.96225 15 10.7321L3.75 17.2272C2.41667 17.997 0.75 17.0348 0.75 15.4952V2.50481C0.75 0.96521 2.41667 0.00295806 3.75 0.772758L15 7.26795Z",
      fill: "#F3EEFC"
    }));
  },
  clock: function clock(_ref4) {
    var className = _ref4.className,
      id = _ref4.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "17",
      height: "18",
      viewBox: "0 0 17 18",
      fill: "none"
    }, React.createElement("path", {
      d: "M8.66895 1.33398C7.0867 1.33398 5.53998 1.80318 4.22439 2.68223C2.90879 3.56128 1.88341 4.81071 1.27791 6.27252C0.672412 7.73432 0.513985 9.34286 0.822667 10.8947C1.13135 12.4466 1.89327 13.872 3.01209 14.9908C4.13091 16.1097 5.55638 16.8716 7.10823 17.1803C8.66007 17.4889 10.2686 17.3305 11.7304 16.725C13.1922 16.1195 14.4417 15.0941 15.3207 13.7785C16.1998 12.463 16.6689 10.9162 16.6689 9.33398C16.6689 8.28341 16.462 7.24312 16.06 6.27252C15.6579 5.30191 15.0687 4.42 14.3258 3.67713C13.5829 2.93426 12.701 2.34499 11.7304 1.94295C10.7598 1.54091 9.71952 1.33398 8.66895 1.33398ZM8.66895 15.734C7.40315 15.734 6.16577 15.3586 5.1133 14.6554C4.06082 13.9521 3.24052 12.9526 2.75612 11.7832C2.27172 10.6137 2.14498 9.32688 2.39192 8.08541C2.63887 6.84393 3.24841 5.70356 4.14346 4.8085C5.03852 3.91344 6.17889 3.3039 7.42037 3.05696C8.66185 2.81001 9.94867 2.93675 11.1181 3.42116C12.2876 3.90556 13.2871 4.72586 13.9904 5.77833C14.6936 6.83081 15.0689 8.06818 15.0689 9.33398C15.0689 11.0314 14.3947 12.6592 13.1944 13.8595C11.9942 15.0597 10.3663 15.734 8.66895 15.734Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M11.8691 8.53398H9.46914V6.13398C9.46914 5.92181 9.38485 5.71833 9.23483 5.5683C9.0848 5.41827 8.88131 5.33398 8.66914 5.33398C8.45697 5.33398 8.25348 5.41827 8.10346 5.5683C7.95343 5.71833 7.86914 5.92181 7.86914 6.13398V9.33398C7.86914 9.54616 7.95343 9.74964 8.10346 9.89967C8.25348 10.0497 8.45697 10.134 8.66914 10.134H11.8691C12.0813 10.134 12.2848 10.0497 12.4348 9.89967C12.5849 9.74964 12.6691 9.54616 12.6691 9.33398C12.6691 9.12181 12.5849 8.91833 12.4348 8.7683C12.2848 8.61827 12.0813 8.53398 11.8691 8.53398Z",
      fill: "currentColor"
    }));
  },
  'reward-stats': function rewardStats(_ref5) {
    var className = _ref5.className,
      id = _ref5.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, React.createElement("g", {
      clipPath: "url(#clip0_3841_23969)"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0296 8.70344C20.2754 6.43489 22.7118 4.87448 25.0028 4.14338C27.2898 3.41353 29.369 3.52415 31.0263 4.48102C31.0264 4.48103 31.0264 4.48104 31.0264 4.48105L31.0264 4.4811L31.0488 4.49405C33.2498 5.77807 34.5366 8.48305 34.6267 12.0948C34.7166 15.6987 33.5952 20.0316 31.1866 24.2035C28.778 28.3753 25.5863 31.513 22.4202 33.237C19.2365 34.9707 16.2411 35.2046 14.0263 33.9259C12.3438 32.9545 11.1986 31.1697 10.699 28.7697C10.1987 26.3663 10.3657 23.4116 11.2642 20.2754C11.4163 19.7445 11.1091 19.1908 10.5782 19.0387C10.0473 18.8866 9.49359 19.1937 9.34149 19.7246C8.37525 23.0975 8.16028 26.3876 8.74101 29.1773C9.32247 31.9705 10.7214 34.3272 13.0263 35.6579C13.0264 35.6579 13.0264 35.658 13.0264 35.658L13.0264 35.658L15.7856 37.251C18.8411 39.0152 22.6535 38.4547 26.1916 36.4972C29.7514 34.5275 33.2156 31.0613 35.7773 26.6242C38.3395 22.1865 39.5618 17.5345 39.4348 13.545C39.3083 9.57082 37.8228 6.09561 34.7856 4.34207L32.0528 2.76429C32.044 2.75917 32.0352 2.75406 32.0263 2.74897C29.7566 1.43855 27.0638 1.38628 24.3947 2.23805C21.7296 3.08855 19.0259 4.85425 16.6083 7.2964C16.2198 7.68889 16.223 8.32205 16.6154 8.7106C17.0079 9.09914 17.6411 9.09594 18.0296 8.70344ZM36.1293 8.46954C36.4317 9.58835 36.5949 10.7932 36.6261 12.0449C36.7266 16.0735 35.4806 20.766 32.9186 25.2035C30.3567 29.6409 26.9159 33.0662 23.3767 34.9935C22.3315 35.5627 21.2632 36.0075 20.198 36.3056C21.7446 36.2473 23.4534 35.7265 25.2233 34.7472C28.4184 32.9794 31.6365 29.7964 34.0453 25.6242C36.4537 21.4527 37.5491 17.1654 37.4359 13.6086C37.3711 11.5751 36.9179 9.83136 36.1293 8.46954Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M12 6C12.8168 8.90948 15.0905 11.1832 18 12C15.0905 12.8168 12.8168 15.0905 12 18C11.1832 15.0905 8.90948 12.8168 6 12C8.90948 11.1832 11.1832 8.90948 12 6Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M5 2L-nan -nanL5 2C5.40841 3.45474 6.54526 4.59159 8 5L-nan -nanL8 5L-nan -nanL8 5C6.54526 5.40841 5.40841 6.54526 5 8L-nan -nanL5 8L-nan -nanL5 8C4.59159 6.54526 3.45474 5.40841 2 5L-nan -nanL2 5L-nan -nanL2 5C3.45474 4.59159 4.59159 3.45474 5 2L-nan -nanL5 2Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M26.0915 12.3207L27.2812 17.666L23.2469 24.6536L18.0229 26.2959L16.8331 20.9506L20.8674 13.963L26.0915 12.3207Z",
      stroke: "currentColor",
      strokeWidth: "2"
    })), React.createElement("defs", null, React.createElement("clipPath", {
      id: "clip0_3841_23969"
    }, React.createElement("rect", {
      width: "40",
      height: "40",
      fill: "white"
    }))));
  },
  'staking-stats': function stakingStats(_ref6) {
    var className = _ref6.className,
      id = _ref6.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.03378 1.41482C7.83367 0.530941 11.6399 0 15.8 0C19.9601 0 23.7663 0.530941 26.5662 1.41482C27.9603 1.85492 29.1612 2.3999 30.0351 3.05213C30.8908 3.69083 31.6 4.56535 31.6 5.67213C31.6 6.77891 30.8908 7.65343 30.0351 8.29213C29.1612 8.94436 27.9603 9.48934 26.5662 9.92944C23.7663 10.8133 19.9601 11.3443 15.8 11.3443C11.6399 11.3443 7.83367 10.8133 5.03378 9.92944C3.63968 9.48934 2.4388 8.94436 1.56492 8.29213C0.709169 7.65343 0 6.77891 0 5.67213C0 4.56535 0.709169 3.69083 1.56492 3.05213C2.4388 2.3999 3.63968 1.85492 5.03378 1.41482ZM2.76119 4.65492C2.1191 5.13415 2 5.48874 2 5.67213C2 5.85552 2.1191 6.21011 2.76119 6.68934C3.38515 7.15504 4.35169 7.61682 5.63586 8.02221C8.19251 8.82931 11.7863 9.34426 15.8 9.34426C19.8137 9.34426 23.4075 8.82931 25.9641 8.02221C27.2483 7.61682 28.2148 7.15504 28.8388 6.68934C29.4809 6.21011 29.6 5.85552 29.6 5.67213C29.6 5.48874 29.4809 5.13415 28.8388 4.65492C28.2148 4.18922 27.2483 3.72744 25.9641 3.32205C23.4075 2.51495 19.8137 2 15.8 2C11.7863 2 8.19251 2.51495 5.63586 3.32205C4.35169 3.72744 3.38515 4.18922 2.76119 4.65492Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M2 11.9565C2 11.4043 1.55228 10.9565 1 10.9565C0.447715 10.9565 0 11.4043 0 11.9565C0 13.061 0.715539 13.9287 1.56947 14.5585C2.44322 15.203 3.6436 15.7413 5.037 16.176C7.38965 16.91 10.4534 17.3976 13.8408 17.5344C12.6983 19.0888 11.8656 20.8886 11.4343 22.8404C8.6251 22.5635 6.23064 22.0302 4.52524 21.3531C3.59411 20.9834 2.92196 20.5918 2.49978 20.2178C2.07525 19.8418 2 19.5758 2 19.4321C2 18.8798 1.55228 18.4321 1 18.4321C0.447715 18.4321 0 18.8798 0 19.4321C0 20.3642 0.514333 21.1309 1.17366 21.7149C1.83532 22.301 2.7413 22.7967 3.78725 23.212C5.69594 23.9698 8.25004 24.5294 11.1417 24.8211C11.1141 25.1832 11.1 25.549 11.1 25.9181C11.1 27.4662 11.3477 28.9565 11.8054 30.3506C9.03794 30.1033 6.64438 29.608 4.88485 28.9654C3.8368 28.5826 3.06856 28.1672 2.58119 27.7629C2.08662 27.3527 2 27.0599 2 26.9075C2 26.3552 1.55228 25.9075 1 25.9075C0.447715 25.9075 0 26.3552 0 26.9075C0 27.8989 0.580086 28.7015 1.30431 29.3022C2.03574 29.909 3.03839 30.4202 4.19872 30.844C6.39596 31.6465 9.35639 32.2061 12.675 32.4237C13.8549 34.7063 15.6365 36.6226 17.8085 37.9569C17.1526 37.9853 16.482 38 15.8 38C11.7853 38 8.19043 37.491 5.63263 36.693C4.34776 36.2922 3.38073 35.8356 2.75664 35.3752C2.11273 34.9003 2 34.5533 2 34.3828C2 33.8305 1.55228 33.3828 1 33.3828C0.447715 33.3828 0 33.8305 0 34.3828C0 35.4873 0.715539 36.3549 1.56947 36.9848C2.44323 37.6293 3.6436 38.1676 5.037 38.6023C7.83575 39.4754 11.6409 40 15.8 40C17.923 40 19.9484 39.8633 21.7917 39.6152L21.7946 39.6148C22.8387 39.8667 23.9287 40.0001 25.05 40.0001C32.7639 40.0001 39 33.6858 39 25.9181C39 20.3849 35.8356 15.5892 31.2268 13.288C31.4581 12.8914 31.6 12.4471 31.6 11.9565C31.6 11.4043 31.1523 10.9565 30.6 10.9565C30.0477 10.9565 29.6 11.4043 29.6 11.9565C29.6 12.0687 29.5528 12.2571 29.3316 12.5116C27.9829 12.0731 26.5441 11.8362 25.05 11.8362C21.3943 11.8362 18.0705 13.2543 15.585 15.5732C11.6571 15.5554 8.14469 15.0504 5.63263 14.2667C4.34776 13.8659 3.38073 13.4093 2.75664 12.949C2.11273 12.474 2 12.127 2 11.9565ZM14.299 31.2C16.239 35.2288 20.3287 38.0001 25.05 38.0001C31.6402 38.0001 37 32.6004 37 25.9181C37 19.2359 31.6402 13.8362 25.05 13.8362C18.4597 13.8362 13.1 19.2359 13.1 25.9181C13.1 27.6924 13.4778 29.3762 14.1562 30.8925C14.2203 30.9851 14.269 31.0889 14.299 31.2Z",
      fill: "CurrentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 18.8453L31.1961 22.4227V29.5774L25 33.1547L18.8038 29.5774V22.4227L25 18.8453ZM20.8038 23.5774V28.4227L25 30.8453L29.1961 28.4227V23.5774L25 21.1547L20.8038 23.5774Z",
      fill: "CurrentColor"
    }));
  },
  rocket: function rocket(_ref7) {
    var className = _ref7.className,
      id = _ref7.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M39.4864 1.61912C39.6332 0.811896 38.9281 0.106774 38.1208 0.253543C28.8713 1.93528 20.8271 7.50203 15.9853 15.4806L12.397 14.2845L5.88076 16.2895C4.02113 16.8617 3.99063 19.4831 5.83647 20.0984L13.2587 22.5724L17.1675 26.4813L19.6416 33.9036C20.2569 35.7494 22.8783 35.7189 23.4505 33.8593L25.4555 27.3431L24.2594 23.7547C32.2379 18.9129 37.8047 10.8687 39.4864 1.61912ZM31.7272 4.27136C33.5016 3.50044 35.3578 2.89318 37.2749 2.46501C36.8468 4.38215 36.2395 6.23836 35.4686 8.0127L31.7272 4.27136ZM29.8112 5.18373C24.261 8.06575 19.6524 12.6091 16.7001 18.2867L15.0242 21.5096L18.2304 24.7157L21.4532 23.0399C27.1308 20.0875 31.6742 15.479 34.5562 9.92875L29.8112 5.18373ZM21.539 33.2711L19.2601 26.4345L22.3759 24.8143L22.4854 24.7571L23.3555 27.3675L21.539 33.2711ZM13.3054 20.4798L14.9257 17.364L14.9828 17.2546L12.3725 16.3845L6.46893 18.201L13.3054 20.4798Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M12.3847 25.9411C12.7752 25.5506 12.7752 24.9174 12.3847 24.5269C11.9942 24.1363 11.361 24.1363 10.9705 24.5269L6.02072 29.4766C5.63019 29.8671 5.63019 30.5003 6.02072 30.8908C6.41124 31.2814 7.0444 31.2814 7.43493 30.8908L12.3847 25.9411Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M15.2132 27.3553C15.6037 27.7458 15.6037 28.379 15.2132 28.7695L5.31367 38.669C4.92315 39.0595 4.28999 39.0595 3.89946 38.669C3.50894 38.2785 3.50894 37.6453 3.89946 37.2548L13.799 27.3553C14.1895 26.9648 14.8226 26.9648 15.2132 27.3553Z",
      fill: "currentColor"
    }));
  },
  power: function power(_ref8) {
    var className = _ref8.className,
      id = _ref8.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, React.createElement("g", {
      clipPath: "url(#clip0_2322_1466)"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.884 8.0984C21.9301 7.63181 21.6458 7.19586 21.2003 7.04984C20.7548 6.90382 20.2676 7.08696 20.0286 7.49031L11.1397 22.4903C10.9565 22.7994 10.9533 23.183 11.1312 23.4952C11.309 23.8074 11.6407 24.0001 12 24.0001H18.8964L18.1159 31.9018C18.0698 32.3684 18.3541 32.8044 18.7996 32.9504C19.2452 33.0964 19.7324 32.9133 19.9714 32.5099L28.8603 17.5099C29.0434 17.2008 29.0467 16.8172 28.8688 16.505C28.6909 16.1929 28.3593 16.0001 28 16.0001H21.1036L21.884 8.0984ZM20 22.0001H13.755L19.4505 12.3888L19.0048 16.9018C18.9771 17.1828 19.0694 17.4624 19.2589 17.6716C19.4485 17.8808 19.7177 18.0001 20 18.0001H26.245L20.5494 27.6114L20.9952 23.0984C21.0229 22.8175 20.9306 22.5379 20.741 22.3287C20.5515 22.1194 20.2823 22.0001 20 22.0001Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20ZM38 20C38 29.9411 29.9411 38 20 38C10.0589 38 2 29.9411 2 20C2 10.0589 10.0589 2 20 2C29.9411 2 38 10.0589 38 20Z",
      fill: "currentColor"
    })));
  },
  locked: function locked(_ref9) {
    var className = _ref9.className,
      id = _ref9.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "none"
    }, React.createElement("path", {
      d: "M21 18C21 17.4477 20.5523 17 20 17C19.4477 17 19 17.4477 19 18V19H17C15.3431 19 14 20.3431 14 22V24C14 25.6569 15.3431 27 17 27H23C23.5523 27 24 27.4477 24 28V30C24 30.5523 23.5523 31 23 31H17C16.4477 31 16 30.5523 16 30V29C16 28.4477 15.5523 28 15 28C14.4477 28 14 28.4477 14 29V30C14 31.6569 15.3431 33 17 33H19V34C19 34.5523 19.4477 35 20 35C20.5523 35 21 34.5523 21 34V33H23C24.6569 33 26 31.6569 26 30V28C26 26.3431 24.6569 25 23 25H17C16.4477 25 16 24.5523 16 24V22C16 21.4477 16.4477 21 17 21H23C23.5523 21 24 21.4477 24 22V23C24 23.5523 24.4477 24 25 24C25.5523 24 26 23.5523 26 23V22C26 20.3431 24.6569 19 23 19H21V18Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 3C11 1.34315 12.3431 0 14 0H26C27.6569 0 29 1.34315 29 3V12H31C32.6569 12 34 13.3431 34 15V37C34 38.6569 32.6569 40 31 40H9C7.34315 40 6 38.6569 6 37V15C6 13.3431 7.34315 12 9 12H11V3ZM27 3V12H13V3C13 2.44772 13.4477 2 14 2H26C26.5523 2 27 2.44772 27 3ZM9 14C8.44772 14 8 14.4477 8 15V37C8 37.5523 8.44772 38 9 38H31C31.5523 38 32 37.5523 32 37V15C32 14.4477 31.5523 14 31 14H9Z",
      fill: "currentColor"
    }));
  },
  union: function union(_ref10) {
    var className = _ref10.className,
      id = _ref10.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "38",
      height: "40",
      viewBox: "0 0 38 40",
      fill: "currentColor"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7808 0C10.863 0 10.0631 0.624593 9.84048 1.51493L0.52985 38.7575C0.395901 39.2933 0.721662 39.8362 1.25746 39.9701C1.79325 40.1041 2.33619 39.7783 2.47013 39.2425L7.78077 18H18.2192L16.3405 25.5149C16.0249 26.7772 16.9796 28 18.2808 28H32.2192C33.137 28 33.9369 27.3754 34.1595 26.4851L37.6595 12.4851C37.9751 11.2228 37.0204 10 35.7192 10H25.7808L27.6595 2.48507C27.9751 1.22278 27.0204 0 25.7192 0H11.7808ZM25.2808 12L24.1595 16.4851C23.9369 17.3754 23.1369 18 22.2192 18H20.2808L18.2808 26H32.2192L35.7192 12H25.2808ZM22.2192 16H8.28077L11.7808 2L25.7192 2L22.2192 16Z",
      fill: "currentColor"
    }));
  },
  diamond: function diamond(_ref11) {
    var className = _ref11.className,
      id = _ref11.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "currentColor"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.10045 9H30.8992L37.3492 15.9873L19.9998 35.5052L2.65076 15.9873L9.10045 9ZM9.40141 11.6226L6.28391 15H11.6001L9.40141 11.6226ZM12.7443 17L17.2682 29.4217L6.22679 17H12.7443ZM22.7315 29.4217L33.7731 17H27.2556L22.7315 29.4217ZM25.1271 17H14.8729L19.9998 31.0778L25.1271 17ZM28.3997 15H33.7159L30.5983 11.6226L28.3997 15ZM28.6172 11H22.5736L26.3608 14.4662L28.6172 11ZM23.9818 15L19.9998 11.3556L16.0181 15H23.9818ZM13.6391 14.4662L17.4261 11H11.3826L13.6391 14.4662Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M24 1C24.5522 1 25 1.44772 25 2V3H26C26.5522 3 27 3.44772 27 4C27 4.55228 26.5522 5 26 5H25V6C25 6.55228 24.5522 7 24 7C23.4477 7 23 6.55228 23 6V5H22C21.4477 5 21 4.55228 21 4C21 3.44772 21.4477 3 22 3H23V2C23 1.44772 23.4477 1 24 1Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5.99996 25C6.55225 25 6.99996 25.4477 6.99996 26V27H7.99996C8.55225 27 8.99996 27.4477 8.99996 28C8.99996 28.5523 8.55225 29 7.99996 29H6.99996V30C6.99996 30.5523 6.55225 31 5.99996 31C5.44768 31 4.99996 30.5523 4.99996 30V29H3.99996C3.44768 29 2.99996 28.5523 2.99996 28C2.99996 27.4477 3.44768 27 3.99996 27H4.99996V26C4.99996 25.4477 5.44768 25 5.99996 25Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32 31C32.5522 31 33 31.4477 33 32V33H34C34.5522 33 35 33.4477 35 34C35 34.5523 34.5522 35 34 35H33V36C33 36.5523 32.5522 37 32 37C31.4477 37 31 36.5523 31 36V35H30C29.4477 35 29 34.5523 29 34C29 33.4477 29.4477 33 30 33H31V32C31 31.4477 31.4477 31 32 31Z",
      fill: "currentColor"
    }));
  },
  participants: function participants(_ref12) {
    var className = _ref12.className,
      id = _ref12.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "38",
      height: "36",
      viewBox: "0 0 38 36",
      fill: "currentColor"
    }, React.createElement("path", {
      d: "M22.9999 4C22.9999 6.20914 21.2091 8 18.9999 8C16.7908 8 14.9999 6.20914 14.9999 4C14.9999 1.79086 16.7908 0 18.9999 0C21.2091 0 22.9999 1.79086 22.9999 4Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M11.9296 24C11.9296 26.2091 10.1387 28 7.92961 28C5.72047 28 3.92961 26.2091 3.92961 24C3.92961 21.7909 5.72047 20 7.92961 20C10.1387 20 11.9296 21.7909 11.9296 24Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M33.9296 24C33.9296 26.2091 32.1387 28 29.9296 28C27.7205 28 25.9296 26.2091 25.9296 24C25.9296 21.7909 27.7205 20 29.9296 20C32.1387 20 33.9296 21.7909 33.9296 24Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19 12C16.4102 12 14.1477 13.4058 12.9358 15.5007C12.6593 15.9788 12.0476 16.1421 11.5695 15.8656C11.0914 15.5891 10.9281 14.9773 11.2046 14.4993C12.7593 11.8118 15.6674 10 19 10C22.3325 10 25.2407 11.8118 26.7953 14.4993C27.0719 14.9773 26.9085 15.5891 26.4304 15.8656C25.9524 16.1421 25.3407 15.9788 25.0641 15.5007C23.8523 13.4058 21.5897 12 19 12Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7.92967 32C5.33994 32 3.07737 33.4058 1.86553 35.5007C1.58898 35.9788 0.977257 36.1421 0.499196 35.8656C0.0211352 35.5891 -0.142227 34.9773 0.134316 34.4993C1.68895 31.8118 4.59714 30 7.92967 30C11.2622 30 14.1704 31.8118 15.725 34.4993C16.0016 34.9773 15.8382 35.5891 15.3601 35.8656C14.8821 36.1421 14.2703 35.9788 13.9938 35.5007C12.782 33.4058 10.5194 32 7.92967 32Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M29.9297 32C27.3399 32 25.0774 33.4058 23.8655 35.5007C23.589 35.9788 22.9773 36.1421 22.4992 35.8656C22.0211 35.5891 21.8578 34.9773 22.1343 34.4993C23.6889 31.8118 26.5971 30 29.9297 30C33.2622 30 36.1704 31.8118 37.725 34.4993C38.0016 34.9773 37.8382 35.5891 37.3601 35.8656C36.8821 36.1421 36.2703 35.9788 35.9938 35.5007C34.782 33.4058 32.5194 32 29.9297 32Z",
      fill: "currentColor"
    }));
  },
  'increase-line': function increaseLine(_ref13) {
    var id = _ref13.id,
      className = _ref13.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "40",
      height: "40",
      viewBox: "0 0 40 40",
      fill: "currentColor"
    }, React.createElement("g", {
      clipPath: "url(#clip0_1596_37858)"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 9C0 4.02944 4.02944 0 9 0H31C35.9706 0 40 4.02944 40 9V31C40 35.9706 35.9706 40 31 40H9C4.02944 40 0 35.9706 0 31V9ZM9 2C5.13401 2 2 5.13401 2 9V31C2 34.866 5.13401 38 9 38H31C34.866 38 38 34.866 38 31V9C38 5.13401 34.866 2 31 2H9Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M32 10C32 22.1503 22.1503 32 10 32H9C8.44772 32 8 31.5523 8 31C8 30.4477 8.44772 30 9 30H10C21.0457 30 30 21.0457 30 10V9C30 8.44772 30.4477 8 31 8C31.5523 8 32 8.44772 32 9V10Z",
      fill: "currentColor"
    })));
  },
  'arrow-down': function arrowDown(_ref14) {
    var id = _ref14.id,
      className = _ref14.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "12",
      height: "13",
      viewBox: "0 0 12 13",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.7933 6.01799C12.0689 6.30139 12.0689 6.76086 11.7933 7.04426L6 13L0.206748 7.04426C-0.0689166 6.76086 -0.0689166 6.30139 0.206748 6.01799C0.482412 5.7346 0.929353 5.7346 1.20502 6.01799L5.29412 10.2218L5.29412 0.72568C5.29412 0.324898 5.61015 -2.79309e-07 6 -2.62268e-07C6.38985 -2.45228e-07 6.70588 0.324898 6.70588 0.72568L6.70588 10.2218L10.795 6.01799C11.0706 5.7346 11.5176 5.7346 11.7933 6.01799Z",
      fill: "#F3EEFC"
    }));
  },
  'under-glow': function underGlow(_ref15) {
    var id = _ref15.id,
      className = _ref15.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 68 12",
      fill: "none"
    }, React.createElement("g", {
      filter: "url(#filter0_f_2010_3783)"
    }, React.createElement("ellipse", {
      cx: "34",
      cy: "6",
      rx: "30",
      ry: "2",
      fill: "url(#paint0_linear_2010_3783)"
    })), React.createElement("defs", null, React.createElement("filter", {
      id: "filter0_f_2010_3783",
      x: "0",
      y: "0",
      width: "68",
      height: "12",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    }, React.createElement("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), React.createElement("feBlend", {
      mode: "normal",
      "in": "SourceGraphic",
      in2: "BackgroundImageFix",
      result: "shape"
    }), React.createElement("feGaussianBlur", {
      stdDeviation: "2",
      result: "effect1_foregroundBlur_2010_3783"
    })), React.createElement("linearGradient", {
      id: "paint0_linear_2010_3783",
      x1: "4",
      y1: "5.99998",
      x2: "63.6667",
      y2: "5.99998",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#110622",
      stopOpacity: "0"
    }), React.createElement("stop", {
      offset: "0.525",
      stopColor: "#110622"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#110622",
      stopOpacity: "0"
    }))));
  },
  'dcb-power': function dcbPower(_ref16) {
    var id = _ref16.id,
      className = _ref16.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "14",
      height: "16",
      viewBox: "0 0 14 16",
      fill: "none"
    }, React.createElement("path", {
      d: "M7.66667 1L1 9.4H7L6.33333 15L13 6.6H7L7.66667 1Z",
      fill: "white",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'play-btn': function playBtn(_ref17) {
    var id = _ref17.id,
      className = _ref17.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none"
    }, React.createElement("circle", {
      cx: "16",
      cy: "16",
      r: "15",
      stroke: "#F3EEFC",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M22 16L13 21L13 11L22 16Z",
      fill: "#F3EEFC"
    }));
  },
  resize: function resize(_ref18) {
    var id = _ref18.id,
      className = _ref18.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "102",
      height: "80",
      viewBox: "0 0 102 80",
      fill: "none",
      color: "#AE1E55"
    }, React.createElement("circle", {
      cx: "51",
      cy: "40",
      r: "40",
      fill: "url(#paint0_linear_750_8767)"
    }), React.createElement("rect", {
      x: "1",
      y: "10",
      width: "100",
      height: "60",
      rx: "8",
      stroke: "#F3EEFC",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M30 60C30 60.5523 30.4477 61 31 61H40C40.5523 61 41 60.5523 41 60C41 59.4477 40.5523 59 40 59H32V51C32 50.4477 31.5523 50 31 50C30.4477 50 30 50.4477 30 51V60ZM72 20C72 19.4477 71.5523 19 71 19H62C61.4477 19 61 19.4477 61 20C61 20.5523 61.4477 21 62 21H70V29C70 29.5523 70.4477 30 71 30C71.5523 30 72 29.5523 72 29V20ZM31.7071 60.7071L71.7071 20.7071L70.2929 19.2929L30.2929 59.2929L31.7071 60.7071Z",
      fill: "#F3EEFC"
    }), React.createElement("circle", {
      cx: "9",
      cy: "18",
      r: "2",
      fill: "#F3EEFC"
    }), React.createElement("circle", {
      cx: "17",
      cy: "18",
      r: "2",
      fill: "#F3EEFC"
    }), React.createElement("circle", {
      cx: "25",
      cy: "18",
      r: "2",
      fill: "#F3EEFC"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_750_8767",
      x1: "22.1111",
      y1: "68.8889",
      x2: "85.4444",
      y2: "5.55557",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor",
      stopOpacity: "0.5"
    }))));
  },
  burn: function burn(_ref19) {
    var id = _ref19.id,
      className = _ref19.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "20",
      viewBox: "0 0 18 20",
      fill: "none"
    }, React.createElement("path", {
      d: "M4.2737 6.86071C-2.58705 11.6424 0.905717 18.5447 2.77682 18.7526C2.70752 17.7131 2.85166 15.2599 3.98264 13.763C3.98264 14.3867 4.35686 20 10.3028 20C17.5793 20 20.1989 12.8482 15.2508 7.52599C14.0866 10.6861 12.4234 11.7256 11.5086 12.4324C15.4587 4.69854 9.05536 1.12266 6.51902 0C7.01795 1.62162 7.92385 4.31668 4.2737 6.86071Z",
      fill: "#F3EEFC"
    }));
  },
  instagram: function instagram(_ref20) {
    var id = _ref20.id,
      className = _ref20.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "21",
      height: "20",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 21 20",
      fill: "none"
    }, React.createElement("g", {
      id: "instagram-icon"
    }, React.createElement("path", {
      id: "Vector",
      d: "M15 1.00003H6C3.51472 1.00003 1.5 3.01475 1.5 5.50003V14.5C1.5 16.9853 3.51472 19 6 19H15C17.4853 19 19.5 16.9853 19.5 14.5V5.50003C19.5 3.01475 17.4853 1.00003 15 1.00003Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_2",
      d: "M14.1 9.43303C14.2111 10.182 14.0831 10.947 13.7344 11.6191C13.3856 12.2913 12.8338 12.8363 12.1575 13.1767C11.4811 13.5172 10.7146 13.6357 9.96701 13.5154C9.21941 13.3951 8.52878 13.0421 7.99335 12.5067C7.45792 11.9712 7.10496 11.2806 6.98466 10.533C6.86436 9.78542 6.98286 9.01893 7.32329 8.34256C7.66373 7.6662 8.20877 7.11439 8.88089 6.76564C9.553 6.4169 10.318 6.28896 11.067 6.40003C11.831 6.51332 12.5384 6.86934 13.0845 7.4155C13.6307 7.96166 13.9867 8.669 14.1 9.43303Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_3",
      d: "M15.45 5.05003H15.459",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  },
  cmc: function cmc(_ref21) {
    var id = _ref21.id,
      className = _ref21.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 20 20",
      fill: "none"
    }, React.createElement("g", {
      id: "cmc-icon"
    }, React.createElement("path", {
      id: "cmc-icon_2",
      d: "M19.9931 10.0042V9.9654C19.9734 4.47818 15.4872 3.05176e-05 9.99655 3.05176e-05C4.50586 3.05176e-05 0 4.47818 0 10.0042C0 15.5309 4.48548 20 9.99655 20C12.5254 20.0017 14.9576 19.0427 16.787 17.3226C16.9672 17.1604 17.0746 16.9343 17.0856 16.6941C17.0966 16.4539 17.0103 16.2192 16.8457 16.0417C16.6811 15.8641 16.4516 15.7583 16.2078 15.7475C15.964 15.7366 15.7258 15.8216 15.5456 15.9838L15.5259 16.0032C14.7365 16.7425 13.8037 17.3171 12.7834 17.6924C11.763 18.0677 10.6762 18.2359 9.58824 18.1871C8.50025 18.1383 7.4335 17.8733 6.45202 17.4082C5.47054 16.943 4.59458 16.2873 3.87673 15.4803L8.14711 8.73332V11.8554C8.14711 13.3472 8.73758 13.8327 9.23386 13.9684C9.73014 14.1042 10.4746 14.0058 11.2808 12.7461L13.6237 8.99788C13.6863 8.88846 13.7587 8.78457 13.8388 8.68692V10.588C13.8388 11.9835 14.4096 13.1083 15.393 13.6506C15.847 13.8941 16.3595 14.0119 16.8759 13.9916C17.3924 13.9712 17.8937 13.8134 18.3264 13.5349C19.4624 12.8084 20.0725 11.5361 19.9931 10.0042ZM17.395 11.9676C17.2373 12.0747 17.0533 12.1383 16.8623 12.1518C16.6712 12.1653 16.4799 12.1283 16.3083 12.0445C15.9146 11.8125 15.6777 11.2896 15.6777 10.5721V8.37457C15.6777 7.32879 15.2644 6.57182 14.5565 6.37928C13.3552 6.02192 12.4512 7.48393 12.1159 8.0269L9.99655 11.3803V7.25122C9.97687 6.30171 9.66125 5.73935 9.07078 5.56413C8.67713 5.44847 8.08666 5.50734 7.51657 6.36058L2.77381 13.8438C2.14287 12.6593 1.81221 11.3419 1.81008 10.0042C1.81008 5.48656 5.48928 1.82218 9.99655 1.82218C14.5038 1.82218 18.183 5.48656 18.183 10.0042V10.0437C18.2301 10.9149 17.9461 11.6144 17.3957 11.9621L17.395 11.9676Z",
      fill: "currentColor"
    })));
  },
  facebook: function facebook(_ref22) {
    var id = _ref22.id,
      className = _ref22.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "11",
      height: "20",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 11 20",
      fill: "none"
    }, React.createElement("g", {
      id: "facebook-icon"
    }, React.createElement("path", {
      id: "Vector",
      d: "M11 3.05176e-05H8C6.67392 3.05176e-05 5.40215 0.526815 4.46447 1.4645C3.52678 2.40218 3 3.67395 3 5.00003V8.00003H0V12H3V20H7V12H10L11 8.00003H7V5.00003C7 4.73481 7.10536 4.48046 7.29289 4.29292C7.48043 4.10539 7.73478 4.00003 8 4.00003H11V3.05176e-05Z",
      fill: "currentColor"
    })));
  },
  draggable: function draggable(_ref23) {
    var id = _ref23.id,
      className = _ref23.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 22 10",
      fill: "none"
    }, React.createElement("g", {
      id: "Group 3389"
    }, React.createElement("path", {
      id: "Vector 67",
      d: "M1 1H21",
      stroke: "#A18CC0",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      id: "Vector 68",
      d: "M1 9H21",
      stroke: "#A18CC0",
      strokeWidth: "2",
      strokeLinecap: "round"
    })));
  },
  bin: function bin(_ref24) {
    var id = _ref24.id,
      className = _ref24.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      width: "21",
      height: "23",
      viewBox: "0 0 21 23",
      fill: "none"
    }, React.createElement("g", {
      id: "Trash-icon"
    }, React.createElement("path", {
      id: "Vector",
      d: "M1.04285 5.5H3.04285H19.0428",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_2",
      d: "M17.0422 5.5V19.5C17.0422 20.0304 16.8315 20.5391 16.4564 20.9142C16.0814 21.2893 15.5727 21.5 15.0422 21.5H5.04224C4.5118 21.5 4.0031 21.2893 3.62802 20.9142C3.25295 20.5391 3.04224 20.0304 3.04224 19.5V5.5M6.04224 5.5V3.5C6.04224 2.96957 6.25295 2.46086 6.62802 2.08579C7.0031 1.71071 7.5118 1.5 8.04224 1.5H12.0422C12.5727 1.5 13.0814 1.71071 13.4564 2.08579C13.8315 2.46086 14.0422 2.96957 14.0422 3.5V5.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_3",
      d: "M8.04224 10.5V16.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_4",
      d: "M12.043 10.5V16.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  },
  bolt: function bolt(_ref25) {
    var id = _ref25.id,
      className = _ref25.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      width: "10",
      height: "12",
      viewBox: "0 0 10 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      d: "M5.44444 1L1 7H5L4.55556 11L9 5H5L5.44444 1Z",
      fill: "#F3EEFC",
      stroke: "#F3EEFC",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  present: function present(_ref26) {
    var id = _ref26.id,
      className = _ref26.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      width: "23",
      height: "23",
      viewBox: "0 0 23 23",
      fill: "none"
    }, React.createElement("path", {
      d: "M19.043 11.5V21.5H3.04297V11.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M21.043 6.5H1.04297V11.5H21.043V6.5Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M11.043 21.5V6.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M11.043 6.5H6.54297C5.87993 6.5 5.24404 6.23661 4.7752 5.76777C4.30636 5.29893 4.04297 4.66304 4.04297 4C4.04297 3.33696 4.30636 2.70107 4.7752 2.23223C5.24404 1.76339 5.87993 1.5 6.54297 1.5C10.043 1.5 11.043 6.5 11.043 6.5Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M11.043 6.5H15.543C16.206 6.5 16.8419 6.23661 17.3107 5.76777C17.7796 5.29893 18.043 4.66304 18.043 4C18.043 3.33696 17.7796 2.70107 17.3107 2.23223C16.8419 1.76339 16.206 1.5 15.543 1.5C12.043 1.5 11.043 6.5 11.043 6.5Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'new-window-link': function newWindowLink(_ref27) {
    var id = _ref27.id,
      className = _ref27.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none"
    }, React.createElement("g", {
      id: "NewWindowLink-Icon"
    }, React.createElement("path", {
      id: "Vector",
      d: "M15.9285 10.9445V16.6111C15.9285 17.1121 15.7188 17.5925 15.3455 17.9468C14.9722 18.301 14.4659 18.5 13.938 18.5H2.99047C2.46256 18.5 1.95628 18.301 1.58299 17.9468C1.20971 17.5925 1 17.1121 1 16.6111V6.22223C1 5.72127 1.20971 5.24082 1.58299 4.88659C1.95628 4.53235 2.46256 4.33334 2.99047 4.33334H8.96187",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_2",
      d: "M12.9427 1.5H18.9142V7.16667",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      id: "Vector_3",
      d: "M7.96667 11.8889L18.9142 1.5",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })));
  },
  'arrow-left': function arrowLeft(_ref28) {
    var id = _ref28.id,
      className = _ref28.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "17",
      viewBox: "0 0 18 17",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.62117 0.292893C9.23065 -0.0976311 8.59748 -0.0976311 8.20696 0.292893L-0.000150681 8.5L8.20696 16.7071C8.59748 17.0976 9.23065 17.0976 9.62117 16.7071C10.0117 16.3166 10.0117 15.6834 9.62117 15.2929L3.82828 9.5H16.9141C17.4663 9.5 17.9141 9.05229 17.9141 8.5C17.9141 7.94772 17.4663 7.5 16.9141 7.5H3.82828L9.62117 1.70711C10.0117 1.31658 10.0117 0.683417 9.62117 0.292893Z",
      fill: "currentColor"
    }));
  },
  events: function events(_ref29) {
    var id = _ref29.id,
      className = _ref29.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "64",
      viewBox: "0 0 62 64",
      fill: "none"
    }, React.createElement("path", {
      d: "M15 9.63333C15 5.14141 18.5817 1.49999 23 1.49999H53C57.4183 1.49999 61 5.14141 61 9.63333V40.1333C61 44.6253 57.4183 48.2667 53 48.2667H23C18.5817 48.2667 15 44.6253 15 40.1333V9.63333Z",
      stroke: "url(#paint0_linear_4188_182)",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M46 55.3833H16C11.5817 55.3833 8 51.8016 8 47.3833V16.75",
      stroke: "url(#paint1_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M39 62.5H9C4.58172 62.5 1 58.9183 1 54.5V23.8667",
      stroke: "url(#paint2_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M25 26.6514L33.1818 35.05L52 15.7333",
      stroke: "url(#paint3_linear_4188_182)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_4188_182",
      x1: "15",
      y1: "24.8833",
      x2: "61",
      y2: "24.8833",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint1_linear_4188_182",
      x1: "8",
      y1: "36.0667",
      x2: "46",
      y2: "36.0667",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint2_linear_4188_182",
      x1: "1",
      y1: "43.1833",
      x2: "39",
      y2: "43.1833",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint3_linear_4188_182",
      x1: "25",
      y1: "25.3917",
      x2: "52",
      y2: "25.3917",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    }))));
  },
  invested: function invested(_ref30) {
    var id = _ref30.id,
      className = _ref30.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "62",
      height: "64",
      viewBox: "0 0 62 64",
      fill: "none"
    }, React.createElement("path", {
      d: "M49 19.0882C49 20.0248 48.4375 20.9207 47.4113 21.7457M25 26.5C11.7452 26.5 1 23.1817 1 19.0882",
      stroke: "url(#paint0_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 31.0882C1 34.5418 8.64864 37.4437 19 38.2665",
      stroke: "url(#paint1_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 43.0882C1 46.7608 9.64915 49.8094 21 50.3975",
      stroke: "url(#paint2_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M1 55.0882C1 59.1817 11.7452 62.5 25 62.5C28.3746 62.5 31.5866 62.2849 34.5 61.8967",
      stroke: "url(#paint3_linear_4188_165)",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("ellipse", {
      cx: "25",
      cy: "8.99999",
      rx: "24",
      ry: "7.5",
      stroke: "url(#paint4_linear_4188_165)",
      strokeWidth: "2"
    }), React.createElement("circle", {
      cx: "40",
      cy: "41.5",
      r: "21",
      stroke: "url(#paint5_linear_4188_165)",
      strokeWidth: "2"
    }), React.createElement("rect", {
      x: "33.1567",
      y: "37.5808",
      width: "10.108",
      height: "4.1351",
      transform: "rotate(-45 33.1567 37.5808)",
      fill: "url(#paint6_linear_4188_165)"
    }), React.createElement("rect", {
      x: "28.9333",
      y: "41.8043",
      width: "4.1351",
      height: "4.1351",
      transform: "rotate(-45 28.9333 41.8043)",
      fill: "url(#paint7_linear_4188_165)"
    }), React.createElement("rect", {
      x: "33.3191",
      y: "46.1902",
      width: "16.0809",
      height: "4.1351",
      transform: "rotate(-45 33.3191 46.1902)",
      fill: "url(#paint8_linear_4188_165)"
    }), React.createElement("rect", {
      x: "37.7051",
      y: "50.5761",
      width: "16.0809",
      height: "4.1351",
      transform: "rotate(-45 37.7051 50.5761)",
      fill: "url(#paint9_linear_4188_165)"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_4188_165",
      x1: "1",
      y1: "22.7941",
      x2: "49",
      y2: "22.7941",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint1_linear_4188_165",
      x1: "1",
      y1: "34.6774",
      x2: "19",
      y2: "34.6774",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint2_linear_4188_165",
      x1: "1",
      y1: "46.7429",
      x2: "21",
      y2: "46.7429",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint3_linear_4188_165",
      x1: "1",
      y1: "58.7941",
      x2: "34.5",
      y2: "58.7941",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint4_linear_4188_165",
      x1: "1",
      y1: "8.99999",
      x2: "49",
      y2: "8.99999",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint5_linear_4188_165",
      x1: "19",
      y1: "41.5",
      x2: "61",
      y2: "41.5",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint6_linear_4188_165",
      x1: "33.1567",
      y1: "39.6483",
      x2: "43.2647",
      y2: "39.6483",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint7_linear_4188_165",
      x1: "28.9333",
      y1: "43.8718",
      x2: "33.0684",
      y2: "43.8718",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint8_linear_4188_165",
      x1: "33.3191",
      y1: "48.2577",
      x2: "49.4",
      y2: "48.2577",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    })), React.createElement("linearGradient", {
      id: "paint9_linear_4188_165",
      x1: "37.7051",
      y1: "52.6436",
      x2: "53.786",
      y2: "52.6436",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor"
    }))));
  },
  'farms-loader': function farmsLoader(_ref31) {
    var id = _ref31.id,
      className = _ref31.className;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: "animate-spin " + className,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 328 328",
      fill: "none"
    }, React.createElement("circle", {
      cx: "164",
      cy: "164",
      r: "160",
      stroke: "url(#paint0_linear_3495_15230)",
      strokeWidth: "8"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: "paint0_linear_3495_15230",
      x1: "48.4444",
      y1: "279.556",
      x2: "301.778",
      y2: "26.2223",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "#AE1E55"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "#AE1E55",
      stopOpacity: "0"
    }))));
  },
  'client-portal-icon': function clientPortalIcon(_ref32) {
    var id = _ref32.id,
      className = _ref32.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 22 22",
      fill: "none"
    }, React.createElement("rect", {
      x: "1",
      y: "1",
      width: "20",
      height: "20",
      rx: "2",
      stroke: "#AE1E55",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M12 5L8.10365 10.8445C8.05934 10.911 8.10698 11 8.18685 11H13.8131C13.893 11 13.9407 11.089 13.8964 11.1555L10 17",
      stroke: "#AE1E55",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  'paste-btn': function pasteBtn(_ref33) {
    var id = _ref33.id,
      className = _ref33.className;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 24 24",
      fill: "none"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9268 9.70715C10.2668 9.70715 9.73169 10.2422 9.73169 10.9023V20.7803C9.73169 21.4404 10.2668 21.9754 10.9268 21.9754H20.8049C21.4649 21.9754 22 21.4404 22 20.7803V10.9023C22 10.2422 21.4649 9.70715 20.8049 9.70715H10.9268ZM7.73169 10.9023C7.73169 9.13766 9.16219 7.70715 10.9268 7.70715H20.8049C22.5695 7.70715 24 9.13766 24 10.9023V20.7803C24 22.5449 22.5695 23.9754 20.8049 23.9754H10.9268C9.16219 23.9754 7.73169 22.5449 7.73169 20.7803V10.9023Z",
      fill: "#F3EEFC"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.24371 2.02454C2.92674 2.02454 2.62276 2.15045 2.39863 2.37458C2.1745 2.59871 2.04858 2.90269 2.04858 3.21966V13.0977C2.04858 13.4147 2.1745 13.7187 2.39863 13.9428C2.62276 14.1669 2.92674 14.2928 3.24371 14.2928H4.34127C4.89355 14.2928 5.34127 14.7405 5.34127 15.2928C5.34127 15.8451 4.89355 16.2928 4.34127 16.2928H3.24371C2.39631 16.2928 1.58361 15.9562 0.984413 15.357C0.385212 14.7578 0.048584 13.9451 0.048584 13.0977V3.21966C0.048584 2.37226 0.385212 1.55957 0.984413 0.960366C1.58362 0.361164 2.39631 0.0245361 3.24371 0.0245361H13.1218C13.9692 0.0245361 14.7818 0.361164 15.381 0.960366C15.9802 1.55957 16.3169 2.37226 16.3169 3.21966V4.31722C16.3169 4.8695 15.8692 5.31722 15.3169 5.31722C14.7646 5.31722 14.3169 4.8695 14.3169 4.31722V3.21966C14.3169 2.90269 14.191 2.59871 13.9668 2.37458C13.7427 2.15045 13.4387 2.02454 13.1218 2.02454H3.24371Z",
      fill: "#F3EEFC"
    }));
  },
  loader: function loader(_ref34) {
    var id = _ref34.id,
      className = _ref34.className;
    var gradient_id = "lin_grad_" + Math.random().toString(16);
    return React.createElement("svg", {
      id: id,
      role: "status",
      "data-testid": id,
      className: "animate-spin " + className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none"
    }, React.createElement("circle", {
      cx: "11",
      cy: "11",
      r: "10",
      stroke: "url(#" + gradient_id + ")",
      strokeWidth: "2"
    }), React.createElement("defs", null, React.createElement("linearGradient", {
      id: gradient_id,
      x1: "-5.31579",
      y1: "26",
      x2: "21.0017",
      y2: "1.00178",
      gradientUnits: "userSpaceOnUse"
    }, React.createElement("stop", {
      stopColor: "currentColor"
    }), React.createElement("stop", {
      offset: "1",
      stopColor: "currentColor",
      stopOpacity: "0"
    }))));
  },
  vesting: function vesting(_ref35) {
    var className = _ref35.className,
      id = _ref35.id;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 32 32",
      fill: "none"
    }, React.createElement("path", {
      d: "M16.8429 19.6371C16.4512 20.2638 15.5385 20.2638 15.1469 19.6371L11.9526 14.5262C11.5363 13.8602 12.0151 12.9962 12.8005 12.9962L19.1892 12.9962C19.9746 12.9962 20.4534 13.8602 20.0372 14.5262L16.8429 19.6371Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M25.9924 2.50366C23.2549 4.69606 19.7811 6.00728 16.0011 6.00728C12.2211 6.00728 8.74728 4.69607 6.00977 2.50366",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M25.9924 29.4963C23.2549 27.3039 19.7811 25.9927 16.0011 25.9927C12.2211 25.9927 8.74728 27.3039 6.00977 29.4963",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M29.4961 25.9914C27.3037 23.2539 25.9925 19.7802 25.9925 16.0001C25.9925 12.2201 27.3037 8.7463 29.4961 6.00879",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M2.5042 25.9914C4.6966 23.2539 6.00781 19.7802 6.00781 16.0001C6.00781 12.2201 4.6966 8.7463 2.5042 6.00879",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  staking: function staking(_ref36) {
    var className = _ref36.className,
      id = _ref36.id;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 34 34",
      fill: "none"
    }, React.createElement("path", {
      d: "M8 3.90974C10.5642 2.16208 13.6628 1.14038 17 1.14038C20.3372 1.14038 23.4358 2.16208 26 3.90974M3.76936 8.14038C2.0217 10.7046 1 13.8032 1 17.1404C1 24.9515 6.59742 31.4554 14 32.8596M30.2306 8.14038C31.9783 10.7046 33 13.8032 33 17.1404C33 24.9516 27.4026 31.4554 20 32.8596",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("path", {
      d: "M16.1362 11.6211C16.5221 10.9596 17.4779 10.9596 17.8638 11.6211L23.1227 20.6365C23.5116 21.3032 23.0308 22.1404 22.259 22.1404H11.741C10.9692 22.1404 10.4884 21.3032 10.8773 20.6365L16.1362 11.6211Z",
      fill: "currentColor"
    }));
  },
  farm: function farm(_ref37) {
    var className = _ref37.className,
      id = _ref37.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 32 34",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      d: "M14.9896 1.41122C15.6149 1.0501 16.3851 1.0501 17.0104 1.41122L28.9896 8.33025C29.6149 8.69136 30 9.35873 30 10.081V23.919C30 24.6412 29.6148 25.3086 28.9896 25.6697L17.0104 32.5888C16.3851 32.9499 15.6149 32.9499 14.9896 32.5888L3.01036 25.6697C2.38515 25.3086 2 24.6412 2 23.919V10.081C2 9.35873 2.38515 8.69136 3.01036 8.33025L14.9896 1.41122Z",
      stroke: "currentColor",
      strokeWidth: "2"
    }), React.createElement("path", {
      d: "M15.6392 11.1542C15.8624 11.0188 16.1376 11.0188 16.3608 11.1542L20.6392 13.7488C20.8624 13.8842 21 14.1345 21 14.4053V19.5946C21 19.8654 20.8624 20.1157 20.6392 20.2511L16.3608 22.8458C16.1376 22.9812 15.8624 22.9812 15.6392 22.8458L11.3608 20.2511C11.1376 20.1157 11 19.8654 11 19.5946V14.4053C11 14.1345 11.1376 13.8842 11.3608 13.7488L15.6392 11.1542Z",
      fill: "currentColor"
    }));
  },
  'chevron-down': function chevronDown(_ref38) {
    var className = _ref38.className,
      id = _ref38.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.04289 1.0858C1.43342 0.695277 2.06658 0.695277 2.45711 1.0858L9.75 8.37869L17.0429 1.0858C17.4334 0.695277 18.0666 0.695277 18.4571 1.0858C18.8476 1.47633 18.8476 2.10949 18.4571 2.50001L9.75 11.2071L1.04289 2.50001C0.652369 2.10949 0.652369 1.47633 1.04289 1.0858Z",
      fill: "currentColor"
    }));
  },
  'chevron-left': function chevronLeft(_ref39) {
    var className = _ref39.className,
      id = _ref39.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 13 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.0391 19.7071C11.6486 20.0976 11.0154 20.0976 10.6249 19.7071L0.917819 10L10.6249 0.292892C11.0155 -0.0976316 11.6486 -0.0976315 12.0391 0.292892C12.4297 0.683418 12.4297 1.31658 12.0391 1.70711L3.74625 10L12.0391 18.2929C12.4297 18.6834 12.4297 19.3166 12.0391 19.7071Z",
      fill: "currentColor"
    }));
  },
  'chevron-right': function chevronRight(_ref40) {
    var className = _ref40.className,
      id = _ref40.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 11 18",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.721604 17.7071C0.33108 17.3166 0.33108 16.6834 0.721604 16.2929L8.0145 9L0.721603 1.70711C0.331079 1.31658 0.331079 0.683418 0.721603 0.292892C1.11213 -0.0976315 1.74529 -0.0976315 2.13582 0.292892L10.8429 9L2.13582 17.7071C1.74529 18.0976 1.11213 18.0976 0.721604 17.7071Z",
      fill: "currentColor"
    }));
  },
  'chevron-up': function chevronUp(_ref41) {
    var className = _ref41.className,
      id = _ref41.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.292893 10.9142C0.683417 11.3047 1.31658 11.3047 1.70711 10.9142L9 3.62131L16.2929 10.9142C16.6834 11.3047 17.3166 11.3047 17.7071 10.9142C18.0976 10.5237 18.0976 9.89051 17.7071 9.49999L9 0.792879L0.292893 9.49999C-0.0976311 9.89051 -0.0976311 10.5237 0.292893 10.9142Z",
      fill: "currentColor"
    }));
  },
  burger: function burger(_ref42) {
    var className = _ref42.className,
      id = _ref42.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 14"
    }, React.createElement("path", {
      d: "M1 13H17M1 1H17H1ZM1 5H17H1ZM1 9H17H1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'four-squares': function fourSquares(_ref43) {
    var className = _ref43.className,
      id = _ref43.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 14 14"
    }, React.createElement("path", {
      d: "M2 0C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V4C0 4.53043 0.210714 5.03914 0.585786 5.41421C0.960859 5.78929 1.46957 6 2 6H4C4.53043 6 5.03914 5.78929 5.41421 5.41421C5.78929 5.03914 6 4.53043 6 4V2C6 1.46957 5.78929 0.960859 5.41421 0.585786C5.03914 0.210714 4.53043 0 4 0H2ZM2 8C1.46957 8 0.960859 8.21071 0.585786 8.58579C0.210714 8.96086 0 9.46957 0 10V12C0 12.5304 0.210714 13.0391 0.585786 13.4142C0.960859 13.7893 1.46957 14 2 14H4C4.53043 14 5.03914 13.7893 5.41421 13.4142C5.78929 13.0391 6 12.5304 6 12V10C6 9.46957 5.78929 8.96086 5.41421 8.58579C5.03914 8.21071 4.53043 8 4 8H2ZM8 2C8 1.46957 8.21071 0.960859 8.58579 0.585786C8.96086 0.210714 9.46957 0 10 0H12C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V4C14 4.53043 13.7893 5.03914 13.4142 5.41421C13.0391 5.78929 12.5304 6 12 6H10C9.46957 6 8.96086 5.78929 8.58579 5.41421C8.21071 5.03914 8 4.53043 8 4V2ZM8 10C8 9.46957 8.21071 8.96086 8.58579 8.58579C8.96086 8.21071 9.46957 8 10 8H12C12.5304 8 13.0391 8.21071 13.4142 8.58579C13.7893 8.96086 14 9.46957 14 10V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H10C9.46957 14 8.96086 13.7893 8.58579 13.4142C8.21071 13.0391 8 12.5304 8 12V10Z",
      fill: "currentColor"
    }));
  },
  copy: function copy(_ref44) {
    var className = _ref44.className,
      id = _ref44.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.9268 9.70715C10.2668 9.70715 9.73169 10.2422 9.73169 10.9023V20.7803C9.73169 21.4404 10.2668 21.9754 10.9268 21.9754H20.8049C21.4649 21.9754 22 21.4404 22 20.7803V10.9023C22 10.2422 21.4649 9.70715 20.8049 9.70715H10.9268ZM7.73169 10.9023C7.73169 9.13766 9.16219 7.70715 10.9268 7.70715H20.8049C22.5695 7.70715 24 9.13766 24 10.9023V20.7803C24 22.5449 22.5695 23.9754 20.8049 23.9754H10.9268C9.16219 23.9754 7.73169 22.5449 7.73169 20.7803V10.9023Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3.24371 2.02454C2.92674 2.02454 2.62276 2.15045 2.39863 2.37458C2.1745 2.59871 2.04858 2.90269 2.04858 3.21966V13.0977C2.04858 13.4147 2.1745 13.7187 2.39863 13.9428C2.62276 14.1669 2.92674 14.2928 3.24371 14.2928H4.34127C4.89355 14.2928 5.34127 14.7405 5.34127 15.2928C5.34127 15.8451 4.89355 16.2928 4.34127 16.2928H3.24371C2.39631 16.2928 1.58361 15.9562 0.984413 15.357C0.385212 14.7578 0.048584 13.9451 0.048584 13.0977V3.21966C0.048584 2.37226 0.385212 1.55957 0.984413 0.960366C1.58362 0.361164 2.39631 0.0245361 3.24371 0.0245361H13.1218C13.9692 0.0245361 14.7818 0.361164 15.381 0.960366C15.9802 1.55957 16.3169 2.37226 16.3169 3.21966V4.31722C16.3169 4.8695 15.8692 5.31722 15.3169 5.31722C14.7646 5.31722 14.3169 4.8695 14.3169 4.31722V3.21966C14.3169 2.90269 14.191 2.59871 13.9668 2.37458C13.7427 2.15045 13.4387 2.02454 13.1218 2.02454H3.24371Z",
      fill: "currentColor"
    }));
  },
  cross: function cross(_ref45) {
    var className = _ref45.className,
      id = _ref45.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0.292893 1.04289C0.683417 0.652369 1.31658 0.652369 1.70711 1.04289L8.25 7.58579L14.7929 1.04289C15.1834 0.652369 15.8166 0.652369 16.2071 1.04289C16.5976 1.43342 16.5976 2.06658 16.2071 2.45711L9.66421 9L16.2071 15.5429C16.5976 15.9334 16.5976 16.5666 16.2071 16.9571C15.8166 17.3476 15.1834 17.3476 14.7929 16.9571L8.25 10.4142L1.70711 16.9571C1.31658 17.3476 0.683417 17.3476 0.292893 16.9571C-0.0976311 16.5666 -0.0976311 15.9334 0.292893 15.5429L6.83579 9L0.292893 2.45711C-0.0976311 2.06658 -0.0976311 1.43342 0.292893 1.04289Z",
      fill: "currentColor"
    }));
  },
  discord: function discord(_ref46) {
    var className = _ref46.className,
      id = _ref46.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 18"
    }, React.createElement("path", {
      d: "M20.3303 1.50753C18.7767 0.80328 17.1156 0.291464 15.3789 3.05176e-05C15.1656 0.373637 14.9164 0.876147 14.7446 1.27589C12.8985 1.0069 11.0693 1.0069 9.25716 1.27589C9.08539 0.876147 8.83055 0.373637 8.61536 3.05176e-05C6.87681 0.291464 5.21376 0.805161 3.66019 1.51126C0.526643 6.09906 -0.322811 10.5729 0.101917 14.9832C2.18025 16.487 4.19441 17.4004 6.17458 17.9982C6.66349 17.3462 7.09953 16.6532 7.47518 15.9228C6.75975 15.6594 6.07453 15.3344 5.42707 14.9571C5.59884 14.8338 5.76686 14.7049 5.92918 14.5723C9.8782 16.3618 14.1689 16.3618 18.0707 14.5723C18.235 14.7049 18.403 14.8338 18.5728 14.9571C17.9235 15.3363 17.2364 15.6613 16.521 15.9247C16.8966 16.6532 17.3308 17.3481 17.8216 18C19.8036 17.4023 21.8197 16.4888 23.898 14.9832C24.3964 9.87054 23.0467 5.43778 20.3303 1.50753ZM8.01318 12.2709C6.82772 12.2709 5.85555 11.1987 5.85555 9.89295C5.85555 8.58722 6.80696 7.51313 8.01318 7.51313C9.21942 7.51313 10.1916 8.58534 10.1708 9.89295C10.1727 11.1987 9.21942 12.2709 8.01318 12.2709ZM15.9867 12.2709C14.8013 12.2709 13.8291 11.1987 13.8291 9.89295C13.8291 8.58722 14.7805 7.51313 15.9867 7.51313C17.193 7.51313 18.1651 8.58534 18.1444 9.89295C18.1444 11.1987 17.193 12.2709 15.9867 12.2709Z",
      fill: "currentColor"
    }));
  },
  edit: function edit(_ref47) {
    var className = _ref47.className,
      id = _ref47.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12.9799 2.58499C12.8709 2.58499 12.7629 2.60646 12.6622 2.64818C12.5615 2.6899 12.47 2.75105 12.3929 2.82813L3.84547 11.3755L3.40522 12.9898L5.01946 12.5495L13.5669 4.00212C13.6439 3.92504 13.7051 3.83352 13.7468 3.73281C13.7885 3.63209 13.81 3.52415 13.81 3.41513C13.81 3.30611 13.7885 3.19816 13.7468 3.09745C13.7051 2.99673 13.6439 2.90522 13.5669 2.82813C13.4898 2.75105 13.3983 2.6899 13.2975 2.64818C13.1968 2.60646 13.0889 2.58499 12.9799 2.58499ZM11.8968 0.800423C12.2402 0.658195 12.6082 0.584991 12.9799 0.584991C13.3515 0.584991 13.7195 0.658195 14.0629 0.800423C14.4063 0.94265 14.7183 1.15112 14.9811 1.41392C15.2439 1.67672 15.4523 1.98871 15.5946 2.33208C15.7368 2.67545 15.81 3.04347 15.81 3.41513C15.81 3.78678 15.7368 4.1548 15.5946 4.49817C15.4523 4.84154 15.2439 5.15353 14.9811 5.41634L6.24589 14.1515C6.12283 14.2746 5.9698 14.3634 5.8019 14.4092L2.24312 15.3798C1.89691 15.4742 1.52665 15.3758 1.2729 15.1221C1.01915 14.8683 0.920818 14.4981 1.01524 14.1519L1.98582 10.5931C2.03161 10.4252 2.12042 10.2722 2.24347 10.1491L10.9787 1.41392C11.2415 1.15112 11.5535 0.94265 11.8968 0.800423Z",
      fill: "currentColor"
    }));
  },
  mail: function mail(_ref48) {
    var className = _ref48.className,
      id = _ref48.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 23 18"
    }, React.createElement("path", {
      d: "M3.25 1H19.25C20.35 1 21.25 1.9 21.25 3V15C21.25 16.1 20.35 17 19.25 17H3.25C2.15 17 1.25 16.1 1.25 15V3C1.25 1.9 2.15 1 3.25 1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M21.25 3L11.25 10L1.25 3",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  gitbook: function gitbook(_ref49) {
    var className = _ref49.className,
      id = _ref49.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 18"
    }, React.createElement("path", {
      d: "M11.5331 15.0016C11.908 15.0016 12.2454 15.3131 12.2454 15.7415C12.2454 16.1309 11.9455 16.4814 11.5331 16.4814C11.1581 16.4814 10.8207 16.1698 10.8207 15.7415C10.8207 15.3131 11.1581 15.0016 11.5331 15.0016ZM22.5558 10.4846C22.1809 10.4846 21.8434 10.1731 21.8434 9.74472C21.8434 9.35532 22.1434 9.00485 22.5558 9.00485C22.9307 9.00485 23.2681 9.31638 23.2681 9.74472C23.2681 10.1341 22.9307 10.4846 22.5558 10.4846ZM22.5558 7.48619C21.356 7.48619 20.3812 8.49863 20.3812 9.74472C20.3812 9.97836 20.4187 10.212 20.4937 10.4456L13.3327 14.4175C12.9203 13.7945 12.2454 13.444 11.5331 13.444C10.7082 13.444 9.95838 13.9502 9.58346 14.6901L3.13479 11.1855C2.45993 10.7961 1.93503 9.66683 2.01002 8.57651C2.04751 8.03135 2.23497 7.60301 2.49742 7.44725C2.68488 7.33043 2.87234 7.36937 3.13479 7.48619L3.17228 7.52513C4.89692 8.45969 10.4833 11.497 10.7082 11.6138C11.0832 11.7696 11.2706 11.8475 11.908 11.536L23.4556 5.30554C23.6431 5.22766 23.8305 5.0719 23.8305 4.79932C23.8305 4.44886 23.4931 4.2931 23.4931 4.2931C22.8182 3.98158 21.8059 3.47536 20.8311 3.00808C18.7316 1.99564 16.3321 0.827432 15.2823 0.24333C14.3825 -0.262891 13.6326 0.16545 13.5202 0.24333L13.2577 0.360151C8.49619 2.85232 2.19748 6.08435 1.82256 6.31799C1.18519 6.70739 0.772773 7.52513 0.735281 8.53757C0.660296 10.1341 1.44763 11.8085 2.5724 12.3926L9.396 16.053C9.54597 17.1433 10.4833 18 11.5331 18C12.7328 18 13.6701 17.0265 13.7076 15.7804L21.2061 11.5749C21.581 11.8864 22.0684 12.0422 22.5558 12.0422C23.7555 12.0422 24.7303 11.0297 24.7303 9.78366C24.7303 8.49863 23.7555 7.48619 22.5558 7.48619Z",
      fill: "currentColor"
    }));
  },
  github: function github(_ref50) {
    var className = _ref50.className,
      id = _ref50.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 22"
    }, React.createElement("path", {
      d: "M13.5701 20.1655V16.7917C13.6029 16.376 13.5467 15.9581 13.4054 15.5658C13.2641 15.1734 13.0409 14.8157 12.7507 14.5163C15.4881 14.2112 18.365 13.1737 18.365 8.41374C18.3648 7.19657 17.8966 6.02607 17.0573 5.14451C17.4547 4.07962 17.4266 2.90256 16.9789 1.85785C16.9789 1.85785 15.9501 1.55272 13.5701 3.1481C11.572 2.60656 9.46573 2.60656 7.46759 3.1481C5.08758 1.55272 4.05887 1.85785 4.05887 1.85785C3.61109 2.90256 3.58299 4.07962 3.98041 5.14451C3.13488 6.03261 2.66619 7.21369 2.67271 8.4399C2.67271 13.165 5.54964 14.2025 8.28707 14.5425C8.00025 14.8388 7.77905 15.1923 7.63785 15.5798C7.49666 15.9674 7.43865 16.3803 7.46759 16.7917V20.1655M7.46759 17.5502C3.10861 18.8578 3.10861 15.3707 1.36502 14.9348L7.46759 17.5502Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  info: function info(_ref51) {
    var className = _ref51.className,
      id = _ref51.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0C17.0751 0 22 4.92487 22 11ZM12 6.00001L11.7607 13L10.2466 13L10 6L12 6.00001ZM11 16C11.5523 16 12 15.5523 12 15C12 14.4477 11.5523 14 11 14C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16Z",
      fill: "currentColor"
    }));
  },
  linkedin: function linkedin(_ref52) {
    var className = _ref52.className,
      id = _ref52.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 17 16"
    }, React.createElement("path", {
      d: "M4.16726 15.8954V5.33289H0.881941V15.8954H4.16726ZM2.50694 3.91985C3.56672 3.91985 4.41454 3.0367 4.41454 1.97692C4.41454 0.952469 3.56672 0.104645 2.50694 0.104645C1.48248 0.104645 0.634659 0.952469 0.634659 1.97692C0.634659 3.0367 1.48248 3.91985 2.50694 3.91985ZM16.4254 15.8954H16.4607V10.1019C16.4607 7.27582 15.8248 5.08561 12.5042 5.08561C10.9145 5.08561 9.85475 5.96876 9.39551 6.78126H9.36018V5.33289H6.21617V15.8954H9.50149V10.6671C9.50149 9.28941 9.74877 7.98234 11.4444 7.98234C13.1401 7.98234 13.1754 9.53669 13.1754 10.7731V15.8954H16.4254Z",
      fill: "currentColor"
    }));
  },
  lock: function lock(_ref53) {
    var className = _ref53.className,
      id = _ref53.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 11 14"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.66663 5V4C1.66663 1.79086 3.45749 0 5.66663 0C7.87576 0 9.66663 1.79086 9.66663 4V5C10.2189 5 10.6666 5.44772 10.6666 6V13C10.6666 13.5523 10.2189 14 9.66663 14H1.66663C1.11434 14 0.666626 13.5523 0.666626 13V6C0.666626 5.44772 1.11434 5 1.66663 5ZM7.66663 4V5H3.66663V4C3.66663 2.89543 4.56206 2 5.66663 2C6.7712 2 7.66663 2.89543 7.66663 4Z",
      fill: "currentColor"
    }));
  },
  manage: function manage(_ref54) {
    var className = _ref54.className,
      id = _ref54.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 20"
    }, React.createElement("path", {
      d: "M4.26196 0C4.81425 0 5.26196 0.447715 5.26196 1V8C5.26196 8.55228 4.81425 9 4.26196 9C3.70968 9 3.26196 8.55228 3.26196 8V1C3.26196 0.447715 3.70968 0 4.26196 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M5.26196 13H7.26196C7.81425 13 8.26196 12.5523 8.26196 12C8.26196 11.4477 7.81425 11 7.26196 11H1.26196C0.709678 11 0.261963 11.4477 0.261963 12C0.261963 12.5523 0.709678 13 1.26196 13H3.26196V19C3.26196 19.5523 3.70968 20 4.26196 20C4.81425 20 5.26196 19.5523 5.26196 19V13Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M13.262 10C13.262 9.44771 12.8142 9 12.262 9C11.7097 9 11.262 9.44771 11.262 10V19C11.262 19.5523 11.7097 20 12.262 20C12.8142 20 13.262 19.5523 13.262 19V10Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M12.262 0C12.8142 0 13.262 0.447715 13.262 1V5H15.262C15.8142 5 16.262 5.44772 16.262 6C16.262 6.55228 15.8142 7 15.262 7H9.26196C8.70968 7 8.26196 6.55228 8.26196 6C8.26196 5.44772 8.70968 5 9.26196 5H11.262V1C11.262 0.447715 11.7097 0 12.262 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M23.262 13C23.8142 13 24.262 13.4477 24.262 14C24.262 14.5523 23.8142 15 23.262 15H21.262V19C21.262 19.5523 20.8142 20 20.262 20C19.7097 20 19.262 19.5523 19.262 19V15H17.262C16.7097 15 16.262 14.5523 16.262 14C16.262 13.4477 16.7097 13 17.262 13H23.262Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M20.262 0C20.8142 0 21.262 0.447715 21.262 1V10C21.262 10.5523 20.8142 11 20.262 11C19.7097 11 19.262 10.5523 19.262 10V1C19.262 0.447715 19.7097 0 20.262 0Z",
      fill: "currentColor"
    }));
  },
  medium: function medium(_ref55) {
    var className = _ref55.className,
      id = _ref55.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 21 16"
    }, React.createElement("path", {
      d: "M2.86025 3.29167V12.2083C2.90166 12.5 2.81884 12.8333 2.6118 13.0833L0.5 15.625V15.9583H6.46273V15.625L4.35093 13.0833C4.10248 12.8333 4.01967 12.5 4.06108 12.2083V4.5L9.27847 16H9.89959L14.413 4.5V13.625C14.413 13.875 14.413 13.9167 14.2474 14.0833L12.6325 15.6667V16H20.5V15.6667L18.9265 14.125C18.8023 14.0417 18.7195 13.8333 18.7609 13.6667V2.33333C18.7195 2.16667 18.8023 2 18.9265 1.91667L20.5 0.375V0H14.9928L11.0176 9.91667L6.54555 0H0.748447V0.375L2.6118 2.625C2.77743 2.79167 2.90166 3.04167 2.86025 3.29167Z",
      fill: "currentColor"
    }));
  },
  menu: function menu(_ref56) {
    var className = _ref56.className,
      id = _ref56.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 8.00031C0 7.44802 0.447716 7.00031 1 7.00031H24C24.5523 7.00031 25 7.44802 25 8.00031C25 8.55259 24.5523 9.00031 24 9.00031H1C0.447715 9.00031 0 8.55259 0 8.00031Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 0C25 1.10457 24.1046 2 23 2L2 2C0.89543 2 7.8281e-08 1.10457 1.74846e-07 -2.18557e-06L25 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M25 16L0 16C9.65645e-08 14.8954 0.89543 14 2 14L23 14C24.1046 14 25 14.8954 25 16Z",
      fill: "currentColor"
    }));
  },
  minus: function minus(_ref57) {
    var className = _ref57.className,
      id = _ref57.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 2"
    }, React.createElement("path", {
      d: "M1 0C0.447716 0 0 0.447716 0 1C0 1.55229 0.447716 2 1 2L17 2C17.5523 2 18 1.55229 18 1C18 0.447716 17.5523 0 17 0H1Z",
      fill: "currentColor"
    }));
  },
  plus: function plus(_ref58) {
    var className = _ref58.className,
      id = _ref58.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 18"
    }, React.createElement("path", {
      d: "M10.25 1C10.25 0.447715 9.80229 0 9.25 0C8.69771 0 8.25 0.447715 8.25 1V8L1.25 8C0.697716 8 0.25 8.44771 0.25 9C0.25 9.55228 0.697716 10 1.25 10H8.25V17C8.25 17.5523 8.69771 18 9.25 18C9.80229 18 10.25 17.5523 10.25 17V10H17.25C17.8023 10 18.25 9.55229 18.25 9C18.25 8.44771 17.8023 8 17.25 8L10.25 8V1Z",
      fill: "currentColor"
    }));
  },
  selector: function selector(_ref59) {
    var className = _ref59.className,
      id = _ref59.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      strokeWidth: 1.5,
      stroke: "currentColor"
    }, React.createElement("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M8.25 15L12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9"
    }));
  },
  settings: function settings(_ref60) {
    var className = _ref60.className,
      id = _ref60.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V3.17399C10.9979 3.6908 10.8448 4.19572 10.5594 4.62661C10.2741 5.0575 9.86895 5.39555 9.39393 5.59914C9.30938 5.63538 9.22042 5.65969 9.12961 5.67157C8.69798 5.82272 8.23333 5.85998 7.781 5.77796C7.26 5.68349 6.77925 5.43512 6.40073 5.06486L6.39285 5.05715L6.33289 4.99711C6.24002 4.90413 6.12934 4.82998 6.00794 4.77965C5.88654 4.72933 5.75642 4.70343 5.625 4.70343C5.49358 4.70343 5.36346 4.72933 5.24206 4.77965C5.12066 4.82998 5.01037 4.90374 4.9175 4.99671L4.91671 4.9975C4.82374 5.09037 4.74998 5.20066 4.69965 5.32206C4.64933 5.44346 4.62343 5.57358 4.62343 5.705C4.62343 5.83642 4.64933 5.96654 4.69965 6.08794C4.74998 6.20934 4.82374 6.31963 4.91671 6.4125L4.98491 6.48069C5.35516 6.85921 5.60349 7.34 5.69796 7.861C5.79055 8.37163 5.73113 8.89797 5.52745 9.37478C5.34189 9.86133 5.01698 10.2827 4.59305 10.5859C4.16054 10.8952 3.64498 11.0673 3.11338 11.0797L3.09 11.08H3C2.73478 11.08 2.48043 11.1854 2.29289 11.3729C2.10536 11.5604 2 11.8148 2 12.08C2 12.3452 2.10536 12.5996 2.29289 12.7871C2.48043 12.9746 2.73478 13.08 3 13.08H3.17399C3.6908 13.0821 4.19572 13.2352 4.62661 13.5206C5.05601 13.8049 5.3932 14.2082 5.59701 14.6811C5.80908 15.1643 5.87211 15.6998 5.77796 16.219C5.68349 16.74 5.43512 17.2207 5.06486 17.5993L5.05715 17.6072L4.9971 17.6671C4.90413 17.76 4.82998 17.8707 4.77965 17.9921C4.72933 18.1135 4.70343 18.2436 4.70343 18.375C4.70343 18.5064 4.72933 18.6365 4.77965 18.7579C4.82998 18.8793 4.90374 18.9896 4.99671 19.0825L4.9975 19.0833C5.09037 19.1763 5.20066 19.25 5.32206 19.3003C5.44346 19.3507 5.57359 19.3766 5.705 19.3766C5.83641 19.3766 5.96654 19.3507 6.08794 19.3003C6.20934 19.25 6.31963 19.1763 6.4125 19.0833L6.48069 19.0151C6.85921 18.6448 7.34 18.3965 7.861 18.302C8.37163 18.2095 8.89796 18.2689 9.37477 18.4725C9.86132 18.6581 10.2827 18.983 10.5859 19.407C10.8952 19.8395 11.0673 20.355 11.0797 20.8866L11.08 20.91V21C11.08 21.2652 11.1854 21.5196 11.3729 21.7071C11.5604 21.8946 11.8148 22 12.08 22C12.3452 22 12.5996 21.8946 12.7871 21.7071C12.9746 21.5196 13.08 21.2652 13.08 21V20.83L13.08 20.826C13.0821 20.3092 13.2352 19.8043 13.5206 19.3734C13.805 18.944 14.2083 18.6067 14.6812 18.4029C15.1643 18.1909 15.6998 18.1279 16.219 18.222C16.74 18.3165 17.2207 18.5649 17.5993 18.9351L17.6071 18.9429L17.6671 19.0029C17.76 19.0959 17.8707 19.17 17.9921 19.2203C18.1135 19.2707 18.2436 19.2966 18.375 19.2966C18.5064 19.2966 18.6365 19.2707 18.7579 19.2203C18.8793 19.17 18.9896 19.0963 19.0825 19.0033L19.0833 19.0025C19.1763 18.9096 19.25 18.7993 19.3003 18.6779C19.3507 18.5565 19.3766 18.4264 19.3766 18.295C19.3766 18.1636 19.3507 18.0335 19.3003 17.9121C19.25 17.7907 19.1763 17.6804 19.0833 17.5875L19.0151 17.5193C18.6448 17.1408 18.3965 16.66 18.302 16.139C18.2079 15.6198 18.2709 15.0843 18.4829 14.6012C18.6867 14.1283 19.024 13.725 19.4534 13.4406C19.8843 13.1552 20.3892 13.0021 20.906 13L20.91 13L21 13C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11H20.83L20.826 11C20.3092 10.9979 19.8043 10.8448 19.3734 10.5594C18.9425 10.2741 18.6045 9.86896 18.4009 9.39393C18.3646 9.30938 18.3403 9.22042 18.3284 9.12961C18.1773 8.69798 18.14 8.23332 18.222 7.781C18.3165 7.26 18.5649 6.77925 18.9351 6.40073L18.9428 6.39285L19.0029 6.3329C19.0959 6.24002 19.17 6.12934 19.2203 6.00794C19.2707 5.88654 19.2966 5.75641 19.2966 5.625C19.2966 5.49359 19.2707 5.36346 19.2203 5.24206C19.17 5.12066 19.0963 5.01037 19.0033 4.9175L19.0025 4.91671C18.9096 4.82374 18.7993 4.74998 18.6779 4.69965C18.5565 4.64933 18.4264 4.62343 18.295 4.62343C18.1636 4.62343 18.0335 4.64933 17.9121 4.69965C17.7907 4.74998 17.6804 4.82374 17.5875 4.91671L17.5193 4.98491C17.1408 5.35516 16.66 5.60349 16.139 5.69796C15.6198 5.79211 15.0843 5.72908 14.6011 5.51701C14.1282 5.3132 13.7249 4.97601 13.4406 4.54661C13.1552 4.11572 13.0021 3.6108 13 3.09399L13 3.09V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2ZM19.4 15L20.3149 15.4038C20.2624 15.5226 20.2468 15.6544 20.27 15.7822C20.2929 15.9086 20.3527 16.0253 20.4419 16.1177L20.4967 16.1725C20.7755 16.451 20.997 16.7822 21.1479 17.1462C21.2989 17.5104 21.3766 17.9008 21.3766 18.295C21.3766 18.6892 21.2989 19.0796 21.1479 19.4438C20.9969 19.808 20.7756 20.1389 20.4967 20.4175L19.79 19.71L20.4975 20.4167C20.2189 20.6956 19.888 20.9169 19.5238 21.0679C19.1596 21.2189 18.7692 21.2966 18.375 21.2966C17.9808 21.2966 17.5904 21.2189 17.2262 21.0679C16.8622 20.917 16.5314 20.6959 16.2529 20.4171L16.1977 20.3619C16.1053 20.2727 15.9886 20.2129 15.8622 20.19C15.7344 20.1668 15.6026 20.1824 15.4838 20.2349L15.474 20.2392C15.3574 20.2891 15.258 20.372 15.1881 20.4777C15.1183 20.583 15.0808 20.7063 15.08 20.8325V21C15.08 21.7957 14.7639 22.5587 14.2013 23.1213C13.6387 23.6839 12.8757 24 12.08 24C11.2843 24 10.5213 23.6839 9.95868 23.1213C9.39607 22.5587 9.08 21.7957 9.08 21V20.9244C9.07526 20.7972 9.03327 20.6741 8.95914 20.5704C8.88326 20.4644 8.77723 20.3836 8.65482 20.3385C8.63505 20.3313 8.61551 20.3234 8.59624 20.3149C8.47742 20.2624 8.34561 20.2468 8.21782 20.27C8.09142 20.2929 7.97467 20.3527 7.8823 20.4419L7.8275 20.4967C7.54896 20.7755 7.21784 20.997 6.85382 21.1479C6.48963 21.2989 6.09925 21.3766 5.705 21.3766C5.31075 21.3766 4.92037 21.2989 4.55618 21.1479C4.19233 20.9971 3.86174 20.7761 3.58329 20.4975C3.30436 20.2189 3.08308 19.888 2.93211 19.5238C2.78113 19.1596 2.70343 18.7692 2.70343 18.375C2.70343 17.9808 2.78113 17.5904 2.93211 17.2262C3.08308 16.862 3.30436 16.5311 3.58329 16.2525L3.63811 16.1977C3.72728 16.1053 3.78713 15.9886 3.81005 15.8622C3.83322 15.7344 3.81758 15.6026 3.76514 15.4838L3.76081 15.474C3.71087 15.3574 3.62801 15.258 3.52232 15.1881C3.41704 15.1183 3.29374 15.0808 3.1675 15.08H3C2.20435 15.08 1.44129 14.7639 0.87868 14.2013C0.316071 13.6387 0 12.8756 0 12.08C0 11.2844 0.316071 10.5213 0.87868 9.95868C1.44129 9.39607 2.20435 9.08 3 9.08H3.07564C3.20283 9.07526 3.32591 9.03327 3.42955 8.95914C3.53564 8.88326 3.61644 8.77723 3.66146 8.65482C3.66874 8.63505 3.67663 8.61551 3.68514 8.59624C3.73758 8.47742 3.75322 8.34561 3.73005 8.21782C3.70713 8.09142 3.64728 7.97468 3.5581 7.88231L3.50329 7.8275C3.22436 7.54888 3.00308 7.21802 2.85211 6.85382C2.70113 6.48963 2.62343 6.09925 2.62343 5.705C2.62343 5.31075 2.70113 4.92037 2.85211 4.55618C3.00301 4.19216 3.22415 3.86143 3.50289 3.58289C3.78143 3.30415 4.11216 3.08301 4.47618 2.93211C4.84037 2.78113 5.23075 2.70343 5.625 2.70343C6.01925 2.70343 6.40963 2.78113 6.77382 2.93211C7.13802 3.08308 7.46888 3.30436 7.7475 3.58329L7.80231 3.6381C7.89468 3.72728 8.01142 3.78713 8.13782 3.81005C8.26561 3.83322 8.39742 3.81758 8.51624 3.76514C8.58027 3.73687 8.64693 3.71549 8.71507 3.70122C8.78479 3.6539 8.84498 3.59323 8.89195 3.52232C8.96167 3.41704 8.99921 3.29374 9 3.1675V3C9 2.20435 9.31607 1.44129 9.87868 0.87868C10.4413 0.316071 11.2044 0 12 0C12.7956 0 13.5587 0.316071 14.1213 0.87868C14.6839 1.44129 15 2.20435 15 3V3.0875C15.0008 3.21374 15.0383 3.33704 15.1081 3.44232C15.178 3.54801 15.2774 3.63092 15.3939 3.68086L15.4038 3.68508C15.5226 3.73752 15.6544 3.75322 15.7822 3.73005C15.9086 3.70713 16.0253 3.64728 16.1177 3.55811L16.1725 3.50329C16.4511 3.22436 16.782 3.00308 17.1462 2.85211C17.5104 2.70113 17.9008 2.62343 18.295 2.62343C18.6892 2.62343 19.0796 2.70113 19.4438 2.85211C19.808 3.00308 20.1389 3.22436 20.4175 3.50329C20.6961 3.78174 20.9171 4.11233 21.0679 4.47618C21.2189 4.84037 21.2966 5.23075 21.2966 5.625C21.2966 6.01925 21.2189 6.40963 21.0679 6.77382C20.917 7.13784 20.6959 7.46857 20.4171 7.7471L20.3619 7.80231C20.2727 7.89468 20.2129 8.01142 20.19 8.13782C20.1668 8.26561 20.1824 8.39742 20.2349 8.51624C20.2631 8.58027 20.2845 8.64692 20.2988 8.71507C20.3461 8.78479 20.4068 8.84498 20.4777 8.89195C20.583 8.96167 20.7063 8.99921 20.8325 9H21C21.7957 9 22.5587 9.31607 23.1213 9.87868C23.6839 10.4413 24 11.2043 24 12C24 12.7957 23.6839 13.5587 23.1213 14.1213C22.5587 14.6839 21.7957 15 21 15H20.9125C20.7863 15.0008 20.663 15.0383 20.5577 15.1081C20.452 15.178 20.3691 15.2774 20.3191 15.3939L19.4 15Z",
      fill: "currentColor"
    }));
  },
  telegram: function telegram(_ref61) {
    var className = _ref61.className,
      id = _ref61.id;
    return React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "18",
      id: id,
      "data-testid": id,
      className: className,
      viewBox: "0 0 20 18",
      fill: "none"
    }, React.createElement("g", {
      id: "telegram-icon-new"
    }, React.createElement("path", {
      id: "telegram-icon-new_2",
      d: "M17.5871 0.68215L0.723245 7.60064C-0.289084 8.01595 -0.222953 9.4713 0.82287 9.79309L3.46741 10.6068C4.62171 10.962 5.87405 10.7874 6.88727 10.1302L14.5456 5.16265C14.7233 5.0474 14.9146 5.28819 14.7621 5.43519L8.93214 11.057C8.40351 11.5667 8.47227 12.4324 9.07474 12.8523L15.2204 17.1356C16.2834 17.8765 17.7547 17.2442 17.9488 15.9632L19.9794 2.56165C20.1829 1.21852 18.8439 0.166537 17.5871 0.68215Z",
      fill: "currentColor"
    })));
  },
  twitch: function twitch(_ref62) {
    var className = _ref62.className,
      id = _ref62.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 1C0 0.447715 0.447715 0 1 0H17C17.5523 0 18 0.447715 18 1V11.8C18 12.0631 17.8963 12.3155 17.7115 12.5027L14.1559 16.1027C13.968 16.2929 13.7118 16.4 13.4444 16.4H9.41786L6.15593 19.7027C5.87092 19.9913 5.43983 20.0791 5.06463 19.9251C4.68943 19.771 4.44444 19.4056 4.44444 19V16.4H1C0.447715 16.4 0 15.9523 0 15.4V1ZM2 2V14.4H5.44444C5.99673 14.4 6.44444 14.8477 6.44444 15.4V16.5644L8.28852 14.6973C8.4764 14.5071 8.73263 14.4 9 14.4H13.0266L16 11.3894V2H2ZM8.11111 4.5C8.66339 4.5 9.11111 4.94771 9.11111 5.5V9.1C9.11111 9.65228 8.66339 10.1 8.11111 10.1C7.55883 10.1 7.11111 9.65228 7.11111 9.1V5.5C7.11111 4.94771 7.55883 4.5 8.11111 4.5ZM12.5556 4.5C13.1078 4.5 13.5556 4.94771 13.5556 5.5V9.1C13.5556 9.65228 13.1078 10.1 12.5556 10.1C12.0033 10.1 11.5556 9.65228 11.5556 9.1V5.5C11.5556 4.94771 12.0033 4.5 12.5556 4.5Z",
      fill: "currentColor"
    }));
  },
  'info-outline': function infoOutline(_ref63) {
    var className = _ref63.className,
      id = _ref63.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      d: "M11 8V15H9V8H11Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19ZM10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M11 6C11 6.55228 10.5523 7 10 7C9.44772 7 9 6.55228 9 6C9 5.44772 9.44772 5 10 5C10.5523 5 11 5.44772 11 6Z",
      fill: "currentColor"
    }));
  },
  search: function search(_ref64) {
    var className = _ref64.className,
      id = _ref64.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.5732 12.9874C10.3631 13.9021 8.85605 14.4446 7.22228 14.4446C3.23352 14.4446 0 11.211 0 7.22229C0 3.23354 3.23352 1.52588e-05 7.22228 1.52588e-05C11.211 1.52588e-05 14.4446 3.23354 14.4446 7.22229C14.4446 8.85608 13.9021 10.3632 12.9874 11.5732L15.707 14.2929C16.0976 14.6834 16.0976 15.3166 15.707 15.7071C15.3165 16.0976 14.6834 16.0976 14.2928 15.7071L11.5732 12.9874ZM2 7.22229C2 4.33811 4.33809 2.00002 7.22228 2.00002C10.1065 2.00002 12.4446 4.33811 12.4446 7.22229C12.4446 8.62308 11.893 9.89504 10.9953 10.8329C10.9656 10.8565 10.9369 10.882 10.9095 10.9095C10.882 10.937 10.8565 10.9657 10.8329 10.9954C9.89501 11.8931 8.62305 12.4446 7.22228 12.4446C4.33809 12.4446 2 10.1065 2 7.22229Z",
      fill: "currentColor"
    }));
  },
  twitter: function twitter(_ref65) {
    var className = _ref65.className,
      id = _ref65.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 23 18"
    }, React.createElement("path", {
      d: "M20.5113 4.46747C21.3723 3.81687 22.1473 3.03614 22.75 2.1253C21.975 2.47229 21.0709 2.73253 20.1668 2.81928C21.114 2.25542 21.8028 1.38795 22.1473 0.303614C21.2862 0.824096 20.296 1.21446 19.3058 1.43133C18.4447 0.520482 17.2823 0 15.9907 0C13.4936 0 11.4702 2.03855 11.4702 4.55422C11.4702 4.9012 11.5132 5.24819 11.5993 5.59518C7.85372 5.37831 4.4956 3.55663 2.25685 0.824096C1.86937 1.4747 1.65411 2.25542 1.65411 3.12289C1.65411 4.68434 2.42906 6.07229 3.67759 6.89639C2.94569 6.85301 2.2138 6.67952 1.61106 6.33253V6.3759C1.61106 8.58795 3.16096 10.4096 5.2275 10.8434C4.88307 10.9301 4.45254 11.0169 4.06507 11.0169C3.7637 11.0169 3.50538 10.9735 3.20401 10.9301C3.7637 12.7518 5.44276 14.053 7.42319 14.0964C5.87329 15.3108 3.93591 16.0482 1.82632 16.0482C1.43885 16.0482 1.09442 16.0048 0.75 15.9614C2.73043 17.2626 5.09834 18 7.68151 18C15.9907 18 20.5113 11.1036 20.5113 5.0747C20.5113 4.85783 20.5113 4.68434 20.5113 4.46747Z",
      fill: "currentColor"
    }));
  },
  user: function user(_ref66) {
    var className = _ref66.className,
      id = _ref66.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.78634 12.6665C6.80818 12.6665 3.74818 14.6485 2.72122 17.3547C2.52527 17.871 1.94783 18.1308 1.43148 17.9348C0.915126 17.7389 0.655388 17.1614 0.851339 16.6451C2.19794 13.0966 6.04973 10.6665 9.78634 10.6665C13.523 10.6665 17.3746 13.0966 18.7212 16.6451C18.9172 17.1614 18.6574 17.7389 18.1411 17.9348C17.6247 18.1308 17.0473 17.871 16.8513 17.3547C15.8244 14.6485 12.7645 12.6665 9.78634 12.6665Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.78628 1.99986C8.37489 1.99986 7.23073 3.14402 7.23073 4.55542C7.23073 5.96681 8.37489 7.11097 9.78628 7.11097C11.1977 7.11097 12.3418 5.96681 12.3418 4.55542C12.3418 3.14402 11.1977 1.99986 9.78628 1.99986ZM5.23073 4.55542C5.23073 2.03945 7.27032 -0.000137329 9.78628 -0.000137329C12.3022 -0.000137329 14.3418 2.03945 14.3418 4.55542C14.3418 7.07138 12.3022 9.11097 9.78628 9.11097C7.27032 9.11097 5.23073 7.07138 5.23073 4.55542Z",
      fill: "currentColor"
    }));
  },
  web: function web(_ref67) {
    var className = _ref67.className,
      id = _ref67.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0154 20C15.5312 19.9917 20 15.5177 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5177 4.46883 19.9917 9.9846 20C9.98973 20 9.99487 20 10 20M7.72462 2.32822C4.72373 3.2169 2.45864 5.81834 2.06189 9H5.45317C5.66143 6.61813 6.44435 4.32979 7.72462 2.32822ZM12.2754 2.32822C13.5557 4.32979 14.3386 6.61813 14.5468 9H17.9381C17.5414 5.81834 15.2763 3.2169 12.2754 2.32822ZM12.538 9C12.301 6.66007 11.4221 4.43113 10 2.55999C8.57787 4.43113 7.69896 6.66007 7.462 9H12.538ZM7.46198 11H12.538C12.3011 13.34 11.4222 15.569 10 17.4402C8.57783 15.569 7.69891 13.34 7.46198 11ZM5.45315 11H2.06189C2.45863 14.1816 4.72365 16.783 7.72445 17.6717C6.44425 15.6702 5.66137 13.3818 5.45315 11ZM12.2755 17.6717C13.5558 15.6702 14.3386 13.3818 14.5469 11H17.9381C17.5414 14.1816 15.2764 16.783 12.2755 17.6717Z",
      fill: "currentColor"
    }));
  },
  wallet: function wallet(_ref68) {
    var className = _ref68.className,
      id = _ref68.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 18"
    }, React.createElement("path", {
      d: "M16 1H3C1.89543 1 1 1.89543 1 3V5M1 5V15C1 16.1046 1.89543 17 3 17H17C18.1046 17 19 16.1046 19 15V7C19 5.89543 18.1046 5 17 5H1Z",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }), React.createElement("ellipse", {
      cx: "14.6754",
      cy: "12.4286",
      rx: "1.05195",
      ry: "1.14286",
      fill: "currentColor"
    }));
  },
  'warning-outline': function warningOutline(_ref69) {
    var className = _ref69.className,
      id = _ref69.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M23.7011 17.7934L14.3889 2.06532C13.5479 0.644893 11.4521 0.644893 10.6111 2.06532L1.29887 17.7934C0.469012 19.195 1.47968 21 3.18777 21H21.8122C23.5203 21 24.531 19.195 23.7011 17.7934ZM15.2494 1.55585C14.0211 -0.518613 10.9789 -0.518618 9.75061 1.55584L0.438383 17.2839C-0.799424 19.3745 0.731179 22 3.18777 22H21.8122C24.2688 22 25.7994 19.3745 24.5616 17.2839L15.2494 1.55585Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M13.5475 7.41446L13.3082 14.6388H11.5675L11.3209 7.41446H13.5475ZM11.2629 16.8755C11.2629 16.5706 11.3693 16.3181 11.582 16.118C11.7996 15.9132 12.0849 15.8107 12.4378 15.8107C12.7957 15.8107 13.0809 15.9132 13.2937 16.118C13.5064 16.3181 13.6128 16.5706 13.6128 16.8755C13.6128 17.1708 13.5064 17.4209 13.2937 17.6258C13.0809 17.8306 12.7957 17.933 12.4378 17.933C12.0849 17.933 11.7996 17.8306 11.582 17.6258C11.3693 17.4209 11.2629 17.1708 11.2629 16.8755Z",
      fill: "currentColor"
    }));
  },
  warning: function warning(_ref70) {
    var className = _ref70.className,
      id = _ref70.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 22"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.2494 1.55585C14.0211 -0.518613 10.9789 -0.518618 9.75061 1.55584L0.438383 17.2839C-0.799424 19.3745 0.731179 22 3.18777 22H21.8122C24.2688 22 25.7994 19.3745 24.5616 17.2839L15.2494 1.55585ZM13.3082 14.6388L13.5475 7.41446H11.3209L11.5675 14.6388H13.3082ZM11.582 16.118C11.3693 16.3181 11.2629 16.5706 11.2629 16.8755C11.2629 17.1708 11.3693 17.4209 11.582 17.6258C11.7996 17.8306 12.0849 17.933 12.4378 17.933C12.7957 17.933 13.0809 17.8306 13.2937 17.6258C13.5064 17.4209 13.6128 17.1708 13.6128 16.8755C13.6128 16.5706 13.5064 16.3181 13.2937 16.118C13.0809 15.9132 12.7957 15.8107 12.4378 15.8107C12.0849 15.8107 11.7996 15.9132 11.582 16.118Z",
      fill: "currentColor"
    }));
  },
  'arrow-narrow-right': function arrowNarrowRight(_ref71) {
    var className = _ref71.className,
      id = _ref71.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 25 14"
    }, React.createElement("path", {
      d: "M1.33325 7H23.3333M23.3333 7L17.74 1.5M23.3333 7L17.74 12.5",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round"
    }));
  },
  'arrow-right': function arrowRight(_ref72) {
    var className = _ref72.className,
      id = _ref72.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 18 18"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.37871 0.792893C8.76923 0.402369 9.4024 0.402369 9.79292 0.792893L18 9L9.79292 17.2071C9.4024 17.5976 8.76923 17.5976 8.37871 17.2071C7.98818 16.8166 7.98818 16.1834 8.37871 15.7929L14.1716 10H1.08582C0.533531 10 0.0858154 9.55229 0.0858154 9C0.0858154 8.44772 0.533531 8 1.08582 8H14.1716L8.37871 2.20711C7.98818 1.81658 7.98818 1.18342 8.37871 0.792893Z",
      fill: "currentColor"
    }));
  },
  youtube: function youtube(_ref73) {
    var className = _ref73.className,
      id = _ref73.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.8381 1.19993C21.1788 1.56336 21.4207 2.01339 21.5395 2.50456C21.8567 4.32469 22.0106 6.17127 21.9994 8.02073C22.0058 9.84255 21.8518 11.6612 21.5395 13.4541C21.4207 13.9453 21.1788 14.3953 20.8381 14.7587C20.4975 15.1222 20.0703 15.3861 19.5996 15.524C17.8796 16 11 16 11 16C11 16 4.12036 16 2.40045 15.524C1.93929 15.3934 1.51847 15.1419 1.17865 14.7938C0.838835 14.4457 0.5915 14.0128 0.460548 13.5369C0.143332 11.7168 -0.0106485 9.87019 0.000571615 8.02073C-0.008192 6.18509 0.145779 4.35248 0.460548 2.54596C0.57933 2.05479 0.821245 1.60476 1.16186 1.24133C1.50247 0.877899 1.92972 0.613935 2.40045 0.476098C4.12036 3.05176e-05 11 3.05176e-05 11 3.05176e-05C11 3.05176e-05 17.8796 3.05176e-05 19.5996 0.434701C20.0703 0.572537 20.4975 0.836502 20.8381 1.19993ZM14.4998 8.02071L8.75012 11.4049V4.63649L14.4998 8.02071Z",
      fill: "currentColor"
    }));
  },
  whitepaper: function whitepaper(_ref74) {
    var className = _ref74.className,
      id = _ref74.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 22 18"
    }, React.createElement("path", {
      d: "M19.8832 0.790288C17.8655 0.900342 13.8668 1.30387 11.409 2.80795C11.2255 2.91801 11.1155 3.10143 11.1155 3.28485V16.6381C11.1155 17.0783 11.5924 17.3351 11.9959 17.1517C14.5272 15.8677 18.1957 15.5009 19.9932 15.4275C20.6168 15.3908 21.0938 14.8772 21.0938 14.2903V1.89083C21.1304 1.26719 20.5435 0.753603 19.8832 0.790288ZM9.68478 2.80795C7.2269 1.30387 3.22826 0.900342 1.2106 0.790288C0.550272 0.753603 0 1.26719 0 1.89083V14.2903C0 14.8772 0.476902 15.3908 1.10054 15.4275C2.8981 15.5009 6.56658 15.8677 9.09783 17.1517C9.50136 17.3351 9.97826 17.0783 9.97826 16.6381V3.28485C9.97826 3.10143 9.86821 2.91801 9.68478 2.80795Z",
      fill: "currentColor"
    }));
  },
  calendar: function calendar(_ref75) {
    var className = _ref75.className,
      id = _ref75.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 15 16"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.29 0.999886C11.29 0.447601 10.8423 -0.000114441 10.29 -0.000114441C9.73769 -0.000114441 9.28998 0.447601 9.28998 0.999886V1.40028H5.69V0.999886C5.69 0.447601 5.24229 -0.000114441 4.69 -0.000114441C4.13772 -0.000114441 3.69 0.447601 3.69 0.999886V1.40028H2.59005C1.26457 1.40028 0.190063 2.47478 0.190063 3.80026V13.6001C0.190063 14.9256 1.26457 16.0001 2.59005 16.0001H12.3899C13.7154 16.0001 14.7899 14.9256 14.7899 13.6001V3.80026C14.7899 2.47478 13.7154 1.40028 12.3899 1.40028H11.29V0.999886ZM12.7899 5.59949V3.80026C12.7899 3.57935 12.6108 3.40028 12.3899 3.40028H11.29V3.79985C11.29 4.35213 10.8423 4.79985 10.29 4.79985C9.73769 4.79985 9.28998 4.35213 9.28998 3.79985V3.40028H5.69V3.79985C5.69 4.35213 5.24229 4.79985 4.69 4.79985C4.13772 4.79985 3.69 4.35213 3.69 3.79985V3.40028H2.59005C2.36914 3.40028 2.19006 3.57935 2.19006 3.80026V5.59949H12.7899ZM2.19006 7.59949H12.7899V13.6001C12.7899 13.821 12.6108 14.0001 12.3899 14.0001H2.59005C2.36914 14.0001 2.19006 13.821 2.19006 13.6001V7.59949Z",
      fill: "currentColor"
    }));
  },
  chart: function chart(_ref76) {
    var className = _ref76.className,
      id = _ref76.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 19 24"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.524 8.25C18.0763 8.25 18.524 8.69771 18.524 9.25V23C18.524 23.5523 18.0763 24 17.524 24C16.9718 24 16.524 23.5523 16.524 23V9.25C16.524 8.69771 16.9718 8.25 17.524 8.25Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.52405 0C10.0763 0 10.524 0.447715 10.524 1V23C10.524 23.5523 10.0763 24 9.52405 24C8.97176 24 8.52405 23.5523 8.52405 23V1C8.52405 0.447715 8.97176 0 9.52405 0Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M1.52405 13.75C2.07633 13.75 2.52405 14.1977 2.52405 14.75V23C2.52405 23.5523 2.07633 24 1.52405 24C0.971763 24 0.524048 23.5523 0.524048 23V14.75C0.524048 14.1977 0.971763 13.75 1.52405 13.75Z",
      fill: "currentColor"
    }));
  },
  tick: function tick(_ref77) {
    var className = _ref77.className,
      id = _ref77.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 12"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.3751 0.835801C15.7656 1.22633 15.7656 1.85949 15.3751 2.25001L6.16797 11.4571L0.460862 5.75001C0.0703377 5.35949 0.0703377 4.72633 0.460862 4.3358C0.851386 3.94528 1.48455 3.94528 1.87508 4.3358L6.16797 8.62869L13.9609 0.835801C14.3514 0.445277 14.9846 0.445277 15.3751 0.835801Z",
      fill: "currentColor"
    }));
  },
  signout: function signout(_ref78) {
    var className = _ref78.className,
      id = _ref78.id;
    return React.createElement("svg", {
      role: "media",
      id: id,
      "data-testid": id,
      className: className,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 20 20"
    }, React.createElement("path", {
      d: "M11.9459 0.646161C11.1238 -0.215387 9.7908 -0.215387 8.96865 0.646161L6.7094 3.01367C6.29833 3.44444 6.29833 4.14287 6.7094 4.57364C7.12048 5.00441 7.78696 5.00441 8.19804 4.57364L10.4573 2.20613L17.8948 10L10.4573 17.7939L8.19804 15.4264C7.78696 14.9956 7.12048 14.9956 6.7094 15.4264C6.29833 15.8571 6.29833 16.5556 6.7094 16.9863L8.96865 19.3538C9.7908 20.2154 11.1238 20.2154 11.9459 19.3538L19.3834 11.56C20.2055 10.6984 20.2055 9.30158 19.3834 8.44003L11.9459 0.646161Z",
      fill: "currentColor"
    }), React.createElement("path", {
      d: "M3.71968 13.9424C4.13076 14.3732 4.79725 14.3732 5.20832 13.9424C5.6194 13.5116 5.6194 12.8132 5.20832 12.3824L4.0299 11.1475H11.0098C11.5912 11.1475 12.0624 10.6537 12.0624 10.0445C12.0624 9.43525 11.5912 8.94139 11.0098 8.94139H4.0299L5.20832 7.7065C5.6194 7.27573 5.6194 6.5773 5.20832 6.14653C4.79724 5.71575 4.13076 5.71575 3.71968 6.14653L0 10.0445L3.71968 13.9424Z",
      fill: "currentColor"
    }));
  },
  'outline-plus': function outlinePlus(_ref79) {
    var className = _ref79.className,
      id = _ref79.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "18",
      height: "18",
      viewBox: "0 0 18 18",
      fill: "none"
    }, React.createElement("path", {
      d: "M9 5C9.55229 5 10 5.44772 10 6V8H12C12.5523 8 13 8.44771 13 9C13 9.55229 12.5523 10 12 10H10V12C10 12.5523 9.55229 13 9 13C8.44771 13 8 12.5523 8 12V10H6C5.44772 10 5 9.55228 5 9C5 8.44771 5.44772 8 6 8H8V6C8 5.44772 8.44771 5 9 5Z",
      fill: "currentColor"
    }), React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9ZM9 2C5.13401 2 2 5.13401 2 9C2 12.866 5.13401 16 9 16C12.866 16 16 12.866 16 9C16 5.13401 12.866 2 9 2Z",
      fill: "currentColor"
    }));
  },
  'new-user': function newUser(_ref80) {
    var className = _ref80.className,
      id = _ref80.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      width: "54",
      height: "54",
      viewBox: "0 0 54 54",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("g", {
      id: "Group 229171"
    }, React.createElement("circle", {
      id: "Ellipse 121",
      cx: "27",
      cy: "14",
      r: "13",
      stroke: "white",
      strokeWidth: "2"
    }), React.createElement("path", {
      id: "Ellipse 122",
      d: "M53 53C53 38.6406 41.3594 27 27 27C12.6406 27 1 38.6406 1 53",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round"
    })));
  },
  shield: function shield(_ref81) {
    var className = _ref81.className,
      id = _ref81.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "42",
      height: "55",
      viewBox: "0 0 42 55",
      fill: "none"
    }, React.createElement("path", {
      d: "M1 6.0473C1 5.07041 1.70571 4.23646 2.66914 4.07485L20.6691 1.0555C20.8882 1.01876 21.1118 1.01876 21.3309 1.0555L39.3309 4.07485C40.2943 4.23646 41 5.07041 41 6.0473V34.1084C41 39.3338 38.0899 44.1243 33.4526 46.5327L21 53L8.54738 46.5327C3.91008 44.1243 1 39.3338 1 34.1084V6.0473Z",
      stroke: "white",
      strokeWidth: "2"
    }));
  },
  'new-present': function newPresent(_ref82) {
    var className = _ref82.className,
      id = _ref82.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "54",
      height: "54",
      viewBox: "0 0 54 54",
      fill: "none"
    }, React.createElement("path", {
      d: "M27 14H38.7C40.4239 14 42.0772 13.3152 43.2962 12.0962C44.5152 10.8772 45.2 9.22391 45.2 7.5C45.2 5.77609 44.5152 4.12279 43.2962 2.90381C42.0772 1.68482 40.4239 1 38.7 1C29.6 1 27 14 27 14Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M27 14H15.3C13.5761 14 11.9228 13.3152 10.7039 12.0962C9.48487 10.8772 8.80005 9.22391 8.80005 7.5C8.80005 5.77609 9.48487 4.12279 10.7039 2.90381C11.9228 1.68482 13.5761 1 15.3 1C24.4 1 27 14 27 14Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M27 53V14",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M53 14H1V27H53V14Z",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), React.createElement("path", {
      d: "M47.7999 27V53H6.19995V27",
      stroke: "#F3EEFC",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'new-wallet': function newWallet(_ref83) {
    var className = _ref83.className,
      id = _ref83.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      width: "54",
      height: "54",
      viewBox: "0 0 54 54",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9 2C5.13401 2 2 5.13401 2 9V10H51C52.6569 10 54 11.3431 54 13V45C54 49.9706 49.9706 54 45 54H3C1.34315 54 0 52.6569 0 51V9C0 4.02944 4.02944 0 9 0H43C43.5523 0 44 0.447715 44 1C44 1.55228 43.5523 2 43 2H9ZM2 12V51C2 51.5523 2.44772 52 3 52H45C48.5265 52 51.4439 49.3923 51.9291 46H23C21.3431 46 20 44.6569 20 43V35C20 33.3431 21.3431 32 23 32H52V13C52 12.4477 51.5523 12 51 12H2ZM52 34H23C22.4477 34 22 34.4477 22 35V43C22 43.5523 22.4477 44 23 44H52V34Z",
      fill: "white"
    }), React.createElement("path", {
      d: "M29 39C29 40.1046 28.1046 41 27 41C25.8954 41 25 40.1046 25 39C25 37.8954 25.8954 37 27 37C28.1046 37 29 37.8954 29 39Z",
      fill: "white"
    }));
  },
  'climate-plant': function climatePlant(_ref84) {
    var className = _ref84.className,
      id = _ref84.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none"
    }, React.createElement("path", {
      d: "M1.66666 17.5013C1.66666 15.0013 3.20833 13.0346 5.9 12.5013C7.91666 12.1013 10 10.8346 10.8333 10.0013M9.16666 16.668C7.70338 16.6724 6.29187 16.1267 5.21209 15.1391C4.13232 14.1516 3.46314 12.7943 3.33728 11.3364C3.21142 9.87853 3.63807 8.4266 4.53262 7.26859C5.42717 6.11057 6.72427 5.33105 8.16666 5.08464C12.9167 4.16797 14.1667 3.73464 15.8333 1.66797C16.6667 3.33464 17.5 5.1513 17.5 8.33464C17.5 12.918 13.5167 16.668 9.16666 16.668Z",
      stroke: "#A18CC0",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  },
  'play-video': function playVideo(_ref85) {
    var className = _ref85.className,
      id = _ref85.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      width: "152",
      height: "60",
      viewBox: "0 0 152 60",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("g", {
      filter: "url(#filter0_d_10497_42930)"
    }, React.createElement("rect", {
      x: "8",
      y: "4",
      width: "136",
      height: "44",
      rx: "8",
      fill: "#F3EEFC",
      fillOpacity: "0.6",
      shapeRendering: "crispEdges"
    }), React.createElement("rect", {
      x: "8.5",
      y: "4.5",
      width: "135",
      height: "43",
      rx: "7.5",
      stroke: "#5F4983",
      strokeOpacity: "0.16",
      shapeRendering: "crispEdges"
    })), React.createElement("path", {
      d: "M39 26L28 32L28 20L39 26Z",
      fill: "#110622"
    }), React.createElement("path", {
      d: "M56.5156 26.5391H53.4766V25.3125H56.5156C57.1042 25.3125 57.5807 25.2188 57.9453 25.0312C58.3099 24.8438 58.5755 24.5833 58.7422 24.25C58.9141 23.9167 59 23.5365 59 23.1094C59 22.7188 58.9141 22.3516 58.7422 22.0078C58.5755 21.6641 58.3099 21.388 57.9453 21.1797C57.5807 20.9661 57.1042 20.8594 56.5156 20.8594H53.8281V31H52.3203V19.625H56.5156C57.375 19.625 58.1016 19.7734 58.6953 20.0703C59.2891 20.3672 59.7396 20.7786 60.0469 21.3047C60.3542 21.8255 60.5078 22.4219 60.5078 23.0938C60.5078 23.8229 60.3542 24.4453 60.0469 24.9609C59.7396 25.4766 59.2891 25.8698 58.6953 26.1406C58.1016 26.4062 57.375 26.5391 56.5156 26.5391ZM63.7656 19V31H62.3125V19H63.7656ZM71.0703 29.5547V25.2031C71.0703 24.8698 71.0026 24.5807 70.8672 24.3359C70.737 24.0859 70.5391 23.8932 70.2734 23.7578C70.0078 23.6224 69.6797 23.5547 69.2891 23.5547C68.9245 23.5547 68.6042 23.6172 68.3281 23.7422C68.0573 23.8672 67.8438 24.0312 67.6875 24.2344C67.5365 24.4375 67.4609 24.6562 67.4609 24.8906H66.0156C66.0156 24.5885 66.0938 24.2891 66.25 23.9922C66.4062 23.6953 66.6302 23.4271 66.9219 23.1875C67.2188 22.9427 67.5729 22.75 67.9844 22.6094C68.401 22.4635 68.8646 22.3906 69.375 22.3906C69.9896 22.3906 70.5312 22.4948 71 22.7031C71.474 22.9115 71.8438 23.2266 72.1094 23.6484C72.3802 24.0651 72.5156 24.5885 72.5156 25.2188V29.1562C72.5156 29.4375 72.5391 29.737 72.5859 30.0547C72.638 30.3724 72.7135 30.6458 72.8125 30.875V31H71.3047C71.2318 30.8333 71.1745 30.612 71.1328 30.3359C71.0911 30.0547 71.0703 29.7943 71.0703 29.5547ZM71.3203 25.875L71.3359 26.8906H69.875C69.4635 26.8906 69.0964 26.9245 68.7734 26.9922C68.4505 27.0547 68.1797 27.151 67.9609 27.2812C67.7422 27.4115 67.5755 27.5755 67.4609 27.7734C67.3464 27.9661 67.2891 28.1927 67.2891 28.4531C67.2891 28.7188 67.349 28.9609 67.4688 29.1797C67.5885 29.3984 67.7682 29.5729 68.0078 29.7031C68.2526 29.8281 68.5521 29.8906 68.9062 29.8906C69.349 29.8906 69.7396 29.7969 70.0781 29.6094C70.4167 29.4219 70.6849 29.1927 70.8828 28.9219C71.0859 28.651 71.1953 28.388 71.2109 28.1328L71.8281 28.8281C71.7917 29.0469 71.6927 29.2891 71.5312 29.5547C71.3698 29.8203 71.1536 30.0755 70.8828 30.3203C70.6172 30.5599 70.2995 30.7604 69.9297 30.9219C69.5651 31.0781 69.1536 31.1562 68.6953 31.1562C68.1224 31.1562 67.6198 31.0443 67.1875 30.8203C66.7604 30.5964 66.4271 30.2969 66.1875 29.9219C65.9531 29.5417 65.8359 29.1172 65.8359 28.6484C65.8359 28.1953 65.9245 27.7969 66.1016 27.4531C66.2786 27.1042 66.5339 26.8151 66.8672 26.5859C67.2005 26.3516 67.6016 26.1745 68.0703 26.0547C68.5391 25.9349 69.0625 25.875 69.6406 25.875H71.3203ZM77.0391 30.125L79.3906 22.5469H80.9375L77.5469 32.3047C77.4688 32.513 77.3646 32.737 77.2344 32.9766C77.1094 33.2214 76.9479 33.4531 76.75 33.6719C76.5521 33.8906 76.3125 34.0677 76.0312 34.2031C75.7552 34.3438 75.4245 34.4141 75.0391 34.4141C74.9245 34.4141 74.7786 34.3984 74.6016 34.3672C74.4245 34.3359 74.2995 34.3099 74.2266 34.2891L74.2188 33.1172C74.2604 33.1224 74.3255 33.1276 74.4141 33.1328C74.5078 33.1432 74.5729 33.1484 74.6094 33.1484C74.9375 33.1484 75.2161 33.1042 75.4453 33.0156C75.6745 32.9323 75.8672 32.7891 76.0234 32.5859C76.1849 32.388 76.3229 32.1146 76.4375 31.7656L77.0391 30.125ZM75.3125 22.5469L77.5078 29.1094L77.8828 30.6328L76.8438 31.1641L73.7344 22.5469H75.3125ZM88.7812 29.6953L91.0938 22.5469H92.5703L89.5312 31H88.5625L88.7812 29.6953ZM86.8516 22.5469L89.2344 29.7344L89.3984 31H88.4297L85.3672 22.5469H86.8516ZM95.5312 22.5469V31H94.0781V22.5469H95.5312ZM93.9688 20.3047C93.9688 20.0703 94.0391 19.8724 94.1797 19.7109C94.3255 19.5495 94.5391 19.4688 94.8203 19.4688C95.0964 19.4688 95.3073 19.5495 95.4531 19.7109C95.6042 19.8724 95.6797 20.0703 95.6797 20.3047C95.6797 20.5286 95.6042 20.7214 95.4531 20.8828C95.3073 21.0391 95.0964 21.1172 94.8203 21.1172C94.5391 21.1172 94.3255 21.0391 94.1797 20.8828C94.0391 20.7214 93.9688 20.5286 93.9688 20.3047ZM103.18 29.3594V19H104.633V31H103.305L103.18 29.3594ZM97.4922 26.8672V26.7031C97.4922 26.0573 97.5703 25.4714 97.7266 24.9453C97.888 24.4141 98.1146 23.9583 98.4062 23.5781C98.7031 23.1979 99.0547 22.9062 99.4609 22.7031C99.8724 22.4948 100.331 22.3906 100.836 22.3906C101.367 22.3906 101.831 22.4844 102.227 22.6719C102.628 22.8542 102.966 23.1224 103.242 23.4766C103.523 23.8255 103.745 24.2474 103.906 24.7422C104.068 25.237 104.18 25.7969 104.242 26.4219V27.1406C104.185 27.7604 104.073 28.3177 103.906 28.8125C103.745 29.3073 103.523 29.7292 103.242 30.0781C102.966 30.4271 102.628 30.6953 102.227 30.8828C101.826 31.0651 101.357 31.1562 100.82 31.1562C100.326 31.1562 99.8724 31.0495 99.4609 30.8359C99.0547 30.6224 98.7031 30.3229 98.4062 29.9375C98.1146 29.5521 97.888 29.099 97.7266 28.5781C97.5703 28.0521 97.4922 27.4818 97.4922 26.8672ZM98.9453 26.7031V26.8672C98.9453 27.2891 98.987 27.6849 99.0703 28.0547C99.1589 28.4245 99.2943 28.75 99.4766 29.0312C99.6589 29.3125 99.8906 29.5339 100.172 29.6953C100.453 29.8516 100.789 29.9297 101.18 29.9297C101.659 29.9297 102.052 29.8281 102.359 29.625C102.672 29.4219 102.922 29.1536 103.109 28.8203C103.297 28.487 103.443 28.125 103.547 27.7344V25.8516C103.484 25.5651 103.393 25.2891 103.273 25.0234C103.159 24.7526 103.008 24.513 102.82 24.3047C102.638 24.0911 102.411 23.9219 102.141 23.7969C101.875 23.6719 101.56 23.6094 101.195 23.6094C100.799 23.6094 100.458 23.6927 100.172 23.8594C99.8906 24.0208 99.6589 24.2448 99.4766 24.5312C99.2943 24.8125 99.1589 25.1406 99.0703 25.5156C98.987 25.8854 98.9453 26.2812 98.9453 26.7031ZM110.391 31.1562C109.802 31.1562 109.268 31.0573 108.789 30.8594C108.315 30.6562 107.906 30.3724 107.562 30.0078C107.224 29.6432 106.964 29.2109 106.781 28.7109C106.599 28.2109 106.508 27.6641 106.508 27.0703V26.7422C106.508 26.0547 106.609 25.4427 106.812 24.9062C107.016 24.3646 107.292 23.9062 107.641 23.5312C107.99 23.1562 108.385 22.8724 108.828 22.6797C109.271 22.487 109.729 22.3906 110.203 22.3906C110.807 22.3906 111.328 22.4948 111.766 22.7031C112.208 22.9115 112.57 23.2031 112.852 23.5781C113.133 23.9479 113.341 24.3854 113.477 24.8906C113.612 25.3906 113.68 25.9375 113.68 26.5312V27.1797H107.367V26H112.234V25.8906C112.214 25.5156 112.135 25.151 112 24.7969C111.87 24.4427 111.661 24.151 111.375 23.9219C111.089 23.6927 110.698 23.5781 110.203 23.5781C109.875 23.5781 109.573 23.6484 109.297 23.7891C109.021 23.9245 108.784 24.1276 108.586 24.3984C108.388 24.6693 108.234 25 108.125 25.3906C108.016 25.7812 107.961 26.2318 107.961 26.7422V27.0703C107.961 27.4714 108.016 27.849 108.125 28.2031C108.24 28.5521 108.404 28.8594 108.617 29.125C108.836 29.3906 109.099 29.599 109.406 29.75C109.719 29.901 110.073 29.9766 110.469 29.9766C110.979 29.9766 111.411 29.8724 111.766 29.6641C112.12 29.4557 112.43 29.1771 112.695 28.8281L113.57 29.5234C113.388 29.7995 113.156 30.0625 112.875 30.3125C112.594 30.5625 112.247 30.7656 111.836 30.9219C111.43 31.0781 110.948 31.1562 110.391 31.1562ZM114.984 26.8672V26.6875C114.984 26.0781 115.073 25.513 115.25 24.9922C115.427 24.4661 115.682 24.0104 116.016 23.625C116.349 23.2344 116.753 22.9323 117.227 22.7188C117.701 22.5 118.232 22.3906 118.82 22.3906C119.414 22.3906 119.948 22.5 120.422 22.7188C120.901 22.9323 121.307 23.2344 121.641 23.625C121.979 24.0104 122.237 24.4661 122.414 24.9922C122.591 25.513 122.68 26.0781 122.68 26.6875V26.8672C122.68 27.4766 122.591 28.0417 122.414 28.5625C122.237 29.0833 121.979 29.5391 121.641 29.9297C121.307 30.3151 120.904 30.6172 120.43 30.8359C119.961 31.0495 119.43 31.1562 118.836 31.1562C118.242 31.1562 117.708 31.0495 117.234 30.8359C116.76 30.6172 116.354 30.3151 116.016 29.9297C115.682 29.5391 115.427 29.0833 115.25 28.5625C115.073 28.0417 114.984 27.4766 114.984 26.8672ZM116.43 26.6875V26.8672C116.43 27.2891 116.479 27.6875 116.578 28.0625C116.677 28.4323 116.826 28.7604 117.023 29.0469C117.227 29.3333 117.479 29.5599 117.781 29.7266C118.083 29.888 118.435 29.9688 118.836 29.9688C119.232 29.9688 119.578 29.888 119.875 29.7266C120.177 29.5599 120.427 29.3333 120.625 29.0469C120.823 28.7604 120.971 28.4323 121.07 28.0625C121.174 27.6875 121.227 27.2891 121.227 26.8672V26.6875C121.227 26.2708 121.174 25.8776 121.07 25.5078C120.971 25.1328 120.82 24.8021 120.617 24.5156C120.419 24.224 120.169 23.9948 119.867 23.8281C119.57 23.6615 119.221 23.5781 118.82 23.5781C118.424 23.5781 118.076 23.6615 117.773 23.8281C117.477 23.9948 117.227 24.224 117.023 24.5156C116.826 24.8021 116.677 25.1328 116.578 25.5078C116.479 25.8776 116.43 26.2708 116.43 26.6875Z",
      fill: "#110622"
    }), React.createElement("defs", null, React.createElement("filter", {
      id: "filter0_d_10497_42930",
      x: "0",
      y: "0",
      width: "152",
      height: "60",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    }, React.createElement("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), React.createElement("feColorMatrix", {
      "in": "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }), React.createElement("feOffset", {
      dy: "4"
    }), React.createElement("feGaussianBlur", {
      stdDeviation: "4"
    }), React.createElement("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }), React.createElement("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.0666667 0 0 0 0 0.0235294 0 0 0 0 0.133333 0 0 0 0.12 0"
    }), React.createElement("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_10497_42930"
    }), React.createElement("feBlend", {
      mode: "normal",
      "in": "SourceGraphic",
      in2: "effect1_dropShadow_10497_42930",
      result: "shape"
    }))));
  },
  'stop-video': function stopVideo(_ref86) {
    var className = _ref86.className,
      id = _ref86.id;
    return React.createElement("svg", {
      id: id,
      "data-testid": id,
      className: className,
      xmlns: "http://www.w3.org/2000/svg",
      width: "152",
      height: "60",
      viewBox: "0 0 152 60",
      fill: "none"
    }, React.createElement("g", {
      filter: "url(#filter0_d_12765_50627)"
    }, React.createElement("rect", {
      x: "8",
      y: "4",
      width: "136",
      height: "44",
      rx: "8",
      fill: "#F3EEFC",
      fillOpacity: "0.6",
      shapeRendering: "crispEdges"
    }), React.createElement("rect", {
      x: "8.5",
      y: "4.5",
      width: "135",
      height: "43",
      rx: "7.5",
      stroke: "#5F4983",
      strokeOpacity: "0.16",
      shapeRendering: "crispEdges"
    })), React.createElement("path", {
      d: "M58.3828 28.125C58.3828 27.8594 58.3411 27.625 58.2578 27.4219C58.1797 27.2135 58.0391 27.026 57.8359 26.8594C57.638 26.6927 57.362 26.5339 57.0078 26.3828C56.6589 26.2318 56.2161 26.0781 55.6797 25.9219C55.1172 25.7552 54.6094 25.5703 54.1562 25.3672C53.7031 25.1589 53.3151 24.9219 52.9922 24.6562C52.6693 24.3906 52.4219 24.0859 52.25 23.7422C52.0781 23.3984 51.9922 23.0052 51.9922 22.5625C51.9922 22.1198 52.0833 21.7109 52.2656 21.3359C52.4479 20.9609 52.7083 20.6354 53.0469 20.3594C53.3906 20.0781 53.7995 19.8594 54.2734 19.7031C54.7474 19.5469 55.276 19.4688 55.8594 19.4688C56.7135 19.4688 57.4375 19.6328 58.0312 19.9609C58.6302 20.2839 59.0859 20.7083 59.3984 21.2344C59.7109 21.7552 59.8672 22.3125 59.8672 22.9062H58.3672C58.3672 22.4792 58.276 22.1016 58.0938 21.7734C57.9115 21.4401 57.6354 21.1797 57.2656 20.9922C56.8958 20.7995 56.4271 20.7031 55.8594 20.7031C55.3229 20.7031 54.8802 20.7839 54.5312 20.9453C54.1823 21.1068 53.9219 21.3255 53.75 21.6016C53.5833 21.8776 53.5 22.1927 53.5 22.5469C53.5 22.7865 53.5495 23.0052 53.6484 23.2031C53.7526 23.3958 53.9115 23.5755 54.125 23.7422C54.3438 23.9089 54.6198 24.0625 54.9531 24.2031C55.2917 24.3438 55.6953 24.4792 56.1641 24.6094C56.8099 24.7917 57.3672 24.9948 57.8359 25.2188C58.3047 25.4427 58.6901 25.6953 58.9922 25.9766C59.2995 26.2526 59.526 26.5677 59.6719 26.9219C59.8229 27.2708 59.8984 27.6667 59.8984 28.1094C59.8984 28.5729 59.8047 28.9922 59.6172 29.3672C59.4297 29.7422 59.1615 30.0625 58.8125 30.3281C58.4635 30.5938 58.0443 30.7995 57.5547 30.9453C57.0703 31.0859 56.5286 31.1562 55.9297 31.1562C55.4036 31.1562 54.8854 31.0833 54.375 30.9375C53.8698 30.7917 53.4089 30.5729 52.9922 30.2812C52.5807 29.9896 52.25 29.6302 52 29.2031C51.7552 28.7708 51.6328 28.2708 51.6328 27.7031H53.1328C53.1328 28.0938 53.2083 28.4297 53.3594 28.7109C53.5104 28.987 53.7161 29.2161 53.9766 29.3984C54.2422 29.5807 54.5417 29.7161 54.875 29.8047C55.2135 29.888 55.5651 29.9297 55.9297 29.9297C56.4557 29.9297 56.901 29.8568 57.2656 29.7109C57.6302 29.5651 57.9062 29.3568 58.0938 29.0859C58.2865 28.8151 58.3828 28.4948 58.3828 28.125ZM65.1406 22.5469V23.6562H60.5703V22.5469H65.1406ZM62.1172 20.4922H63.5625V28.9062C63.5625 29.1927 63.6068 29.4089 63.6953 29.5547C63.7839 29.7005 63.8984 29.7969 64.0391 29.8438C64.1797 29.8906 64.3307 29.9141 64.4922 29.9141C64.612 29.9141 64.737 29.9036 64.8672 29.8828C65.0026 29.8568 65.1042 29.8359 65.1719 29.8203L65.1797 31C65.0651 31.0365 64.9141 31.0703 64.7266 31.1016C64.5443 31.138 64.3229 31.1562 64.0625 31.1562C63.7083 31.1562 63.3828 31.0859 63.0859 30.9453C62.7891 30.8047 62.5521 30.5703 62.375 30.2422C62.2031 29.9089 62.1172 29.4609 62.1172 28.8984V20.4922ZM66.2969 26.8672V26.6875C66.2969 26.0781 66.3854 25.513 66.5625 24.9922C66.7396 24.4661 66.9948 24.0104 67.3281 23.625C67.6615 23.2344 68.0651 22.9323 68.5391 22.7188C69.013 22.5 69.5443 22.3906 70.1328 22.3906C70.7266 22.3906 71.2604 22.5 71.7344 22.7188C72.2135 22.9323 72.6198 23.2344 72.9531 23.625C73.2917 24.0104 73.5495 24.4661 73.7266 24.9922C73.9036 25.513 73.9922 26.0781 73.9922 26.6875V26.8672C73.9922 27.4766 73.9036 28.0417 73.7266 28.5625C73.5495 29.0833 73.2917 29.5391 72.9531 29.9297C72.6198 30.3151 72.2161 30.6172 71.7422 30.8359C71.2734 31.0495 70.7422 31.1562 70.1484 31.1562C69.5547 31.1562 69.0208 31.0495 68.5469 30.8359C68.0729 30.6172 67.6667 30.3151 67.3281 29.9297C66.9948 29.5391 66.7396 29.0833 66.5625 28.5625C66.3854 28.0417 66.2969 27.4766 66.2969 26.8672ZM67.7422 26.6875V26.8672C67.7422 27.2891 67.7917 27.6875 67.8906 28.0625C67.9896 28.4323 68.138 28.7604 68.3359 29.0469C68.5391 29.3333 68.7917 29.5599 69.0938 29.7266C69.3958 29.888 69.7474 29.9688 70.1484 29.9688C70.5443 29.9688 70.8906 29.888 71.1875 29.7266C71.4896 29.5599 71.7396 29.3333 71.9375 29.0469C72.1354 28.7604 72.2839 28.4323 72.3828 28.0625C72.487 27.6875 72.5391 27.2891 72.5391 26.8672V26.6875C72.5391 26.2708 72.487 25.8776 72.3828 25.5078C72.2839 25.1328 72.1328 24.8021 71.9297 24.5156C71.7318 24.224 71.4818 23.9948 71.1797 23.8281C70.8828 23.6615 70.5339 23.5781 70.1328 23.5781C69.737 23.5781 69.388 23.6615 69.0859 23.8281C68.7891 23.9948 68.5391 24.224 68.3359 24.5156C68.138 24.8021 67.9896 25.1328 67.8906 25.5078C67.7917 25.8776 67.7422 26.2708 67.7422 26.6875ZM77.25 24.1719V34.25H75.7969V22.5469H77.125L77.25 24.1719ZM82.9453 26.7031V26.8672C82.9453 27.4818 82.8724 28.0521 82.7266 28.5781C82.5807 29.099 82.3672 29.5521 82.0859 29.9375C81.8099 30.3229 81.4688 30.6224 81.0625 30.8359C80.6562 31.0495 80.1901 31.1562 79.6641 31.1562C79.1276 31.1562 78.6536 31.0677 78.2422 30.8906C77.8307 30.7135 77.4818 30.4557 77.1953 30.1172C76.9089 29.7786 76.6797 29.3724 76.5078 28.8984C76.3411 28.4245 76.2266 27.8906 76.1641 27.2969V26.4219C76.2266 25.7969 76.3438 25.237 76.5156 24.7422C76.6875 24.2474 76.9141 23.8255 77.1953 23.4766C77.4818 23.1224 77.8281 22.8542 78.2344 22.6719C78.6406 22.4844 79.1094 22.3906 79.6406 22.3906C80.1719 22.3906 80.6432 22.4948 81.0547 22.7031C81.4661 22.9062 81.8125 23.1979 82.0938 23.5781C82.375 23.9583 82.5859 24.4141 82.7266 24.9453C82.8724 25.4714 82.9453 26.0573 82.9453 26.7031ZM81.4922 26.8672V26.7031C81.4922 26.2812 81.4479 25.8854 81.3594 25.5156C81.2708 25.1406 81.1328 24.8125 80.9453 24.5312C80.763 24.2448 80.5286 24.0208 80.2422 23.8594C79.9557 23.6927 79.6146 23.6094 79.2188 23.6094C78.8542 23.6094 78.5365 23.6719 78.2656 23.7969C78 23.9219 77.7734 24.0911 77.5859 24.3047C77.3984 24.513 77.2448 24.7526 77.125 25.0234C77.0104 25.2891 76.9245 25.5651 76.8672 25.8516V27.875C76.9714 28.2396 77.1172 28.5833 77.3047 28.9062C77.4922 29.224 77.7422 29.4818 78.0547 29.6797C78.3672 29.8724 78.7604 29.9688 79.2344 29.9688C79.625 29.9688 79.9609 29.888 80.2422 29.7266C80.5286 29.5599 80.763 29.3333 80.9453 29.0469C81.1328 28.7604 81.2708 28.4323 81.3594 28.0625C81.4479 27.6875 81.4922 27.2891 81.4922 26.8672ZM91.3281 29.6953L93.6406 22.5469H95.1172L92.0781 31H91.1094L91.3281 29.6953ZM89.3984 22.5469L91.7812 29.7344L91.9453 31H90.9766L87.9141 22.5469H89.3984ZM98.0781 22.5469V31H96.625V22.5469H98.0781ZM96.5156 20.3047C96.5156 20.0703 96.5859 19.8724 96.7266 19.7109C96.8724 19.5495 97.0859 19.4688 97.3672 19.4688C97.6432 19.4688 97.8542 19.5495 98 19.7109C98.151 19.8724 98.2266 20.0703 98.2266 20.3047C98.2266 20.5286 98.151 20.7214 98 20.8828C97.8542 21.0391 97.6432 21.1172 97.3672 21.1172C97.0859 21.1172 96.8724 21.0391 96.7266 20.8828C96.5859 20.7214 96.5156 20.5286 96.5156 20.3047ZM105.727 29.3594V19H107.18V31H105.852L105.727 29.3594ZM100.039 26.8672V26.7031C100.039 26.0573 100.117 25.4714 100.273 24.9453C100.435 24.4141 100.661 23.9583 100.953 23.5781C101.25 23.1979 101.602 22.9062 102.008 22.7031C102.419 22.4948 102.878 22.3906 103.383 22.3906C103.914 22.3906 104.378 22.4844 104.773 22.6719C105.174 22.8542 105.513 23.1224 105.789 23.4766C106.07 23.8255 106.292 24.2474 106.453 24.7422C106.615 25.237 106.727 25.7969 106.789 26.4219V27.1406C106.732 27.7604 106.62 28.3177 106.453 28.8125C106.292 29.3073 106.07 29.7292 105.789 30.0781C105.513 30.4271 105.174 30.6953 104.773 30.8828C104.372 31.0651 103.904 31.1562 103.367 31.1562C102.872 31.1562 102.419 31.0495 102.008 30.8359C101.602 30.6224 101.25 30.3229 100.953 29.9375C100.661 29.5521 100.435 29.099 100.273 28.5781C100.117 28.0521 100.039 27.4818 100.039 26.8672ZM101.492 26.7031V26.8672C101.492 27.2891 101.534 27.6849 101.617 28.0547C101.706 28.4245 101.841 28.75 102.023 29.0312C102.206 29.3125 102.438 29.5339 102.719 29.6953C103 29.8516 103.336 29.9297 103.727 29.9297C104.206 29.9297 104.599 29.8281 104.906 29.625C105.219 29.4219 105.469 29.1536 105.656 28.8203C105.844 28.487 105.99 28.125 106.094 27.7344V25.8516C106.031 25.5651 105.94 25.2891 105.82 25.0234C105.706 24.7526 105.555 24.513 105.367 24.3047C105.185 24.0911 104.958 23.9219 104.688 23.7969C104.422 23.6719 104.107 23.6094 103.742 23.6094C103.346 23.6094 103.005 23.6927 102.719 23.8594C102.438 24.0208 102.206 24.2448 102.023 24.5312C101.841 24.8125 101.706 25.1406 101.617 25.5156C101.534 25.8854 101.492 26.2812 101.492 26.7031ZM112.938 31.1562C112.349 31.1562 111.815 31.0573 111.336 30.8594C110.862 30.6562 110.453 30.3724 110.109 30.0078C109.771 29.6432 109.51 29.2109 109.328 28.7109C109.146 28.2109 109.055 27.6641 109.055 27.0703V26.7422C109.055 26.0547 109.156 25.4427 109.359 24.9062C109.562 24.3646 109.839 23.9062 110.188 23.5312C110.536 23.1562 110.932 22.8724 111.375 22.6797C111.818 22.487 112.276 22.3906 112.75 22.3906C113.354 22.3906 113.875 22.4948 114.312 22.7031C114.755 22.9115 115.117 23.2031 115.398 23.5781C115.68 23.9479 115.888 24.3854 116.023 24.8906C116.159 25.3906 116.227 25.9375 116.227 26.5312V27.1797H109.914V26H114.781V25.8906C114.76 25.5156 114.682 25.151 114.547 24.7969C114.417 24.4427 114.208 24.151 113.922 23.9219C113.635 23.6927 113.245 23.5781 112.75 23.5781C112.422 23.5781 112.12 23.6484 111.844 23.7891C111.568 23.9245 111.331 24.1276 111.133 24.3984C110.935 24.6693 110.781 25 110.672 25.3906C110.562 25.7812 110.508 26.2318 110.508 26.7422V27.0703C110.508 27.4714 110.562 27.849 110.672 28.2031C110.786 28.5521 110.951 28.8594 111.164 29.125C111.383 29.3906 111.646 29.599 111.953 29.75C112.266 29.901 112.62 29.9766 113.016 29.9766C113.526 29.9766 113.958 29.8724 114.312 29.6641C114.667 29.4557 114.977 29.1771 115.242 28.8281L116.117 29.5234C115.935 29.7995 115.703 30.0625 115.422 30.3125C115.141 30.5625 114.794 30.7656 114.383 30.9219C113.977 31.0781 113.495 31.1562 112.938 31.1562ZM117.531 26.8672V26.6875C117.531 26.0781 117.62 25.513 117.797 24.9922C117.974 24.4661 118.229 24.0104 118.562 23.625C118.896 23.2344 119.299 22.9323 119.773 22.7188C120.247 22.5 120.779 22.3906 121.367 22.3906C121.961 22.3906 122.495 22.5 122.969 22.7188C123.448 22.9323 123.854 23.2344 124.188 23.625C124.526 24.0104 124.784 24.4661 124.961 24.9922C125.138 25.513 125.227 26.0781 125.227 26.6875V26.8672C125.227 27.4766 125.138 28.0417 124.961 28.5625C124.784 29.0833 124.526 29.5391 124.188 29.9297C123.854 30.3151 123.451 30.6172 122.977 30.8359C122.508 31.0495 121.977 31.1562 121.383 31.1562C120.789 31.1562 120.255 31.0495 119.781 30.8359C119.307 30.6172 118.901 30.3151 118.562 29.9297C118.229 29.5391 117.974 29.0833 117.797 28.5625C117.62 28.0417 117.531 27.4766 117.531 26.8672ZM118.977 26.6875V26.8672C118.977 27.2891 119.026 27.6875 119.125 28.0625C119.224 28.4323 119.372 28.7604 119.57 29.0469C119.773 29.3333 120.026 29.5599 120.328 29.7266C120.63 29.888 120.982 29.9688 121.383 29.9688C121.779 29.9688 122.125 29.888 122.422 29.7266C122.724 29.5599 122.974 29.3333 123.172 29.0469C123.37 28.7604 123.518 28.4323 123.617 28.0625C123.721 27.6875 123.773 27.2891 123.773 26.8672V26.6875C123.773 26.2708 123.721 25.8776 123.617 25.5078C123.518 25.1328 123.367 24.8021 123.164 24.5156C122.966 24.224 122.716 23.9948 122.414 23.8281C122.117 23.6615 121.768 23.5781 121.367 23.5781C120.971 23.5781 120.622 23.6615 120.32 23.8281C120.023 23.9948 119.773 24.224 119.57 24.5156C119.372 24.8021 119.224 25.1328 119.125 25.5078C119.026 25.8776 118.977 26.2708 118.977 26.6875Z",
      fill: "#110622"
    }), React.createElement("rect", {
      x: "28",
      y: "20",
      width: "4",
      height: "12",
      fill: "#110622"
    }), React.createElement("rect", {
      x: "36",
      y: "20",
      width: "4",
      height: "12",
      fill: "#110622"
    }), React.createElement("defs", null, React.createElement("filter", {
      id: "filter0_d_12765_50627",
      x: "0",
      y: "0",
      width: "152",
      height: "60",
      filterUnits: "userSpaceOnUse",
      colorInterpolationFilters: "sRGB"
    }, React.createElement("feFlood", {
      floodOpacity: "0",
      result: "BackgroundImageFix"
    }), React.createElement("feColorMatrix", {
      "in": "SourceAlpha",
      type: "matrix",
      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
      result: "hardAlpha"
    }), React.createElement("feOffset", {
      dy: "4"
    }), React.createElement("feGaussianBlur", {
      stdDeviation: "4"
    }), React.createElement("feComposite", {
      in2: "hardAlpha",
      operator: "out"
    }), React.createElement("feColorMatrix", {
      type: "matrix",
      values: "0 0 0 0 0.0666667 0 0 0 0 0.0235294 0 0 0 0 0.133333 0 0 0 0.12 0"
    }), React.createElement("feBlend", {
      mode: "normal",
      in2: "BackgroundImageFix",
      result: "effect1_dropShadow_12765_50627"
    }), React.createElement("feBlend", {
      mode: "normal",
      "in": "SourceGraphic",
      in2: "effect1_dropShadow_12765_50627",
      result: "shape"
    }))));
  }
};

var _excluded$1 = ["className", "size", "variant", "id"];
var Media = function Media(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'text-primary' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 10 : _ref$size,
    variant = _ref.variant,
    id = _ref.id,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$1);
  var Icon = SVGS[variant];
  return React.createElement(Icon, Object.assign({
    id: "" + variant + (id ? "-" + id : ''),
    className: className + " " + (size === 0 ? '' : "h-" + size + " w-" + size)
  }, rest));
};
Media.displayName = 'Media';

var Steps = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'text-primary' : _ref$className,
    children = _ref.children,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'steps-el' : _ref$id,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant;
  return React.createElement(Component, {
    id: id,
    className: [variant === 'primary' ? 'bg-surface-level-two low-border w-[25px] h-[25px]' : '', variant === 'secondary' ? 'bg-gradient-alpha w-5 h-5' : '', variant === 'light' ? 'bg-gradient-alpha-white w-5 h-5' : '', 'flex', 'rounded-full', 'items-center', 'justify-center', 'overflow-hidden', 'pb-[2px]', className].join(' '),
    "data-testid": id,
    ref: ref,
    role: "Steps"
  }, children);
});
Steps.displayName = 'Steps';

function useBreakpoint() {
  var _useState = useState(1200),
    breakpoint = _useState[0],
    setBreakpoint = _useState[1];
  useEffect(function () {
    setBreakpoint(window.innerWidth);
    var calcInnerWidth = function calcInnerWidth() {
      setBreakpoint(window.innerWidth);
    };
    window.addEventListener('resize', calcInnerWidth);
    return function () {
      return window.removeEventListener('resize', calcInnerWidth);
    };
  }, []);
  return breakpoint;
}

var _excluded$2 = ["className"];
function useClasses(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$2);
  return useCallback(function (styles) {
    var classList = [styles.base];
    Object.keys(styles).map(function (key) {
      if (props[key] || props['variant'] === key || props['size'] === key || props['surface'] === key) {
        classList.push(styles[key]);
      }
    });
    classList.push(className);
    return classList.filter(function (l) {
      return !!l;
    }).join(' ');
  }, [className, props]);
}

function shortenHex(hex, length) {
  if (length === void 0) {
    length = 4;
  }
  return hex.substring(0, length + 2) + "\u2026" + hex.substring(hex.length - length);
}
var useIntitialised = function useIntitialised() {
  var _useState = useState(false),
    initialized = _useState[0],
    setInitalized = _useState[1];
  useEffect(function () {
    setInitalized(true);
  }, [setInitalized]);
  return initialized;
};
var addNewButtonCard = function addNewButtonCard(text, handleAddNew, bg_className) {
  if (bg_className === void 0) {
    bg_className = 'bg-surface-level-two hover:bg-surface-level-three';
  }
  return React.createElement("div", {
    className: "rounded low-border h-[64px] w-full flex items-center p-5 " + bg_className,
    onClick: handleAddNew
  }, React.createElement(Media, {
    variant: "plus",
    size: 0,
    className: "h-[18px] w-[18px] text-primary"
  }), React.createElement(Typography, {
    className: "ml-5",
    allBold: true,
    size: "md"
  }, text));
};

var styles = {
  grid: {
    '12': 'grid grid-cols-12',
    '11': 'grid grid-cols-11',
    '10': 'grid grid-cols-10',
    '9': 'grid grid-cols-9',
    '8': 'grid grid-cols-8',
    '7': 'grid grid-cols-7',
    '6': 'grid grid-cols-6',
    '5': 'grid grid-cols-5',
    '4': 'grid grid-cols-4',
    '3': 'grid grid-cols-3',
    '2': 'grid grid-cols-2',
    '1': 'grid grid-cols-1'
  },
  span: {
    '12': 'col-span-12',
    '11': 'col-span-11',
    '10': 'col-span-10',
    '9': 'col-span-9',
    '8': 'col-span-8',
    '7': 'col-span-7',
    '6': 'col-span-6',
    '5': 'col-span-5',
    '4': 'col-span-4',
    '3': 'col-span-3',
    '2': 'col-span-2',
    '1': 'col-span-1'
  },
  typography: {
    allBold: 'font-bold',
    allCaps: 'uppercase',
    allUnderline: 'underline',
    primary: 'text-primary',
    secondary: 'text-secondary',
    custom: '',
    '4xl': 'text-4xl',
    '3xl': 'text-3xl',
    '2xl': 'text-2xl',
    xl: 'text-xl',
    lg: 'text-lg',
    md: 'text-md',
    sm: 'text-sm',
    xs: 'text-xs'
  }
};

var _excluded$3 = ["as", "children", "className", "id", "allBold", "allCaps", "allUnderline", "size", "variant"];
var Typography = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    Component = _props$as === void 0 ? 'p' : _props$as,
    children = props.children,
    className = props.className,
    id = props.id,
    allBold = props.allBold,
    allCaps = props.allCaps,
    allUnderline = props.allUnderline,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'primary' : _props$variant,
    rest = _objectWithoutPropertiesLoose(props, _excluded$3);
  var classes = useClasses({
    className: className,
    allBold: allBold,
    allCaps: allCaps,
    allUnderline: allUnderline,
    size: size,
    variant: variant
  });
  var _classes = useMemo(function () {
    return classes(styles.typography);
  }, [classes]);
  return React.createElement(Component, Object.assign({
    className: _classes,
    "data-testid": id,
    ref: ref
  }, rest), children);
});
Typography.displayName = 'Typography';

var BreakPoint;
(function (BreakPoint) {
  BreakPoint[BreakPoint["XS"] = 480] = "XS";
  BreakPoint[BreakPoint["SM"] = 768] = "SM";
  BreakPoint[BreakPoint["MD"] = 992] = "MD";
  BreakPoint[BreakPoint["LG"] = 1220] = "LG";
})(BreakPoint || (BreakPoint = {}));
var ContentAlignment;
(function (ContentAlignment) {
  ContentAlignment["Centre"] = "Centre";
  ContentAlignment["Left"] = "Left";
})(ContentAlignment || (ContentAlignment = {}));

var Adjust = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    value = _ref.value,
    setValue = _ref.setValue,
    max = _ref.max,
    _ref$min = _ref.min,
    min = _ref$min === void 0 ? 1 : _ref$min,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'adjust' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: "flex items-center space-x-2 " + className,
    "data-testid": id
  }, React.createElement("button", {
    "data-testid": id + "-minus",
    id: id + "-minus",
    onClick: function onClick() {
      return setValue(Math.max(1, value - 1));
    },
    className: "w-11 h-11 px-3 rounded bg-surface-level-one low-border flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "minus",
    className: "text-primary w-[18px] h-[18px]",
    size: 0
  })), React.createElement("input", {
    "data-testid": "input",
    value: value,
    min: min,
    max: max,
    onChange: function onChange(e) {
      setValue(Number(e.target.value));
    },
    type: "number",
    className: "text-primary text-sm leading-5 font-bold text-center h-[2.875rem] w-full rounded bg-surface-level-one low-border bg-clip-padding outline-none",
    onBlur: function onBlur(e) {
      if (max && Number(e.target.value) < max) {
        setValue(Number(e.target.value));
      }
      if (max && Number(e.target.value) > max) {
        setValue(max);
      }
      if (min && Number(e.target.value) < min) {
        setValue(min);
      }
    }
  }), React.createElement("button", {
    id: id + "-add",
    "data-testid": id + "-add",
    onClick: function onClick() {
      return setValue(Math.min.apply(Math, max ? [value + 1, max] : [value + 1]));
    },
    className: "w-11 h-11 px-3 rounded bg-surface-level-one low-border"
  }, React.createElement(Media, {
    variant: "plus",
    className: "text-primary mx-auto w-[18px] h-[18px]",
    size: 0
  })));
});
Adjust.displayName = 'Adjust';

var _process$env$DECUBATE;
var DECUBATE_UI_THEME = /*#__PURE__*/JSON.parse((_process$env$DECUBATE = process.env.DECUBATE_UI_THEME) != null ? _process$env$DECUBATE : '{}');
var styles$1 = {
  toggle: {
    border_classes: 'disabled:opacity-50 border border-border border-opacity-[0.03] hover:border-opacity-[0.16] disabled:border-opacity-[0.03] focus:border-accent'
  },
  alert: {
    base: 'border gap-4 rounded',
    error: 'border-error bg-transparent',
    warning: 'border-[#CC7E00] bg-transparent',
    note: 'border-secondary bg-transparent'
  },
  avatar: {
    base: 'overflow-hidden relative w-10 h-10 flex items-center justify-center rounded-full',
    primary: 'bg-gradient-alpha',
    secondary: 'bg-gradient-level-one-to-accent',
    light: 'bg-gradient-alpha-white'
  },
  button: {
    base: 'rounded inline-flex items-center justify-center h-11 low-border focus:outline-none',
    padding: 'px-5',
    custom: '',
    fullwidth: 'w-full',
    iconOnly: 'w-11',
    primary: 'font-bold text-button bg-gradient-button',
    secondary: 'text-secondary bg-surface-level-two hover:bg-surface-level-three',
    light: 'text-surface-level-zero bg-primary',
    disabled: 'disabled:opacity-50 pointer-events-none',
    success: 'font-bold text-button bg-success'
  },
  card: {
    base: 'rounded',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    custom: '',
    three: 'bg-surface-level-three',
    border: 'low-border'
  },
  chip: {
    base: 'rounded inline-flex items-center',
    custom: '',
    accent: 'bg-gradient px-5 shadow-accent text-primary high-border text-sm',
    secondary: 'bg-surface-level-two px-3 text-secondary border border-border border-opacity-[0.03] text-sm',
    lighter: 'bg-surface-level-three px-3 text-secondary border border-border border-opacity-[0.03] text-sm',
    purple: 'bg-gradient-purple px-5 shadow-purple text-primary high-border text-sm',
    'purple-gradient-border': 'px-3 shadow-gradient-border-chip text-sm text-primary bg-surface-level-two bg-gradient-surface-one-to-zero',
    green: 'bg-gradient-green px-5 text-primary high-border text-sm',
    yellow: 'bg-gradient-warning px-5 text-primary high-border text-sm',
    orange: 'bg-gradient-orange px-5 text-primary high-border text-sm',
    'surface-two-green': 'px-3 shadow-green border border-success text-sm text-success bg-surface-level-two',
    lg: 'h-11',
    md: 'h-9',
    sm: 'h-8',
    xs: 'h-6'
  },
  input: {
    base: "date-picker block bg-clip-padding h-11 px-5 text-sm rounded font-normal text-primary placeholder-secondary w-full focus:outline-none ",
    border: 'border border-border border-opacity-[0.03] hover:border-opacity-[0.16] focus:border-opacity-[0.16]',
    unclickable: 'pointer-events-none',
    disabled: 'disabled:opacity-[0.6] pointer-events-none low-border',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    three: 'bg-surface-level-three',
    err_border: 'border border-error'
  },
  progress: {
    base: 'overflow-hidden relative w-full',
    zero: 'bg-surface-level-zero',
    one: 'bg-surface-level-one',
    two: 'bg-surface-level-two',
    three: 'bg-surface-level-three',
    rounded: 'rounded-full',
    border: 'bg-clip-padding low-border'
  }
};

// i added this has_icon class because you cant have a p tag inside a p tag and if i have two items flex as the childres I can't style a span so i need to add p tags. So if you want to have a icon or two items you need to style flex as the chidren please use has_icon as true
var Alert = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'alert' : _ref$id,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'error' : _ref$variant,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    has_icon = _ref.has_icon,
    children_classes = _ref.children_classes;
  var classes = useClasses({
    className: className,
    variant: variant
  });
  return React.createElement(Component, {
    className: classes(styles$1.alert) + " " + (title ? 'p-5' : 'px-5 py-3'),
    id: id + "-" + variant,
    "data-testid": id,
    ref: ref
  }, has_icon ? React.createElement(React.Fragment, null, title && React.createElement("div", {
    className: "flex gap-2 items-center mb-4"
  }, React.createElement(Media, {
    variant: variant === 'error' ? 'warning' : 'info',
    className: [variant === 'error' ? 'text-error' : '', variant === 'warning' ? 'text-[#CC7E00]' : '', variant === 'note' ? 'text-secondary' : ''].join(''),
    size: 5
  }), React.createElement(Typography, {
    variant: variant === 'note' ? 'secondary' : 'primary',
    allBold: true,
    size: "sm"
  }, title)), React.createElement("div", {
    className: children_classes
  }, children)) : React.createElement(React.Fragment, null, title && React.createElement("div", {
    className: "flex gap-2 items-center mb-4"
  }, React.createElement(Media, {
    variant: variant === 'error' ? 'warning' : 'info',
    className: [variant === 'error' ? 'text-error' : '', variant === 'warning' ? 'text-[#CC7E00]' : '', variant === 'note' ? 'text-secondary' : ''].join(''),
    size: 5
  }), React.createElement(Typography, {
    variant: variant === 'note' ? 'secondary' : 'primary',
    allBold: true,
    size: "sm"
  }, title)), React.createElement(Typography, {
    className: children_classes,
    "data-testid": "children",
    size: "sm",
    variant: variant === 'note' ? 'secondary' : 'primary'
  }, children)));
});
Alert.displayName = 'Alert';

var _excluded$4 = ["children", "className", "as", "variant"];
var Avatar = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var className = props.className,
    _props$as = props.as,
    Component = _props$as === void 0 ? 'div' : _props$as,
    rest = _objectWithoutPropertiesLoose(props, _excluded$4);
  var classes = useClasses(_extends({
    className: className
  }, props));
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.avatar),
    ref: ref,
    role: "avatar"
  }, rest), React.createElement(Media, {
    size: 5,
    variant: "user",
    className: "text-button"
  }));
});
Avatar.displayName = 'Avatar';

var _excluded$5 = ["children", "className", "disabled", "fullwidth", "href", "id", "iconOnly", "loading", "type", "variant", "padding", "as", "has_icon"];
var Button = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    fullwidth = _ref.fullwidth,
    href = _ref.href,
    id = _ref.id,
    iconOnly = _ref.iconOnly,
    loading = _ref.loading,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'primary' : _ref$variant,
    _ref$padding = _ref.padding,
    padding = _ref$padding === void 0 ? true : _ref$padding,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'button' : _ref$as,
    has_icon = _ref.has_icon,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$5);
  var classes = useClasses({
    className: className,
    disabled: disabled,
    fullwidth: fullwidth,
    iconOnly: iconOnly,
    loading: loading,
    variant: variant,
    padding: padding
  });
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.button),
    "data-testid": id,
    disabled: disabled,
    href: href,
    ref: ref,
    type: type
  }, rest), loading ? React.createElement(Media, {
    className: "text-button",
    size: 5,
    variant: "loader"
  }) : has_icon ? children : React.createElement(Typography, {
    variant: "custom",
    size: "sm"
  }, children));
});
Button.displayName = 'Button';

var _excluded$6 = ["as", "border", "children", "className", "id", "surface", "title"];
var Card = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? true : _ref$border,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    _ref$surface = _ref.surface,
    surface = _ref$surface === void 0 ? 'one' : _ref$surface,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$6);
  var classes = useClasses(_extends({
    className: className,
    surface: surface,
    border: border
  }, rest));
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.card),
    "data-testid": id,
    ref: ref
  }, rest), title && React.createElement(Typography, {
    allBold: true,
    size: "4xl",
    className: "mb-2",
    as: "h1"
  }, title), children);
});
Card.displayName = 'Card';

var ReactApexChart = /*#__PURE__*/React.lazy(function () {
  return import('react-apexcharts');
});
var formatNumberForAxis = function formatNumberForAxis(n) {
  if (n >= 1000000000000) {
    return (n / 1000000000000).toFixed(1) + 'T';
  }
  if (n >= 1000000000) {
    return (n / 1000000000).toFixed(1) + 'B';
  }
  if (n >= 1000000) {
    return (n / 1000000).toFixed(1) + 'M';
  }
  if (n >= 1000) {
    return (n / 1000).toFixed(1) + 'K';
  }
  return n.toFixed(1);
};
var Chart = function Chart(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$colors = _ref.colors,
    colors = _ref$colors === void 0 ? ['#ae1e55'] : _ref$colors,
    data = _ref.data,
    _ref$mode = _ref.mode,
    mode = _ref$mode === void 0 ? 'dark' : _ref$mode,
    _ref$surface = _ref.surface,
    surface = _ref$surface === void 0 ? 'two' : _ref$surface,
    unit = _ref.unit;
  var options = {
    chart: {
      id: 'chart',
      type: 'area',
      zoom: {
        enabled: false
      },
      background: '#00000000'
    },
    theme: {
      mode: mode
    },
    fill: {
      type: 'gradient',
      gradient: {
        type: 'vertical',
        shadeIntensity: 0,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 100]
      }
    },
    stroke: {
      curve: 'straight'
    },
    colors: colors,
    dataLabels: {
      enabled: false
    },
    xaxis: {
      type: 'datetime'
    },
    yaxis: {
      labels: {
        formatter: formatNumberForAxis
      }
    },
    tooltip: {
      y: {
        formatter: function formatter(n) {
          return formatNumberForAxis(n) + " " + unit;
        }
      }
    },
    grid: {
      borderColor: '#00000000'
    }
  };
  return React.createElement("div", {
    id: "chart",
    className: [className, 'flex', 'low-border', 'rounded', 'items-center', 'justify-center', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : ''].join(' ')
  }, React.createElement(Suspense, {
    fallback: null
  }, React.createElement("div", {
    className: "w-full h-fit"
  }, typeof window !== 'undefined' ? React.createElement(ReactApexChart, {
    options: options,
    series: [{
      name: "" + unit,
      data: data
    }],
    type: "area"
  }) : null)));
};
Chart.displayName = 'Chart';

var _excluded$7 = ["children", "className", "id", "size", "variant", "as"];
var Chip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'accent' : _ref$variant,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'span' : _ref$as,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$7);
  var classes = useClasses({
    className: className,
    size: size,
    variant: variant
  });
  return React.createElement(Component, Object.assign({
    className: classes(styles$1.chip),
    "data-testid": id,
    ref: ref
  }, rest), children);
});
Chip.displayName = 'Chip';

var DefaultDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    tooltip = _ref.tooltip,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    values = _ref.values,
    label = _ref.label,
    _ref$loaded = _ref.loaded,
    loaded = _ref$loaded === void 0 ? true : _ref$loaded,
    _ref$loading_surface_ = _ref.loading_surface_level,
    loading_surface_level = _ref$loading_surface_ === void 0 ? 'bg-surface-level-two' : _ref$loading_surface_,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'default-data-line' : _ref$id;
  return React.createElement(Component, {
    "data-testid": id,
    ref: ref,
    className: "flex space-x-4 items-start " + className,
    id: id
  }, React.createElement("div", {
    className: "flex min-w-max items-start space-x-4 flex-1 " + (values.length > 1 ? '' : 'items-center')
  }, React.createElement(Typography, {
    size: size,
    variant: "secondary"
  }, label), tooltip && React.createElement(Tooltip, {
    id: id,
    "data-testid": "tooltip",
    text: tooltip
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent",
    size: 5
  }))), React.createElement("div", {
    className: "text-right space-y-1"
  }, values.map(function (_ref2, idx) {
    var value = _ref2.value,
      color = _ref2.color;
    return React.createElement(Typography, {
      className: (color ? color : '') + " " + (loaded ? '' : "h-5 animate-pulse " + loading_surface_level + " w-24 rounded-sm"),
      variant: color ? 'custom' : 'primary',
      key: idx + '-' + (value || ''),
      allBold: true,
      size: size
    }, loaded && value);
  })));
});
DefaultDataLine.displayName = 'DefaultDataLine';

var NumberedDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    values = _ref.values,
    label = _ref.label,
    tooltip = _ref.tooltip,
    number = _ref.number,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'numbered-data-line' : _ref$id;
  return React.createElement(Component, {
    ref: ref,
    className: "flex justify-between " + className,
    id: id,
    "data-testid": id
  }, React.createElement("div", {
    className: "flex items-center space-x-4"
  }, React.createElement(Steps, null, number || 0), React.createElement(Typography, {
    allBold: true,
    className: "flex-1"
  }, label), tooltip && React.createElement(Tooltip, {
    "data-testid": "tooltip",
    text: tooltip
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent mt-[1px]",
    size: 5
  }))), values.map(function (_ref2, idx) {
    var value = _ref2.value,
      complete = _ref2.complete,
      color = _ref2.color;
    return React.createElement("div", {
      key: idx + (value || ''),
      className: "flex items-center"
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm",
      className: "text-right flex items-center " + (color ? color : ''),
      variant: color ? 'custom' : 'primary'
    }, value), complete && React.createElement("div", {
      className: "pl-3"
    }, React.createElement(Steps, {
      variant: "secondary"
    }, React.createElement(Media, {
      size: 0,
      className: "w-4 h-[11px] pt-[2px] pr-[1px]",
      variant: "tick"
    }))));
  }));
});
NumberedDataLine.displayName = 'NumberedDataLine';

var VerticleDataLine = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$top_size = _ref.top_size,
    top_size = _ref$top_size === void 0 ? 'sm' : _ref$top_size,
    _ref$bottom_size = _ref.bottom_size,
    bottom_size = _ref$bottom_size === void 0 ? 'xs' : _ref$bottom_size,
    is_top_bold = _ref.is_top_bold,
    is_bottom_bold = _ref.is_bottom_bold,
    values = _ref.values,
    label = _ref.label,
    label_color = _ref.label_color,
    _ref$float_right = _ref.float_right,
    float_right = _ref$float_right === void 0 ? false : _ref$float_right,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'verticle-data-line' : _ref$id,
    verticle_bottom_truncate = _ref.verticle_bottom_truncate,
    verticle_top_truncate = _ref.verticle_top_truncate;
  return React.createElement(Component, {
    ref: ref,
    className: className + " " + (float_right ? 'text-right' : ''),
    id: id
  }, values.map(function (_ref2, idx) {
    var value = _ref2.value,
      color = _ref2.color;
    return React.createElement(Typography, {
      className: (color ? color : '') + " " + (verticle_top_truncate ? 'truncate' : ''),
      variant: color ? 'custom' : 'primary',
      key: idx + (value || ''),
      allBold: is_top_bold,
      size: top_size
    }, value);
  }), React.createElement(Typography, {
    allBold: is_bottom_bold,
    size: bottom_size,
    className: (label_color ? label_color : '') + " " + (verticle_bottom_truncate ? 'truncate' : ''),
    variant: label_color ? 'custom' : 'secondary'
  }, label));
});
VerticleDataLine.displayName = 'VerticleDataLine';

var renderSwitch = function renderSwitch(props, ref) {
  switch (props.variant) {
    case 'verticle':
      return React.createElement(VerticleDataLine, Object.assign({
        ref: ref
      }, props));
    case 'numbered':
      return React.createElement(NumberedDataLine, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(DefaultDataLine, Object.assign({
        ref: ref
      }, props));
  }
};
var DataLines = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(React.Fragment, null, renderSwitch(props, ref));
});
DataLines.displayName = 'DataLines';

var defaultProps = {
  as: 'div'
};
var Drawer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    as = _ref.as,
    show = _ref.show,
    className = _ref.className,
    style = _ref.style;
  return React.createElement(Transition, {
    show: show,
    as: as,
    ref: ref,
    className: "fixed inset-0 overflow-scroll " + className,
    style: style
  }, React.createElement(Transition.Child, {
    as: as,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }), React.createElement(Transition.Child, {
    as: as,
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full",
    className: "bg-surface-level-one"
  }, React.createElement("div", {
    className: "px-5 "
  }, children)));
});
Drawer.displayName = 'Drawer';
Drawer.defaultProps = defaultProps;

var _excluded$8 = ["as", "children", "mediaClassName", "id", "options", "size", "surface", "title", "accent_icon", "no_hover", "container_class", "className", "width", "dropdown_width", "has_max_height", "left_position", "dropdown_height", "left_position_top_dropdown"];
var defaultProps$1 = {
  as: 'div',
  size: 'md',
  surface: 'two',
  title: '',
  mediaClassName: '',
  accent_icon: false
};
// use children if you want to customize the dropdown button
var Dropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    mediaClassName = _ref.mediaClassName,
    id = _ref.id,
    options = _ref.options,
    surface = _ref.surface,
    title = _ref.title,
    accent_icon = _ref.accent_icon,
    no_hover = _ref.no_hover,
    container_class = _ref.container_class,
    className = _ref.className,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 'min-w-[124px]' : _ref$width,
    _ref$dropdown_width = _ref.dropdown_width,
    dropdown_width = _ref$dropdown_width === void 0 ? 'w-[140px]' : _ref$dropdown_width,
    has_max_height = _ref.has_max_height,
    left_position = _ref.left_position,
    dropdown_height = _ref.dropdown_height,
    left_position_top_dropdown = _ref.left_position_top_dropdown,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$8);
  var _useState = useState(false),
    open = _useState[0],
    setOpen = _useState[1];
  var menu_items_position = left_position ? 'left-0' : 'right-0';
  var menu_offset_class = left_position_top_dropdown ? 'bottom-12' : '';
  return React.createElement(Menu, Object.assign({
    as: as,
    className: "relative " + container_class,
    ref: ref
  }, rest), React.createElement(Menu.Button, {
    className: children ? className : [width, 'h-11', 'border', 'rounded', 'inline-flex', 'items-center', 'text-primary', 'border-border', 'justify-between', 'border-opacity-[0.03]', surface === 'zero' ? "bg-surface-level-zero  " + (no_hover ? '' : 'hover:bg-surface-level-one') : '', surface === 'one' ? "bg-surface-level-one  " + (no_hover ? '' : 'hover:bg-surface-level-two') : '', surface === 'two' ? "bg-surface-level-two  " + (no_hover ? '' : 'hover:bg-surface-level-three') : '', surface === 'three' ? "bg-surface-level-three " + (no_hover ? '' : 'hover:bg-surface-level-one') : '', className].join(' '),
    "data-testid": id,
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, children ? children : React.createElement(React.Fragment, null, title, React.createElement(Media, {
    className: "mr-3 " + (accent_icon ? 'text-accent' : 'text-primary'),
    size: 4,
    variant: "chevron-down"
  }))), React.createElement(Transition, {
    as: as,
    enter: "transition ease-out duration-100",
    enterFrom: "transform opacity-0 scale-95",
    enterTo: "transform opacity-100 scale-100",
    leave: "transition ease-in duration-75",
    leaveFrom: "transform opacity-100 scale-100",
    leaveTo: "transform opacity-0 scale-95"
  }, React.createElement(Menu.Items, {
    style: {
      height: dropdown_height ? dropdown_height : has_max_height ? '200px' : undefined
    },
    className: "absolute low-border mt-1 origin-top-right rounded shadow-tight focus:outline-none md:" + menu_items_position + " bg-surface-level-one overflow-y-auto " + dropdown_width + " " + menu_offset_class
  }, options && options.map(function (_ref2) {
    var name = _ref2.name,
      icon = _ref2.icon,
      onOptionClick = _ref2.onOptionClick,
      has_image_icon = _ref2.has_image_icon;
    return React.createElement(Menu.Item, {
      "data-testid": id + "-" + name,
      key: name
    }, function (_ref3) {
      var active = _ref3.active;
      return React.createElement("button", {
        className: ['p-4', 'flex', 'h-11', 'group', 'gap-4', 'w-full', 'text-sm', 'rounded', 'inline-flex', 'items-center', 'text-primary', active && 'bg-surface-level-three'].join(' '),
        onClick: onOptionClick,
        type: "button"
      }, icon && React.createElement(React.Fragment, null, has_image_icon ? React.createElement("img", {
        className: "h-[18px] " + mediaClassName,
        src: icon,
        alt: name + "-exchange-img"
      }) : React.createElement(Media, {
        size: 0,
        className: "h-[18px] " + mediaClassName,
        variant: icon
      })), name);
    });
  }))));
});
Dropdown.displayName = 'Dropdown';
Dropdown.defaultProps = defaultProps$1;

var HelperBox = function HelperBox(_ref) {
  var helper_text = _ref.helper_text,
    className = _ref.className,
    _ref$has_text_center = _ref.has_text_center,
    has_text_center = _ref$has_text_center === void 0 ? false : _ref$has_text_center;
  return React.createElement("div", {
    className: "flex flex-col " + className
  }, React.createElement("div", {
    className: "rounded border border-border border-opacity-[0.03] bg-surface-level-three px-5 py-4 shadow-broad text-xs text-secondary " + (has_text_center ? 'text-center' : 'text-left') + "\n      "
  }, helper_text), React.createElement("div", {
    className: "ml-[45%] -mt-[1px] inline-block overflow-hidden"
  }, React.createElement("div", {
    className: "h-[14px] w-[14px] origin-top-left -rotate-45 transform border border-border border-opacity-[0.03] bg-surface-level-three"
  })));
};
HelperBox.displayName = 'HelperBox';

var _excluded$9 = ["id", "children", "className", "text", "as", "offset"];
var Tooltip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'tooltip' : _ref$id,
    children = _ref.children,
    text = _ref.text,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    offset = _ref.offset,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$9);
  return React.createElement(Component, Object.assign({
    "data-testid": id,
    ref: ref
  }, rest, {
    className: "tooltip-container"
  }), React.createElement("div", {
    "data-html": true,
    "data-tip": text,
    "data-for": id
  }, children), React.createElement(ReactTooltip, {
    html: true,
    className: "custom-tooltip bg-surface-level-three after:bg-surface-level-three !p-4",
    arrowColor: "bg-surface-level-three after:bg-surface-level-three",
    "data-testid": id,
    id: id,
    getContent: function getContent(dataTip) {
      return dataTip;
    },
    overridePosition: function overridePosition(position, _currentEvent, currentTarget, node) {
      var targetElement = currentTarget;
      var modalElement = targetElement.closest('.popup');
      var computedPosition;
      if (!modalElement) {
        computedPosition = position;
      } else {
        var modalBounds = modalElement.getBoundingClientRect();
        var targetBounds = currentTarget.getBoundingClientRect();
        var relativeTop = targetBounds.top - modalBounds.top;
        var relativeLeft = targetBounds.left - modalBounds.left;
        computedPosition = {
          top: relativeTop - node.offsetHeight - 10,
          left: relativeLeft - node.offsetWidth / 2 + targetBounds.width / 2
        };
      }
      if (offset) {
        return {
          top: computedPosition.top - (offset.top || 0),
          left: computedPosition.left - (offset.left || 0)
        };
      }
      return computedPosition;
    },
    effect: "solid"
  }));
});

var _excluded$a = ["children", "className", "disabled", "error", "helperText", "id", "label", "is_initialized", "loading", "placeholder", "surface", "tooltip", "unit", "type", "handleMaxClick", "as", "containerClasses", "helper_box_text", "onBlur", "max_btn", "err_border", "multiline", "value", "unclickable", "onChange", "num_rows", "handleFocus", "min", "success_text", "img_height", "img_width", "offset", "has_error_color_error_text", "label_and_input_disabled"];
var defaultProps$2 = {
  as: 'div',
  error: '',
  helperText: '',
  label: '',
  loading: false,
  surface: 'one',
  tooltip: '',
  unit: '',
  containerClasses: '',
  helper_text_arr: undefined,
  is_initialized: true,
  max_btn: true,
  err_border: false,
  multiline: false,
  has_error_color_error_text: false
};
var Input = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    error = _ref.error,
    helperText = _ref.helperText,
    id = _ref.id,
    label = _ref.label,
    is_initialized = _ref.is_initialized,
    loading = _ref.loading,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? '' : _ref$placeholder,
    surface = _ref.surface,
    tooltip = _ref.tooltip,
    unit = _ref.unit,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    handleMaxClick = _ref.handleMaxClick,
    Component = _ref.as,
    containerClasses = _ref.containerClasses,
    helper_box_text = _ref.helper_box_text,
    onBlur = _ref.onBlur,
    max_btn = _ref.max_btn,
    err_border = _ref.err_border,
    multiline = _ref.multiline,
    value = _ref.value,
    unclickable = _ref.unclickable,
    onChange = _ref.onChange,
    _ref$num_rows = _ref.num_rows,
    num_rows = _ref$num_rows === void 0 ? 4 : _ref$num_rows,
    handleFocus = _ref.handleFocus,
    min = _ref.min,
    success_text = _ref.success_text,
    offset = _ref.offset,
    has_error_color_error_text = _ref.has_error_color_error_text,
    label_and_input_disabled = _ref.label_and_input_disabled,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$a);
  var inputRef = useRef(null);
  var _useState = useState(false),
    focused = _useState[0],
    setFocused = _useState[1];
  var _onFocus = function onFocus() {
    setFocused(true);
    if ((type === 'datetime-local' || type === 'date') && 'showPicker' in HTMLInputElement.prototype) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) == null || _inputRef$current.showPicker();
    }
  };
  var handleBlur = function handleBlur(e) {
    setFocused(false);
    onBlur && onBlur(e);
  };
  var classes = useClasses({
    className: className,
    disabled: disabled,
    surface: surface,
    unclickable: unclickable,
    err_border: is_initialized ? err_border : false,
    border: err_border || disabled ? false : true,
    label_and_input_disabled: label_and_input_disabled
  });
  return React.createElement(Component, {
    className: containerClasses + " " + (label_and_input_disabled ? 'opacity-50' : ''),
    ref: ref
  }, React.createElement("div", {
    className: "flex space-between items-center relative"
  }, label && React.createElement("label", {
    className: "mb-4 text-secondary text-sm " + (label_and_input_disabled ? 'opacity-50' : ''),
    htmlFor: id
  }, label), tooltip && React.createElement("div", {
    className: "relative ml-2 mb-4"
  }, React.createElement(Tooltip, {
    offset: offset,
    text: tooltip,
    id: "tooltip-" + id
  }, React.createElement(Media, {
    className: "text-accent",
    size: 5,
    variant: "info-outline"
  }))), is_initialized && error && React.createElement("div", {
    className: "flex-1 text-right text-xs mb-4 " + (has_error_color_error_text ? 'text-error' : 'text-accent')
  }, error), !error && helperText && React.createElement("div", {
    className: "flex-1 text-right text-xs mb-4 text-secondary"
  }, helperText), !error && success_text && React.createElement("div", {
    className: "flex-1 text-right text-xs mb-4 text-success"
  }, success_text)), React.createElement("div", {
    className: "relative"
  }, focused && helper_box_text && React.createElement("div", {
    className: "absolute bottom-[43px] left-[28%] w-[194px]"
  }, React.createElement(HelperBox, {
    helper_text: helper_box_text
  })), multiline ? React.createElement("textarea", {
    ref: inputRef,
    id: id,
    className: "resize-y box-border w-full text-primary placeholder-secondary px-5 py-3 focus:outline-none rounded bg-surface-level-zero border text-sm font-normal border-border border-opacity-[0.03] hover:border-opacity-[0.16] focus:border-opacity-[0.16]",
    "data-testid": id,
    disabled: disabled,
    placeholder: placeholder,
    rows: num_rows,
    value: value,
    onChange: onChange
  }) : React.createElement("input", Object.assign({
    min: min,
    ref: inputRef,
    id: id,
    readOnly: unclickable ? true : false,
    className: classes(styles$1.input),
    "data-testid": id,
    onWheel: function onWheel(event) {
      return event.currentTarget.blur();
    },
    disabled: disabled,
    placeholder: placeholder,
    type: type,
    onFocus: function onFocus() {
      _onFocus();
      handleFocus && handleFocus();
    },
    onBlur: handleBlur,
    value: value,
    onChange: onChange
  }, rest)), loading && React.createElement(Media, {
    className: "absolute right-5 bottom-2.5 text-button",
    size: 5,
    variant: "loader"
  }), !loading && React.createElement("div", null, unit && React.createElement("small", {
    className: (max_btn ? 'bottom-3 right-16' : 'bottom-[11px] right-5') + " absolute  text-primary text-sm font-bold"
  }, unit), max_btn && React.createElement("div", {
    className: "absolute bottom-[11px] right-5"
  }, handleMaxClick && React.createElement("button", {
    onClick: handleMaxClick
  }, React.createElement("small", {
    className: "text-accent text-sm pb-2"
  }, "MAX"))))));
});
Input.displayName = 'Input';
Input.defaultProps = defaultProps$2;

var defaultProps$3 = {
  className: '',
  size: 'sm',
  surface: 'two',
  variant: 'staking'
};
var ProductBadge = function ProductBadge(_ref) {
  var variant = _ref.variant,
    surface = _ref.surface,
    size = _ref.size,
    className = _ref.className;
  return React.createElement("div", {
    className: ['low-border', 'rounded-full', size === 'md' ? 'p-[13px] h-[60px] w-[60px]' : 'p-[9px] h-[44px] w-[44px]', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : '', className].join(' ')
  }, React.createElement(Media, {
    size: size === 'md' ? 8 : 6,
    className: "text-secondary",
    variant: variant
  }));
};
ProductBadge.displayName = 'ProductBadge';
ProductBadge.defaultProps = defaultProps$3;

var _excluded$b = ["className", "id", "label", "marker", "percent", "surface", "as", "rounded", "height", "border", "has_lighter_bar", "progressClassName"];
var Progress = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? false : _ref$label,
    _ref$marker = _ref.marker,
    marker = _ref$marker === void 0 ? 0 : _ref$marker,
    _ref$percent = _ref.percent,
    percent = _ref$percent === void 0 ? 0 : _ref$percent,
    _ref$surface = _ref.surface,
    surface = _ref$surface === void 0 ? 'zero' : _ref$surface,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$rounded = _ref.rounded,
    rounded = _ref$rounded === void 0 ? true : _ref$rounded,
    height = _ref.height,
    _ref$border = _ref.border,
    border = _ref$border === void 0 ? true : _ref$border,
    _ref$has_lighter_bar = _ref.has_lighter_bar,
    has_lighter_bar = _ref$has_lighter_bar === void 0 ? false : _ref$has_lighter_bar,
    _ref$progressClassNam = _ref.progressClassName,
    progressClassName = _ref$progressClassNam === void 0 ? '' : _ref$progressClassNam,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$b);
  var classes = useClasses(_extends({
    className: className,
    surface: surface,
    rounded: rounded,
    border: border
  }, rest));
  var actual_height = height || (marker ? 'h-4' : 'h-2');
  return React.createElement("div", {
    className: label ? 'flex items-center space-x-2' : ''
  }, React.createElement(Component, Object.assign({
    ref: ref,
    className: classes(styles$1.progress)
  }, rest), marker && marker > 0 ? React.createElement("div", {
    className: "absolute bg-white w-1 " + actual_height,
    style: {
      left: marker + "%"
    }
  }, React.createElement("div", {
    className: "absolute flex h-full items-center right-4 text-primary text-xs"
  }, "MIN")) : null, React.createElement("div", {
    className: (has_lighter_bar ? 'bg-accent-hover' : 'bg-accent') + " " + (rounded ? 'rounded-full' : '') + " " + actual_height + " " + progressClassName,
    "data-testid": id,
    style: {
      width: percent + "%"
    }
  })), label && React.createElement("div", {
    className: "text-accent text-xs"
  }, percent, "%"));
});
Progress.displayName = 'Progress';

var defaultProps$4 = {
  as: 'div',
  accent_icon: false,
  className: '',
  fullWidth: false,
  searchText: 'Search your properties'
};
var SortSearch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    accent_icon = _ref.accent_icon,
    className = _ref.className,
    filterOptions = _ref.filterOptions,
    searchText = _ref.searchText,
    sortOptions = _ref.sortOptions,
    selectedSortOption = _ref.selectedSortOption,
    selectedFilterOption = _ref.selectedFilterOption,
    handleSearch = _ref.handleSearch,
    _ref$sort_text = _ref.sort_text,
    sort_text = _ref$sort_text === void 0 ? 'Sort by' : _ref$sort_text;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 400;
  var is_tablet = breakpoint < 560;
  return React.createElement(Component, {
    ref: ref
  }, React.createElement("div", {
    className: "w-full " + (is_tablet ? 'space-y-5' : 'flex items-center') + " " + className
  }, React.createElement("div", {
    className: "relative w-full"
  }, React.createElement(Input, {
    placeholder: is_mobile ? 'Search' : searchText,
    surface: "one",
    type: "text",
    onChange: function onChange(e) {
      return handleSearch(e.target.value);
    }
  }), React.createElement(Media, {
    size: 4,
    variant: "search",
    className: "absolute right-5 bottom-[16px] pointer-events-none text-primary"
  })), React.createElement("div", {
    className: "flex items-center " + (is_tablet ? 'space-x-5' : '')
  }, ' ', React.createElement("div", {
    className: "flex items-center " + (is_tablet ? 'w-[50%]' : '')
  }, React.createElement(Typography, {
    allBold: true,
    as: "label",
    className: "ml-4 hidden sm:block " + (sort_text === 'Sort by' ? 'min-w-[50px]' : 'min-w-[70px]'),
    size: "sm"
  }, sort_text), React.createElement(Dropdown, {
    dropdown_width: is_tablet ? 'min-w-[50%]' : '',
    width: is_tablet ? 'w-full' : undefined,
    accent_icon: accent_icon,
    container_class: "" + (is_tablet ? 'w-full' : 'ml-4'),
    options: sortOptions,
    size: "xs",
    surface: "one",
    title: React.createElement("span", {
      className: "mx-3"
    }, selectedSortOption)
  })), filterOptions ? React.createElement("div", {
    className: "flex items-center " + (is_tablet ? 'w-[50%]' : '')
  }, React.createElement(Typography, {
    allBold: true,
    as: "label",
    className: "hidden sm:block ml-4 min-w-[60px]",
    size: "sm"
  }, "Filter by"), React.createElement(Dropdown, {
    dropdown_width: is_tablet ? 'min-w-[50%]' : '',
    width: is_tablet ? 'w-full' : undefined,
    accent_icon: accent_icon,
    container_class: " " + (is_tablet ? 'w-full' : 'ml-4'),
    options: filterOptions,
    size: "xs",
    surface: "one",
    title: React.createElement("span", {
      className: "mx-3"
    }, selectedFilterOption)
  })) : null)));
});
SortSearch.displayName = 'SortSearch';
SortSearch.defaultProps = defaultProps$4;

var defaultProps$5 = {
  as: Fragment,
  current: {
    label: '',
    id: ''
  },
  disabled: false,
  label: '',
  options: [],
  placeholder: '',
  surface: 'zero',
  setCurrent: function setCurrent() {},
  is_initialized: true
};
var Select = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    current = _ref.current,
    disabled = _ref.disabled,
    label = _ref.label,
    options = _ref.options,
    placeholder = _ref.placeholder,
    surface = _ref.surface,
    tooltip = _ref.tooltip,
    setCurrent = _ref.setCurrent,
    is_initialized = _ref.is_initialized,
    error = _ref.error,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'select' : _ref$id,
    onFocus = _ref.onFocus;
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "flex space-between items-center"
  }, label && React.createElement("label", {
    className: "text-secondary text-sm mb-4",
    htmlFor: id
  }, label), tooltip && React.createElement(Tooltip, {
    text: tooltip
  }, React.createElement(Media, {
    className: "ml-2 text-accent mb-4",
    size: 5,
    variant: "info-outline"
  })), is_initialized && error && React.createElement("div", {
    className: "flex-1 text-right text-xs text-accent mb-4"
  }, error)), React.createElement(Listbox, {
    disabled: disabled,
    value: current,
    onChange: setCurrent
  }, React.createElement("div", {
    className: "relative"
  }, React.createElement(Listbox.Button, {
    "data-testid": "select",
    onFocus: onFocus,
    className: [disabled ? 'opacity-[0.6]' : '', 'h-11', 'bg-clip-padding', 'focus:border-opacity-[0.16]', disabled ? '' : 'hover:border-opacity-[0.16]', 'border', 'border-border', 'border-opacity-[0.03]', 'w-full', 'px-5', 'py-2', 'text-left', 'rounded', 'text-primary', 'cursor-default', 'flex', 'justify-between', 'items-center', 'focus:outline-none', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : ''].join(' ')
  }, React.createElement(Typography, {
    className: "truncate",
    size: "sm",
    variant: current != null && current.label ? 'primary' : 'secondary'
  }, (current == null ? void 0 : current.label) || placeholder), React.createElement("span", {
    className: "pl-2 pointer-events-none flex items-center justify-center"
  }, React.createElement(Media, {
    className: "mt-[4px]",
    size: 5,
    variant: 'chevron-down'
  }))), React.createElement(Transition, {
    as: as,
    leave: "transition ease-in duration-100",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    ref: ref
  }, React.createElement(Listbox.Options, {
    className: ['w-full', 'absolute', 'mt-1', 'z-50', 'max-h-40', 'low-border', 'overflow-auto', 'rounded', 'text-base', 'shadow-tight', 'focus:outline-none', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : ''].join(' ')
  }, options.map(function (option, idx) {
    return React.createElement(Listbox.Option, {
      key: option.label + idx,
      className: function className(_ref2) {
        var active = _ref2.active;
        return ['w-full', 'relative', 'cursor-default', 'select-none', 'p-3', active ? 'bg-surface-level-two' : 'bg-surface-level-zero'].join(' ');
      },
      value: option
    }, function (_ref3) {
      var active = _ref3.active,
        selected = _ref3.selected;
      return React.createElement(Typography, {
        className: "truncate",
        variant: active || selected ? 'primary' : 'secondary',
        "data-testid": option.label,
        size: "sm"
      }, option.label);
    });
  }))))));
});
Select.displayName = 'Select';
Select.defaultProps = defaultProps$5;

var defaultProps$6 = {};
var SingleButton = function SingleButton(_ref) {
  var label = _ref.label,
    sub_label = _ref.sub_label,
    title = _ref.title,
    value = _ref.value,
    disabled = _ref.disabled,
    helper_text = _ref.helper_text,
    is_mobile = _ref.is_mobile,
    idx = _ref.idx,
    selected = _ref.selected,
    setSelected = _ref.setSelected;
  var _useState = useState(false),
    hover = _useState[0],
    setHover = _useState[1];
  useEffect(function () {
    if (disabled && selected === idx) {
      setSelected();
    }
  }, [disabled, selected, idx]);
  return React.createElement("div", {
    className: "relative",
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    }
  }, disabled && helper_text && hover && React.createElement("div", {
    className: "text-xs absolute z-50 w-[198px] " + (is_mobile ? 'bottom-[128px] left-[55px]' : 'bottom-[180px] left-[24px]')
  }, React.createElement(HelperBox, {
    className: "",
    helper_text: helper_text
  })), React.createElement(Card, {
    as: "button",
    onClick: function onClick() {
      return disabled ? null : setSelected(idx);
    },
    surface: "custom",
    className: "text-left w-full focus:outline-none " + (is_mobile ? 'p-5 space-y-2' : 'p-8 space-y-5') + " " + (disabled ? 'opacity-50' : '') + " " + (selected === idx ? 'bg-gradient-light-theme-alternative' : "bg-surface-level-two " + (disabled ? '' : 'hover:bg-surface-level-three'))
  }, React.createElement(Typography, {
    allBold: true,
    className: selected === idx ? 'text-surface-level-zero' : '',
    size: is_mobile ? '2xl' : '3xl'
  }, title), React.createElement("div", null, React.createElement(DataLines, {
    top_size: is_mobile ? 'md' : '2xl',
    bottom_size: "sm",
    label: label,
    label_color: selected === idx ? 'text-surface-level-zero' : 'text-secondary',
    variant: "verticle",
    values: [{
      value: value,
      color: selected === idx ? 'text-surface-level-zero' : 'text-accent'
    }]
  }), React.createElement(Typography, {
    className: selected === idx ? 'text-surface-level-zero' : 'text-secondary',
    variant: "custom",
    size: "sm"
  }, sub_label))));
};
var SquareButtons = function SquareButtons(_ref2) {
  var buttons_info_array = _ref2.buttons_info_array,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? 'square-buttons' : _ref2$id,
    selected = _ref2.selected,
    setSelected = _ref2.setSelected,
    label = _ref2.label,
    className = _ref2.className,
    tooltip = _ref2.tooltip;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 620;
  return React.createElement("div", {
    id: id,
    className: className
  }, label && React.createElement("label", {
    className: "flex items-center mb-4 text-secondary text-sm"
  }, label, tooltip && React.createElement(Tooltip, {
    id: id,
    text: tooltip
  }, React.createElement(Media, {
    className: "ml-2 text-accent",
    size: 5,
    variant: "info-outline"
  }))), React.createElement("div", {
    className: "grid " + (is_mobile ? 'grid-cols-1' : 'grid-cols-2') + " gap-5"
  }, buttons_info_array.map(function (props, idx) {
    return React.createElement("div", {
      key: props.title
    }, React.createElement(SingleButton, Object.assign({}, props, {
      selected: selected,
      setSelected: setSelected,
      is_mobile: is_mobile,
      idx: idx
    })));
  })));
};
SquareButtons.displayName = 'SquareButtons';
SquareButtons.defaultProps = defaultProps$6;

var FullWidthTabs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    options = _ref.options,
    setCurrent = _ref.setCurrent,
    current = _ref.current,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'full-width' : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    custom_optionClass = _ref.custom_optionClass;
  return React.createElement(Component, {
    className: "h-16 flex w-full text-center bg-surface-level-one bg-clip-padding mb-10 cursor-pointer justify-start rounded overflow-x-auto low-border space-x-[80px] px-[32px] scroll-none " + className,
    id: id,
    ref: ref
  }, options.map(function (_ref2) {
    var title = _ref2.title,
      locked = _ref2.locked,
      id = _ref2.id;
    return React.createElement("button", {
      key: title,
      id: title,
      disabled: locked,
      onClick: function onClick() {
        return setCurrent(id);
      },
      className: "min-w-max flex space-x-2 items-center justify-center " + (id === current ? 'border-b-4 border-accent pt-4 pb-3' : 'py-4') + " " + custom_optionClass
    }, locked && React.createElement(Media, {
      variant: "lock",
      className: "text-secondary h-4 w-4"
    }), React.createElement(Typography, {
      allBold: id === current,
      size: "sm",
      variant: id !== current ? 'secondary' : 'primary'
    }, title));
  }));
});

var LimitedTabs = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    options = _ref.options,
    setCurrent = _ref.setCurrent,
    className = _ref.className,
    current = _ref.current,
    background_color = _ref.background_color,
    button_color = _ref.button_color,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'limited' : _ref$id,
    custom_optionClass = _ref.custom_optionClass;
  return React.createElement(Component, {
    ref: ref,
    className: "border bg-clip-padding rounded border-border border-opacity-[0.03] h-[54px] flex items-center p-1 " + background_color + " " + className,
    id: id
  }, options.map(function (_ref2) {
    var title = _ref2.title,
      id = _ref2.id,
      locked = _ref2.locked,
      number = _ref2.number;
    return React.createElement("button", {
      "data-testid": title,
      id: title,
      key: title + "-" + id,
      disabled: locked,
      onClick: function onClick() {
        return setCurrent(id);
      },
      className: "h-[44px] rounded flex-1 " + (id === current ? button_color + " text-primary low-border" : 'font-normal text-secondary') + " " + custom_optionClass
    }, React.createElement("div", {
      className: "flex justify-center items-center space-x-2"
    }, locked && React.createElement(Media, {
      variant: "lock",
      className: "text-secondary h-4 w-4"
    }), React.createElement(Typography, {
      allBold: id === current,
      size: "sm",
      variant: id !== current && 'secondary' || 'primary'
    }, title), number !== undefined && number > 0 && React.createElement("div", {
      id: id,
      className: ["bg-gradient-alpha text-sm mt-[1px] " + (number < 100 ? 'w-[24px] h-[24px]' : 'w-[34px] h-[34px]'), 'flex', 'rounded-full', 'items-center', 'justify-center', className].join(' ')
    }, number)));
  }));
});

var defaultProps$7 = {
  variant: 'limited',
  as: 'div',
  background_color: 'bg-surface-level-one',
  button_color: 'bg-surface-level-two'
};
var renderSwitch$1 = function renderSwitch(props, ref) {
  switch (props.variant) {
    case 'full-width':
      return React.createElement(FullWidthTabs, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(LimitedTabs, Object.assign({
        ref: ref
      }, props));
  }
};
var Tabs = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(React.Fragment, null, renderSwitch$1(props, ref));
});
Tabs.displayName = 'Tabs';
Tabs.defaultProps = defaultProps$7;

var tier_borders = {
  yellow: 'border-[#CC7E00]',
  blue: 'border-[#007499]',
  green: 'border-[#1EAE8C]',
  orange: 'border-[#CC4900]',
  pink: 'border-[#E51A67]'
};
var defaultProps$8 = {
  as: 'div',
  className: '',
  variant: 'md',
  is_max_tier: false,
  label: false
};
var TierLevel = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var image_url = _ref.image_url,
    text = _ref.text,
    is_max_tier = _ref.is_max_tier,
    className = _ref.className,
    Component = _ref.as,
    variant = _ref.variant,
    _ref$multiplier = _ref.multiplier,
    multiplier = _ref$multiplier === void 0 ? 1 : _ref$multiplier,
    _ref$tier_color = _ref.tier_color,
    tier_color = _ref$tier_color === void 0 ? 'yellow' : _ref$tier_color,
    label = _ref.label;
  var medium = variant === 'md';
  var large = variant === 'lg';
  return React.createElement(Component, {
    ref: ref,
    className: "flex items-center " + className
  }, React.createElement("img", {
    className: (large ? 'h-[60px] w-[60px]' : medium ? 'w-11 h-11' : 'h-7 w-7') + " " + (label ? 'mr-5' : 'mr-2'),
    src: image_url,
    alt: "Tier-" + text
  }), React.createElement("div", {
    className: "flex " + (label ? '' : 'items-center')
  }, label ? React.createElement(DataLines, {
    variant: "verticle",
    is_top_bold: true,
    top_size: large ? 'xl' : '2xl',
    label: "INVESTOR TIER",
    bottom_size: large ? 'sm' : 'xs',
    values: [{
      value: text
    }]
  }) : React.createElement(Typography, {
    size: medium ? 'md' : 'sm',
    allBold: true
  }, text), is_max_tier && React.createElement("div", {
    className: "py-[2px] px-[6px] bg-surface-level-one rounded border " + (label ? 'ml-3 h-7' : 'ml-2') + " " + tier_borders[tier_color]
  }, React.createElement(Typography, {
    className: "mb-[1px]",
    size: "sm",
    allBold: true
  }, multiplier, "x"))));
});
TierLevel.displayName = 'TierLevel';
TierLevel.defaultProps = defaultProps$8;

var toggle = styles$1.toggle;
var ToggleCheckbox = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    active = _ref.active,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'checkbox' : _ref$id,
    surface_level = _ref.surface_level;
  return React.createElement(Component, {
    ref: ref,
    className: "flex space-x-5 items-center"
  }, React.createElement("button", {
    id: id,
    onClick: onChange,
    value: active.toString(),
    className: "w-[22px] h-[22px] rounded-[4px] bg-clip-padding bg-surface-level-" + surface_level + " " + toggle.border_classes + " " + className,
    "data-testid": id,
    disabled: disabled,
    type: "button"
  }, React.createElement("div", {
    className: "w-[21px] h-[21px] flex justify-center items-center"
  }, active && React.createElement(Media, {
    size: 0,
    className: "text-accent h-[15.5px] w-[15.5px]",
    variant: "tick"
  }))), label && React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, label));
});

var _excluded$c = ["active", "onChange", "as", "children", "className", "disabled", "id", "label", "switch_active_color", "switch_surface_color"];
var getBackgroundColor = function getBackgroundColor(active, type, bg_color) {
  if (!active) return bg_color;
  switch (type) {
    case 'success':
      return 'bg-success';
    default:
      return 'bg-gradient';
  }
};
var getBorderFocusColor = function getBorderFocusColor(type) {
  switch (type) {
    case 'success':
      return 'focus:border-success';
    default:
      return 'focus:border-accent';
  }
};
var ToggleSwitch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var active = _ref.active,
    onChange = _ref.onChange,
    as = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    disabled = _ref.disabled,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'switch' : _ref$id,
    label = _ref.label,
    _ref$switch_active_co = _ref.switch_active_color,
    switch_active_color = _ref$switch_active_co === void 0 ? 'accent' : _ref$switch_active_co,
    _ref$switch_surface_c = _ref.switch_surface_color,
    switch_surface_color = _ref$switch_surface_c === void 0 ? 'bg-surface-level-one' : _ref$switch_surface_c,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$c);
  return React.createElement(Switch.Group, Object.assign({
    as: as,
    className: "" + className,
    ref: ref
  }, rest), React.createElement(Switch.Label, {
    className: "text-sm text-secondary flex items-center"
  }, label), React.createElement(Switch, {
    checked: active,
    onChange: onChange,
    "data-testid": id,
    className: ['relative', 'inline-flex', 'shrink-0', 'w-[50px]', 'h-[26px]', 'pt-[2px]', 'pl-[2px]', 'ease-in-out', 'duration-200', 'rounded-full', 'transition-colors', 'disabled:opacity-50', 'border', 'border-border', 'border-opacity-[0.03]', getBorderFocusColor(switch_active_color), 'focus:border-opacity-100', 'hover:border-opacity-[0.16]', 'disabled:border-opacity-[0.03]', 'bg-clip-padding', getBackgroundColor(active, switch_active_color, switch_surface_color)].join(' '),
    disabled: disabled
  }, React.createElement("span", {
    "aria-hidden": "true",
    className: ['pointer-events-none', 'inline-block', 'h-[20px]', 'w-[20px]', 'transform', 'rounded-full', 'ring-0', 'transition', 'duration-200', 'ease-in-out', 'bg-white', active ? 'translate-x-6' : 'translate-x-0'].join(' ')
  })));
});

var toggle$1 = styles$1.toggle;
var ToggleRadioBtn = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    active = _ref.active,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    label = _ref.label,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'radio-btn' : _ref$id,
    surface_level = _ref.surface_level,
    size = _ref.size;
  return React.createElement(Component, {
    className: "flex space-x-2 " + className,
    ref: ref
  }, label && React.createElement("label", {
    htmlFor: id,
    className: "block mb-2 text-sm font-medium text-secondary"
  }, label), React.createElement("button", {
    id: id,
    onClick: onChange,
    value: active.toString(),
    className: "bg-clip-padding " + (size === 'md' ? 'w-5 h-5 rounded' : 'h-[26px] w-[26px] rounded') + " bg-surface-level-" + surface_level + " " + toggle$1.border_classes + " " + className,
    "data-testid": id,
    disabled: disabled,
    type: "button"
  }, active && React.createElement("div", {
    "data-testid": "square-div",
    className: "mx-auto bg-gradient bg-origin-border border border-border border-opacity-10  " + (size === 'md' ? 'rounded-[0.188rem] h-3 w-3' : 'rounded-[0.188rem] h-3.5 w-3.5')
  })));
});

var defaultProps$9 = {
  as: 'div',
  label: undefined,
  variant: 'switch',
  active: false,
  surface_level: 'zero',
  size: 'md',
  switch_surface_color: 'surface-level-one',
  switch_active_color: 'accent'
};
var Toggle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  switch (props.variant) {
    case 'checkbox':
      return React.createElement(ToggleCheckbox, Object.assign({
        ref: ref
      }, props));
    case 'radio':
      return React.createElement(ToggleRadioBtn, Object.assign({
        ref: ref
      }, props));
    default:
      return React.createElement(ToggleSwitch, Object.assign({
        ref: ref
      }, props));
  }
});
Toggle.displayName = 'Toggle';
Toggle.defaultProps = defaultProps$9;

var _excluded$d = ["as", "children", "className", "subtitle", "has_brighter_header", "custom_padding", "is_defaulted_to_open"],
  _excluded2 = ["as", "children", "className", "isClickable", "isExpandable", "subtitle"];
var AccordionBase = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$subtitle = _ref.subtitle,
    subtitle = _ref$subtitle === void 0 ? '' : _ref$subtitle,
    _ref$has_brighter_hea = _ref.has_brighter_header,
    has_brighter_header = _ref$has_brighter_hea === void 0 ? false : _ref$has_brighter_hea,
    _ref$custom_padding = _ref.custom_padding,
    custom_padding = _ref$custom_padding === void 0 ? 'p-7' : _ref$custom_padding,
    _ref$is_defaulted_to_ = _ref.is_defaulted_to_open,
    is_defaulted_to_open = _ref$is_defaulted_to_ === void 0 ? false : _ref$is_defaulted_to_,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$d);
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Disclosure, Object.assign({
    as: as,
    defaultOpen: is_defaulted_to_open,
    className: className + " mt-2 w-full",
    ref: ref
  }, rest), function (_ref2) {
    var open = _ref2.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: [custom_padding, 'flex', 'w-full', 'border-t', 'border-x', 'text-left', 'items-center', 'justify-between', 'border-opacity-[0.03]', 'text-primary', 'border-border', has_brighter_header ? 'bg-surface-level-two border-b ' : 'bg-surface-level-one', open ? 'rounded-t' : "border-b rounded " + (has_brighter_header ? 'hover:bg-surface-level-three' : 'hover:bg-surface-level-two')].join(' ')
    }, React.createElement(Typography, {
      allBold: true,
      as: "h3",
      size: is_mobile ? 'lg' : '2xl'
    }, subtitle), React.createElement(Media, {
      className: "flex-shrink-0 ml-2",
      size: 5,
      variant: open ? 'chevron-up' : 'chevron-down'
    })), React.createElement(Disclosure.Panel, {
      className: ['px-7', 'pb-7', 'border-b', 'border-x', 'rounded-b', 'border-opacity-[0.03]', 'border-border', 'bg-surface-level-one'].join(' ')
    }, children));
  });
});
var Investment = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var as = _ref3.as,
    children = _ref3.children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? '' : _ref3$className,
    _ref3$isClickable = _ref3.isClickable,
    isClickable = _ref3$isClickable === void 0 ? false : _ref3$isClickable,
    _ref3$isExpandable = _ref3.isExpandable,
    isExpandable = _ref3$isExpandable === void 0 ? true : _ref3$isExpandable,
    _ref3$subtitle = _ref3.subtitle,
    subtitle = _ref3$subtitle === void 0 ? '' : _ref3$subtitle,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded2);
  return React.createElement(Disclosure, Object.assign({
    as: as,
    className: className + " mt-2 w-full",
    ref: ref
  }, rest), function (_ref4) {
    var open = _ref4.open;
    return React.createElement(React.Fragment, null, React.createElement(Disclosure.Button, {
      className: ['w-full', 'border-t', 'border-x', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-one', open ? 'rounded-t' : 'border-b rounded md:hover:bg-surface-level-two'].join(' '),
      disabled: !isExpandable
    }, React.createElement("div", {
      className: "grid grid-cols-4 md:grid-cols-12 md:p-5"
    }, subtitle, React.createElement("div", {
      className: "col-span-2 hidden justify-self-end self-center md:block"
    }, isExpandable ? React.createElement(Media, {
      size: 5,
      variant: open ? 'chevron-up' : 'chevron-down'
    }) : null, isClickable ? React.createElement(Media, {
      size: 5,
      variant: "chevron-right"
    }) : null))), React.createElement(Disclosure.Panel, {
      className: ['px-5', 'pb-5', 'border-b', 'border-x', 'rounded-b', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-one'].join(' ')
    }, children));
  });
});
AccordionBase.displayName = 'AccordionBase';
var Accordion = /*#__PURE__*/Object.assign(AccordionBase, {
  Investment: Investment
});

var defaultProps$a = {
  as: 'div',
  className: '',
  steps: []
};
var AccountProgress = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    id = _ref.id,
    progress = _ref.progress,
    steps = _ref.steps;
  return React.createElement(Component, {
    className: "bg-surface-level-one low-border p-5 rounded space-y-8 " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement("div", {
    className: "space-y-4"
  }, React.createElement(Typography, {
    allBold: true
  }, progress === 100 ? 'Congratulations! Your account is complete' : 'Let’s complete your investor account'), React.createElement(Progress, {
    label: true,
    percent: progress
  })), steps == null ? void 0 : steps.map(function (step, id) {
    return React.createElement("div", {
      className: "flex items-center gap-5",
      key: step.label
    }, React.createElement("div", null, React.createElement(Steps, {
      variant: "secondary"
    }, progress >= 100 / steps.length * (id + 1) ? React.createElement(Media, {
      size: 0,
      className: "w-4 h-[11px] pt-[2px] pr-[1px]",
      variant: "tick"
    }) : null)), React.createElement("div", {
      className: "flex items-center justify-between w-full",
      onClick: step.onClick
    }, React.createElement(Typography, {
      variant: "secondary"
    }, step.label), progress < 100 / steps.length * (id + 1) && step.onClick !== undefined ? React.createElement(Media, {
      className: "cursor-pointer text-white",
      size: 5,
      variant: "arrow-right"
    }) : null));
  }), progress === 100 ? React.createElement(Button, {
    fullwidth: true,
    variant: "secondary"
  }, "Dismiss") : null);
});
AccountProgress.displayName = 'AccountProgress';
AccountProgress.defaultProps = defaultProps$a;

var defaultProps$b = {
  if_contract_type: false,
  loading: false,
  token_options: undefined,
  contract_options: undefined,
  setContractSelected: undefined,
  contract_selected: undefined,
  setTokenSelected: undefined,
  token_selected: undefined
};
var DepositForm = function DepositForm(_ref) {
  var contract = _ref.contract,
    balance = _ref.balance,
    handleClick = _ref.handleClick,
    value = _ref.value,
    handleChange = _ref.handleChange,
    loading = _ref.loading,
    handleMaxClick = _ref.handleMaxClick,
    token_ticker = _ref.token_ticker,
    contract_options = _ref.contract_options,
    setContractSelected = _ref.setContractSelected,
    contract_selected = _ref.contract_selected,
    token_selected = _ref.token_selected,
    token_options = _ref.token_options,
    setTokenSelected = _ref.setTokenSelected,
    disabled = _ref.disabled,
    className = _ref.className,
    pool_balance = _ref.pool_balance,
    is_wrong_chain = _ref.is_wrong_chain;
  var breakpoint = useBreakpoint();
  return React.createElement(Card, {
    className: "p-5 " + className
  }, contract_options && React.createElement(Select, {
    className: "mb-5",
    current: contract_selected,
    setCurrent: setContractSelected,
    surface: "zero",
    placeholder: "Select contract",
    options: contract_options,
    label: "Smart contract"
  }), token_options && React.createElement(Select, {
    className: "mb-5",
    current: token_selected,
    setCurrent: setTokenSelected,
    surface: "zero",
    placeholder: "Select token",
    options: token_options,
    label: "Token"
  }), React.createElement(Input, {
    placeholder: "Enter deposit amount",
    min: 0,
    value: value,
    containerClasses: contract_options ? 'mt-5' : '',
    className: "w-full",
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    label: 'Deposit amount',
    id: "contract-deposit-input",
    type: "number",
    unit: token_ticker,
    surface: "zero",
    handleMaxClick: handleMaxClick
  }), React.createElement("div", {
    className: "bg-surface-level-two rounded p-5 mt-5 border space-y-[2px] border-border border-opacity-[0.03]"
  }, React.createElement(DataLines, {
    variant: "default",
    label: "Contract Address",
    values: [{
      value: breakpoint < 640 ? shortenHex(contract) : contract
    }]
  }), React.createElement(DataLines, {
    variant: "default",
    label: "Wallet Balance",
    values: [{
      value: balance
    }]
  }), pool_balance && React.createElement(DataLines, {
    variant: "default",
    label: "Pool Balance",
    values: [{
      value: pool_balance
    }]
  })), React.createElement(Button, {
    id: "button",
    onClick: handleClick,
    className: "mt-5 w-full",
    disabled: value === '0' || value === '' || loading || disabled,
    loading: loading
  }, is_wrong_chain ? 'Switch Network' : 'Deposit'));
};
DepositForm.displayName = 'DepositForm';
DepositForm.defaultProps = defaultProps$b;

var IconLink = function IconLink(_ref) {
  var type = _ref.type,
    url = _ref.url;
  var _useState = useState(false),
    hovering = _useState[0],
    setHovering = _useState[1];
  return React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHovering(false);
    }
  }, React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "hover:text-primary"
  }, React.createElement(Media, {
    size: 5,
    className: hovering ? 'text-primary' : 'text-accent',
    variant: type
  })));
};
var Footer = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    links = _ref2.links,
    social_links = _ref2.social_links,
    _ref2$as = _ref2.as,
    Component = _ref2$as === void 0 ? 'footer' : _ref2$as,
    audited_by_img_urls = _ref2.audited_by_img_urls,
    evm_chains_supported = _ref2.evm_chains_supported,
    launchpad_show_powered_by_logo = _ref2.launchpad_show_powered_by_logo,
    has_caps_labels = _ref2.has_caps_labels,
    _ref2$has_copyright = _ref2.has_copyright,
    has_copyright = _ref2$has_copyright === void 0 ? true : _ref2$has_copyright,
    _ref2$powered_by_link = _ref2.powered_by_link,
    powered_by_link = _ref2$powered_by_link === void 0 ? 'https://www.decubate.com' : _ref2$powered_by_link,
    company_name = _ref2.company_name;
  var breakpoint = useBreakpoint();
  var first_break = breakpoint < 990;
  var only_audited = !launchpad_show_powered_by_logo && !evm_chains_supported;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className
  }, React.createElement("div", {
    className: (first_break ? '' : "flex " + (only_audited || launchpad_show_powered_by_logo && audited_by_img_urls ? '' : 'space-x-[100px]') + " justify-center") + " mb-[97px]"
  }, React.createElement("div", null, evm_chains_supported && React.createElement("div", {
    className: "" + (launchpad_show_powered_by_logo ? 'mr-[100px]' : '')
  }, React.createElement(Typography, {
    className: 'pb-5',
    size: "sm",
    variant: "secondary"
  }, has_caps_labels ? 'EVM chains supported'.toUpperCase() : 'EVM chains supported'), React.createElement("div", {
    className: "flex items-center space-x-4"
  }, evm_chains_supported.map(function (chain, i) {
    return React.createElement("img", {
      key: chain + "-" + i,
      alt: chain,
      className: "w-[32px] h-[32px]",
      src: chain
    });
  })))), React.createElement("div", {
    className: (first_break ? '' : 'flex space-x-[100px]') + "  " + (only_audited ? 'flex justify-center' : '')
  }, launchpad_show_powered_by_logo && React.createElement("div", {
    className: "" + (first_break ? 'mt-8 w-[150px]' : '')
  }, React.createElement("a", {
    href: powered_by_link,
    target: "_blank",
    rel: "noopener noreferrer",
    className: "w-full"
  }, React.createElement(Typography, {
    className: 'pb-5',
    size: "sm",
    variant: "secondary"
  }, has_caps_labels ? 'Powered by'.toUpperCase() : 'Powered by'), React.createElement("img", {
    className: "h-[32px] w-full",
    alt: "decubate-img",
    src: launchpad_show_powered_by_logo
  }))), audited_by_img_urls && React.createElement("div", null, React.createElement(Typography, {
    className: "pb-5 " + (only_audited ? 'text-center' : '') + " " + (first_break ? 'mt-8' : ''),
    size: "sm",
    variant: "secondary"
  }, has_caps_labels ? 'Smart contracts audited by'.toUpperCase() : 'Smart contracts audited by'), React.createElement("div", {
    className: "flex items-center space-x-[50px] " + (only_audited ? 'justify-center' : '')
  }, React.createElement("img", {
    className: "h-[32px]",
    alt: "audited-0",
    src: audited_by_img_urls[0]
  }), React.createElement("img", {
    className: "h-[32px]",
    alt: "audited-1",
    src: audited_by_img_urls[1]
  }))))), React.createElement("div", {
    className: "md:flex items-center " + (social_links.length ? 'mb-8' : 'md:mb-8') + " md:space-x-8"
  }, links && React.createElement("div", {
    className: "flex-1 md:flex items-center justify-items-start md:space-x-10 sm:gap-y-8 gap-y-10 grid grid-cols-2 sm:grid-cols-3"
  }, links.map(function (_ref3, idx) {
    var name = _ref3.name,
      handleClick = _ref3.handleClick,
      dropdown_options = _ref3.dropdown_options;
    if (dropdown_options != null && dropdown_options.length) {
      return React.createElement(Dropdown, {
        key: "footer-" + name + "-" + idx,
        container_class: "ml-4",
        options: dropdown_options.map(function (_ref4) {
          var name = _ref4.name,
            link = _ref4.link;
          return {
            name: name,
            onOptionClick: function onOptionClick() {
              window.open(link, '_blank');
            }
          };
        }),
        size: "xs",
        id: name.toLowerCase(),
        surface: "one",
        title: React.createElement("span", {
          className: "mx-3"
        }, name),
        dropdown_width: "w-[250px]",
        className: "min-w-max flex items-center space-x-3 h-full pt-4 pb-4",
        left_position_top_dropdown: true
      }, React.createElement(Typography, {
        size: "md",
        variant: "secondary"
      }, name), React.createElement(Media, {
        className: "mr-3 text-secondary",
        size: 4,
        variant: "chevron-up"
      }));
    }
    return React.createElement("button", {
      key: "footer-" + name + "-" + idx,
      onClick: handleClick
    }, React.createElement(Typography, {
      className: "hover:text-primary",
      size: "md",
      variant: "secondary"
    }, name));
  })), social_links && React.createElement("div", {
    className: "flex items-center justify-between space-x-10 mt-[60px] sm:mt-8 md:mt-0"
  }, social_links.map(function (_ref5) {
    var type = _ref5.type,
      url = _ref5.url;
    return React.createElement(IconLink, {
      key: type + JSON.stringify(url),
      type: type,
      url: url
    });
  }))), has_copyright && React.createElement("div", {
    className: "my-5"
  }, React.createElement("div", {
    className: "border-t-[1px] border-border text-primary"
  }, React.createElement(Typography, {
    size: "xs",
    className: "mt-5"
  }, "\xA9 COPYRIGHT ", new Date().getFullYear(), ' ', company_name ? company_name : 'Decubate', " | All rights reserved"))));
});
Footer.displayName = 'Footer';

var defaultProps$c = {
  className: '',
  disabled: false,
  continue_btn_text: 'Continue',
  loading: false,
  progress: undefined,
  skip_btn_text: undefined,
  subtitle: '',
  title: ''
};
var FormWrapper = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    skip_btn_disabled = _ref.skip_btn_disabled,
    continue_btn_disabled = _ref.continue_btn_disabled,
    loading = _ref.loading,
    progress = _ref.progress,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    subtitle = _ref.subtitle,
    title = _ref.title,
    handleContinueBtnClick = _ref.handleContinueBtnClick,
    handleSkipBtnClick = _ref.handleSkipBtnClick;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    border: false,
    height: "h-4",
    percent: progress,
    rounded: false,
    surface: "two"
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: (is_mobile ? 'px-5' : 'px-8') + " pt-8 rounded-b " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, title), subtitle && React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, subtitle), children, React.createElement("div", {
    className: "flex flex-row-reverse pt-8 " + (is_mobile ? 'pb-5' : 'pb-8')
  }, React.createElement(Button, {
    id: "continue-btn",
    className: skip_btn_text ? 'min-w-[177px]' : 'w-full',
    disabled: continue_btn_disabled,
    loading: loading,
    onClick: handleContinueBtnClick
  }, continue_btn_text), handleSkipBtnClick && skip_btn_text && React.createElement(Button, {
    id: "skip-btn",
    className: "bg-surface-level-one border-none text-secondary pr-5",
    disabled: skip_btn_disabled,
    variant: "custom",
    onClick: handleSkipBtnClick
  }, skip_btn_text))));
});
FormWrapper.displayName = 'FormWrapper';
FormWrapper.defaultProps = defaultProps$c;

var Links = function Links(_ref) {
  var nav_options = _ref.nav_options,
    current = _ref.current,
    setCurrent = _ref.setCurrent,
    has_smaller_link_gap = _ref.has_smaller_link_gap,
    is_mobile = _ref.is_mobile;
  var nav_options_to_use = useMemo(function () {
    return nav_options.filter(function (_ref2) {
      var desktop = _ref2.desktop;
      return desktop;
    });
  }, [nav_options]);
  return React.createElement("div", {
    className: (is_mobile ? 'hidden' : 'flex') + " items-center  h-16 " + (has_smaller_link_gap ? 'space-x-6' : 'space-x-12')
  }, nav_options_to_use.map(function (_ref3, idx) {
    var name = _ref3.name,
      id = _ref3.id,
      onOptionClick = _ref3.onOptionClick,
      dropdown_options = _ref3.dropdown_options;
    return dropdown_options ? React.createElement(Dropdown, {
      key: name + "-" + idx + "-dropdown",
      left_position: true,
      container_class: "ml-4",
      options: dropdown_options,
      size: "xs",
      id: name,
      surface: "one",
      title: React.createElement("span", {
        className: "mx-3"
      }, name),
      dropdown_width: "w-[160px]",
      className: "min-w-max flex items-center space-x-3 h-full pt-4 pb-4"
    }, React.createElement(Typography, {
      size: "md"
    }, name), React.createElement(Media, {
      className: "mr-3 text-primary",
      size: 4,
      variant: "chevron-down"
    })) : React.createElement("button", {
      key: name + "-" + idx,
      id: name,
      onClick: function onClick() {
        setCurrent(id);
        onOptionClick();
      },
      className: "min-w-max flex items-center h-full justify-center " + (id === current ? 'border-b-4 border-accent pt-4 pb-3' : 'pt-4 pb-4')
    }, React.createElement(Typography, {
      allBold: id === current,
      size: "md"
    }, name));
  }));
};

var Logo = function Logo(_ref) {
  var _onClick = _ref.onClick,
    mobile = _ref.mobile,
    desktop = _ref.desktop;
  return React.createElement("button", {
    onClick: function onClick() {
      return _onClick();
    }
  }, React.createElement("div", {
    className: "hidden md:flex items-center h-[44px] min-w-[150px]"
  }, React.createElement("img", {
    src: desktop,
    className: "object-contain max-h-[44px]",
    alt: "Logo"
  })), React.createElement("div", {
    className: "md:hidden flex items-center h-[44px]"
  }, React.createElement("img", {
    src: mobile,
    className: "object-contain max-h-[44px]",
    alt: "Logo"
  })));
};

var Account = function Account(_ref) {
  var dropdown_options = _ref.dropdown_options,
    handleDrawerClose = _ref.handleDrawerClose;
  return React.createElement("div", {
    className: "space-y-6 mt-10 mb-4"
  }, dropdown_options.map(function (_ref2, idx) {
    var name = _ref2.name,
      icon = _ref2.icon,
      onOptionClick = _ref2.onOptionClick,
      rightBtnHandleClick = _ref2.rightBtnHandleClick,
      right_btn_text = _ref2.right_btn_text;
    return React.createElement("div", {
      key: name + "-" + idx + "-" + icon,
      className: "flex justify-between"
    }, React.createElement("div", {
      className: "flex space-x-6 items-center"
    }, React.createElement(Media, {
      variant: icon,
      size: 5,
      className: "text-accent"
    }), React.createElement("button", {
      key: name,
      id: name,
      onClick: function onClick() {
        if (onOptionClick) {
          onOptionClick();
          handleDrawerClose();
        }
      }
    }, React.createElement(Typography, {
      variant: "secondary",
      size: "md"
    }, name))), rightBtnHandleClick && React.createElement(Typography, {
      size: "sm",
      variant: "custom",
      className: "text-accent hover:underline cursor-pointer pl-5",
      onClick: function onClick() {
        if (rightBtnHandleClick) {
          rightBtnHandleClick();
          handleDrawerClose();
        }
      }
    }, right_btn_text));
  }));
};

var defaultProps$d = {
  right_label_text: undefined,
  right_info_text: undefined,
  variant: 'none',
  active: undefined
};
var ListItem = function ListItem(_ref) {
  var button_text = _ref.button_text,
    label_text = _ref.label_text,
    info_text = _ref.info_text,
    image_url = _ref.image_url,
    right_label_text = _ref.right_label_text,
    right_info_text = _ref.right_info_text,
    label_color = _ref.label_color,
    variant = _ref.variant,
    active = _ref.active,
    _ref$tooltipText = _ref.tooltipText,
    tooltipText = _ref$tooltipText === void 0 ? '' : _ref$tooltipText,
    setActive = _ref.setActive,
    handleClick = _ref.handleClick,
    handleCardClick = _ref.handleCardClick,
    handleDelete = _ref.handleDelete;
  return React.createElement("div", {
    className: "flex justify-between items-center w-full"
  }, React.createElement("div", {
    onClick: handleCardClick,
    className: "flex pl-5 py-4 w-full " + (handleCardClick ? 'cursor-pointer' : '')
  }, image_url && React.createElement("div", {
    className: "pr-5 relative"
  }, tooltipText ? React.createElement(Tooltip, {
    text: tooltipText
  }, React.createElement("div", {
    className: "absolute ml-7 bottom-8 md:bottom-8"
  }, React.createElement("div", {
    className: "bg-accent flex h-4 items-center justify-center rounded-full w-4"
  }, React.createElement(Media, {
    size: 3,
    variant: "bolt"
  }))), React.createElement("div", {
    className: "w-11 h-11"
  }, React.createElement("img", {
    src: image_url,
    alt: label_text
  }))) : React.createElement("div", {
    className: "w-11 h-11"
  }, React.createElement("img", {
    src: image_url,
    alt: label_text
  }))), React.createElement("div", {
    className: "max-w-[400px] text-left"
  }, React.createElement(Typography, {
    allBold: true,
    size: "md",
    "data-testid": "list-item-label"
  }, label_text), React.createElement(Typography, {
    variant: "secondary",
    className: "truncate",
    size: variant === 'data' ? 'xs' : 'sm'
  }, info_text))), React.createElement("div", {
    className: "pr-5 py-4"
  }, variant === 'button' && React.createElement(Typography, {
    size: "sm",
    onClick: handleClick,
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer pl-5 min-w-max"
  }, button_text), variant === 'switch' && setActive && active !== undefined && React.createElement("div", {
    className: "flex items-center space-x-5 w-full ml-5"
  }, React.createElement("div", {
    className: "flex space-x-5"
  }, React.createElement(Typography, {
    variant: "custom",
    className: (active ? 'text-success' : 'text-accent') + " w-[99px] text-right"
  }, active ? 'Announced' : 'Unannounced'), React.createElement(Toggle, {
    switch_active_color: "success",
    switch_surface_color: "bg-surface-level-zero",
    active: active,
    onChange: setActive,
    variant: "switch"
  })), handleDelete && React.createElement(Button, {
    onClick: handleDelete,
    iconOnly: true
  }, React.createElement(Media, {
    variant: "bin",
    size: 0,
    className: "w-[17px] h-[18px]"
  }))), variant === 'data' && React.createElement(DataLines, {
    top_size: "md",
    bottom_size: "xs",
    is_top_bold: true,
    is_bottom_bold: true,
    label_color: label_color,
    label: right_info_text,
    values: [{
      value: right_label_text
    }],
    variant: "verticle",
    float_right: true
  })));
};
ListItem.displayName = 'ListItem';
ListItem.defaultProps = defaultProps$d;

var defaultProps$e = {
  surface: 'two'
};
var TierCard = function TierCard(_ref) {
  var tier_info = _ref.tier_info,
    className = _ref.className,
    surface = _ref.surface;
  return React.createElement(Card, {
    surface: surface,
    className: "" + className
  }, React.createElement(ListItem, {
    button_text: tier_info != null && tier_info.handleClick ? 'Upgrade' : undefined,
    image_url: tier_info.tier_img_url,
    info_text: "Investor tier",
    label_text: tier_info == null ? void 0 : tier_info.tier_string,
    variant: tier_info.handleClick ? 'button' : 'data',
    tooltipText: tier_info.has_boost ? "<div class=\"text-xs text-secondary\">Your tier is boosted by <span class='font-bold text-white'>" + tier_info.tier_boost + "%</span>. Tier without boost is <span class='font-bold text-white'>" + tier_info.tier_without_boost + "</span>.</div>" : undefined,
    handleClick: tier_info.handleClick
  }));
};
TierCard.displayName = 'TierCard';
TierCard.defaultProps = defaultProps$e;

var MobileNav = function MobileNav(_ref) {
  var dropdown_options = _ref.dropdown_options,
    mobile_nav_open = _ref.mobile_nav_open,
    handleDrawerClose = _ref.handleDrawerClose,
    nav_options = _ref.nav_options,
    tier = _ref.tier,
    notification_active = _ref.notification_active,
    notification_height = _ref.notification_height,
    is_mobile = _ref.is_mobile;
  var margin_to_add = notification_active ? 63 + notification_height : 63;
  return React.createElement(Drawer, {
    className: "bg-surface-level-one z-50 " + (is_mobile ? 'inline' : 'hidden') + " " + (tier ? 'pt-5' : ''),
    show: mobile_nav_open,
    style: {
      marginTop: margin_to_add + "px"
    }
  }, tier && React.createElement(TierCard, {
    tier_info: tier
  }), React.createElement("div", null, React.createElement("div", {
    className: "space-y-10 pt-10"
  }, nav_options.map(function (_ref2, idx) {
    var name = _ref2.name,
      onOptionClick = _ref2.onOptionClick;
    return React.createElement("div", {
      key: name + "-" + idx + "-mobile"
    }, React.createElement("button", {
      onClick: function onClick() {
        onOptionClick();
        handleDrawerClose();
      }
    }, React.createElement(Typography, {
      allBold: true,
      as: "h4",
      size: "2xl"
    }, name)));
  })), React.createElement(Account, {
    handleDrawerClose: handleDrawerClose,
    dropdown_options: dropdown_options
  })));
};
MobileNav.displayName = 'MobileNav';

var defaultProps$f = {};
var CustomChip = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    custom_image = _ref.custom_image,
    label = _ref.label,
    value = _ref.value,
    handleClick = _ref.handleClick;
  return React.createElement("div", {
    onClick: handleClick,
    className: "flex gap-1 items-center " + className
  }, React.createElement(Chip, {
    className: [className, 'px-2', 'border', 'border-border', 'text-secondary', 'border-opacity-[0.03]', 'bg-surface-level-two', 'hover:bg-surface-level-three'].join(' '),
    ref: ref,
    size: "lg",
    variant: "custom"
  }, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement("div", null, custom_image), React.createElement("div", {
    className: "ml-2 pb-1.5"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, value), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "leading-[8px]"
  }, label)))));
});
CustomChip.displayName = 'CustomChip';
CustomChip.defaultProps = defaultProps$f;

var defaultProps$g = {
  user: undefined,
  tier: undefined,
  dcb_burned: undefined
};
var Header = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    dropdown_options = _ref.dropdown_options,
    tier = _ref.tier,
    setCurrent = _ref.setCurrent,
    current = _ref.current,
    nav_options = _ref.nav_options,
    logo = _ref.logo,
    dcb_burned = _ref.dcb_burned,
    handleBurnClick = _ref.handleBurnClick,
    notification = _ref.notification,
    handleReferralClick = _ref.handleReferralClick,
    burn_label = _ref.burn_label,
    _ref$has_centered_lin = _ref.has_centered_links,
    has_centered_links = _ref$has_centered_lin === void 0 ? false : _ref$has_centered_lin,
    has_smaller_link_gap = _ref.has_smaller_link_gap,
    smaller_logo_links_gap = _ref.smaller_logo_links_gap;
  var _useState = useState(false),
    mobile_nav_open = _useState[0],
    setMobileNavOpen = _useState[1];
  var notificationRef = React.useRef(null);
  var breakpoint = useBreakpoint();
  var _React$useState = React.useState(0),
    notification_height = _React$useState[0],
    setNotificationHeight = _React$useState[1]; // State for height
  useEffect(function () {
    var handleResize = function handleResize() {
      // Measure height and update state
      if (notificationRef.current) {
        setNotificationHeight(notificationRef.current.offsetHeight);
      }
    };
    // Measure height initially and on window resize
    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [notification == null ? void 0 : notification.active]);
  var handleDrawerClose = function handleDrawerClose() {
    setMobileNavOpen(false);
  };
  var is_mobile = breakpoint < 1150;
  return React.createElement("header", {
    "data-testid": "header",
    className: " " + (className || ''),
    ref: ref
  }, notification && (notification == null ? void 0 : notification.active) && React.createElement(NotificationBar, Object.assign({
    ref: notificationRef
  }, notification)), React.createElement("div", {
    className: "bg-surface-level-one w-full mx-auto flex items-center justify-between h-16 border-b border-border border-opacity-[0.03]"
  }, React.createElement("div", {
    className: "flex w-full max-w-screen-lg mx-auto px-5 items-center"
  }, has_centered_links ? React.createElement(React.Fragment, null, React.createElement("div", {
    className: "w-1/4 flex justify-start"
  }, React.createElement(Logo, Object.assign({}, logo))), React.createElement("div", {
    className: "w-1/2 flex justify-center"
  }, React.createElement(Links, {
    is_mobile: is_mobile,
    has_smaller_link_gap: has_smaller_link_gap,
    nav_options: nav_options,
    current: current,
    setCurrent: setCurrent
  })), React.createElement("div", {
    className: "w-1/4 flex justify-end"
  }, React.createElement("div", {
    className: "flex my-auto space-x-3"
  }, handleReferralClick && React.createElement("button", {
    className: "inline-flex items-center justify-center h-11 w-11 flex-shrink-0 border rounded border-border border-opacity-[0.03] bg-surface-level-two hover:bg-surface-level-three",
    onClick: handleReferralClick
  }, React.createElement(Media, {
    size: 5,
    variant: "present"
  })), dcb_burned && React.createElement(CustomChip, {
    className: "cursor-pointer min-w-[118px]",
    handleClick: handleBurnClick,
    value: dcb_burned,
    label: burn_label || 'DCB Burned',
    custom_image: React.createElement("div", {
      className: "h-7 w-7 rounded-full high-border bg-gradient-burn-logo flex items-center justify-center"
    }, React.createElement(Media, {
      size: 0,
      className: "w-[18px] h-5",
      variant: "burn"
    }))
  }), React.createElement("div", {
    className: "flex space-x-5 md:space-x-10 items-center w-[81px] flex-shrink-0"
  }, React.createElement(AccountDropdown, {
    is_mobile: is_mobile,
    tier_info: tier,
    setMobileNavOpen: setMobileNavOpen,
    mobile_nav_open: mobile_nav_open,
    className: "absolute z-30 md:inline-block",
    options: dropdown_options,
    mediaClassName: "text-accent"
  }))))) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex justify-between w-full"
  }, React.createElement("div", {
    className: "flex items-center " + (smaller_logo_links_gap ? 'space-x-6' : 'space-x-20')
  }, React.createElement(Logo, Object.assign({}, logo)), React.createElement(Links, {
    is_mobile: is_mobile,
    has_smaller_link_gap: has_smaller_link_gap,
    nav_options: nav_options,
    current: current,
    setCurrent: setCurrent
  })), React.createElement("div", {
    className: "flex my-auto space-x-3 flex-shrink-0"
  }, handleReferralClick && React.createElement("button", {
    className: "inline-flex items-center justify-center h-11 w-11 border  rounded border-border border-opacity-[0.03] bg-surface-level-two hover:bg-surface-level-three",
    onClick: handleReferralClick
  }, React.createElement(Media, {
    size: 5,
    variant: "present"
  })), dcb_burned && React.createElement(CustomChip, {
    className: "cursor-pointer",
    handleClick: handleBurnClick,
    value: dcb_burned,
    label: burn_label || 'DCB Burned',
    custom_image: React.createElement("div", {
      className: "h-7 w-7 rounded-full high-border bg-gradient-burn-logo flex items-center justify-center"
    }, React.createElement(Media, {
      size: 0,
      className: "w-[18px] h-5",
      variant: "burn"
    }))
  }), React.createElement("div", {
    className: "flex items-center"
  }, React.createElement(AccountDropdown, {
    is_mobile: is_mobile,
    tier_info: tier,
    setMobileNavOpen: setMobileNavOpen,
    mobile_nav_open: mobile_nav_open,
    className: "absolute z-30 " + (is_mobile ? '' : 'inline-block'),
    options: dropdown_options,
    mediaClassName: "text-accent"
  }))))))), React.createElement(MobileNav, {
    is_mobile: is_mobile,
    notification_active: (notification == null ? void 0 : notification.active) || false,
    tier: tier,
    handleDrawerClose: handleDrawerClose,
    nav_options: nav_options,
    dropdown_options: dropdown_options,
    mobile_nav_open: mobile_nav_open,
    notification_height: notification_height
  }));
});
Header.displayName = 'Header';
Header.defaultProps = defaultProps$g;

var DisclosureButton = function DisclosureButton(_ref) {
  var chainId = _ref.chainId,
    eventName = _ref.eventName,
    isProtected = _ref.isProtected,
    status = _ref.status,
    totalInvested = _ref.totalInvested,
    totalTokens = _ref.totalTokens,
    vestingDetails = _ref.vestingDetails,
    handleClick = _ref.handleClick;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: ['p-5', 'col-span-4', 'rounded', 'bg-surface-level-two', 'md:p-0', 'md:rounded-none', 'md:bg-transparent', handleClick ? 'cursor-pointer' : ''].join(' '),
    onClick: handleClick
  }, React.createElement("div", {
    className: "flex items-center self-center"
  }, React.createElement(Typography, {
    allBold: true
  }, eventName), isProtected ? React.createElement("img", {
    className: "h-8 w-8 ml-3",
    src: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/Protected-Green.svg',
    alt: "protected"
  }) : null, chainId ? React.createElement("img", {
    className: "h-8 w-8 ml-3",
    src: chainId,
    alt: "blockchain"
  }) : null, React.createElement("span", {
    className: "ml-auto md:hidden"
  }, handleClick ? React.createElement(Media, {
    size: 5,
    variant: "chevron-right"
  }) : vestingDetails !== undefined ? React.createElement(Media, {
    size: 5,
    variant: "chevron-down"
  }) : null))), React.createElement("div", {
    className: "col-span-2 mt-5 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Invested")), React.createElement("div", {
    className: "col-span-2 mt-5 pr-5 self-center md:mt-0 md:pr-0"
  }, totalInvested ? React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, totalInvested) : React.createElement("div", {
    className: "rounded-full border border-accent text-accent px-3 py-1 text-xs max-w-min mx-auto"
  }, "N/A")), React.createElement("div", {
    className: "col-span-2 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Tokens")), React.createElement("div", {
    className: "col-span-2 pr-5 self-center md:pr-0"
  }, React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, totalTokens)), React.createElement("div", {
    className: "col-span-2 mb-5 pl-5 self-center md:hidden"
  }, React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Status")), React.createElement("div", {
    className: "col-span-2 mb-5 pr-5 self-center md:mb-0 md:pr-0"
  }, React.createElement("p", {
    className: "font-bold text-primary text-right text-sm md:font-normal md:text-justify"
  }, status)));
};
var PortfolioItem = function PortfolioItem(_ref2) {
  var className = _ref2.className,
    chainId = _ref2.chainId,
    eventName = _ref2.eventName,
    isProtected = _ref2.isProtected,
    status = _ref2.status,
    totalInvested = _ref2.totalInvested,
    totalTokens = _ref2.totalTokens,
    vestingDetails = _ref2.vestingDetails,
    handleClick = _ref2.handleClick;
  return React.createElement(Accordion.Investment, {
    className: " " + className,
    isClickable: handleClick !== undefined,
    isExpandable: vestingDetails !== undefined,
    subtitle: React.createElement(DisclosureButton, {
      chainId: chainId,
      eventName: eventName,
      isProtected: isProtected,
      status: status,
      totalInvested: totalInvested,
      totalTokens: totalTokens,
      vestingDetails: vestingDetails,
      handleClick: handleClick
    })
  }, React.createElement("div", {
    className: "flex flex-col gap-5 border-t border-surface-level-three md:flex-row"
  }, React.createElement("div", {
    className: "flex-1 space-y-5"
  }, React.createElement("div", {
    className: "gap-5 grid grid-cols-2 mt-5 md:grid-cols-3"
  }, React.createElement(Card, {
    className: "p-5 w-full",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.startDate), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "vesting start")), React.createElement(Card, {
    className: "p-5 w-full",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.endDate), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "vesting end")), React.createElement(Card, {
    className: "col-span-2 p-5 w-full md:col-span-1",
    surface: "two"
  }, React.createElement("h1", {
    className: "font-bold text-md text-white md:text-2xl"
  }, vestingDetails == null ? void 0 : vestingDetails.refundDeadline), React.createElement(Typography, {
    allCaps: true,
    size: "xs",
    variant: "secondary"
  }, "refund deadline"))), React.createElement("div", null, React.createElement(Card, {
    className: "p-5",
    surface: "two"
  }, React.createElement("div", {
    className: "mb-8 space-y-2"
  }, React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Locked"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.locked)), React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Claimed"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.claimed)), React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Available to claim"), React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, vestingDetails == null ? void 0 : vestingDetails.available))), React.createElement(Button, {
    fullwidth: true,
    className: "mb-4"
  }, "Claim tokens"), React.createElement(Button, {
    fullwidth: true,
    className: "bg-surface-level-three text-secondary",
    variant: "custom"
  }, "Refund")))), React.createElement(Chart, {
    className: "flex-1 md:mt-5",
    data: vestingDetails == null ? void 0 : vestingDetails.chartData,
    unit: "" + (vestingDetails == null ? void 0 : vestingDetails.symbol)
  })));
};
PortfolioItem.displayName = 'PortfolioItem';

var defaultProps$h = {
  surface: 'one'
};
var ListItemUnit = function ListItemUnit(_ref) {
  var list_item_arr = _ref.list_item_arr,
    className = _ref.className,
    surface = _ref.surface;
  return React.createElement("div", {
    className: "bg-surface-level-" + surface + " low-border rounded w-full " + className
  }, list_item_arr.map(function (_ref2, id) {
    var button_text = _ref2.button_text,
      label_text = _ref2.label_text,
      info_text = _ref2.info_text,
      image_url = _ref2.image_url,
      handleClick = _ref2.handleClick,
      right_info_text = _ref2.right_info_text,
      right_label_text = _ref2.right_label_text,
      label_color = _ref2.label_color,
      active = _ref2.active,
      setActive = _ref2.setActive,
      variant = _ref2.variant,
      handleCardClick = _ref2.handleCardClick,
      handleDelete = _ref2.handleDelete;
    return React.createElement("div", {
      key: JSON.stringify({
        label_text: label_text,
        id: id
      })
    }, React.createElement("div", {
      className: ""
    }, React.createElement(ListItem, {
      variant: variant,
      button_text: button_text,
      label_text: label_text,
      info_text: info_text,
      image_url: image_url,
      handleClick: handleClick,
      label_color: label_color,
      right_info_text: right_info_text,
      right_label_text: right_label_text,
      active: active,
      setActive: setActive,
      handleCardClick: handleCardClick,
      handleDelete: handleDelete
    })), list_item_arr.length - 1 !== id && React.createElement("div", {
      key: label_text + "-" + id,
      className: "border-b bg-surface-level-three border-b-surface-level-three " + (image_url ? 'mr-5 ml-[84px]' : 'mr-5 ml-5')
    }));
  }));
};
ListItemUnit.displayName = 'ListItemUnit';
ListItemUnit.defaultProps = defaultProps$h;

var defaultProps$i = {};
var MessageCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    subtitle = _ref.subtitle,
    progress = _ref.progress,
    title = _ref.title,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    loading = _ref.loading,
    disabled = _ref.disabled;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "max-w-[580px] overflow-hidden " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border border-b-surface-level-one border-t-surface-level-one border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b  " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, title), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, subtitle), React.createElement("div", {
    className: "flex flex-row-reverse py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    disabled: disabled,
    onClick: function onClick() {
      return handleContinueClick();
    },
    className: "" + (skip_btn_text ? 'w-[200px]' : 'w-full'),
    type: "submit",
    loading: loading
  }, continue_btn_text), skip_btn_text && handleSkipClick && React.createElement("button", {
    "data-testid": "skip-btn",
    onClick: function onClick() {
      return handleSkipClick();
    },
    className: "sm:px-10 pr-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, skip_btn_text)))));
});
MessageCard.displayName = 'MessageCard';
MessageCard.defaultProps = defaultProps$i;

var _excluded$e = ["as", "children", "className", "desc", "noClose", "show", "title", "surface", "onClose", "is_fixed_height", "container_class", "children_classes", "no_centered_text", "contentRef"];
var Modal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'max-w-[580px]' : _ref$className,
    _ref$desc = _ref.desc,
    desc = _ref$desc === void 0 ? '' : _ref$desc,
    noClose = _ref.noClose,
    show = _ref.show,
    title = _ref.title,
    _ref$surface = _ref.surface,
    surface = _ref$surface === void 0 ? 'one' : _ref$surface,
    onClose = _ref.onClose,
    _ref$is_fixed_height = _ref.is_fixed_height,
    is_fixed_height = _ref$is_fixed_height === void 0 ? true : _ref$is_fixed_height,
    children_classes = _ref.children_classes,
    no_centered_text = _ref.no_centered_text,
    contentRef = _ref.contentRef,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$e);
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  useEffect(function () {
    var originalStyle = window.getComputedStyle(document.body).overflow;
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = originalStyle;
    }
    // Cleanup function to reset the overflow style
    return function () {
      document.body.style.overflow = originalStyle;
    };
  }, [show]);
  return React.createElement(Transition, {
    show: show,
    onClick: inside_card ? undefined : onClose
  }, React.createElement(Component, Object.assign({
    ref: ref
  }, rest), React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0"
  }, React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-80 z-[80]"
  })), React.createElement("div", {
    className: "fixed inset-0 overflow-y-auto z-[90]",
    ref: contentRef
  }, React.createElement("div", {
    className: "flex min-h-full items-center justify-center p-4 " + (no_centered_text ? '' : 'text-center')
  }, React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 scale-95",
    enterTo: "opacity-100 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 scale-100",
    leaveTo: "opacity-0 scale-95",
    className: "w-full"
  }, !noClose ? React.createElement(Button, {
    iconOnly: true,
    className: [surface === 'zero' ? 'bg-surface-level-zero hover:bg-surface-level-one' : '', surface === 'one' ? 'bg-surface-level-one hover:bg-surface-level-two' : '', surface === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : '', surface === 'three' ? 'bg-surface-level-three hover:bg-surface-level-zero' : '', surface === 'custom' ? 'bg-primary hover:bg-white' : '', 'mb-8'].join(' '),
    variant: "custom",
    onClick: onClose
  }, React.createElement(Media, {
    size: 5,
    variant: "cross"
  })) : null, React.createElement("div", {
    className: ['p-5', 'border', 'border-border', 'border-opacity-[0.03]', 'w-full', 'mx-auto', 'transform', 'rounded', 'align-middle', is_fixed_height ? 'max-h-[540px] xs:max-h-[580px]' : 'max-h-[90vh] overflow-y-auto', 'transition-all', 'xs:p-8', surface === 'zero' ? 'bg-surface-level-zero' : '', surface === 'one' ? 'bg-surface-level-one' : '', surface === 'two' ? 'bg-surface-level-two' : '', surface === 'three' ? 'bg-surface-level-three' : '', surface === 'custom' ? '' : '', className].join(' '),
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    }
  }, title && React.createElement("h3", {
    className: "font-bold text-3xl text-center text-primary xs:text-4xl"
  }, title), desc && React.createElement("div", {
    className: "mt-2 text-center text-secondary mb-8"
  }, desc), React.createElement("div", {
    className: "" + children_classes
  }, children)))))));
});
Modal.displayName = 'Modal';

var defaultProps$j = {
  chipText: '',
  className: '',
  subtitle: '',
  surface: 'one',
  title: '',
  variant: 'staking'
};
var ProductCard = function ProductCard(_ref) {
  var id = _ref.id,
    chipText = _ref.chipText,
    className = _ref.className,
    subtitle = _ref.subtitle,
    surface = _ref.surface,
    title = _ref.title,
    variant = _ref.variant,
    handleClick = _ref.handleClick;
  var breakpoint = useBreakpoint();
  var _useState = useState(false),
    hover = _useState[0],
    setHover = _useState[1];
  return React.createElement("button", {
    onClick: handleClick,
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: ['px-5', 'py-[12px]', 'flex', 'w-full', 'relative', 'low-border', 'rounded', 'items-center', surface === 'zero' ? 'bg-surface-level-zero hover:bg-surface-level-one' : '', surface === 'one' ? 'bg-surface-level-one hover:bg-surface-level-two' : '', surface === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : '', surface === 'three' ? 'bg-surface-level-three' : '', 'xs:p-5', className].join(' '),
    "data-testid": id
  }, chipText ? React.createElement(Chip, {
    variant: "custom",
    size: "xs",
    className: "bg-gradient-purple text-primary text-xs font-bold px-3 absolute -top-3 right-5"
  }, chipText) : null, React.createElement(ProductBadge, {
    size: breakpoint < 480 ? 'sm' : 'md',
    surface: hover ? 'three' : 'two',
    variant: variant
  }), React.createElement("div", {
    className: "pl-5 pb-[1px] text-left"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, subtitle), React.createElement(Typography, {
    allBold: true,
    as: "h3",
    size: "2xl"
  }, title)));
};
ProductCard.displayName = 'ProductCard';
ProductCard.defaultProps = defaultProps$j;

var _event_labels;
var ChipType;
(function (ChipType) {
  ChipType["Private"] = "Private";
  ChipType["Seed"] = "Seed";
  ChipType["Public"] = "Public";
  ChipType["TokenClaim"] = "TokenClaim";
  ChipType["Standard"] = "Standard";
  ChipType["Exclusive"] = "Exclusive";
  ChipType["Acceleration"] = "Acceleration";
  ChipType["Incubation"] = "Incubation";
})(ChipType || (ChipType = {}));
var event_labels = (_event_labels = {}, _event_labels[ChipType.Private] = 'Private IDO', _event_labels[ChipType.Public] = 'Public IDO', _event_labels[ChipType.Seed] = 'Seed IDO', _event_labels[ChipType.TokenClaim] = 'Learn 2 Earn', _event_labels[ChipType.Standard] = 'Standard', _event_labels[ChipType.Exclusive] = 'Exclusive', _event_labels[ChipType.Acceleration] = 'Acceleration', _event_labels[ChipType.Incubation] = 'Incubation', _event_labels);
// TODO: delete this component when the new designs are implemented
var getLeftPosition = function getLeftPosition(chip_text) {
  switch (chip_text) {
    case ChipType.Private:
      return {
        icon: 'left-[140px]',
        helper_text: 'left-[67px]'
      };
    case ChipType.Seed:
      return {
        icon: 'left-[129px]',
        helper_text: 'left-[55px]'
      };
    case ChipType.Acceleration:
      return {
        icon: 'left-[150px]',
        helper_text: 'left-[76px]'
      };
    case ChipType.Incubation:
      return {
        icon: 'left-[135px]',
        helper_text: 'left-[60px]'
      };
    case ChipType.Exclusive:
      return {
        icon: 'left-[130px]',
        helper_text: 'left-[55px]'
      };
    case ChipType.Standard:
      return {
        icon: 'left-[130px]',
        helper_text: 'left-[55px]'
      };
    case ChipType.TokenClaim:
      return {
        icon: 'left-[145px]',
        helper_text: 'left-[70px]'
      };
    case ChipType.Public:
      return {
        icon: 'left-[135px]',
        helper_text: 'left-[60px]'
      };
    default:
      return {
        icon: 'left-[140px]',
        helper_text: 'left-[160px]'
      };
  }
};
var ProjectCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    chip_text = _ref.chip_text,
    heading_text = _ref.heading_text,
    image_url = _ref.image_url,
    logo_url = _ref.logo_url,
    network_logo = _ref.network_logo,
    status_badge = _ref.status_badge,
    card_data = _ref.card_data,
    _ref$badge_color = _ref.badge_color,
    badge_color = _ref$badge_color === void 0 ? 'secondary' : _ref$badge_color,
    protected_img_url = _ref.protected_img_url,
    protected_helper_text = _ref.protected_helper_text,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'project-card' : _ref$id,
    has_cut_corners = _ref.has_cut_corners,
    _ref$announced = _ref.announced,
    announced = _ref$announced === void 0 ? true : _ref$announced,
    handleClick = _ref.handleClick;
  var _useState = useState(true),
    logo_loading = _useState[0],
    setLogoLoading = _useState[1];
  var _useState2 = useState(true),
    image_loading = _useState2[0],
    setImageLoading = _useState2[1];
  var _useState3 = useState(false),
    hover = _useState3[0],
    setHover = _useState3[1];
  var _useState4 = useState(false),
    card_hover = _useState4[0],
    setCardHover = _useState4[1];
  var image = useRef(null);
  var logo = useRef(null);
  useEffect(function () {
    var _image$current;
    if ((_image$current = image.current) != null && _image$current.complete) setImageLoading(false);
  }, [image.current]);
  useEffect(function () {
    var _logo$current;
    if ((_logo$current = logo.current) != null && _logo$current.complete) setLogoLoading(false);
  }, [logo, image]);
  return React.createElement("div", {
    onMouseEnter: function onMouseEnter() {
      return setCardHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setCardHover(false);
    },
    id: id,
    className: "low-border relative w-full rounded cursor-pointer " + (has_cut_corners ? 'cut-corner-card' : 'bg-surface-level-one hover:bg-surface-level-two') + " " + className,
    ref: ref
  }, React.createElement("div", {
    className: "relative p-[1px] " + (image_loading ? 'bg-surface-level-two aspect-[7/4] animate-pulse' : '')
  }, React.createElement("div", {
    className: "" + (has_cut_corners ? 'cut-image-for-card' : '')
  }, React.createElement("img", {
    ref: image,
    className: "h-full w-full " + (has_cut_corners ? '' : 'rounded-t'),
    src: image_url,
    alt: "card-img",
    onLoad: function onLoad() {
      return setImageLoading(false);
    }
  })), React.createElement("div", {
    className: "flex items-center justify-center w-20 h-20 bg-surface-level-zero low-border rounded absolute left-7 bottom-[-32px] " + (logo_loading ? 'animate-pulse' : '')
  }, React.createElement("img", {
    alt: "logo-img",
    ref: logo,
    src: logo_url,
    className: "h-[52px] w-[52px]",
    onLoad: function onLoad() {
      return setLogoLoading(false);
    }
  }))), React.createElement("div", {
    className: "pb-7 px-7 pt-12"
  }, React.createElement(Chip, {
    className: "absolute right-7 top-7",
    variant: badge_color
  }, status_badge), protected_img_url && protected_helper_text && hover && React.createElement(HelperBox, {
    className: "absolute w-[180px] bottom-[208px] " + getLeftPosition(chip_text).helper_text,
    helper_text: protected_helper_text
  }), protected_img_url && React.createElement("img", {
    onMouseEnter: function onMouseEnter() {
      return setHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setHover(false);
    },
    className: "absolute h-8 w-8 " + getLeftPosition(chip_text).icon,
    src: protected_img_url,
    alt: "protected"
  }), React.createElement("div", {
    className: "flex items-center space-x-8"
  }, React.createElement(Chip, {
    variant: "" + (card_hover ? 'lighter' : 'secondary')
  }, chip_text ? event_labels[chip_text] : 'TBA'), React.createElement("div", {
    className: "flex-1 flex items-center justify-end"
  }, React.createElement("img", {
    src: network_logo,
    alt: "network"
  }))), React.createElement(Typography, {
    allBold: true,
    className: "pt-4",
    size: "2xl"
  }, heading_text), React.createElement("div", {
    className: "space-y-3 pt-4"
  }, card_data.map(function (_ref2, idx) {
    var label = _ref2.label,
      values = _ref2.values;
    return React.createElement(DataLines, {
      key: label + idx,
      label: label,
      values: values,
      variant: "default"
    });
  })), !announced && React.createElement(Button, {
    variant: "primary",
    className: "mt-[22px] w-full",
    onClick: handleClick
  }, "Join community to guess who")));
});
ProjectCard.displayName = 'ProjectCard';

var Setup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    value = _ref.value,
    loading = _ref.loading,
    handleClick = _ref.handleClick,
    handleChange = _ref.handleChange,
    error = _ref.error,
    handleSkipClick = _ref.handleSkipClick,
    qr_code = _ref.qr_code,
    progress = _ref.progress,
    disabled = _ref.disabled;
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, "2FA setup"), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center pb-8"
  }, React.createElement("span", null, "Please use your authenticator app such as ", React.createElement("br", null), "Google Authenticator, to scan this QR code.")), React.createElement("div", {
    className: "mx-auto flex items-center justify-center rounded bg-surface-level-two w-[230px] h-[230px]"
  }, qr_code ? React.createElement("img", {
    src: qr_code,
    className: "w-[230px] h-[230px] mx-auto rounded",
    alt: "QR code"
  }) : React.createElement(Media, {
    className: "text-button",
    variant: "loader"
  })), React.createElement(Typography, {
    variant: "secondary",
    className: "pt-8",
    size: "sm"
  }, React.createElement("span", null, "1. Download an authenticator app (like Google Authenticator) on your device.", React.createElement("br", null), "2. Scan the QR code using the authenticator app.", React.createElement("br", null), "3. Enter the code below")), React.createElement(Input, {
    containerClasses: "pt-8",
    surface: "zero",
    placeholder: "Enter verification code",
    id: "verification",
    label: "Verification code",
    type: "text",
    value: value,
    error: error,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  }), React.createElement("div", {
    className: "flex flex-row-reverse py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    onClick: function onClick() {
      return handleClick();
    },
    className: "w-[114px]",
    type: "submit",
    loading: loading,
    disabled: disabled
  }, "Enable 2FA"), React.createElement("button", {
    "data-testid": "skip-btn",
    onClick: function onClick() {
      return handleSkipClick();
    },
    className: "px-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Cancel")))));
});
Setup.displayName = 'Setup';

var screens = {
  xs: 480,
  sm: 768,
  md: 992,
  lg: 1220
};
var StakingAnalytics = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    bounty_data = _ref.bounty_data,
    card_data = _ref.card_data,
    handleClick = _ref.handleClick,
    loading = _ref.loading,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'bounty-info-cards' : _ref$id,
    account = _ref.account;
  var Breakpoint = useBreakpoint();
  var button_text = Breakpoint > screens.sm ? 'Connect wallet' : 'Connect';
  return React.createElement("div", {
    className: "overflow-x-auto"
  }, React.createElement(Component, {
    className: "grid grid-cols-3 gap-5 min-w-max " + className,
    ref: ref,
    id: id
  }, React.createElement("div", null, React.createElement(Typography, {
    className: "mb-4",
    size: "md",
    allBold: true
  }, "Compound bounty"), React.createElement(Card, {
    className: "bg-gradient-level-one-to-accent h-40 p-5 w-[320px] md:w-[380px]"
  }, React.createElement("div", {
    className: "w-full md:space-y-7 space-y-3.5 items-center"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, bounty_data.text), React.createElement("div", {
    className: "flex items-center justify-between"
  }, Breakpoint > screens.md ? React.createElement(DataLines, {
    top_size: "2xl",
    is_top_bold: true,
    label: bounty_data.label,
    values: bounty_data.values,
    variant: "verticle"
  }) : React.createElement("div", null, React.createElement(Typography, {
    key: bounty_data.values[0].value,
    allBold: true,
    size: "md"
  }, bounty_data.values[0].value), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, bounty_data.label)), React.createElement(Button, {
    loading: loading,
    onClick: handleClick,
    className: "float-right min-w-[130px]"
  }, account ? 'Claim bounty' : button_text))))), card_data.map(function (card, idx) {
    return React.createElement("div", {
      key: JSON.stringify(card)
    }, React.createElement(Typography, {
      className: "mb-4",
      size: "md",
      allBold: true
    }, idx === 1 ? 'My account' : 'Platform'), React.createElement(Card, {
      className: "h-40 w-[320px] p-5 md:w-[380px] flex items-center",
      key: card[0].label + idx,
      surface: "one"
    }, React.createElement("div", {
      className: "md:space-y-5  space-y-3.5"
    }, card.map(function (_ref2, idx) {
      var label = _ref2.label,
        values = _ref2.values;
      return React.createElement(DataLines, {
        key: idx + label,
        top_size: "2xl",
        is_top_bold: true,
        label: label.toUpperCase(),
        values: values,
        variant: "verticle"
      });
    }))));
  })));
});
StakingAnalytics.displayName = 'StakingAnalytics';

var StakingChips = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    booster = _ref.booster,
    className = _ref.className,
    is_mobile = _ref.is_mobile,
    message = _ref.message,
    multiplier = _ref.multiplier,
    tokens = _ref.tokens,
    has_accent_gradient = _ref.has_accent_gradient,
    has_accent_zero_gradient = _ref.has_accent_zero_gradient,
    is_always_mobile = _ref.is_always_mobile;
  var getStakingChipColor = function getStakingChipColor() {
    if (has_accent_gradient) return 'bg-gradient';
    if (has_accent_zero_gradient) return 'bg-gradient-accent-to-level-one';
    if (booster && !has_accent_gradient) return 'bg-gradient-yellow-purple';
    if (multiplier && !has_accent_zero_gradient) return 'bg-gradient-violet';
    if (!is_always_mobile && !is_mobile) return 'bg-surface-level-two';
    if (is_always_mobile) return 'bg-surface-level-four';
    if (is_mobile) return 'bg-surface-level-three';else return 'bg-surface-level-two';
  };
  var tooltipId = useMemo(function () {
    return "tooltip-" + Date.now() + "-" + Math.floor(Math.random() * 1000);
  }, []); // Dependency array is empty, so it runs only once
  return React.createElement(Tooltip, {
    id: tooltipId,
    text: message
  }, React.createElement("div", {
    className: "flex gap-2 items-center"
  }, tokens == null ? void 0 : tokens.map(function (token) {
    return React.createElement(Chip, {
      className: [className, 'px-2', 'border', 'border-border', 'text-secondary', 'border-opacity-[0.03]', getStakingChipColor()].join(' '),
      "data-testid": id,
      key: JSON.stringify(token),
      ref: ref,
      size: "lg",
      variant: "custom"
    }, token.parts && token.parts.length > 1 ? React.createElement(React.Fragment, null, React.createElement("div", {
      className: "relative w-12 -top-4"
    }, React.createElement("img", {
      src: token.parts[0].image,
      className: "absolute h-6 left-0 top-2",
      alt: token.parts[0].name
    }), React.createElement("img", {
      src: token.parts[1].image,
      className: "absolute h-6 left-4 top-0",
      alt: token.parts[1].name
    })), React.createElement("div", {
      className: "pb-1.5"
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm"
    }, token.parts.map(function (t) {
      return t.name;
    }).join(' / ')), React.createElement(Typography, {
      variant: "secondary",
      size: "xs",
      className: "leading-[8px]"
    }, token.label))) : React.createElement(React.Fragment, null, token.parts && React.createElement(React.Fragment, null, token.parts[0].image ? React.createElement("img", {
      src: token.parts[0].image,
      className: "h-7 w-7",
      alt: token.parts[0].name
    }) : null, React.createElement("div", {
      className: [token.parts[0].image ? 'ml-2' : '', token.label ? 'pb-1.5' : ''].join(' ')
    }, React.createElement(Typography, {
      allBold: true,
      size: "sm"
    }, token.parts[0].name), React.createElement(Typography, {
      variant: "secondary",
      size: "xs",
      className: "leading-[8px]"
    }, token.label)))));
  })));
});
StakingChips.displayName = 'StakingChips';

var _excluded$f = ["items", "className"];
var MainCard = function MainCard(_ref) {
  var button_text = _ref.button_text,
    handleClick = _ref.handleClick,
    image = _ref.image,
    subtitle = _ref.subtitle,
    title = _ref.title,
    mobile_image = _ref.mobile_image,
    full_width = _ref.full_width;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  var _useState = useState(''),
    background = _useState[0],
    setBackground = _useState[1];
  useEffect(function () {
    setBackground((is_mobile ? 'linear-gradient(360deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 70.49%)' : 'linear-gradient(90deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 50%)') + ", url('" + (is_mobile && mobile_image ? mobile_image : image) + "')");
  }, [is_mobile, image, mobile_image]);
  return React.createElement("div", {
    className: (full_width ? 'w-full' : 'w-[300px]') + " h-[460px] sm:w-full sm:h-full sm:cursor-pointer relative bg-surface-level-one rounded",
    onClick: handleClick
  }, React.createElement("div", {
    key: background,
    style: {
      backgroundImage: background
    },
    className: "w-full h-full object-cover rounded bg-cover bg-center transition-all ease-out duration-500"
  }), React.createElement("div", {
    className: "absolute bottom-8 left-8 right-8 max-w-[320px]"
  }, React.createElement(Typography, {
    allBold: true,
    size: is_mobile ? '2xl' : '3xl',
    className: "mb-2"
  }, title), React.createElement(Typography, {
    className: "sm:mb-5"
  }, subtitle), React.createElement(Button, {
    className: "hidden sm:inline"
  }, button_text)));
};
var Thumbnail = function Thumbnail(_ref2) {
  var image = _ref2.image,
    subtitle = _ref2.subtitle,
    title = _ref2.title,
    id = _ref2.id,
    current = _ref2.current,
    handleClick = _ref2.handleClick;
  var _useState2 = useState('w-0'),
    className = _useState2[0],
    setClassName = _useState2[1];
  var init = useIntitialised();
  useEffect(function () {
    if (!init) return;
    if (current === id) {
      setClassName('w-full ease-in duration-[9000ms]');
    } else {
      setClassName('w-0 ease-out duration-[0ms]');
    }
  }, [current, id, init]);
  return React.createElement("div", {
    "data-testid": "carousel-thumbnail",
    className: "relative rounded overflow-hidden object-cover bg-cover bg-center cursor-pointer",
    onClick: handleClick,
    style: {
      backgroundImage: "linear-gradient(360deg, rgba(17, 6, 34, 0.4) 0%, rgba(17, 6, 34, 0) 71.52%), url('" + image + "')"
    }
  }, React.createElement("img", {
    src: image,
    alt: subtitle,
    className: "rounded-t pointer-events-none opacity-0"
  }), React.createElement("div", {
    className: "absolute bottom-5 left-5 max-w-[60%]"
  }, React.createElement(Typography, {
    allBold: true
  }, title)), React.createElement("div", {
    className: "h-1 relative w-[full] rounded-b overflow-hidden"
  }, React.createElement("div", {
    className: "w-full h-full bg-surface-level-two absolute"
  }), React.createElement("div", {
    id: "bar",
    className: "\"transition-all h-full bg-accent relative " + className
  })));
};
var CarouselContainer = function CarouselContainer(_ref3) {
  var items = _ref3.items,
    className = _ref3.className,
    rest = _objectWithoutPropertiesLoose(_ref3, _excluded$f);
  var _useState3 = useState(0),
    current = _useState3[0],
    setCurrent = _useState3[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  var handleNext = useCallback(function () {
    return setCurrent((current + 1) % items.length);
  }, [current, items.length, setCurrent]);
  var has_multiple_items = items.length > 1;
  useEffect(function () {
    if (is_mobile) return;
    var handler = setTimeout(handleNext, 9000);
    return function () {
      return clearTimeout(handler);
    };
  }, [handleNext, is_mobile]);
  return React.createElement("div", Object.assign({
    className: "sm:grid sm:grid-cols-4 gap-5 overflow-x-scroll sm:overflow-x-auto " + className
  }, rest), React.createElement("div", {
    className: "hidden sm:inline " + (has_multiple_items ? 'col-span-3' : 'col-span-4') + " min-h-[460px]",
    "data-testid": "carousel-main-card"
  }, React.createElement(MainCard, Object.assign({}, items[current]))), has_multiple_items && React.createElement("div", {
    className: "hidden sm:inline h-full space-y-5"
  }, items.map(function (i, idx) {
    return React.createElement(Thumbnail, Object.assign({}, i, {
      id: idx,
      current: current,
      handleNext: handleNext,
      handleClick: function handleClick() {
        return setCurrent(idx);
      },
      key: JSON.stringify(i)
    }));
  })), React.createElement("div", {
    className: "flex gap-5 mb-8 sm:hidden min-w-max"
  }, items.map(function (i) {
    return React.createElement(MainCard, Object.assign({}, i, {
      key: JSON.stringify(i),
      full_width: !has_multiple_items
    }));
  })));
};
var Carousel = /*#__PURE__*/Object.assign(CarouselContainer, {
  MainCard: MainCard,
  Thumbnail: Thumbnail
});

var Header$1 = function Header(_ref) {
  var logo = _ref.logo,
    title = _ref.title,
    className = _ref.className;
  return React.createElement("div", {
    className: "text-center " + className
  }, logo && React.createElement("img", {
    src: logo,
    alt: "logo",
    className: "mx-auto h-[30px] mb-5"
  }), React.createElement(Typography, {
    allBold: true,
    as: "h1",
    size: "4xl"
  }, title));
};

var LoginContents = function LoginContents(_ref) {
  var disabled = _ref.disabled,
    loading = _ref.loading,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleClick = _ref.handleClick,
    show_password = _ref.show_password,
    setShowPassword = _ref.setShowPassword,
    has_forgot_password_btn = _ref.has_forgot_password_btn,
    handleForgotPassword = _ref.handleForgotPassword;
  return React.createElement(React.Fragment, null, React.createElement(Input, {
    placeholder: "Enter email address",
    surface: "zero",
    id: "email",
    label: "Email",
    type: "email",
    value: state.email,
    onChange: function onChange(e) {
      return handleChange('email', e.target.value);
    }
  }), React.createElement(Input, {
    containerClasses: "my-8",
    surface: "zero",
    id: "password",
    label: "Password",
    type: show_password ? 'text' : 'password',
    placeholder: "Enter password",
    value: state.password,
    onChange: function onChange(e) {
      return handleChange('password', e.target.value);
    }
  }), React.createElement("div", {
    className: " pb-8 flex justify-between"
  }, React.createElement(Toggle, {
    label: "Show password",
    surface_level: "zero",
    active: show_password,
    onChange: function onChange() {
      return setShowPassword(!show_password);
    },
    variant: "checkbox"
  }), has_forgot_password_btn && React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleForgotPassword
  }, "Forgot password?")), React.createElement("div", {
    className: "flex flex-row-reverse"
  }, React.createElement(Button, {
    disabled: disabled,
    onClick: function onClick() {
      return handleClick();
    },
    className: 'w-full' + " text-sm",
    loading: loading
  }, "Log in")));
};

var LoginStage;
(function (LoginStage) {
  LoginStage["Login"] = "login";
  LoginStage["MFA"] = "mfa";
})(LoginStage || (LoginStage = {}));
var defaultProps$k = {
  as: 'div',
  disabled: false,
  image: '',
  loading: false,
  noTitle: false,
  logo: ''
};
var LoginForm = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    errors = _ref.errors,
    image = _ref.image,
    loading = _ref.loading,
    logo = _ref.logo,
    noTitle = _ref.noTitle,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleClick = _ref.handleClick,
    handleCreateAccount = _ref.handleCreateAccount,
    handleForgotPassword = _ref.handleForgotPassword,
    Component = _ref.as;
  var _useState = useState(false),
    show_password = _useState[0],
    setShowPassword = _useState[1];
  return React.createElement(Component, {
    ref: ref,
    className: "max-w-[580px] " + className
  }, state.stage === LoginStage.Login && React.createElement(Header$1, {
    title: !noTitle ? 'Log in' : '',
    className: "mb-[60px]",
    logo: logo
  }), React.createElement(Card, {
    className: "overflow-hidden",
    ref: ref
  }, image ? React.createElement("img", {
    className: "w-full",
    src: image,
    alt: "login-img"
  }) : null, React.createElement("div", {
    className: "" + (state.stage === LoginStage.Login ? 'p-5' : 'p-8')
  }, (errors == null ? void 0 : errors.form) && React.createElement("div", {
    className: "pb-8"
  }, React.createElement(Alert, {
    variant: "error"
  }, React.createElement("span", {
    className: "text-error"
  }, errors.form))), state.stage === LoginStage.Login && React.createElement(LoginContents, {
    disabled: disabled,
    loading: loading,
    state: state,
    handleChange: handleChange,
    handleClick: handleClick,
    show_password: show_password,
    setShowPassword: setShowPassword
  }), state.stage === LoginStage.MFA && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "w-full"
  }, React.createElement(Typography, {
    size: "4xl",
    as: "h1",
    allBold: true,
    className: "mb-8 text-center"
  }, "Two-factor authentication"), React.createElement(Typography, {
    className: "mb-[16px]",
    variant: "secondary",
    size: "sm"
  }, "Enter two-factor authentication code from your authenticator app."), React.createElement(Input, {
    placeholder: "--- ---",
    surface: "zero",
    id: "code",
    type: "code",
    className: "mb-8",
    value: state.code,
    onChange: function onChange(e) {
      return handleChange('code', e.target.value);
    }
  })), React.createElement("div", {
    className: "flex flex-row-reverse"
  }, React.createElement(Button, {
    disabled: disabled,
    onClick: function onClick() {
      return handleClick();
    },
    className: 'w-[200px]',
    loading: loading
  }, "Verify code"), state.stage === LoginStage.MFA && React.createElement("button", {
    onClick: function onClick() {
      return handleChange('stage', LoginStage.Login);
    },
    className: "px-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Cancel")))))), state.stage === LoginStage.Login && handleCreateAccount && handleForgotPassword && React.createElement("div", {
    className: "flex justify-between mt-5"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleCreateAccount
  }, "Create account"), React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleForgotPassword
  }, "Forgot password?")));
});
LoginForm.displayName = 'LoginForm';
LoginForm.defaultProps = defaultProps$k;

var defaultProps$l = {
  progress: 0,
  loading: false,
  disabled: false
};
var Onboarding = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    loading = _ref.loading,
    progress = _ref.progress,
    roles = _ref.roles,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleContinue = _ref.handleContinue;
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var first_name = state.first_name,
      last_name = state.last_name,
      company_name = state.company_name,
      company_role = state.company_role;
    handleContinue({
      first_name: first_name,
      last_name: last_name,
      company_name: company_name,
      company_role: company_role
    });
  };
  return React.createElement(Card, {
    border: progress ? false : true,
    className: "overflow-hidden max-w-[580px] " + className,
    ref: ref
  }, progress && React.createElement("div", null, React.createElement(Progress, {
    percent: progress,
    surface: "two",
    border: false,
    height: "h-4",
    rounded: false
  }), React.createElement("div", {
    className: "h-8 border-x border-border border-opacity-[0.03]"
  })), React.createElement("div", {
    className: "px-8 pt-8 rounded-b " + (progress ? 'border-b border-x border-border border-opacity-[0.03]' : '')
  }, React.createElement(Typography, {
    className: "text-center",
    size: "4xl",
    allBold: true
  }, "Welcome to Client portal"), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "pt-2 text-center"
  }, "Let\u2019s get you all set up to deploy and manage ", React.createElement("br", null), "your Decubate products."), React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(Input, {
    containerClasses: "pt-[32px]",
    surface: "zero",
    placeholder: "Enter first name",
    id: "first-name-input",
    label: "First name",
    type: "text",
    value: state.first_name,
    onChange: function onChange(e) {
      return handleChange('first_name', e.target.value);
    }
  }), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter last name",
    id: "last-name-input",
    label: "Last name",
    type: "text",
    value: state.last_name,
    onChange: function onChange(e) {
      return handleChange('last_name', e.target.value);
    }
  }), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter registered company name",
    id: "company-name-input",
    label: "Registered company name",
    type: "text",
    value: state.company_name,
    onChange: function onChange(e) {
      return handleChange('company_name', e.target.value);
    }
  }), React.createElement(Typography, {
    variant: "secondary",
    className: "mb-4 mt-5"
  }, "Your role in the company"), React.createElement("div", {
    className: "grid grid-cols-2 sm:grid-cols-4 gap-4"
  }, roles.map(function (role) {
    return React.createElement(Button, {
      key: role.split(' ').join('') + "-btn",
      id: role.split(' ').join('') + "-btn",
      onClick: function onClick() {
        handleChange('company_role', role);
      },
      variant: role === state.company_role ? 'light' : 'secondary'
    }, role);
  })), React.createElement("div", {
    className: "py-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    className: "w-full",
    type: "submit",
    loading: loading,
    disabled: disabled
  }, "Continue")))));
});
Onboarding.displayName = 'Onboarding';
Onboarding.defaultProps = defaultProps$l;

var countries = [
	{
		name_en: "Afghanistan",
		name_es: "Afganistán",
		dial_code: "+93",
		code: "AF"
	},
	{
		name_en: "Albania",
		name_es: "Albania",
		dial_code: "+355",
		code: "AL"
	},
	{
		name_en: "Algeria",
		name_es: "Argelia",
		dial_code: "+213",
		code: "DZ"
	},
	{
		name_en: "AmericanSamoa",
		name_es: "Samoa Americana",
		dial_code: "+1684",
		code: "AS"
	},
	{
		name_en: "Andorra",
		name_es: "Andorra",
		dial_code: "+376",
		code: "AD"
	},
	{
		name_en: "Angola",
		name_es: "Angola",
		dial_code: "+244",
		code: "AO"
	},
	{
		name_en: "Anguilla",
		name_es: "Anguilla",
		dial_code: "+1264",
		code: "AI"
	},
	{
		name_en: "Antarctica",
		name_es: "Antártida",
		dial_code: "+672",
		code: "AQ"
	},
	{
		name_en: "Antigua and Barbuda",
		name_es: "Antigua y Barbuda",
		dial_code: "+1268",
		code: "AG"
	},
	{
		name_en: "Argentina",
		name_es: "Argentina",
		dial_code: "+54",
		code: "AR"
	},
	{
		name_en: "Armenia",
		name_es: "Armenia",
		dial_code: "+374",
		code: "AM"
	},
	{
		name_en: "Aruba",
		name_es: "Aruba",
		dial_code: "+297",
		code: "AW"
	},
	{
		name_en: "Australia",
		name_es: "Australia",
		dial_code: "+61",
		code: "AU"
	},
	{
		name_en: "Austria",
		name_es: "Austria",
		dial_code: "+43",
		code: "AT"
	},
	{
		name_en: "Azerbaijan",
		name_es: "Azerbaiyán",
		dial_code: "+994",
		code: "AZ"
	},
	{
		name_en: "Bahamas",
		name_es: "Bahamas",
		dial_code: "+1242",
		code: "BS"
	},
	{
		name_en: "Bahrain",
		name_es: "Baréin",
		dial_code: "+973",
		code: "BH"
	},
	{
		name_en: "Bangladesh",
		name_es: "Banglades",
		dial_code: "+880",
		code: "BD"
	},
	{
		name_en: "Barbados",
		name_es: "Barbados",
		dial_code: "+1246",
		code: "BB"
	},
	{
		name_en: "Belarus",
		name_es: "Bielorrusia",
		dial_code: "+375",
		code: "BY"
	},
	{
		name_en: "Belgium",
		name_es: "Bélgica",
		dial_code: "+32",
		code: "BE"
	},
	{
		name_en: "Belize",
		name_es: "Belice",
		dial_code: "+501",
		code: "BZ"
	},
	{
		name_en: "Benin",
		name_es: "Benin",
		dial_code: "+229",
		code: "BJ"
	},
	{
		name_en: "Bermuda",
		name_es: "Bermudas",
		dial_code: "+1441",
		code: "BM"
	},
	{
		name_en: "Bhutan",
		name_es: "Butan",
		dial_code: "+975",
		code: "BT"
	},
	{
		name_en: "Bolivia",
		name_es: "Bolivia",
		dial_code: "+591",
		code: "BO"
	},
	{
		name_en: "Bosnia and Herzegovina",
		name_es: "Bosnia-Herzegovina",
		dial_code: "+387",
		code: "BA"
	},
	{
		name_en: "Botswana",
		name_es: "Botsuana",
		dial_code: "+267",
		code: "BW"
	},
	{
		name_en: "Brazil",
		name_es: "Brasil",
		dial_code: "+55",
		code: "BR"
	},
	{
		name_en: "British Indian Ocean Territory",
		name_es: "Territorio Británico del Océano Índico",
		dial_code: "+246",
		code: "IO"
	},
	{
		name_en: "Brunei Darussalam",
		name_es: "Brunei",
		dial_code: "+673",
		code: "BN"
	},
	{
		name_en: "Bulgaria",
		name_es: "Bulgaria",
		dial_code: "+359",
		code: "BG"
	},
	{
		name_en: "Burkina Faso",
		name_es: "Burkina Faso",
		dial_code: "+226",
		code: "BF"
	},
	{
		name_en: "Burundi",
		name_es: "Burundi",
		dial_code: "+257",
		code: "BI"
	},
	{
		name_en: "Cambodia",
		name_es: "Camboya",
		dial_code: "+855",
		code: "KH"
	},
	{
		name_en: "Cameroon",
		name_es: "Camerún",
		dial_code: "+237",
		code: "CM"
	},
	{
		name_en: "Canada",
		name_es: "Canadá",
		dial_code: "+1",
		code: "CA"
	},
	{
		name_en: "Cape Verde",
		name_es: "Cabo Verde",
		dial_code: "+238",
		code: "CV"
	},
	{
		name_en: "Cayman Islands",
		name_es: "Islas Caimán",
		dial_code: "+ 345",
		code: "KY"
	},
	{
		name_en: "Central African Republic",
		name_es: "República Centroafricana",
		dial_code: "+236",
		code: "CF"
	},
	{
		name_en: "Chad",
		name_es: "Chad",
		dial_code: "+235",
		code: "TD"
	},
	{
		name_en: "Chile",
		name_es: "Chile",
		dial_code: "+56",
		code: "CL"
	},
	{
		name_en: "China",
		name_es: "China",
		dial_code: "+86",
		code: "CN"
	},
	{
		name_en: "Christmas Island",
		name_es: "Isla de Navidad",
		dial_code: "+61",
		code: "CX"
	},
	{
		name_en: "Cocos (Keeling) Islands",
		name_es: "Islas Cocos",
		dial_code: "+61",
		code: "CC"
	},
	{
		name_en: "Colombia",
		name_es: "Colombia",
		dial_code: "+57",
		code: "CO"
	},
	{
		name_en: "Comoros",
		name_es: "Comoras",
		dial_code: "+269",
		code: "KM"
	},
	{
		name_en: "Congo",
		name_es: "Congo",
		dial_code: "+242",
		code: "CG"
	},
	{
		name_en: "Congo, The Democratic Republic of the",
		name_es: "República Democrática del Congo",
		dial_code: "+243",
		code: "CD"
	},
	{
		name_en: "Cook Islands",
		name_es: "Islas Cook",
		dial_code: "+682",
		code: "CK"
	},
	{
		name_en: "Costa Rica",
		name_es: "Costa Rica",
		dial_code: "+506",
		code: "CR"
	},
	{
		name_en: "Cote d'Ivoire",
		name_es: "Costa de Marfil",
		dial_code: "+225",
		code: "CI"
	},
	{
		name_en: "Croatia",
		name_es: "Croacia",
		dial_code: "+385",
		code: "HR"
	},
	{
		name_en: "Cuba",
		name_es: "Cuba",
		dial_code: "+53",
		code: "CU"
	},
	{
		name_en: "Cyprus",
		name_es: "Chipre",
		dial_code: "+537",
		code: "CY"
	},
	{
		name_en: "Czechia",
		name_es: "Chequia",
		dial_code: "+420",
		code: "CZ"
	},
	{
		name_en: "Denmark",
		name_es: "Dinamarca",
		dial_code: "+45",
		code: "DK"
	},
	{
		name_en: "Djibouti",
		name_es: "Yibuti",
		dial_code: "+253",
		code: "DJ"
	},
	{
		name_en: "Dominica",
		name_es: "Dominica",
		dial_code: "+1767",
		code: "DM"
	},
	{
		name_en: "Dominican Republic",
		name_es: "República Dominicana",
		dial_code: "+1849",
		code: "DO"
	},
	{
		name_en: "Ecuador",
		name_es: "Ecuador",
		dial_code: "+593",
		code: "EC"
	},
	{
		name_en: "Egypt",
		name_es: "Egipto",
		dial_code: "+20",
		code: "EG"
	},
	{
		name_en: "El Salvador",
		name_es: "El Salvador",
		dial_code: "+503",
		code: "SV"
	},
	{
		name_en: "Equatorial Guinea",
		name_es: "Guinea Ecuatorial",
		dial_code: "+240",
		code: "GQ"
	},
	{
		name_en: "Eritrea",
		name_es: "Eritrea",
		dial_code: "+291",
		code: "ER"
	},
	{
		name_en: "Estonia",
		name_es: "Estonia",
		dial_code: "+372",
		code: "EE"
	},
	{
		name_en: "Ethiopia",
		name_es: "Etiopía",
		dial_code: "+251",
		code: "ET"
	},
	{
		name_en: "Falkland Islands (Malvinas)",
		name_es: "Islas Malvinas",
		dial_code: "+500",
		code: "FK"
	},
	{
		name_en: "Faroe Islands",
		name_es: "Islas Feroe",
		dial_code: "+298",
		code: "FO"
	},
	{
		name_en: "Fiji",
		name_es: "Fiyi",
		dial_code: "+679",
		code: "FJ"
	},
	{
		name_en: "Finland",
		name_es: "Finlandia",
		dial_code: "+358",
		code: "FI"
	},
	{
		name_en: "France",
		name_es: "Francia",
		dial_code: "+33",
		code: "FR"
	},
	{
		name_en: "French Guiana",
		name_es: "Guayana Francesa",
		dial_code: "+594",
		code: "GF"
	},
	{
		name_en: "French Polynesia",
		name_es: "Polinesia Francesa",
		dial_code: "+689",
		code: "PF"
	},
	{
		name_en: "Gabon",
		name_es: "Gabón",
		dial_code: "+241",
		code: "GA"
	},
	{
		name_en: "Gambia",
		name_es: "Gambia",
		dial_code: "+220",
		code: "GM"
	},
	{
		name_en: "Georgia",
		name_es: "Georgia",
		dial_code: "+995",
		code: "GE"
	},
	{
		name_en: "Germany",
		name_es: "Alemania",
		dial_code: "+49",
		code: "DE"
	},
	{
		name_en: "Ghana",
		name_es: "Ghana",
		dial_code: "+233",
		code: "GH"
	},
	{
		name_en: "Gibraltar",
		name_es: "Gibraltar",
		dial_code: "+350",
		code: "GI"
	},
	{
		name_en: "Greece",
		name_es: "Grecia",
		dial_code: "+30",
		code: "GR"
	},
	{
		name_en: "Greenland",
		name_es: "Groenlandia",
		dial_code: "+299",
		code: "GL"
	},
	{
		name_en: "Grenada",
		name_es: "Granada",
		dial_code: "+1473",
		code: "GD"
	},
	{
		name_en: "Guadeloupe",
		name_es: "Guadalupe",
		dial_code: "+590",
		code: "GP"
	},
	{
		name_en: "Guam",
		name_es: "Guam",
		dial_code: "+1671",
		code: "GU"
	},
	{
		name_en: "Guatemala",
		name_es: "Guatemala",
		dial_code: "+502",
		code: "GT"
	},
	{
		name_en: "Guernsey",
		name_es: "Guernsey",
		dial_code: "+44",
		code: "GG"
	},
	{
		name_en: "Guinea",
		name_es: "Guinea",
		dial_code: "+224",
		code: "GN"
	},
	{
		name_en: "Guinea-Bissau",
		name_es: "Guinea-Bisau",
		dial_code: "+245",
		code: "GW"
	},
	{
		name_en: "Guyana",
		name_es: "Guyana",
		dial_code: "+595",
		code: "GY"
	},
	{
		name_en: "Haiti",
		name_es: "Haití",
		dial_code: "+509",
		code: "HT"
	},
	{
		name_en: "Holy See (Vatican City State)",
		name_es: "Ciudad del Vaticano",
		dial_code: "+379",
		code: "VA"
	},
	{
		name_en: "Honduras",
		name_es: "Honduras",
		dial_code: "+504",
		code: "HN"
	},
	{
		name_en: "Hong Kong",
		name_es: "Hong Kong",
		dial_code: "+852",
		code: "HK"
	},
	{
		name_en: "Hungary",
		name_es: "Hungría",
		dial_code: "+36",
		code: "HU"
	},
	{
		name_en: "Iceland",
		name_es: "Islandia",
		dial_code: "+354",
		code: "IS"
	},
	{
		name_en: "India",
		name_es: "India",
		dial_code: "+91",
		code: "IN"
	},
	{
		name_en: "Indonesia",
		name_es: "Indonesia",
		dial_code: "+62",
		code: "ID"
	},
	{
		name_en: "Iran, Islamic Republic of",
		name_es: "Irán",
		dial_code: "+98",
		code: "IR"
	},
	{
		name_en: "Iraq",
		name_es: "Iraq",
		dial_code: "+964",
		code: "IQ"
	},
	{
		name_en: "Ireland",
		name_es: "Irlanda",
		dial_code: "+353",
		code: "IE"
	},
	{
		name_en: "Isle of Man",
		name_es: "Isla de Man",
		dial_code: "+44",
		code: "IM"
	},
	{
		name_en: "Israel",
		name_es: "Israel",
		dial_code: "+972",
		code: "IL"
	},
	{
		name_en: "Italy",
		name_es: "Italia",
		dial_code: "+39",
		code: "IT"
	},
	{
		name_en: "Jamaica",
		name_es: "Jamaica",
		dial_code: "+1876",
		code: "JM"
	},
	{
		name_en: "Japan",
		name_es: "Japón",
		dial_code: "+81",
		code: "JP"
	},
	{
		name_en: "Jersey",
		name_es: "Jersey",
		dial_code: "+44",
		code: "JE"
	},
	{
		name_en: "Jordan",
		name_es: "Jordania",
		dial_code: "+962",
		code: "JO"
	},
	{
		name_en: "Kazakhstan",
		name_es: "Kazajistán",
		dial_code: "+7",
		code: "KZ"
	},
	{
		name_en: "Kenya",
		name_es: "Kenia",
		dial_code: "+254",
		code: "KE"
	},
	{
		name_en: "Kiribati",
		name_es: "Kiribati",
		dial_code: "+686",
		code: "KI"
	},
	{
		name_en: "Korea, Democratic People's Republic of",
		name_es: "Corea del Norte",
		dial_code: "+850",
		code: "KP"
	},
	{
		name_en: "Korea, Republic of",
		name_es: "Corea del Sur",
		dial_code: "+82",
		code: "KR"
	},
	{
		name_en: "Kosovo",
		name_es: "Kosovo",
		dial_code: "+383",
		code: "XK"
	},
	{
		name_en: "Kuwait",
		name_es: "Kuwait",
		dial_code: "+965",
		code: "KW"
	},
	{
		name_en: "Kyrgyzstan",
		name_es: "Kirguistán",
		dial_code: "+996",
		code: "KG"
	},
	{
		name_en: "Lao People's Democratic Republic",
		name_es: "Laos",
		dial_code: "+856",
		code: "LA"
	},
	{
		name_en: "Latvia",
		name_es: "Letonia",
		dial_code: "+371",
		code: "LV"
	},
	{
		name_en: "Lebanon",
		name_es: "Líbano",
		dial_code: "+961",
		code: "LB"
	},
	{
		name_en: "Lesotho",
		name_es: "Lesoto",
		dial_code: "+266",
		code: "LS"
	},
	{
		name_en: "Liberia",
		name_es: "Liberia",
		dial_code: "+231",
		code: "LR"
	},
	{
		name_en: "Libyan Arab Jamahiriya",
		name_es: "Libia",
		dial_code: "+218",
		code: "LY"
	},
	{
		name_en: "Liechtenstein",
		name_es: "Liechtenstein",
		dial_code: "+423",
		code: "LI"
	},
	{
		name_en: "Lithuania",
		name_es: "Lituania",
		dial_code: "+370",
		code: "LT"
	},
	{
		name_en: "Luxembourg",
		name_es: "Luxemburgo",
		dial_code: "+352",
		code: "LU"
	},
	{
		name_en: "Macao",
		name_es: "Macao",
		dial_code: "+853",
		code: "MO"
	},
	{
		name_en: "Macedonia, The Former Yugoslav Republic of",
		name_es: "República de Macedonia",
		dial_code: "+389",
		code: "MK"
	},
	{
		name_en: "Madagascar",
		name_es: "Madagascar",
		dial_code: "+261",
		code: "MG"
	},
	{
		name_en: "Malawi",
		name_es: "Malaui",
		dial_code: "+265",
		code: "MW"
	},
	{
		name_en: "Malaysia",
		name_es: "Malasia",
		dial_code: "+60",
		code: "MY"
	},
	{
		name_en: "Maldives",
		name_es: "Maldivas",
		dial_code: "+960",
		code: "MV"
	},
	{
		name_en: "Mali",
		name_es: "Malí",
		dial_code: "+223",
		code: "ML"
	},
	{
		name_en: "Malta",
		name_es: "Malta",
		dial_code: "+356",
		code: "MT"
	},
	{
		name_en: "Marshall Islands",
		name_es: "Islas Marshall",
		dial_code: "+692",
		code: "MH"
	},
	{
		name_en: "Martinique",
		name_es: "Martinica",
		dial_code: "+596",
		code: "MQ"
	},
	{
		name_en: "Mauritania",
		name_es: "Mauritania",
		dial_code: "+222",
		code: "MR"
	},
	{
		name_en: "Mauritius",
		name_es: "Mauricio",
		dial_code: "+230",
		code: "MU"
	},
	{
		name_en: "Mayotte",
		name_es: "Mayotte",
		dial_code: "+262",
		code: "YT"
	},
	{
		name_en: "Mexico",
		name_es: "México",
		dial_code: "+52",
		code: "MX"
	},
	{
		name_en: "Micronesia, Federated States of",
		name_es: "Estados Federados de Micronesia",
		dial_code: "+691",
		code: "FM"
	},
	{
		name_en: "Moldova, Republic of",
		name_es: "Moldavia",
		dial_code: "+373",
		code: "MD"
	},
	{
		name_en: "Monaco",
		name_es: "Monaco",
		dial_code: "+377",
		code: "MC"
	},
	{
		name_en: "Mongolia",
		name_es: "Mongolia",
		dial_code: "+976",
		code: "MN"
	},
	{
		name_en: "Montenegro",
		name_es: "Montenegro",
		dial_code: "+382",
		code: "ME"
	},
	{
		name_en: "Montserrat",
		name_es: "Montserrat",
		dial_code: "+1664",
		code: "MS"
	},
	{
		name_en: "Morocco",
		name_es: "Marruecos",
		dial_code: "+212",
		code: "MA"
	},
	{
		name_en: "Mozambique",
		name_es: "Mozambique",
		dial_code: "+258",
		code: "MZ"
	},
	{
		name_en: "Myanmar",
		name_es: "Birmania",
		dial_code: "+95",
		code: "MM"
	},
	{
		name_en: "Namibia",
		name_es: "Namibia",
		dial_code: "+264",
		code: "NA"
	},
	{
		name_en: "Nauru",
		name_es: "Nauru",
		dial_code: "+674",
		code: "NR"
	},
	{
		name_en: "Nepal",
		name_es: "Nepal",
		dial_code: "+977",
		code: "NP"
	},
	{
		name_en: "Netherlands",
		name_es: "Holanda",
		dial_code: "+31",
		code: "NL"
	},
	{
		name_en: "Netherlands Antilles",
		name_es: "Antillas Holandesas",
		dial_code: "+599",
		code: "AN"
	},
	{
		name_en: "New Caledonia",
		name_es: "Nueva Caledonia",
		dial_code: "+687",
		code: "NC"
	},
	{
		name_en: "New Zealand",
		name_es: "Nueva Zelanda",
		dial_code: "+64",
		code: "NZ"
	},
	{
		name_en: "Nicaragua",
		name_es: "Nicaragua",
		dial_code: "+505",
		code: "NI"
	},
	{
		name_en: "Niger",
		name_es: "Niger",
		dial_code: "+227",
		code: "NE"
	},
	{
		name_en: "Nigeria",
		name_es: "Nigeria",
		dial_code: "+234",
		code: "NG"
	},
	{
		name_en: "Niue",
		name_es: "Niue",
		dial_code: "+683",
		code: "NU"
	},
	{
		name_en: "NorfolkIsland",
		name_es: "IslaNorfolk",
		dial_code: "+672",
		code: "NF"
	},
	{
		name_en: "NorthernMarianaIslands",
		name_es: "IslasMarianasdelNorte",
		dial_code: "+1670",
		code: "MP"
	},
	{
		name_en: "Norway",
		name_es: "Noruega",
		dial_code: "+47",
		code: "NO"
	},
	{
		name_en: "Oman",
		name_es: "Omán",
		dial_code: "+968",
		code: "OM"
	},
	{
		name_en: "Pakistan",
		name_es: "Pakistán",
		dial_code: "+92",
		code: "PK"
	},
	{
		name_en: "Palau",
		name_es: "Palaos",
		dial_code: "+680",
		code: "PW"
	},
	{
		name_en: "Panama",
		name_es: "Panamá",
		dial_code: "+507",
		code: "PA"
	},
	{
		name_en: "Papua New Guinea",
		name_es: "Papúa Nueva Guinea",
		dial_code: "+675",
		code: "PG"
	},
	{
		name_en: "Paraguay",
		name_es: "Paraguay",
		dial_code: "+595",
		code: "PY"
	},
	{
		name_en: "Peru",
		name_es: "Perú",
		dial_code: "+51",
		code: "PE"
	},
	{
		name_en: "Philippines",
		name_es: "Filipinas",
		dial_code: "+63",
		code: "PH"
	},
	{
		name_en: "Pitcairn",
		name_es: "Islas Pitcairn",
		dial_code: "+872",
		code: "PN"
	},
	{
		name_en: "Poland",
		name_es: "Polonia",
		dial_code: "+48",
		code: "PL"
	},
	{
		name_en: "Portugal",
		name_es: "Portugal",
		dial_code: "+351",
		code: "PT"
	},
	{
		name_en: "Puerto Rico",
		name_es: "Puerto Rico",
		dial_code: "+1939",
		code: "PR"
	},
	{
		name_en: "Qatar",
		name_es: "Qatar",
		dial_code: "+974",
		code: "QA"
	},
	{
		name_en: "Romania",
		name_es: "Rumania",
		dial_code: "+40",
		code: "RO"
	},
	{
		name_en: "Russia",
		name_es: "Rusia",
		dial_code: "+7",
		code: "RU"
	},
	{
		name_en: "Rwanda",
		name_es: "Ruanda",
		dial_code: "+250",
		code: "RW"
	},
	{
		name_en: "Réunion",
		name_es: "Reunion",
		dial_code: "+262",
		code: "RE"
	},
	{
		name_en: "Saint Barthélemy",
		name_es: "San Bartolome",
		dial_code: "+590",
		code: "BL"
	},
	{
		name_en: "Saint Helena, Ascension and Tristan Da Cunha",
		name_es: "Santa Elena, Ascensión y Tristán de Acuña",
		dial_code: "+290",
		code: "SH"
	},
	{
		name_en: "Saint Kitts and Nevis",
		name_es: "San Cristóbal y Nieves",
		dial_code: "+1869",
		code: "KN"
	},
	{
		name_en: "Saint Lucia",
		name_es: "Santa Lucía",
		dial_code: "+1758",
		code: "LC"
	},
	{
		name_en: "Saint Martin",
		name_es: "Isla de San Martín",
		dial_code: "+590",
		code: "MF"
	},
	{
		name_en: "Saint Pierre and Miquelon",
		name_es: "San Pedro y Miquelon",
		dial_code: "+508",
		code: "PM"
	},
	{
		name_en: "Saint Vincent and the Grenadines",
		name_es: "San Vicente y las Granadinas",
		dial_code: "+1784",
		code: "VC"
	},
	{
		name_en: "Samoa",
		name_es: "Samoa",
		dial_code: "+685",
		code: "WS"
	},
	{
		name_en: "San Marino",
		name_es: "San Marino",
		dial_code: "+378",
		code: "SM"
	},
	{
		name_en: "Sao Tome and Principe",
		name_es: " Santo Tomé y Príncipe",
		dial_code: "+239",
		code: "ST"
	},
	{
		name_en: "Saudi Arabia",
		name_es: "Arabia Saudita",
		dial_code: "+966",
		code: "SA"
	},
	{
		name_en: "Senegal",
		name_es: "Senegal",
		dial_code: "+221",
		code: "SN"
	},
	{
		name_en: "Serbia",
		name_es: "Serbia",
		dial_code: "+381",
		code: "RS"
	},
	{
		name_en: "Seychelles",
		name_es: "Seychelles",
		dial_code: "+248",
		code: "SC"
	},
	{
		name_en: "Sierra Leone",
		name_es: "Sierra Leona",
		dial_code: "+232",
		code: "SL"
	},
	{
		name_en: "Singapore",
		name_es: "Singapur",
		dial_code: "+65",
		code: "SG"
	},
	{
		name_en: "Slovakia",
		name_es: "Eslovaquia",
		dial_code: "+421",
		code: "SK"
	},
	{
		name_en: "Slovenia",
		name_es: "Eslovenia",
		dial_code: "+386",
		code: "SI"
	},
	{
		name_en: "Solomon Islands",
		name_es: "Islas Salomón",
		dial_code: "+677",
		code: "SB"
	},
	{
		name_en: "Somalia",
		name_es: "Somalia",
		dial_code: "+252",
		code: "SO"
	},
	{
		name_en: "South Africa",
		name_es: "Sudáfrica",
		dial_code: "+27",
		code: "ZA"
	},
	{
		name_en: "South Sudan",
		name_es: "Sudán del Sur",
		dial_code: "+211",
		code: "SS"
	},
	{
		name_en: "Spain",
		name_es: "España",
		dial_code: "+34",
		code: "ES"
	},
	{
		name_en: "Sri Lanka",
		name_es: "Sri Lanka",
		dial_code: "+94",
		code: "LK"
	},
	{
		name_en: "State of Palestine",
		name_es: "Estado de Palestina",
		dial_code: "+970",
		code: "PS"
	},
	{
		name_en: "Sudan",
		name_es: "Sudán",
		dial_code: "+249",
		code: "SD"
	},
	{
		name_en: "Suriname",
		name_es: "Surinam",
		dial_code: "+597",
		code: "SR"
	},
	{
		name_en: "Svalbard and Jan Mayen",
		name_es: "Svalbard y Jan Mayen",
		dial_code: "+47",
		code: "SJ"
	},
	{
		name_en: "Swaziland",
		name_es: "Suazilandia",
		dial_code: "+268",
		code: "SZ"
	},
	{
		name_en: "Sweden",
		name_es: "Suecia",
		dial_code: "+46",
		code: "SE"
	},
	{
		name_en: "Switzerland",
		name_es: "Suiza",
		dial_code: "+41",
		code: "CH"
	},
	{
		name_en: "Syrian Arab Republic",
		name_es: "Siria",
		dial_code: "+963",
		code: "SY"
	},
	{
		name_en: "Taiwan, Province of China",
		name_es: "Taiwán",
		dial_code: "+886",
		code: "TW"
	},
	{
		name_en: "Tayikistan",
		name_es: "Tayikistán",
		dial_code: "+992",
		code: "TJ"
	},
	{
		name_en: "Tanzania, United Republic of",
		name_es: "Tanzania",
		dial_code: "+255",
		code: "TZ"
	},
	{
		name_en: "Thailand",
		name_es: "Tailandia",
		dial_code: "+66",
		code: "TH"
	},
	{
		name_en: "Timor-Leste",
		name_es: "Timor Oriental",
		dial_code: "+670",
		code: "TL"
	},
	{
		name_en: "Togo",
		name_es: "Togo",
		dial_code: "+228",
		code: "TG"
	},
	{
		name_en: "Tokelau",
		name_es: "Tokelau",
		dial_code: "+690",
		code: "TK"
	},
	{
		name_en: "Tonga",
		name_es: "Tonga",
		dial_code: "+676",
		code: "TO"
	},
	{
		name_en: "Trinidad and Tobago",
		name_es: "Trinidad y Tobago",
		dial_code: "+1868",
		code: "TT"
	},
	{
		name_en: "Tunisia",
		name_es: "Túnez",
		dial_code: "+216",
		code: "TN"
	},
	{
		name_en: "Turkey",
		name_es: "Turquía",
		dial_code: "+90",
		code: "TR"
	},
	{
		name_en: "Turkmenistan",
		name_es: "Turkmenistán",
		dial_code: "+993",
		code: "TM"
	},
	{
		name_en: "Turks and Caicos Islands",
		name_es: "Islas Turcas y Caicos",
		dial_code: "+1649",
		code: "TC"
	},
	{
		name_en: "Tuvalu",
		name_es: "Tuvalu",
		dial_code: "+688",
		code: "TV"
	},
	{
		name_en: "Uganda",
		name_es: "Uganda",
		dial_code: "+256",
		code: "UG"
	},
	{
		name_en: "Ukraine",
		name_es: "Ucrania",
		dial_code: "+380",
		code: "UA"
	},
	{
		name_en: "United Arab Emirates",
		name_es: "Emiratos Árabes Unidos",
		dial_code: "+971",
		code: "AE"
	},
	{
		name_en: "United Kingdom",
		name_es: "Reino Unido",
		dial_code: "+44",
		code: "GB"
	},
	{
		name_en: "United States",
		name_es: "Estados Unidos",
		dial_code: "+1",
		code: "US"
	},
	{
		name_en: "Uruguay",
		name_es: "Uruguay",
		dial_code: "+598",
		code: "UY"
	},
	{
		name_en: "Uzbekistan",
		name_es: "Uzbekistán",
		dial_code: "+998",
		code: "UZ"
	},
	{
		name_en: "Vanuatu",
		name_es: "Vanuatu",
		dial_code: "+678",
		code: "VU"
	},
	{
		name_en: "Venezuela, Bolivarian Republic of",
		name_es: "Venezuela",
		dial_code: "+58",
		code: "VE"
	},
	{
		name_en: "Vietnam",
		name_es: "Vietnam",
		dial_code: "+84",
		code: "VN"
	},
	{
		name_en: "Virgin Islands, British",
		name_es: "Islas Vírgenes Británicas",
		dial_code: "+1284",
		code: "VG"
	},
	{
		name_en: "Virgin Islands, U.S.",
		name_es: "Islas Vírgenes de los Estados Unidos",
		dial_code: "+1340",
		code: "VI"
	},
	{
		name_en: "Wallis and Futuna",
		name_es: "Wallis y Futuna",
		dial_code: "+681",
		code: "WF"
	},
	{
		name_en: "Yemen",
		name_es: "Yemen",
		dial_code: "+967",
		code: "YE"
	},
	{
		name_en: "Zambia",
		name_es: "Zambia",
		dial_code: "+260",
		code: "ZM"
	},
	{
		name_en: "Zimbabwe",
		name_es: "Zimbabue",
		dial_code: "+263",
		code: "ZW"
	},
	{
		name_en: "Åland Islands",
		name_es: "Åland",
		dial_code: "+358",
		code: "AX"
	}
];
var data = {
	countries: countries
};

var options = /*#__PURE__*/data.countries.map(function (_ref) {
  var name_en = _ref.name_en,
    code = _ref.code;
  return {
    label: name_en,
    id: code
  };
});
var RegisterForm = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    disabled = _ref2.disabled,
    title = _ref2.title,
    state = _ref2.state,
    loading = _ref2.loading,
    logo = _ref2.logo,
    errors = _ref2.errors,
    policy = _ref2.policy,
    terms = _ref2.terms,
    handleLoginClick = _ref2.handleLoginClick,
    handleRegister = _ref2.handleRegister,
    handleChange = _ref2.handleChange,
    unsupported_country_data = _ref2.unsupported_country_data,
    alert = _ref2.alert;
  var _useState = useState(false),
    showPassword = _useState[0],
    setShowPassword = _useState[1];
  var _useState2 = useState({
      email: false,
      password: false
    }),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  var breakpoint = useBreakpoint();
  var handleSubmit = function handleSubmit(event) {
    event.preventDefault();
    var email = state.email,
      password = state.password,
      country = state.country,
      acceptTerms = state.acceptTerms;
    handleRegister({
      email: email,
      password: password,
      country: country,
      acceptTerms: acceptTerms
    });
  };
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, title && React.createElement(Header$1, {
    className: "mb-[60px]",
    title: "Create account",
    logo: logo
  }), React.createElement(Card, {
    className: "p-5",
    ref: ref
  }, (errors == null ? void 0 : errors.form) && React.createElement("div", {
    className: "pb-8"
  }, React.createElement(Alert, {
    variant: "error"
  }, React.createElement("span", {
    className: "text-error"
  }, errors.form))), React.createElement("form", {
    onSubmit: handleSubmit
  }, React.createElement(Input, {
    id: "email",
    error: errors == null ? void 0 : errors.email,
    label: "Email",
    placeholder: "Enter your email address",
    surface: "zero",
    type: "email",
    is_initialized: initialized.email,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        email: true
      }));
    },
    value: state.email,
    onChange: function onChange(event) {
      return handleChange(event.target.id, event.target.value);
    }
  }), React.createElement(Input, {
    id: "password",
    helper_box_text: React.createElement("span", {
      className: "space-y-2"
    }, ['At least 8 characters', 'Upper & lowercase letters', 'At least 2 numbers', 'At least 1 symbol'].map(function (s) {
      return React.createElement(Typography, {
        key: s,
        size: "xs",
        variant: "secondary"
      }, s);
    })),
    containerClasses: "pt-5",
    error: errors == null ? void 0 : errors.password,
    label: "Password",
    placeholder: "Create new password",
    surface: "zero",
    is_initialized: initialized.password,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        password: true
      }));
    },
    type: showPassword ? 'text' : 'password',
    value: state.password,
    onChange: function onChange(event) {
      return handleChange(event.target.id, event.target.value);
    }
  }), React.createElement("div", {
    className: "pt-5 pl-5"
  }, React.createElement(Toggle, {
    id: "show-password",
    label: "Show password",
    surface_level: "zero",
    active: showPassword,
    onChange: function onChange() {
      return setShowPassword(!showPassword);
    },
    variant: "checkbox"
  })), React.createElement(Select, {
    id: "country",
    className: "pt-5",
    current: state.country,
    options: options,
    label: "Country of residence",
    placeholder: "Select your country of residence",
    setCurrent: function setCurrent(option) {
      handleChange('country', option);
    }
  }), unsupported_country_data && React.createElement(Alert, {
    variant: "warning",
    title: "Not supported country",
    className: "mt-8"
  }, "Due to regulations, some countries are not supported.", React.createElement("br", null), React.createElement("br", null), " Find the list of unsupported countries in", ' ', React.createElement("a", {
    href: terms,
    rel: "noreferrer",
    target: "_blank",
    className: "text-warning hover:underline"
  }, unsupported_country_data.company_name, " Terms and conditions.")), alert && React.createElement(Alert, {
    variant: alert.variant || 'warning',
    title: alert.title,
    className: "mt-8 max-w-[511px]"
  }, alert.content), React.createElement(Card, {
    id: "toggle-card",
    surface: "two",
    className: "mt-8 mb-5 " + (breakpoint > 505 ? 'px-5 py-[10px]' : 'p-5')
  }, React.createElement(Toggle, {
    id: "accept-terms",
    active: state.acceptTerms || false,
    onChange: function onChange() {
      return handleChange('acceptTerms', !state.acceptTerms);
    },
    label: React.createElement(React.Fragment, null, "I have read and accept the", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: terms,
      rel: "noreferrer",
      target: "_blank"
    }, "terms & conditions"), ' ', "and", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: policy,
      rel: "noreferrer",
      target: "_blank"
    }, "privacy policy"), "."),
    variant: "checkbox"
  })), React.createElement(Button, {
    fullwidth: true,
    id: "register-button",
    disabled: disabled,
    loading: loading,
    type: "submit"
  }, "Create account"))), React.createElement("div", {
    className: "flex justify-center space-x-2 mt-5"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Already have an account?"), React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer",
    onClick: handleLoginClick
  }, "Log in")));
});
RegisterForm.displayName = 'RegisterForm';

var ResetPasswordStage;
(function (ResetPasswordStage) {
  ResetPasswordStage["Email"] = "email";
  ResetPasswordStage["Password"] = "password";
})(ResetPasswordStage || (ResetPasswordStage = {}));
var defaultProps$m = {
  errors: undefined,
  helper_text: undefined,
  loading: false,
  disabled: false
};
var ResetPassword = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    handleClick = _ref.handleClick,
    state = _ref.state,
    handleChange = _ref.handleChange,
    errors = _ref.errors,
    disabled = _ref.disabled,
    loading = _ref.loading,
    handleResendCode = _ref.handleResendCode,
    handleLogin = _ref.handleLogin,
    handleCreateAccount = _ref.handleCreateAccount,
    logo = _ref.logo;
  var _useState = useState(false),
    show_password = _useState[0],
    setShowPassword = _useState[1];
  var _useState2 = useState({
      code: false,
      email: false,
      password: false
    }),
    initialized = _useState2[0],
    setInitialized = _useState2[1];
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, React.createElement(Header$1, {
    title: "Reset password",
    logo: logo
  }), state.stage === ResetPasswordStage.Email ? React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "mb-[60px] text-center mt-2"
  }, "Enter your email below and we will send you instructions to reset your password.") : React.createElement("div", {
    className: "mb-[60px] mt-2 text-center"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "We have sent the verification code to the provided email."), React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Please enter the verification code and the new password below.")), React.createElement(Card, {
    className: "p-5",
    ref: ref
  }, state.stage === ResetPasswordStage.Password && React.createElement(Input, {
    placeholder: "Enter verification code",
    containerClasses: "pb-5",
    surface: "zero",
    id: "verification-code",
    label: "Verification code",
    type: "number",
    is_initialized: initialized.code,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        code: true
      }));
    },
    error: errors == null ? void 0 : errors.code,
    value: state.code,
    onChange: function onChange(e) {
      return handleChange('code', e.target.value);
    }
  }), state.stage === ResetPasswordStage.Email ? React.createElement(Input, {
    placeholder: "Enter email address",
    containerClasses: "pb-5",
    surface: "zero",
    id: "email",
    label: "Email",
    type: "email",
    is_initialized: initialized.email,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        email: true
      }));
    },
    error: errors == null ? void 0 : errors.email,
    value: state.email,
    onChange: function onChange(e) {
      return handleChange('email', e.target.value);
    }
  }) : React.createElement(React.Fragment, null, React.createElement(Input, {
    surface: "zero",
    id: "password",
    helper_box_text: React.createElement("span", {
      className: "space-y-2"
    }, ['At least 8 characters', 'Upper & lowercase letters', 'At least 2 numbers', 'At least 1 symbol'].map(function (s) {
      return React.createElement(Typography, {
        key: s,
        size: "xs",
        variant: "secondary"
      }, s);
    })),
    containerClasses: "pb-2",
    label: "New password",
    type: show_password ? 'text' : 'password',
    placeholder: "New password",
    value: state.password,
    error: errors == null ? void 0 : errors.password,
    is_initialized: initialized.password,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        password: true
      }));
    },
    onChange: function onChange(e) {
      return handleChange('password', e.target.value);
    }
  }), React.createElement(Input, {
    surface: "zero",
    id: "retype_password",
    containerClasses: "pb-5",
    type: show_password ? 'text' : 'password',
    placeholder: "Retype password",
    value: state.retype_password,
    is_initialized: initialized.password,
    onBlur: function onBlur() {
      return setInitialized(_extends({}, initialized, {
        password: true
      }));
    },
    onChange: function onChange(e) {
      return handleChange('retype_password', e.target.value);
    }
  })), state.stage === ResetPasswordStage.Password && React.createElement("div", {
    className: "pb-5"
  }, React.createElement(Toggle, {
    label: "Show password",
    surface_level: "zero",
    active: show_password,
    onChange: function onChange() {
      return setShowPassword(!show_password);
    },
    variant: "checkbox"
  })), React.createElement("div", {
    className: "pt-3"
  }, React.createElement(Button, {
    onClick: function onClick() {
      return handleClick();
    },
    className: "w-full",
    loading: loading,
    disabled: disabled
  }, state.stage === ResetPasswordStage.Password ? 'Set new password' : 'Reset password'))), state.stage === ResetPasswordStage.Password ? React.createElement("div", {
    className: "text-center mt-5"
  }, React.createElement(Typography, {
    onClick: handleResendCode,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Resend code")) : React.createElement("div", {
    className: "flex justify-between mt-5"
  }, React.createElement(Typography, {
    onClick: handleCreateAccount,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Create account"), React.createElement(Typography, {
    onClick: handleLogin,
    size: "sm",
    variant: "custom",
    className: "text-accent hover:underline cursor-pointer"
  }, "Log in")));
});
ResetPassword.displayName = 'ResetPassword';
ResetPassword.defaultProps = defaultProps$m;

var defaultProps$n = {
  as: 'div',
  className: '',
  email: '',
  error: '',
  id: 'verify-email',
  loading: false,
  title: '',
  value: ''
};
var VerifyEmail = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    email = _ref.email,
    error = _ref.error,
    id = _ref.id,
    loading = _ref.loading,
    title = _ref.title,
    value = _ref.value,
    handleChange = _ref.handleChange,
    handleResendCode = _ref.handleResendCode;
  return React.createElement(Component, {
    className: "max-w-[580px] " + className
  }, React.createElement(Card, {
    className: "p-8 space-y-8",
    "data-testid": id,
    ref: ref
  }, title && React.createElement(Typography, {
    as: "h1",
    allBold: true,
    size: "4xl"
  }, title), React.createElement(Typography, {
    size: "sm"
  }, React.createElement("span", null, "We have sent a verification code to", React.createElement("span", {
    className: "font-bold"
  }, " ", email), ".", React.createElement("br", null), " Please enter the verification code below.")), React.createElement(Input, {
    id: id + "-input",
    className: "w-full",
    error: error,
    label: "Verification code",
    loading: loading,
    maxLength: 6,
    placeholder: "Enter verification code",
    surface: "zero",
    type: "text",
    value: value,
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    }
  })), React.createElement("div", {
    className: "flex justify-center mt-5 space-x-2"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Did not receive the verification code?"), React.createElement(Typography, {
    className: "text-accent cursor-pointer hover:underline",
    size: "sm",
    variant: "custom",
    onClick: handleResendCode
  }, "Resend code")));
});
VerifyEmail.displayName = 'VerifyEmail';
VerifyEmail.defaultProps = defaultProps$n;

var defaultProps$o = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined
};
var Branding = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    loading = _ref.loading,
    progress = _ref.progress,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    state = _ref.state,
    errors = _ref.errors,
    handleChange = _ref.handleChange,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    subtitle: "Brand your farm to attract investors.",
    title: "Branding",
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    handleSkipBtnClick: handleSkipClick,
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    continue_btn_disabled: state.farm_name === '' || state.farm_image === '' || disabled
  }, React.createElement(Input, {
    containerClasses: "mt-[32px]",
    surface: "zero",
    placeholder: "Enter farm name",
    error: errors == null ? void 0 : errors.farm_name,
    id: "farm-name-input",
    label: "Farm name",
    type: "text",
    value: state.farm_name,
    onChange: function onChange(e) {
      return handleChange('farm_name', e.target.value);
    }
  }), React.createElement("div", {
    className: "mt-5 flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter image URL",
    id: "farm-image-input",
    label: "Farm image (999x999 pixels)",
    type: "text",
    error: errors == null ? void 0 : errors.farm_image,
    value: state.farm_image,
    onChange: function onChange(e) {
      return handleChange('farm_image', e.target.value);
    }
  }), !is_mobile && React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('farm_image', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "paste-btn"
  }))));
});
Branding.displayName = 'Branding';
Branding.defaultProps = defaultProps$o;

var APPROVAL_TIME_DAYS = 1;
var defaultProps$p = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  skip_btn_text: 'Back'
};
var Composition = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    errors = _ref.errors,
    Component = _ref.as,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    buttons_info_array = _ref.buttons_info_array,
    className = _ref.className,
    loading = _ref.loading,
    progress = _ref.progress,
    apy_value = _ref.apy_value,
    reward_value = _ref.reward_value,
    cut_off_value = _ref.cut_off_value,
    ticker = _ref.ticker,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var minDate = useMemo(function () {
    return dayjs().add(APPROVAL_TIME_DAYS, 'days').format('YYYY-MM-DDTHH:mm');
  }, []);
  var maxDate = useMemo(function () {
    return dayjs().add(30 + APPROVAL_TIME_DAYS, 'days').format('YYYY-MM-DDTHH:mm');
  }, []);
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.farm_capacity === '' || state.reward_amount === '' || state.lock_term === '' || state.start_date === '' || state.selected_plan_option === undefined || disabled,
    subtitle: "Design the farm entirely to your specification.",
    title: "Farm composition",
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Input, {
    error: errors == null ? void 0 : errors.reward_amount,
    containerClasses: "mt-[32px]",
    surface: "zero",
    tooltip: "The total amount of reward tokens to be distributed in this farm.",
    placeholder: (breakpoint > 400 ? 'Enter reward token amount' : 'Enter amount') + " ",
    id: "reward-amount-input",
    label: "Reward tokens",
    type: "number",
    value: state.reward_amount,
    onChange: function onChange(e) {
      return handleChange('reward_amount', e.target.value);
    },
    unit: ticker,
    max_btn: false
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.farm_capacity,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter farm capacity",
    id: "farm-capacity-input",
    label: "Capacity",
    tooltip: "Maximum amount of tokens that can be locked in this pool by investors.",
    type: "number",
    unit: ticker,
    max_btn: false,
    value: state.farm_capacity,
    onChange: function onChange(e) {
      return handleChange('farm_capacity', e.target.value);
    }
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.start_date,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter farm start date",
    id: "start-date-input",
    tooltip: "Date your farm becomes public, subject to approval. Approval may take 24-48 hours.",
    label: "Start date",
    type: "datetime-local",
    value: state.start_date,
    onChange: function onChange(e) {
      return handleChange('start_date', e.target.value);
    },
    min: minDate,
    max: maxDate
  }), React.createElement(Input, {
    error: errors == null ? void 0 : errors.lock_term,
    containerClasses: "mt-5",
    surface: "zero",
    placeholder: "Enter lock term",
    id: "lock-term-input",
    label: "Lock term",
    tooltip: "Amount of days tokens will be locked before investors can withdraw. Max. 1/2 of the farm\u2019s life time.",
    unit: "Days",
    max_btn: false,
    type: "number",
    value: state.lock_term,
    onChange: function onChange(e) {
      return handleChange('lock_term', e.target.value);
    }
  }), React.createElement(SquareButtons, {
    className: "pt-5",
    buttons_info_array: buttons_info_array,
    label: 'Farm life time',
    tooltip: "Total amount of days the farm will be providing rewards to all participants. Can be extended at any time.",
    selected: state.selected_plan_option,
    setSelected: function setSelected(val) {
      return handleChange('selected_plan_option', val);
    }
  }), React.createElement(Card, {
    surface: "two",
    className: "p-5 mt-8 mb-8"
  }, React.createElement(DataLines, {
    variant: "default",
    values: [{
      value: apy_value
    }],
    label: "Minimum APY"
  }), React.createElement(DataLines, {
    variant: "default",
    className: "pt-5",
    values: [{
      value: reward_value
    }],
    label: "Daily reward"
  }), React.createElement(DataLines, {
    variant: "default",
    className: "pt-5",
    values: [{
      value: cut_off_value
    }],
    label: "Staking cut-off",
    tooltip: "Investors will no longer be able to stake more in the farm past this date. The date can be pushed further at any time by extending the farm\u2019s life time."
  })), React.createElement(Alert, {
    variant: "note"
  }, React.createElement(React.Fragment, null, React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "To ensure fair conditions for all participants, minimum APY cannot be reduced after the farm is created.")), React.createElement("br", null), React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "You can extend the farm\u2019s lifetime at any time, however, it will require additional reward tokens to maintain the minimum APY.")), React.createElement("br", null), React.createElement("span", {
    className: "flex space-x-2"
  }, React.createElement("span", null, " \u2022"), React.createElement("span", null, "Adding more reward tokens will require to extend the farm\u2019s life-time.")))));
});
Composition.displayName = 'Composition';
Composition.defaultProps = defaultProps$p;

var defaultProps$q = {
  as: FormWrapper,
  className: '',
  continue_btn_disabled: false,
  loading: false,
  progress: undefined,
  skip_btn_text: 'Back',
  skip_btn_disabled: false
};
var Deploy = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    Component = _ref.as,
    className = _ref.className,
    list_item_arr = _ref.list_item_arr,
    loading = _ref.loading,
    progress = _ref.progress,
    policy_url = _ref.policy_url,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_disabled = _ref.continue_btn_disabled,
    skip_btn_disabled = _ref.skip_btn_disabled,
    terms_url = _ref.terms_url,
    handleContinueClick = _ref.handleContinueClick,
    handleSkipClick = _ref.handleSkipClick,
    handleFarmSummary = _ref.handleFarmSummary;
  var breakpoint = useBreakpoint();
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: continue_btn_disabled,
    skip_btn_disabled: skip_btn_disabled,
    loading: loading,
    progress: progress,
    title: "Deploy the farm",
    skip_btn_text: skip_btn_text,
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick();
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Card, {
    surface: "two",
    className: "mt-8"
  }, React.createElement(ListItem, {
    label_text: "Farm summary",
    info_text: "View the farm\u2019s full summary.",
    button_text: "View",
    variant: "button",
    handleClick: handleFarmSummary
  })), React.createElement(Card, {
    id: "toggle-card",
    surface: "two",
    className: "my-5 " + (breakpoint > 505 ? 'px-5 py-[12px]' : 'p-5')
  }, React.createElement(Toggle, {
    id: "accept-terms",
    active: state.checked,
    onChange: function onChange() {
      return handleChange('checked', !state.checked);
    },
    label: React.createElement(React.Fragment, null, "I agree to", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      rel: "noreferrer",
      target: "_blank",
      href: terms_url
    }, "Terms"), ' ', "&", ' ', React.createElement("a", {
      className: "hover:underline text-accent",
      href: policy_url,
      rel: "noreferrer",
      target: "_blank"
    }, "Privacy Conditions"), "."),
    variant: "checkbox"
  })), React.createElement(ListItemUnit, {
    surface: "two",
    list_item_arr: list_item_arr
  }), React.createElement(Alert, {
    className: "mt-8",
    variant: "note"
  }, "All fees are processed on the BNB Chain (BEP-20)."));
});
Deploy.displayName = 'Deploy';
Deploy.defaultProps = defaultProps$q;

var defaultProps$r = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  select_disabled: false
};
var FarmSetup = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var state = _ref.state,
    errors = _ref.errors,
    handleChange = _ref.handleChange,
    Component = _ref.as,
    className = _ref.className,
    loading = _ref.loading,
    chain_options = _ref.chain_options,
    progress = _ref.progress,
    select_disabled = _ref.select_disabled,
    skip_btn_text = _ref.skip_btn_text,
    continue_btn_text = _ref.continue_btn_text,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    skip_btn_text: skip_btn_text,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.token === '' || !state.chain_option || disabled,
    subtitle: is_mobile ? React.createElement("span", null, "Creating a staking farm is a fast and easy way to attract new eyes and engage with investors, while locking your project tokens away from the market.") : React.createElement("span", null, "Creating a staking farm is a fast and easy way to attract new eyes", ' ', React.createElement("br", null), " and engage with investors, while locking your project tokens away ", React.createElement("br", null), " from the market."),
    title: "Farm Setup",
    handleContinueBtnClick: handleContinueClick,
    handleSkipBtnClick: handleSkipClick
  }, React.createElement(Select, {
    disabled: select_disabled,
    options: chain_options,
    current: state.chain_option,
    setCurrent: function setCurrent(o) {
      return handleChange('option', o);
    },
    className: "mt-8",
    surface: "zero",
    placeholder: "Binance Smart Chain",
    label: "Blockchain",
    tooltip: "Currently we only support Binance Smart Chain, but hope to support many more EVM compatable chains soon."
  }), React.createElement("div", {
    className: "mt-5 flex justify-between items-end"
  }, React.createElement(Input, {
    error: errors == null ? void 0 : errors.token,
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter token contract address",
    id: "token-contract-input",
    label: "Token contract address",
    type: "text",
    value: state.token,
    onChange: function onChange(e) {
      return handleChange('token', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return window.navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('token', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "paste-btn"
  }))));
});
FarmSetup.displayName = 'FarmSetup';
FarmSetup.defaultProps = defaultProps$r;

var defaultProps$s = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined,
  disabled: false
};
var Manage = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    state = _ref.state,
    setState = _ref.setState,
    list_item_arr = _ref.list_item_arr,
    alert_message = _ref.alert_message,
    alert_title = _ref.alert_title,
    continue_btn_text = _ref.continue_btn_text,
    buttons_info_array = _ref.buttons_info_array,
    className = _ref.className,
    loading = _ref.loading,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled,
    alert_variant = _ref.alert_variant;
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    continue_btn_text: continue_btn_text,
    title: "Manage farm",
    continue_btn_disabled: state === undefined || disabled,
    handleContinueBtnClick: handleContinueClick
  }, alert_message && alert_variant && React.createElement(Alert, {
    className: "mt-8",
    title: alert_title,
    variant: alert_variant
  }, alert_message), React.createElement(SquareButtons, {
    className: "pt-8 pb-8",
    buttons_info_array: buttons_info_array,
    label: "Extend farm\u2019s life time",
    tooltip: "Total amount of days the farm will be providing rewards to all participants. This will add additional days to your current farm life time.",
    selected: state,
    setSelected: setState
  }), React.createElement(ListItemUnit, {
    surface: "two",
    list_item_arr: list_item_arr
  }));
});
Manage.displayName = 'Manage';
Manage.defaultProps = defaultProps$s;

var defaultProps$t = {
  as: FormWrapper,
  className: '',
  loading: false,
  progress: undefined
};
var ParticipationFees = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    className = _ref.className,
    continue_btn_text = _ref.continue_btn_text,
    skip_btn_text = _ref.skip_btn_text,
    loading = _ref.loading,
    progress = _ref.progress,
    handleSkipClick = _ref.handleSkipClick,
    handleContinueClick = _ref.handleContinueClick,
    disabled = _ref.disabled;
  var _useState = useState({
      wallet_address: '',
      fee_percentage: ''
    }),
    state = _useState[0],
    setState = _useState[1];
  var handleChange = function handleChange(name, val) {
    var _extends2;
    return setState(_extends({}, state, (_extends2 = {}, _extends2[name] = val, _extends2)));
  };
  return React.createElement(Component, {
    ref: ref,
    className: "" + className,
    loading: loading,
    progress: progress,
    continue_btn_text: continue_btn_text,
    continue_btn_disabled: state.wallet_address === '' || state.fee_percentage === '' || disabled,
    skip_btn_text: skip_btn_text,
    subtitle: "Split the cost of the farm with the participants. Leave blank if you don\u2019t want to collect fees.",
    title: "Participation Fees",
    handleContinueBtnClick: function handleContinueBtnClick() {
      return handleContinueClick(state.wallet_address, state.fee_percentage);
    },
    handleSkipBtnClick: handleSkipClick
  }, React.createElement("div", {
    className: "mt-[32px] flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter wallet address",
    id: "wallet-address-input",
    label: "Wallet address to send the fees to",
    type: "text",
    value: state.wallet_address,
    onChange: function onChange(e) {
      return handleChange('wallet_address', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('wallet_address', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "paste-btn"
  }))), React.createElement(Input, {
    containerClasses: "pt-5",
    surface: "zero",
    placeholder: "Enter fee percent",
    id: "fee-percentage-input",
    label: "Fee percentage",
    type: "number",
    value: state.fee_percentage,
    onChange: function onChange(e) {
      return handleChange('fee_percentage', e.target.value);
    },
    unit: "percent",
    max_btn: false,
    tooltip: "some tooltip some tooltip some tooltip"
  }));
});
ParticipationFees.displayName = 'ParticipationFees';
ParticipationFees.defaultProps = defaultProps$t;

var defaultProps$u = {
  as: Modal,
  className: '',
  id: 'farm-summary',
  items: [],
  show: false
};
var Summary = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var Component = _ref.as,
    id = _ref.id,
    items = _ref.items,
    show = _ref.show,
    onClose = _ref.onClose;
  return React.createElement(Component, {
    children_classes: "space-y-8",
    "data-testid": id,
    ref: ref,
    show: show,
    title: "Farm summary",
    onClose: onClose
  }, items && items.map(function (item) {
    return React.createElement("div", {
      className: "text-left",
      key: JSON.stringify(item)
    }, React.createElement("div", {
      className: "flex items-center justify-between mb-5"
    }, React.createElement(Typography, {
      allBold: true,
      size: "2xl"
    }, item.title), item.onEdit && React.createElement(Typography, {
      className: "text-accent cursor-pointer",
      size: "sm",
      variant: "custom",
      onClick: item.onEdit
    }, "Edit")), React.createElement(ListItemUnit, {
      list_item_arr: item.list,
      surface: "two"
    }));
  }));
});
Summary.displayName = 'Summary';
Summary.defaultProps = defaultProps$u;

var defaultProps$v = {
  className: '',
  id: 'farm-stats-summary',
  items: []
};
var StatsSummary = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    items = _ref.items,
    handleFarmSummary = _ref.handleFarmSummary;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Card, {
    id: id,
    ref: ref,
    surface: "one",
    className: "max-w-[580px] p-5 xs:p-8 " + className
  }, React.createElement(Typography, {
    allBold: true,
    size: is_mobile ? '3xl' : '4xl',
    className: "text-center"
  }, "Stats & summary"), React.createElement(Card, {
    surface: "two",
    className: "my-8"
  }, React.createElement(ListItem, {
    label_text: "Full summary",
    info_text: "View the farm\u2019s full summary.",
    button_text: "View",
    variant: "button",
    handleClick: handleFarmSummary
  })), React.createElement(ListItemUnit, {
    list_item_arr: items,
    surface: "two"
  }));
});
StatsSummary.displayName = 'StatsSummary';
StatsSummary.defaultProps = defaultProps$v;

var KYCContents = function KYCContents(_ref) {
  var Kyc_form_data = _ref.Kyc_form_data,
    handleClick = _ref.handleClick,
    handleChange = _ref.handleChange,
    loading = _ref.loading,
    disabled = _ref.disabled,
    error = _ref.error,
    alert = _ref.alert;
  return React.createElement("div", null, React.createElement("ul", {
    className: "font-normal py-8 sm:py-4 list-disc pl-7 sm:pl-7 text-left"
  }, React.createElement("li", {
    className: "text-secondary text-sm sm:text-md"
  }, React.createElement("span", {
    className: "text-primary"
  }, "Clear Photos:"), " Take clear, high-quality photos."), React.createElement("li", {
    className: "text-secondary text-sm sm:text-md"
  }, React.createElement("span", {
    className: "text-primary"
  }, "Avoid Screens:"), " Don\u2019t take photos of monitors or screens."), React.createElement("li", {
    className: "text-secondary text-sm sm:text-md"
  }, React.createElement("span", {
    className: "text-primary"
  }, "Check Expiry:"), " Ensure your documents are still valid."), React.createElement("li", {
    className: "text-secondary text-sm sm:text-md"
  }, React.createElement("span", {
    className: "text-primary"
  }, "No Cropping:"), " Avoid cutting off corners in photos.")), React.createElement("div", {
    className: "space-y-5 sm:space-y-3"
  }, Kyc_form_data.map(function (_ref2, idx) {
    var name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      type = _ref2.type;
    return React.createElement(Input, {
      name: name,
      key: "form-field-" + idx,
      surface: "zero",
      placeholder: placeholder,
      id: name,
      label: label,
      type: type,
      onChange: function onChange(e) {
        return handleChange(e);
      },
      className: "sm:text-sm",
      error: name === 'dob' && error ? error : ''
    });
  })), alert && React.createElement(Alert, {
    variant: alert.variant || 'warning',
    title: alert.title,
    className: "mt-8"
  }, alert.content), React.createElement(Button, {
    loading: loading,
    disabled: disabled,
    onClick: handleClick,
    className: "mt-8 w-full text-sm"
  }, "Verify now"));
};

var KYCSteps = function KYCSteps(_ref) {
  var className = _ref.className,
    Kyc_form_data = _ref.Kyc_form_data,
    _ref$show_skip = _ref.show_skip,
    show_skip = _ref$show_skip === void 0 ? true : _ref$show_skip,
    handleSkipNow = _ref.handleSkipNow,
    handleClick = _ref.handleClick,
    handleChange = _ref.handleChange,
    state = _ref.state,
    loading = _ref.loading,
    disabled = _ref.disabled,
    error = _ref.error,
    alert = _ref.alert;
  return React.createElement("div", {
    className: "max-w-[580px] " + className
  }, React.createElement(Card, {
    className: "p-[20px]"
  }, React.createElement(Typography, null, "Almost done! To verify, you\u2019ll be asked to provide documents (e.g. passport, driving license, ID card). Ensure that the information provided below matches the details on your document."), React.createElement(KYCContents, {
    disabled: disabled,
    handleClick: handleClick,
    handleChange: handleChange,
    state: state,
    loading: loading,
    Kyc_form_data: Kyc_form_data,
    error: error,
    alert: alert
  })), show_skip && React.createElement("div", {
    className: "flex justify-center pt-5"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-primary cursor-pointer",
    onClick: handleSkipNow
  }, "Skip for now")));
};

var QuestionStage;
(function (QuestionStage) {
  QuestionStage[QuestionStage["StageOne"] = 0] = "StageOne";
  QuestionStage[QuestionStage["StageTwo"] = 1] = "StageTwo";
  QuestionStage[QuestionStage["StageThree"] = 2] = "StageThree";
  QuestionStage[QuestionStage["StageFour"] = 3] = "StageFour";
  QuestionStage[QuestionStage["StageFive"] = 4] = "StageFive";
  QuestionStage[QuestionStage["StageSix"] = 5] = "StageSix";
})(QuestionStage || (QuestionStage = {}));
var ComplianceQuestions = function ComplianceQuestions(_ref) {
  var _answers$declaration, _answers$declaration2;
  var className = _ref.className,
    show = _ref.show,
    setShow = _ref.setShow,
    handleSubmitClick = _ref.handleSubmitClick,
    compliance_questions = _ref.compliance_questions,
    answers = _ref.answers,
    setAnswers = _ref.setAnswers,
    handleLogOut = _ref.handleLogOut;
  var _useState = useState(QuestionStage.StageOne),
    current_stage = _useState[0],
    setCurrentStage = _useState[1];
  var handleOptionChange = function handleOptionChange(option) {
    setAnswers(function (prev) {
      var _extends2;
      return _extends({}, prev, (_extends2 = {}, _extends2[current_stage] = {
        option: option,
        other_text: ''
      }, _extends2));
    });
  };
  var goToNextStage = function goToNextStage() {
    if (current_stage < QuestionStage.StageSix) {
      setCurrentStage(current_stage + 1);
    }
  };
  var goToPreviousStage = function goToPreviousStage() {
    if (current_stage > QuestionStage.StageOne) {
      setCurrentStage(current_stage - 1);
    }
  };
  var current_question = compliance_questions.find(function (q) {
    return q.stage === current_stage;
  });
  var isActionDisabled = function isActionDisabled() {
    var answer = answers[current_stage];
    if (!(answer != null && answer.option)) return true; // No answer selected
    var selected_option = answer.option.toLowerCase();
    var is_other_option = selected_option.includes('other');
    // If "Other" is selected, ensure `other_text` has at least one character
    if (is_other_option && (!answer.other_text || answer.other_text.trim().length < 1)) {
      return true;
    }
    return false;
  };
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false,
    className: "max-w-[640px] mx-auto overflow-y-auto"
  }, React.createElement("div", {
    className: "text-center"
  }, React.createElement(Typography, {
    variant: "primary",
    size: "4xl",
    allBold: true,
    className: "mb-3"
  }, "Additional Questions"), React.createElement(Typography, {
    variant: "secondary"
  }, "To comply with the regulations, we are required to collect these details from you. Please note that these questions are mandatory to proceed with investing on Decubate platform."), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] my-[32px]"
  }), React.createElement("div", {
    className: "flex items-center justify-center"
  }, React.createElement("div", {
    className: "w-full"
  }, React.createElement(Progress, {
    percent: (current_stage + 1) / compliance_questions.length * 100,
    id: "compliance-questions",
    height: "h-2",
    surface: "zero"
  })), React.createElement("div", {
    className: "ml-2 text-accent text-xs"
  }, current_stage + 1 + "/" + compliance_questions.length)), current_question && React.createElement("div", {
    className: "px-4 " + (current_stage === QuestionStage.StageTwo || current_stage === QuestionStage.StageFour ? 'overflow-y-auto max-h-[400px]' : '')
  }, React.createElement(Typography, {
    variant: "primary",
    className: "my-8 text-left",
    allBold: true
  }, current_question.title), current_question.options.map(function (option) {
    var _answers$current_stag, _answers$current_stag2, _answers$current_stag3;
    return React.createElement("div", {
      className: "mb-4",
      key: option
    }, React.createElement("div", {
      className: "flex items-center gap-2"
    }, React.createElement(Toggle, {
      variant: "radio",
      active: ((_answers$current_stag = answers[current_stage]) == null ? void 0 : _answers$current_stag.option) === option,
      onChange: function onChange() {
        return handleOptionChange(option);
      }
    }), React.createElement("label", {
      onClick: function onClick() {
        return handleOptionChange(option);
      },
      className: "ml-2 cursor-pointer text-primary text-sm"
    }, option)), option.toLowerCase().includes('other') && ((_answers$current_stag2 = answers[current_stage]) == null ? void 0 : _answers$current_stag2.option) === option && React.createElement(Input, {
      type: "text",
      className: "mt-4 rounded w-full bg-surface-level-zero",
      placeholder: "Please specify",
      value: ((_answers$current_stag3 = answers[current_stage]) == null ? void 0 : _answers$current_stag3.other_text) || '',
      onChange: function onChange(e) {
        return setAnswers(function (prev) {
          var _extends3;
          return _extends({}, prev, (_extends3 = {}, _extends3[current_stage] = _extends({}, prev[current_stage], {
            other_text: e.target.value
          }), _extends3));
        });
      }
    }));
  })), React.createElement("div", {
    className: "mt-8"
  }, current_stage === QuestionStage.StageOne && React.createElement(React.Fragment, null, React.createElement(Button, {
    className: "btn-primary w-full mt-[28px]",
    onClick: goToNextStage,
    disabled: isActionDisabled()
  }, "Next"), React.createElement("button", {
    className: " mt-4 text-secondary text-sm",
    onClick: handleLogOut
  }, "Log out")), current_stage > QuestionStage.StageOne && current_stage < QuestionStage.StageSix && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "flex justify-between gap-4 mt-[32px]"
  }, React.createElement(Button, {
    variant: "custom",
    onClick: goToPreviousStage,
    className: "bg-surface-level-three text-secondary w-full"
  }, React.createElement(Media, {
    className: "cursor-pointer inline-block mr-2 items-center text-secondary",
    size: 4,
    variant: "arrow-left"
  }), "Previous Step"), React.createElement(Button, {
    className: "btn-primary w-full",
    onClick: goToNextStage,
    disabled: isActionDisabled()
  }, "Next")), React.createElement("div", null, React.createElement("button", {
    className: " mt-4 text-secondary text-sm",
    onClick: handleLogOut
  }, "Log out"))), current_stage === QuestionStage.StageSix && React.createElement(React.Fragment, null, React.createElement(Card, {
    id: "toggle-card",
    surface: "two",
    className: "mt-8 mb-5 px-2 py-2"
  }, React.createElement(Toggle, {
    active: ((_answers$declaration = answers.declaration) == null ? void 0 : _answers$declaration.option) === 'accept-terms',
    onChange: function onChange() {
      return setAnswers(function (prev) {
        return _extends({}, prev, {
          declaration: {
            option: 'accept-terms',
            other_text: ''
          }
        });
      });
    },
    id: "accept-terms",
    label: "I confirm that the information provided is accurate and true.",
    variant: "checkbox",
    className: "text-xs"
  })), React.createElement("div", {
    className: "flex justify-between gap-4"
  }, React.createElement(Button, {
    variant: "custom",
    onClick: goToPreviousStage,
    className: "bg-surface-level-three text-secondary w-full"
  }, React.createElement(Media, {
    className: "cursor-pointer inline-block mr-2 items-center text-secondary",
    size: 4,
    variant: "arrow-left"
  }), "Previous Step"), React.createElement(Button, {
    className: "btn-primary w-full",
    onClick: function onClick() {
      handleSubmitClick();
      setShow(false);
    },
    disabled: isActionDisabled() || !((_answers$declaration2 = answers.declaration) != null && _answers$declaration2.option)
  }, "Submit")), React.createElement("button", {
    className: " mt-4 text-secondary text-sm",
    onClick: handleLogOut
  }, "Log out"))))));
};

var defaultProps$w = {
  loading: false,
  disabled: false,
  has_tabs: false
};
var setup_tab_options = [{
  title: 'Compounding',
  id: '0'
}, {
  title: 'Dynamic',
  id: '1'
}];
var SetupForm = function SetupForm(_ref) {
  var loading = _ref.loading,
    disabled = _ref.disabled,
    handleClick = _ref.handleClick,
    select_current = _ref.select_current,
    setSelectCurrent = _ref.setSelectCurrent,
    options = _ref.options,
    handleChange = _ref.handleChange,
    state = _ref.state,
    alert_text = _ref.alert_text,
    has_tabs = _ref.has_tabs;
  return React.createElement("div", {
    className: "" + (has_tabs ? 'pt-5' : '')
  }, options && React.createElement(Select, {
    current: select_current,
    setCurrent: setSelectCurrent,
    surface: "zero",
    placeholder: "Staking contract name",
    options: options,
    label: "Staking contract",
    className: "mb-5"
  }), React.createElement("div", {
    className: "flex justify-between items-end"
  }, React.createElement(Input, {
    containerClasses: "w-full",
    surface: "zero",
    placeholder: "Enter fee wallet address",
    tooltip: "Wallet that collects all staking fees. Leave blank if you don't want to collect fees from each stake.",
    id: "wallet-addr-input",
    label: "Fee wallet address",
    type: "text",
    value: state.wallet_addr,
    onChange: function onChange(e) {
      return handleChange('wallet_addr', e.target.value);
    }
  }), React.createElement(Button, {
    variant: "secondary",
    className: "ml-5 w-11",
    onClick: function () {
      var _onClick = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var text;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return navigator.clipboard.readText();
            case 2:
              text = _context.sent;
              handleChange('wallet_addr', text);
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onClick() {
        return _onClick.apply(this, arguments);
      }
      return onClick;
    }()
  }, React.createElement(Media, {
    size: 6,
    className: "text-primary flex items-center justify-center",
    variant: "paste-btn"
  }))), React.createElement(Input, {
    containerClasses: "w-full my-5",
    surface: "zero",
    placeholder: "Enter fee percentage",
    unit: "percent",
    id: "fee-percentage-input",
    label: "Fee percentage",
    tooltip: "Percent of each stake that will be deducted and forwarded to the above specified wallet address.",
    max_btn: false,
    type: "number",
    value: state.fee_percentage,
    onChange: function onChange(e) {
      return handleChange('fee_percentage', e.target.value);
    }
  }), alert_text && React.createElement(Alert, {
    variant: "note"
  }, alert_text), React.createElement(Button, {
    id: "button",
    onClick: handleClick,
    className: "mt-5 w-full",
    disabled: disabled,
    loading: loading
  }, "Save changes"));
};
var FeeSetupForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Card, {
    className: "p-5 " + props.className,
    ref: ref
  }, props.has_tabs && React.createElement(Tabs, {
    variant: "limited",
    button_color: "bg-surface-level-one",
    options: setup_tab_options,
    current: props.tab_current || '',
    setCurrent: function setCurrent(id) {
      return props.setTabCurrent ? props.setTabCurrent(id) : null;
    },
    background_color: "bg-surface-level-zero"
  }), React.createElement(SetupForm, Object.assign({}, props)));
});
FeeSetupForm.displayName = 'FeeSetupForm';
FeeSetupForm.defaultProps = defaultProps$w;

var defaultProps$x = {};
var OpenableItem = function OpenableItem(_ref) {
  var className = _ref.className,
    title = _ref.title,
    children = _ref.children,
    main_values = _ref.main_values,
    loading = _ref.loading;
  var _useState = useState(false),
    show = _useState[0],
    setShow = _useState[1];
  return React.createElement("div", {
    className: "max-w-[1000px] bg-surface-level-one rounded low-border " + className
  }, React.createElement("div", {
    className: "bg-surface-level-two p-5 rounded flex items-center justify-between w-full"
  }, React.createElement(Typography, {
    className: "mr-5 max-w-[154px] w-full",
    size: "md",
    allBold: true
  }, title), React.createElement("div", {
    className: "flex items-center space-x-5 w-full"
  }, main_values.map(function (_ref2, idx) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      key: idx + "-" + label + "-" + value,
      className: "w-full"
    }, React.createElement(DataLines, {
      className: "w-full",
      label: label,
      values: [{
        value: value
      }],
      variant: "verticle"
    }));
  })), React.createElement(Button, {
    iconOnly: true,
    className: "w-11 h-11 ml-5 border border-border",
    onClick: function onClick() {
      setShow(!show);
    }
  }, React.createElement(Media, {
    size: 0,
    className: "mx-auto w-[18px] h-[18px] text-primary",
    variant: loading ? 'loader' : show ? 'chevron-up' : 'chevron-down'
  }))), show && React.createElement("div", {
    className: "bg-surface-level-one p-5"
  }, React.createElement("div", null, children)));
};
OpenableItem.displayName = 'OpenableItem';
OpenableItem.defaultProps = defaultProps$x;

var defaultProps$y = {};
var AnalyticsComponent = function AnalyticsComponent(_ref) {
  var className = _ref.className,
    title = _ref.title,
    main_values = _ref.main_values,
    tier_info = _ref.tier_info,
    buttons_info = _ref.buttons_info,
    _ref$crowdfunding_inf = _ref.crowdfunding_info,
    crowdfunding_info = _ref$crowdfunding_inf === void 0 ? undefined : _ref$crowdfunding_inf,
    loading = _ref.loading;
  return React.createElement(OpenableItem, {
    main_values: main_values,
    title: title,
    className: "" + className,
    loading: loading
  }, React.createElement("div", {
    className: "space-y-5"
  }, crowdfunding_info && React.createElement("div", {
    className: "grid grid-cols-3 p-5"
  }, crowdfunding_info.map(function (_ref2, idx) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement(DataLines, {
      key: idx + "-" + label + "-" + value,
      label: label,
      values: [{
        value: value
      }],
      variant: "verticle"
    });
  })), tier_info.map(function (_ref3, idx) {
    var tier = _ref3.tier,
      info = _ref3.info,
      image = _ref3.image;
    return React.createElement(Card, {
      key: tier + "-" + idx,
      className: "p-5 flex items-center w-full",
      surface: "two"
    }, React.createElement("div", {
      className: "" + (crowdfunding_info ? 'w-[195px]' : 'w-[233px]')
    }, React.createElement(TierLevel, {
      label: true,
      text: tier,
      image_url: image
    })), React.createElement("div", {
      className: "grid flex-1 " + (crowdfunding_info ? 'grid-cols-3 gap-y-5' : 'grid-cols-2')
    }, info.map(function (_ref4, idx) {
      var label = _ref4.label,
        value = _ref4.value;
      return React.createElement(DataLines, {
        key: label + '-' + idx,
        variant: "verticle",
        label: label,
        values: [{
          value: value
        }]
      });
    })));
  })), React.createElement("div", null, buttons_info.map(function (_ref5) {
    var button_text = _ref5.button_text,
      handleClick = _ref5.handleClick,
      label = _ref5.label,
      loading = _ref5.loading,
      disabled = _ref5.disabled;
    return React.createElement("div", {
      key: button_text + '-' + label,
      className: "flex items-center justify-between mt-5"
    }, React.createElement(Typography, null, label), React.createElement(Button, {
      loading: loading,
      disabled: disabled,
      onClick: handleClick
    }, button_text));
  })));
};
AnalyticsComponent.displayName = 'AnalyticsComponent';
AnalyticsComponent.defaultProps = defaultProps$y;

var defaultProps$z = {};
var ButtonStack = function ButtonStack(_ref) {
  var className = _ref.className,
    state = _ref.state,
    setState = _ref.setState,
    options = _ref.options,
    has_secondary_btns = _ref.has_secondary_btns;
  return React.createElement("div", {
    className: "flex flex-col gap-3 " + className
  }, options.map(function (option) {
    return React.createElement(Button, {
      variant: state === option && !has_secondary_btns ? 'light' : 'custom',
      className: "justify-between w-[180px] " + (state === option ? has_secondary_btns ? 'text-secondary bg-surface-level-two' : 'text-black' : 'bg-surface-level-one text-secondary'),
      key: option,
      has_icon: true,
      onClick: function onClick() {
        return setState(option);
      }
    }, React.createElement(Typography, {
      size: "sm",
      variant: "custom",
      className: ""
    }, option), React.createElement(Media, {
      className: state === option && !has_secondary_btns ? 'text-black' : 'text-primary',
      variant: "arrow-right",
      size: 4
    }));
  }));
};
ButtonStack.displayName = 'ButtonStack';
ButtonStack.defaultProps = defaultProps$z;

var MarkdownEditor = function MarkdownEditor(_ref) {
  var value = _ref.value,
    onChange = _ref.onChange;
  var ref = useRef(null);
  var editorRef = useRef();
  var _useState = useState(null),
    EasyMDE = _useState[0],
    setEasyMDE = _useState[1];
  useEffect(function () {
    // Dynamically import EasyMDE only in the browser
    import('easymde').then(function (mod) {
      setEasyMDE(function () {
        return mod["default"];
      });
    });
  }, []);
  useEffect(function () {
    if (EasyMDE && ref.current && !editorRef.current) {
      editorRef.current = new EasyMDE({
        element: ref.current,
        initialValue: value,
        spellChecker: false,
        status: false,
        toolbar: ['bold', 'italic', 'strikethrough', 'heading', '|', 'quote', 'code', 'unordered-list', 'ordered-list', 'table', '|', 'link', 'image', 'horizontal-rule', '|', 'undo', 'redo', '|', 'guide']
      });
      editorRef.current.codemirror.on('change', function () {
        var _editorRef$current;
        var newValue = ((_editorRef$current = editorRef.current) == null ? void 0 : _editorRef$current.value()) || '';
        onChange(newValue);
      });
    }
    return function () {
      var _editorRef$current2;
      (_editorRef$current2 = editorRef.current) == null || _editorRef$current2.toTextArea();
      editorRef.current = undefined;
    };
  }, [EasyMDE]);
  useEffect(function () {
    var _editorRef$current3;
    if (((_editorRef$current3 = editorRef.current) == null ? void 0 : _editorRef$current3.value()) !== value) {
      var _editorRef$current4;
      (_editorRef$current4 = editorRef.current) == null || _editorRef$current4.value(value);
    }
  }, [value]);
  return React.createElement("textarea", {
    ref: ref
  });
};

// functions that takes in a number and returns a string with the number formatted with commmas
// ex: 1000000 -> 1,000,000
var formatLargeNumber = function formatLargeNumber(num) {
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
var RenderInput = function RenderInput(_ref) {
  var _ref$choose_img_btn_c = _ref.choose_img_btn_color,
    choose_img_btn_color = _ref$choose_img_btn_c === void 0 ? 'two' : _ref$choose_img_btn_c,
    className = _ref.className,
    handleChange = _ref.handleChange,
    label = _ref.label,
    name = _ref.name,
    type = _ref.type,
    value = _ref.value,
    placeholder = _ref.placeholder,
    handleOpenModal = _ref.handleOpenModal,
    errors = _ref.errors,
    has_comma_helper = _ref.has_comma_helper,
    inset = _ref.inset,
    multiline = _ref.multiline,
    options = _ref.options,
    sub_label = _ref.sub_label,
    tooltip = _ref.tooltip,
    min_date_input_vals = _ref.min_date_input_vals,
    disable_input = _ref.disable_input,
    not_editable = _ref.not_editable,
    helper_text = _ref.helper_text,
    success_text = _ref.success_text,
    img_height = _ref.img_height,
    img_width = _ref.img_width;
  // initialize inputs so errors don't show till focused once
  var _useState = useState(false),
    input_initialized = _useState[0],
    setInputInitialized = _useState[1];
  var _useState2 = useState(false),
    select_initialized = _useState2[0],
    setSelectInitialized = _useState2[1];
  switch (type) {
    case 'image':
      return React.createElement("div", {
        className: "flex items-center space-x-5 w-full"
      }, React.createElement(Input, {
        surface: "zero",
        placeholder: placeholder,
        label: label,
        tooltip: tooltip,
        type: "text",
        unclickable: true,
        name: name,
        value: typeof value === 'string' ? value : '',
        containerClasses: "flex-grow"
      }), handleOpenModal && React.createElement(Button, {
        has_icon: true,
        onClick: handleOpenModal,
        className: "mt-auto " + (choose_img_btn_color === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : 'bg-surface-level-three hover:bg-surface-level-four') + " ",
        variant: "custom"
      }, React.createElement(Typography, {
        size: "sm",
        variant: "secondary"
      }, "Choose image")));
    case 'video':
      return React.createElement("div", {
        className: "flex items-center space-x-5 w-full"
      }, React.createElement(Input, {
        surface: "zero",
        placeholder: placeholder,
        label: label,
        tooltip: tooltip,
        type: "text",
        unclickable: true,
        name: name,
        value: value,
        containerClasses: "flex-grow"
      }), handleOpenModal && React.createElement(Button, {
        has_icon: true,
        onClick: handleOpenModal,
        className: "mt-auto " + (choose_img_btn_color === 'two' ? 'bg-surface-level-two hover:bg-surface-level-three' : 'bg-surface-level-three hover:bg-surface-level-four') + " ",
        variant: "custom"
      }, React.createElement(Typography, {
        size: "sm",
        variant: "secondary"
      }, "Choose video")));
    case 'select':
      var v = options && options.find(function (option) {
        return option.id === value;
      });
      return React.createElement(Select, {
        disabled: not_editable ? disable_input : false,
        is_initialized: select_initialized,
        onFocus: function onFocus() {
          return setSelectInitialized(true);
        },
        error: errors ? errors[name] : undefined,
        className: "mt-5",
        current: v,
        placeholder: placeholder,
        setCurrent: function setCurrent(v) {
          return handleChange(name, v.id);
        },
        options: options,
        label: label,
        tooltip: tooltip
      });
    case 'switch':
      return React.createElement("div", null, React.createElement("div", {
        className: "flex"
      }, React.createElement("label", {
        className: "mb-4 pt-2 text-secondary text-sm",
        htmlFor: type
      }, label), tooltip && React.createElement(Tooltip, {
        className: "pl-[10px]",
        text: tooltip,
        id: "tooltip-" + type + "-" + label
      }, React.createElement(Media, {
        className: "ml-2 mb-4 text-accent",
        size: 5,
        variant: "info-outline"
      }))), React.createElement(Card, {
        surface: "two",
        className: "h-11 px-5 flex items-center w-full"
      }, React.createElement(Toggle, {
        className: "flex justify-between w-full",
        variant: "switch",
        switch_surface_color: "bg-surface-level-zero",
        active: value,
        onChange: function onChange() {
          return handleChange(name, !value);
        },
        label: React.createElement("span", {
          className: "text-primary"
        }, sub_label)
      })));
    default:
      if (name === 'explanation') {
        return React.createElement("div", {
          className: "space-y-4"
        }, React.createElement("label", {
          className: "text-secondary text-sm"
        }, label), React.createElement("div", {
          className: "bg-surface-level-one text-secondary p-4 rounded"
        }, React.createElement(MarkdownEditor, {
          value: value,
          onChange: function onChange(val) {
            return handleChange(name, val);
          }
        })), React.createElement(Typography, {
          variant: "secondary",
          size: "sm",
          className: "text-right my-2"
        }, React.createElement("a", {
          href: "https://www.markdownguide.org/basic-syntax/",
          target: "_blank",
          rel: "noreferrer",
          className: "text-accent my-2"
        }, "Markdown Guide")), React.createElement("div", {
          className: "py-2 space-x-2 space-y-4"
        }, React.createElement(Typography, {
          allBold: true,
          size: "sm",
          variant: "secondary",
          className: "space-y-4"
        }, "Content Preview"), React.createElement(Card, {
          surface: "two",
          className: "p-6 space-x-2 space-y-4 text-secondary"
        }, React.createElement(Markdown, {
          options: {
            overrides: {
              a: {
                component: 'a',
                props: {
                  className: 'text-accent hover:underline cursor-pointer'
                }
              },
              ul: {
                component: 'ul',
                props: {
                  className: 'list-disc ml-5'
                }
              },
              ol: {
                component: 'ol',
                props: {
                  className: 'list-decimal ml-5'
                }
              },
              li: {
                component: 'li',
                props: {
                  className: 'mb-2'
                }
              }
            }
          }
        }, typeof value === 'string' ? value : ''))));
      }
      // fallback to normal input
      return React.createElement(Input, {
        disabled: not_editable ? disable_input : false,
        helperText: helper_text ? helper_text : has_comma_helper && value !== '' ? formatLargeNumber(Number(value)) : undefined,
        placeholder: placeholder,
        surface: "zero",
        label: label,
        error: errors ? errors[name] : undefined,
        min: min_date_input_vals ? min_date_input_vals[name] : undefined,
        type: type,
        handleFocus: function handleFocus() {
          return setInputInitialized(true);
        },
        is_initialized: input_initialized,
        name: name,
        id: "input-" + label + "-" + placeholder,
        tooltip: tooltip,
        unit: inset,
        success_text: success_text,
        max_btn: false,
        multiline: multiline,
        onChange: function onChange(e) {
          return handleChange(name, e.target.value);
        },
        value: value,
        containerClasses: className,
        img_height: img_height,
        img_width: img_width
      });
  }
};

var defaultProps$A = {};
var CarouselForm = function CarouselForm(_ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    _handleOpenModal = _ref.handleOpenModal,
    className = _ref.className,
    form_data = _ref.form_data;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, form_data.map(function (_ref2, idx) {
    var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      multiline = _ref2.multiline,
      inset = _ref2.inset,
      tooltip = _ref2.tooltip,
      options = _ref2.options;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      handleOpenModal: function handleOpenModal() {
        return _handleOpenModal(name);
      }
    };
    return React.createElement(RenderInput, Object.assign({
      key: "carousel-input-" + idx
    }, props));
  }));
};
CarouselForm.displayName = 'CarouselForm';
CarouselForm.defaultProps = defaultProps$A;

var defaultProps$B = {
  status: undefined
};
var EventRequestStatus;
(function (EventRequestStatus) {
  EventRequestStatus["Approved"] = "Approved";
  EventRequestStatus["Declined"] = "Declined";
  EventRequestStatus["Pending"] = "Pending";
})(EventRequestStatus || (EventRequestStatus = {}));
var statusShowVal = {
  Approved: {
    color: 'text-success',
    text: 'Approved'
  },
  Pending: {
    color: 'text-accent',
    text: 'Pending approval'
  },
  Declined: {
    color: 'text-accent',
    text: 'Rejected'
  }
};
var EditableItem = function EditableItem(_ref) {
  var _statusShowVal$status, _statusShowVal$status2, _statusShowVal$status3, _statusShowVal$status4;
  var className = _ref.className,
    _ref$initial_show = _ref.initial_show,
    initial_show = _ref$initial_show === void 0 ? false : _ref$initial_show,
    title = _ref.title,
    show = _ref.show,
    setShow = _ref.setShow,
    handleRemoveItem = _ref.handleRemoveItem,
    is_draggable = _ref.is_draggable,
    children = _ref.children,
    _ref$show_title_when_ = _ref.show_title_when_open,
    show_title_when_open = _ref$show_title_when_ === void 0 ? true : _ref$show_title_when_,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? undefined : _ref$status,
    _ref$has_secondary_bt = _ref.has_secondary_btns,
    has_secondary_btns = _ref$has_secondary_bt === void 0 ? false : _ref$has_secondary_bt,
    network = _ref.network,
    has_lighter_secondary_btns = _ref.has_lighter_secondary_btns,
    disabled = _ref.disabled;
  var _useState = useState(initial_show),
    internalShow = _useState[0],
    setInternalShow = _useState[1];
  var showContent = useMemo(function () {
    return setShow ? !show : !internalShow;
  }, [setShow, show, internalShow]);
  var secondary_btn_variant = has_lighter_secondary_btns ? 'custom' : 'secondary';
  return React.createElement("div", {
    className: "bg-surface-level-one p-5 rounded low-border " + className
  }, showContent ? React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement("div", {
    className: "flex items-center"
  }, is_draggable && React.createElement(Media, {
    size: 0,
    className: "h-2 w-[20px] mr-5",
    variant: "draggable"
  }), React.createElement(Typography, {
    allBold: true,
    size: is_draggable ? 'md' : '2xl'
  }, title), status && React.createElement(Typography, {
    className: ((_statusShowVal$status = statusShowVal[status]) == null ? void 0 : _statusShowVal$status.color) + " pl-5",
    size: "md",
    variant: "custom"
  }, (_statusShowVal$status2 = statusShowVal[status]) == null ? void 0 : _statusShowVal$status2.text)), React.createElement("div", {
    className: "flex items-center"
  }, network && React.createElement(Tooltip, {
    text: network.label,
    id: "tooltip-" + network.label + "-" + title + "-outside"
  }, React.createElement("img", {
    src: network.logo_url,
    alt: "network-logo"
  })), React.createElement(Button, {
    padding: false,
    className: "w-11 h-11 ml-5",
    onClick: function onClick() {
      setShow ? setShow(!show) : setInternalShow(!internalShow);
    },
    disabled: disabled
  }, React.createElement(Media, {
    size: 0,
    className: "mx-auto w-[17px] h-[18px] text-primary",
    variant: "edit"
  })), handleRemoveItem && React.createElement(Button, {
    padding: false,
    className: "w-11 h-11 ml-5",
    onClick: handleRemoveItem,
    disabled: disabled
  }, React.createElement(Media, {
    size: 0,
    className: "mx-auto w-[17px] h-[18px]  text-primary",
    variant: "bin"
  })))) : React.createElement("div", null, React.createElement("div", {
    className: "w-full flex items-center " + (show_title_when_open ? 'justify-between' : 'justify-end')
  }, show_title_when_open && React.createElement("div", {
    className: "flex items-center"
  }, React.createElement(Typography, {
    allBold: true,
    size: "2xl",
    className: ""
  }, title), status && React.createElement(Typography, {
    className: ((_statusShowVal$status3 = statusShowVal[status]) == null ? void 0 : _statusShowVal$status3.color) + " pl-5",
    size: "md",
    variant: "custom"
  }, (_statusShowVal$status4 = statusShowVal[status]) == null ? void 0 : _statusShowVal$status4.text)), React.createElement("div", {
    className: "flex items-center"
  }, network && React.createElement(Tooltip, {
    text: network.label,
    id: "tooltip-" + network.label + "-" + title + "-inside"
  }, React.createElement("img", {
    src: network.logo_url,
    alt: "network-logo"
  })), React.createElement(Button, {
    padding: false,
    variant: has_secondary_btns || !handleRemoveItem ? secondary_btn_variant : 'primary',
    className: "w-11 h-11 ml-5 " + (has_lighter_secondary_btns ? 'bg-surface-level-three hover:bg-surface-level-four' : ''),
    onClick: function onClick() {
      setShow ? setShow(!show) : setInternalShow(!internalShow);
    }
  }, React.createElement(Media, {
    size: 0,
    className: "mx-auto w-[17px] h-[18px] text-primary",
    variant: "tick"
  })), handleRemoveItem && React.createElement(Button, {
    variant: has_secondary_btns ? 'secondary' : 'primary',
    padding: false,
    className: "w-11 h-11 ml-5",
    onClick: handleRemoveItem
  }, React.createElement(Media, {
    size: 0,
    className: "mx-auto w-[17px] h-[18px]  text-primary",
    variant: "bin"
  })))), React.createElement("div", null, children)));
};
EditableItem.displayName = 'EditableItem';
EditableItem.defaultProps = defaultProps$B;

var ChallengeCard = function ChallengeCard(_ref) {
  var data = _ref.data,
    question_idx = _ref.question_idx,
    answers_state = _ref.answers_state,
    setAnswersState = _ref.setAnswersState,
    handleQuestionChange = _ref.handleQuestionChange,
    handleAnswerChange = _ref.handleAnswerChange,
    handleRemoveQuestion = _ref.handleRemoveQuestion,
    disable_inputs = _ref.disable_inputs,
    handleAddAnswer = _ref.handleAddAnswer,
    handleRemoveAnswer = _ref.handleRemoveAnswer;
  var _useState = useState((data == null ? void 0 : data.question) === ''),
    open = _useState[0],
    setOpen = _useState[1];
  return React.createElement(Card, {
    className: "p-5",
    surface: "two"
  }, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement("div", {
    className: "truncate"
  }, open ? React.createElement(Typography, {
    allBold: true,
    size: "2xl"
  }, 'Question ' + (question_idx + 1)) : React.createElement(DataLines, {
    variant: "verticle",
    verticle_top_truncate: true,
    verticle_bottom_truncate: true,
    top_size: "md",
    bottom_size: "sm",
    label_color: answers_state[question_idx] ? 'text-success' : '',
    label: answers_state[question_idx],
    values: [{
      value: data.question
    }]
  })), React.createElement("div", {
    className: "flex items-center ml-5"
  }, !open && !disable_inputs && React.createElement(Button, {
    iconOnly: true,
    className: "bg-surface-level-three hover:bg-surface-level-four mr-5",
    variant: "custom",
    onClick: function onClick() {
      return handleRemoveQuestion(question_idx);
    }
  }, React.createElement(Media, {
    variant: "bin",
    size: 0,
    className: "w-[18px] h-[17px]"
  })), React.createElement(Button, {
    iconOnly: true,
    className: "bg-surface-level-three hover:bg-surface-level-four",
    variant: "custom",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, React.createElement(Media, {
    variant: open ? 'tick' : 'chevron-down',
    size: 0,
    className: "w-[18px] h-[17px]"
  })))), open && React.createElement("div", {
    className: "pt-5"
  }, React.createElement(Input, {
    unclickable: disable_inputs,
    className: "mt-2",
    key: "question-" + question_idx,
    type: "text",
    surface: "zero",
    name: "question",
    placeholder: "Enter question",
    label: "Question",
    value: data.question,
    onChange: function onChange(e) {
      return handleQuestionChange(e.target.value, question_idx);
    }
  }), data.answers.map(function (answer, answer_idx) {
    return React.createElement("div", {
      key: "question-" + question_idx + "-answer-" + answer_idx,
      className: "flex items-center justify-between w-full space-x-5 mt-5"
    }, React.createElement(Input, {
      unclickable: disable_inputs,
      key: "challenge-answer-" + answer_idx,
      surface: "zero",
      containerClasses: "w-full",
      type: "text",
      name: "answer",
      placeholder: "Enter answer",
      label: "Answer " + (answer_idx + 1),
      value: answer,
      onChange: function onChange(e) {
        return handleAnswerChange(e.target.value, question_idx, answer_idx);
      }
    }), !disable_inputs && React.createElement("div", {
      className: "flex space-x-5 mt-auto"
    }, React.createElement(Button, {
      variant: "custom",
      className: "w-11 h-11 " + (answers_state[question_idx] === answer && answer !== '' ? 'bg-success' : 'bg-surface-level-zero'),
      onClick: function onClick() {
        var _extends2;
        return setAnswersState(_extends({}, answers_state, (_extends2 = {}, _extends2[question_idx] = answer, _extends2)));
      }
    }, React.createElement(Media, {
      variant: "tick",
      size: 0,
      className: "w-[18px] h-[17px]"
    })), React.createElement(Button, {
      iconOnly: true,
      className: "bg-surface-level-three hover:bg-surface-level-four mr-5",
      variant: "custom",
      disabled: data.answers.length === 3,
      onClick: function onClick() {
        return handleRemoveAnswer(question_idx, answer_idx);
      }
    }, React.createElement(Media, {
      variant: "bin",
      size: 0,
      className: "w-[18px] h-[17px]"
    }))));
  }), !disable_inputs && data.answers.length < 4 && React.createElement("div", {
    className: "mt-5"
  }, addNewButtonCard('Add answer', function () {
    return handleAddAnswer(question_idx);
  }, 'bg-surface-level-three hover:bg-surface-level-four'))));
};

var ContractSetupForm = function ContractSetupForm(_ref) {
  var setup_form_data = _ref.setup_form_data,
    event_idx = _ref.event_idx,
    handleDetailsChange = _ref.handleDetailsChange,
    errors = _ref.errors,
    vesting_form_data = _ref.vesting_form_data,
    handleVestingChange = _ref.handleVestingChange,
    vesting_details_state = _ref.vesting_details_state,
    event_details_state = _ref.event_details_state,
    min_date_input_vals = _ref.min_date_input_vals,
    setChecks = _ref.setChecks,
    checks = _ref.checks,
    checklist_title = _ref.checklist_title,
    disable_inputs = _ref.disable_inputs,
    showChecklist = _ref.showChecklist,
    check_messages = _ref.check_messages;
  return React.createElement("div", null, React.createElement("div", {
    className: "space-y-4"
  }, setup_form_data.map(function (_ref2, idx) {
    var label = _ref2.label,
      name = _ref2.name,
      type = _ref2.type,
      inset = _ref2.inset,
      multiline = _ref2.multiline,
      options = _ref2.options,
      placeholder = _ref2.placeholder,
      tooltip = _ref2.tooltip,
      has_comma_helper = _ref2.has_comma_helper,
      not_editable = _ref2.not_editable,
      helper_text = _ref2.helper_text,
      success_text = _ref2.success_text,
      message = _ref2.message,
      url = _ref2.url,
      divider = _ref2.divider;
    var props = {
      value: event_details_state[name] || '',
      handleChange: handleDetailsChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      errors: errors,
      has_comma_helper: has_comma_helper,
      disable_input: disable_inputs,
      not_editable: not_editable,
      helper_text: helper_text,
      success_text: success_text,
      message: message,
      url: url,
      divider: divider
    };
    // if divider, just render divider
    if (divider) {
      return React.createElement(Card, {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name,
        className: "w-full h-[1px] bg-surface-level-three"
      });
    }
    if (message) {
      return React.createElement("div", {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name
      }, React.createElement(Typography, null, "" + message), url && url !== '' && React.createElement(Typography, null, "For more information, please visit ", React.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-primary underline font-bold"
      }, "this link")));
    }
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-request-form-input-" + idx + "-" + name
    }, props));
  }), ' ', vesting_form_data.map(function (_ref3, idx) {
    var label = _ref3.label,
      name = _ref3.name,
      type = _ref3.type,
      inset = _ref3.inset,
      multiline = _ref3.multiline,
      options = _ref3.options,
      placeholder = _ref3.placeholder,
      tooltip = _ref3.tooltip,
      not_editable = _ref3.not_editable,
      helper_text = _ref3.helper_text,
      success_text = _ref3.success_text,
      message = _ref3.message,
      url = _ref3.url,
      divider = _ref3.divider;
    var props = {
      value: vesting_details_state[name] || '',
      handleChange: handleVestingChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      errors: errors,
      min_date_input_vals: min_date_input_vals,
      disable_input: disable_inputs,
      not_editable: not_editable,
      helper_text: helper_text,
      success_text: success_text
    };
    // if divider, just render divider
    if (divider) {
      return React.createElement(Card, {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name,
        className: "w-full h-[1px] bg-surface-level-three"
      });
    }
    if (message) {
      return React.createElement("div", {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name
      }, React.createElement(Typography, null, "" + message), url && url !== '' && React.createElement(Typography, null, "For more information, please visit ", React.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-primary underline font-bold"
      }, "this link")));
    }
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name
    }, props));
  })), showChecklist && React.createElement(CheckInfoCard, {
    className: "mt-5",
    checks: checks,
    setChecks: setChecks,
    title: checklist_title,
    check_messages: check_messages
  }));
};

var MarketingForm = function MarketingForm(_ref) {
  var handleChange = _ref.handleChange,
    form_data = _ref.form_data,
    button_props = _ref.button_props,
    state = _ref.state,
    handleOpenModal = _ref.handleOpenModal;
  var loading = button_props.loading,
    handleClick = button_props.handleClick,
    text = button_props.text,
    disabled = button_props.disabled;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "space-y-4"
  }, form_data == null ? void 0 : form_data.map(function (_ref2) {
    var label = _ref2.label,
      name = _ref2.name,
      type = _ref2.type,
      placeholder = _ref2.placeholder,
      options = _ref2.options;
    var props = {
      value: (state == null ? void 0 : state[name]) || '',
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      choose_img_btn_color: 'three',
      handleOpenModal: handleOpenModal ? function () {
        return handleOpenModal(name);
      } : undefined
    };
    return React.createElement(RenderInput, Object.assign({
      key: name
    }, props));
  })), React.createElement(Button, {
    loading: loading,
    disabled: disabled,
    onClick: handleClick,
    className: "w-full mt-5"
  }, text));
};

var MarketingEventType;
(function (MarketingEventType) {
  MarketingEventType["Telegram"] = "Telegram";
  MarketingEventType["Youtube"] = "Youtube";
})(MarketingEventType || (MarketingEventType = {}));
var EventType;
(function (EventType) {
  EventType["Crowdfunding"] = "Crowdfunding";
  EventType["TokenClaim"] = "TokenClaim";
})(EventType || (EventType = {}));
var CrowdfundingType;
(function (CrowdfundingType) {
  CrowdfundingType["Private"] = "Private";
  CrowdfundingType["Seed"] = "Seed";
  CrowdfundingType["Public"] = "Public";
  CrowdfundingType["Standard"] = "Standard";
  CrowdfundingType["Exclusive"] = "Exclusive";
  CrowdfundingType["Acceleration"] = "Acceleration";
  CrowdfundingType["Incubation"] = "Incubation";
})(CrowdfundingType || (CrowdfundingType = {}));

var EventSetupForm = function EventSetupForm(_ref) {
  var event_setup_form_data = _ref.event_setup_form_data,
    event_state = _ref.event_state,
    handleEventChange = _ref.handleEventChange,
    handleToggleChange = _ref.handleToggleChange,
    setupErrors = _ref.setupErrors,
    min_date_input_vals = _ref.min_date_input_vals,
    disable_inputs = _ref.disable_inputs,
    event_idx = _ref.event_idx;
  return React.createElement("div", {
    className: "space-y-5"
  }, event_setup_form_data.map(function (_ref2, idx) {
    var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      multiline = _ref2.multiline,
      inset = _ref2.inset,
      tooltip = _ref2.tooltip,
      options = _ref2.options,
      sub_label = _ref2.sub_label,
      not_editable = _ref2.not_editable,
      helper_text = _ref2.helper_text,
      success_text = _ref2.success_text,
      message = _ref2.message,
      url = _ref2.url,
      divider = _ref2.divider;
    var props = {
      value: event_state[name],
      handleChange: type === 'switch' && handleToggleChange ? handleToggleChange : handleEventChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      errors: setupErrors,
      min_date_input_vals: min_date_input_vals,
      disable_input: disable_inputs,
      sub_label: sub_label,
      not_editable: not_editable,
      helper_text: helper_text,
      success_text: success_text,
      message: message,
      url: url,
      divider: divider
    };
    // if divider, just render divider
    if (divider) {
      return React.createElement(Card, {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name,
        className: "w-full h-[1px] bg-surface-level-three"
      });
    }
    if (message) {
      return React.createElement("div", {
        key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name
      }, React.createElement(Typography, null, "" + message), url && url !== '' && React.createElement(Typography, null, "For more information, please visit ", React.createElement("a", {
        href: url,
        target: "_blank",
        rel: "noopener noreferrer",
        className: "text-primary underline font-bold"
      }, "this link")));
    }
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-form-input-" + idx + "-" + name
    }, props));
  }));
};

var EventsForm = function EventsForm(_ref) {
  var _event_state$challeng;
  var event_idx = _ref.event_idx,
    event_state = _ref.event_state,
    handleEventChange = _ref.handleEventChange,
    handleToggleChange = _ref.handleToggleChange,
    event_setup_form_data = _ref.event_setup_form_data,
    setupErrors = _ref.setupErrors,
    min_date_input_vals = _ref.min_date_input_vals,
    disable_inputs = _ref.disable_inputs,
    display_contract = _ref.display_contract,
    vesting_contract_details = _ref.vesting_contract_details,
    contract_setup_form_data = _ref.contract_setup_form_data,
    contractSetupErrors = _ref.contractSetupErrors,
    show_contract_setup_form = _ref.show_contract_setup_form,
    open_contract_setup = _ref.open_contract_setup,
    setOpenContractSetup = _ref.setOpenContractSetup,
    event_details_state = _ref.event_details_state,
    handleDetailsChange = _ref.handleDetailsChange,
    vesting_details_state = _ref.vesting_details_state,
    handleVestingChange = _ref.handleVestingChange,
    vesting_form_data = _ref.vesting_form_data,
    first_half_form_button = _ref.first_half_form_button,
    second_half_form_button = _ref.second_half_form_button,
    answers_obj = _ref.answers_obj,
    setAnswersObj = _ref.setAnswersObj,
    handleQuestionChange = _ref.handleQuestionChange,
    handleAnswerChange = _ref.handleAnswerChange,
    addNewQuestion = _ref.addNewQuestion,
    handleAddAnswer = _ref.handleAddAnswer,
    handleRemoveAnswer = _ref.handleRemoveAnswer,
    removeQuestion = _ref.removeQuestion,
    checks = _ref.checks,
    setChecks = _ref.setChecks,
    showChecklist = _ref.showChecklist,
    check_messages = _ref.check_messages,
    marketing_form_data = _ref.marketing_form_data,
    marketing_button_props = _ref.marketing_button_props,
    marketing_event_state = _ref.marketing_event_state,
    handleMarketingChange = _ref.handleMarketingChange,
    ama_form_data = _ref.ama_form_data,
    handleAmaChange = _ref.handleAmaChange,
    ama_state = _ref.ama_state,
    ama_button_props = _ref.ama_button_props,
    handleOpenMarketingFormModal = _ref.handleOpenMarketingFormModal,
    className = _ref.className,
    has_insufficient_funds = _ref.has_insufficient_funds;
  var _useState = useState(false),
    show_challenge = _useState[0],
    setShowChallenge = _useState[1];
  var _useState2 = useState(false),
    open_marketing_setup = _useState2[0],
    setOpenMarketingSetup = _useState2[1];
  var _useState3 = useState(false),
    open_ama_setup = _useState3[0],
    setOpenAmaSetup = _useState3[1];
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "Marketing event",
    show: open_marketing_setup,
    setShow: setOpenMarketingSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(MarketingForm, {
    form_data: marketing_form_data,
    handleChange: handleMarketingChange,
    state: marketing_event_state,
    button_props: marketing_button_props,
    handleOpenModal: handleOpenMarketingFormModal
  })), React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "AMA event",
    show: open_ama_setup,
    setShow: setOpenAmaSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(MarketingForm, {
    form_data: ama_form_data,
    handleChange: handleAmaChange,
    state: ama_state,
    button_props: ama_button_props
  })), React.createElement("div", {
    className: "space-y-5"
  }, display_contract && React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mb-4"
  }, "Event contract"), React.createElement(Card, {
    className: "px-5 py-3",
    surface: "two"
  }, React.createElement(DataLines, {
    label: "Address",
    values: [{
      value: display_contract
    }]
  }))), (vesting_contract_details == null ? void 0 : vesting_contract_details.vesting_contract) && React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mb-4"
  }, "Vesting contract"), React.createElement(Card, {
    className: 'px-5 py-3 space-y-2',
    surface: "two"
  }, React.createElement(DataLines, {
    label: "Address",
    values: [{
      value: vesting_contract_details == null ? void 0 : vesting_contract_details.vesting_contract
    }]
  }), vesting_contract_details == null ? void 0 : vesting_contract_details.balances.map(function (_ref2, idx) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      key: label + "-" + value + "-" + idx
    }, value && React.createElement(DataLines, {
      label: label,
      values: [{
        value: value,
        color: idx === 1 && has_insufficient_funds ? 'text-error' : undefined
      }]
    }));
  }), has_insufficient_funds && React.createElement(Alert, {
    variant: "error",
    children_classes: "text-error flex items-center space-x-4",
    has_icon: true
  }, React.createElement(Media, {
    variant: "warning",
    size: 0,
    className: "text-error h-5"
  }), React.createElement("div", {
    className: "text-error"
  }, "insufficient funds")))), React.createElement(EventSetupForm, {
    event_setup_form_data: event_setup_form_data,
    event_state: event_state,
    handleEventChange: handleEventChange,
    handleToggleChange: handleToggleChange,
    setupErrors: setupErrors,
    min_date_input_vals: min_date_input_vals,
    disable_inputs: disable_inputs,
    event_idx: event_idx
  })), event_state.type === EventType.TokenClaim && React.createElement("div", {
    className: "mt-5"
  }, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement(Typography, {
    allBold: true,
    size: "2xl"
  }, "Challenge"), React.createElement(Button, {
    className: "w-[144px]",
    onClick: function onClick() {
      return setShowChallenge(!show_challenge);
    }
  }, show_challenge ? 'Hide' : disable_inputs ? 'View' : 'Edit', ' ', "challenge")), show_challenge && handleQuestionChange && handleAnswerChange && answers_obj && setAnswersObj && removeQuestion && handleAddAnswer && handleRemoveAnswer && React.createElement("div", {
    className: "space-y-5 mt-5"
  }, (_event_state$challeng = event_state.challenge) == null ? void 0 : _event_state$challeng.map(function (single_question, idx) {
    return React.createElement("div", {
      key: "challenge-question-" + idx + "-" + single_question
    }, React.createElement(ChallengeCard, {
      disable_inputs: disable_inputs,
      data: single_question,
      question_idx: idx,
      handleQuestionChange: handleQuestionChange,
      handleAnswerChange: handleAnswerChange,
      answers_state: answers_obj,
      setAnswersState: setAnswersObj,
      handleRemoveQuestion: removeQuestion,
      handleAddAnswer: handleAddAnswer,
      handleRemoveAnswer: handleRemoveAnswer
    }));
  }), !disable_inputs && addNewQuestion && React.createElement("div", {
    className: "mt-5"
  }, addNewButtonCard('Add another question', addNewQuestion, 'bg-surface-level-three hover:bg-surface-level-four')))), React.createElement(Button, {
    className: "mt-5 w-full",
    loading: first_half_form_button == null ? void 0 : first_half_form_button.loading,
    onClick: first_half_form_button.handleClick,
    disabled: first_half_form_button.disabled
  }, first_half_form_button.text), show_contract_setup_form && React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "Contract Setup",
    show: open_contract_setup,
    setShow: setOpenContractSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(ContractSetupForm, {
    setChecks: setChecks,
    checks: checks,
    checklist_title: "Please complete the checklist below to avoid unexpected issues during and after the event.",
    disable_inputs: disable_inputs,
    event_details_state: event_details_state,
    setup_form_data: contract_setup_form_data,
    event_idx: event_idx,
    handleDetailsChange: handleDetailsChange,
    errors: contractSetupErrors,
    vesting_form_data: vesting_form_data,
    handleVestingChange: handleVestingChange,
    vesting_details_state: vesting_details_state,
    min_date_input_vals: min_date_input_vals,
    showChecklist: showChecklist,
    check_messages: check_messages
  }), React.createElement(Button, {
    className: "mt-5 w-full",
    loading: second_half_form_button == null ? void 0 : second_half_form_button.loading,
    onClick: second_half_form_button.handleClick,
    disabled: second_half_form_button.disabled
  }, second_half_form_button.text)));
};
EventsForm.displayName = 'EventsForm';

var defaultProps$C = {};
var Form = function Form(_ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    _handleOpenModal = _ref.handleOpenModal,
    className = _ref.className,
    form_data = _ref.form_data;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, form_data.map(function (_ref2, idx) {
    var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      multiline = _ref2.multiline,
      inset = _ref2.inset,
      tooltip = _ref2.tooltip,
      options = _ref2.options;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      handleOpenModal: function handleOpenModal() {
        return _handleOpenModal(name);
      }
    };
    return React.createElement(RenderInput, Object.assign({
      key: "carousel-input-" + idx
    }, props));
  }));
};
Form.displayName = 'Form';
Form.defaultProps = defaultProps$C;

var _excluded$g = ["className", "media", "media_title", "selected", "surface", "handleDelete", "has_hover", "z_index_delete_btn", "onClick"];
var handleHover = function handleHover(title) {
  var popover = document.getElementById('popover-' + title);
  if (popover) {
    popover.style.display = 'block';
  }
};
var handleMouseOut = function handleMouseOut(title) {
  var popover = document.getElementById('popover-' + title);
  if (popover) {
    popover.style.display = 'none';
  }
};
var defaultProps$D = {
  className: '',
  surface: 'one'
};
var MediaThumbnail = function MediaThumbnail(_ref) {
  var className = _ref.className,
    media = _ref.media,
    media_title = _ref.media_title,
    selected = _ref.selected,
    surface = _ref.surface,
    handleDelete = _ref.handleDelete,
    has_hover = _ref.has_hover,
    z_index_delete_btn = _ref.z_index_delete_btn,
    onClick = _ref.onClick,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$g);
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  var _useState2 = useState(false),
    videoLoaded = _useState2[0],
    setVideoLoaded = _useState2[1];
  var videoRef = useRef(null);
  var isVideoFile = function isVideoFile(filename) {
    return /\.(mp4|webm|ogg|mov)$/i.test(filename);
  };
  // Load video metadata to show first frame
  useEffect(function () {
    if (isVideoFile(media) && videoRef.current) {
      var video = videoRef.current;
      var handleLoadedMetadata = function handleLoadedMetadata() {
        video.currentTime = 1; // Seek to 1 second
      };
      var handleSeeked = function handleSeeked() {
        setVideoLoaded(true); // Show video after seeking is complete
      };
      video.addEventListener('loadedmetadata', handleLoadedMetadata);
      video.addEventListener('seeked', handleSeeked);
      video.load(); // Start loading
      return function () {
        video.removeEventListener('loadedmetadata', handleLoadedMetadata);
        video.removeEventListener('seeked', handleSeeked);
      };
    }
    // Return cleanup function even when condition is not met
    return function () {};
  }, [media]);
  var handleCardClick = function handleCardClick(e) {
    if (onClick) {
      onClick(e);
    }
  };
  return React.createElement(Card, Object.assign({}, props, {
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    },
    border: has_hover ? false : selected ? true : false,
    className: "p-5 relative cursor-pointer border border-transparent " + (has_hover ? 'hover:bg-surface-level-one hover:low-border' : '') + " " + className,
    surface: has_hover ? 'custom' : selected ? surface : 'custom',
    onClick: handleCardClick
  }), (!has_hover ? handleDelete && selected : inside_card) && React.createElement(Button, {
    iconOnly: true,
    className: "w-8 h-8 absolute right-3 top-3 " + (z_index_delete_btn ? 'z-10' : ''),
    padding: false,
    variant: "secondary",
    onClick: function onClick(e) {
      e.stopPropagation();
      handleDelete == null || handleDelete();
    }
  }, React.createElement(Media, {
    size: 4,
    variant: "bin"
  })), React.createElement("div", {
    className: "w-full h-full flex flex-col"
  }, React.createElement("div", {
    className: "flex-grow relative"
  }, isVideoFile(media) ? React.createElement("div", {
    className: "relative w-full h-full"
  }, React.createElement("video", {
    ref: videoRef,
    className: "w-full h-full object-contain absolute",
    src: media,
    muted: true,
    playsInline: true,
    preload: "metadata",
    onMouseOver: function onMouseOver() {
      return handleHover(media_title);
    },
    onMouseOut: function onMouseOut() {
      return handleMouseOut(media_title);
    },
    style: {
      display: videoLoaded ? 'block' : 'none'
    }
  }), !videoLoaded && React.createElement("div", {
    className: "w-full h-full bg-gray-800 rounded-md flex items-center justify-center"
  }, React.createElement("div", {
    className: "text-white text-xs"
  }, "Loading..."))) : React.createElement("img", {
    className: "h-full object-contain w-full absolute",
    src: media,
    alt: media_title,
    onMouseOver: function onMouseOver() {
      return handleHover(media_title);
    },
    onMouseOut: function onMouseOut() {
      return handleMouseOut(media_title);
    }
  })), React.createElement("div", {
    className: "items-center justify-center hidden",
    id: "popover-" + media_title
  }, React.createElement(Typography, {
    className: "text-center mt-3 absolute bottom-5 inset-x-0 z-10 bg-white",
    size: "sm",
    variant: "secondary"
  }, media_title)), React.createElement(Typography, {
    className: "truncate text-center mt-3",
    size: "sm",
    variant: "secondary"
  }, media_title)));
};
MediaThumbnail.displayName = 'MediaThumbnail';
MediaThumbnail.defaultProps = defaultProps$D;

var MediaType;
(function (MediaType) {
  MediaType["IMAGE"] = "image";
  MediaType["VIDEO"] = "video";
  MediaType["BOTH"] = "both";
})(MediaType || (MediaType = {}));
var MediaModal = function MediaModal(_ref) {
  var show = _ref.show,
    state = _ref.state,
    loading = _ref.loading,
    _onClose = _ref.onClose,
    handleUpload = _ref.handleUpload,
    handleChooseMedia = _ref.handleChooseMedia,
    title = _ref.title,
    accepted_file_types = _ref.accepted_file_types,
    _ref$media_type = _ref.media_type,
    media_type = _ref$media_type === void 0 ? MediaType.IMAGE : _ref$media_type,
    _ref$base_img_url = _ref.base_img_url,
    base_img_url = _ref$base_img_url === void 0 ? '' : _ref$base_img_url;
  var _useState = useState(''),
    selected_media = _useState[0],
    setSelectedMedia = _useState[1];
  var resolved_file_types = accepted_file_types != null ? accepted_file_types : media_type === MediaType.VIDEO ? ['.mp4', '.webm', '.ogg', '.mov', '.avi'] : media_type === MediaType.IMAGE ? ['.jpg', '.jpeg', '.png', '.svg', '.webp', '.gif'] : ['.jpg', '.jpeg', '.png', '.svg', '.webp', '.gif', '.mp4', '.webm', '.ogg', '.mov'];
  var handleFileChange = function handleFileChange(e) {
    if (e.target.files && e.target.files.length) {
      var filesArray = Array.from(e.target.files);
      handleUpload(filesArray);
    }
  };
  // Simple helper to get the right data format
  var getMediaUrl = function getMediaUrl(item) {
    if (typeof item === 'string') {
      return base_img_url ? base_img_url + "/" + item : item;
    }
    return item.preview_url;
  };
  var getMediaName = function getMediaName(item) {
    if (typeof item === 'string') {
      return item;
    }
    return item.name;
  };
  return React.createElement(Modal, {
    onClose: function onClose() {
      _onClose();
      setSelectedMedia('');
    },
    noClose: true,
    show: show,
    className: "w-full h-[537px] flex flex-col justify-end relative"
  }, React.createElement(Typography, {
    className: "absolute top-4 inset-x-0"
  }, title), React.createElement("div", {
    className: "overflow-y-scroll h-[375px] no-scrollbar"
  }, React.createElement("div", {
    className: "grid grid-cols-5 gap-5 w-full"
  }, React.createElement("div", {
    className: "flex items-center justify-center border border-transparent px-5 py-[19px]"
  }, React.createElement("label", {
    htmlFor: "file-input",
    className: "cursor-pointer"
  }, loading ? React.createElement(Media, {
    variant: "loader"
  }) : React.createElement("div", null, React.createElement("div", {
    className: "h-20 w-20 flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "plus"
  })), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "text-center mt-[7px] truncate"
  }, "Add media"))), React.createElement("input", {
    onChange: handleFileChange,
    type: "file",
    id: "file-input",
    name: "file",
    accept: resolved_file_types == null ? void 0 : resolved_file_types.join(','),
    multiple: true,
    style: {
      display: 'none'
    }
  })), state.map(function (item, idx) {
    var mediaUrl = getMediaUrl(item);
    var mediaName = getMediaName(item);
    return React.createElement("div", {
      onClick: function onClick() {
        return setSelectedMedia(mediaUrl);
      },
      key: mediaUrl + '-' + idx
    }, React.createElement(MediaThumbnail, {
      className: "w-[148px] h-[148px]",
      media: mediaUrl,
      media_title: mediaName,
      selected: selected_media === mediaUrl,
      surface: "two"
    }));
  }))), React.createElement("div", {
    className: "flex flex-row-reverse mt-8"
  }, React.createElement(Button, {
    className: "ml-5",
    onClick: function onClick() {
      handleChooseMedia(selected_media);
      setSelectedMedia('');
    }
  }, "Select media"), React.createElement(Button, {
    variant: "secondary",
    onClick: function onClick() {
      _onClose();
      setSelectedMedia('');
    }
  }, "Cancel")));
};
MediaModal.displayName = 'MediaModal';

var _helper_text;
var PlatformNotificationType;
(function (PlatformNotificationType) {
  PlatformNotificationType["Default"] = "Default";
  PlatformNotificationType["Info"] = "Info";
  PlatformNotificationType["Alert"] = "Alert";
})(PlatformNotificationType || (PlatformNotificationType = {}));
var defaultProps$E = {};
var options$1 = [{
  title: 'Neutral',
  id: PlatformNotificationType.Default
}, {
  title: 'Important',
  id: PlatformNotificationType.Info
}, {
  title: 'Urgent',
  id: PlatformNotificationType.Alert
}];
var helper_text = (_helper_text = {}, _helper_text[PlatformNotificationType.Default] = {
  text: 'Neutral notification bars are used to notify users about events that don’t have a particular degree of urgency. It’s good to know but not important or urgent.',
  text_color: 'text-primary',
  btn_color: 'bg-surface-level-two'
}, _helper_text[PlatformNotificationType.Info] = {
  text: 'Important notification bars are used to notify users about events that are important but not urgent.',
  text_color: 'text-info',
  btn_color: 'bg-gradient-light-theme-alternative'
}, _helper_text[PlatformNotificationType.Alert] = {
  text: 'Urgent notification bars are used to notify users about events that are urgent and require immediate action.',
  text_color: 'text-accent',
  btn_color: 'bg-gradient'
}, _helper_text);
var NotificationsForm = function NotificationsForm(_ref) {
  var className = _ref.className,
    state = _ref.state,
    handleChange = _ref.handleChange,
    form_data = _ref.form_data;
  return React.createElement(Card, {
    className: "max-w-[580px] w-full p-5 " + className
  }, React.createElement(Tabs, {
    background_color: "bg-surface-level-zero",
    button_color: helper_text[state.type].btn_color,
    current: state.type,
    setCurrent: function setCurrent(v) {
      return handleChange('type', v);
    },
    options: options$1,
    variant: "limited"
  }), React.createElement(Typography, {
    size: "sm",
    className: "py-5"
  }, React.createElement("span", {
    className: helper_text[state.type].text_color + " font-bold"
  }, helper_text[state.type].text.split(' ').slice(0, 2).join(' '), ' '), React.createElement("span", null, helper_text[state.type].text.split(' ').slice(2).join(' '))), React.createElement("div", {
    className: "space-y-5"
  }, form_data.map(function (_ref2, idx) {
    var label = _ref2.label,
      name = _ref2.name,
      type = _ref2.type,
      options = _ref2.options,
      placeholder = _ref2.placeholder,
      inset = _ref2.inset,
      tooltip = _ref2.tooltip,
      multiline = _ref2.multiline,
      sub_label = _ref2.sub_label;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      sub_label: sub_label
    };
    return React.createElement(RenderInput, Object.assign({
      key: "notification-form-input-" + idx
    }, props));
  })));
};
NotificationsForm.displayName = 'NotificationsForm';
NotificationsForm.defaultProps = defaultProps$E;

var ProjectType;
(function (ProjectType) {
  ProjectType["Advised"] = "Advised";
  ProjectType["Incubated"] = "Incubated";
  ProjectType["None"] = "None";
})(ProjectType || (ProjectType = {}));
var ProjectStatus;
(function (ProjectStatus) {
  ProjectStatus["ACTIVE"] = "ACTIVE";
  ProjectStatus["APPROVED"] = "APPROVED";
  ProjectStatus["COMPLETE"] = "COMPLETE";
  ProjectStatus["PENDING"] = "PENDING";
})(ProjectStatus || (ProjectStatus = {}));
var OverviewForm = function OverviewForm(_ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    _handleOpenModal = _ref.handleOpenModal,
    className = _ref.className,
    form_data = _ref.form_data,
    errors = _ref.errors;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, form_data.map(function (_ref2, idx) {
    var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      multiline = _ref2.multiline,
      inset = _ref2.inset,
      tooltip = _ref2.tooltip,
      options = _ref2.options;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      handleOpenModal: function handleOpenModal() {
        return _handleOpenModal(name);
      },
      errors: errors
    };
    return React.createElement(RenderInput, Object.assign({
      key: "overview-form-input-" + idx
    }, props));
  }));
};
OverviewForm.displayName = 'OverviewForm';

var ResourcesForm = function ResourcesForm(_ref) {
  var className = _ref.className,
    handleChange = _ref.handleChange,
    state = _ref.state,
    possible_links = _ref.possible_links;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, possible_links.map(function (_ref2) {
    var link_name = _ref2.id,
      title = _ref2.title;
    return React.createElement(Card, {
      key: link_name + title,
      surface: "two",
      className: "p-5"
    }, React.createElement(Typography, {
      size: "md",
      allBold: true,
      className: "mb-5"
    }, title), React.createElement(Input, {
      placeholder: 'Enter url',
      surface: "zero",
      label: 'URL',
      type: 'text',
      name: "href",
      id: "input-" + link_name + "-href",
      onChange: function onChange(e) {
        return handleChange(link_name, 'href', e.target.value);
      },
      value: state[link_name]['href']
    }));
  }));
};
ResourcesForm.displayName = 'ResourcesForm';

var defaultProps$F = {
  className: ''
};
var SearchList = function SearchList(_ref) {
  var children = _ref.children,
    className = _ref.className,
    data = _ref.data,
    handleButtonClick = _ref.handleButtonClick;
  return React.createElement(Card, {
    className: "" + className
  }, React.createElement("div", {
    className: "grid items-center grid-cols-3 p-5"
  }, React.createElement(DataLines, {
    is_top_bold: true,
    top_size: !data.label ? 'md' : 'sm',
    label: data.label,
    values: data.values,
    variant: "verticle"
  }), React.createElement(Typography, {
    className: "mx-auto"
  }, children), React.createElement(Button, {
    className: "justify-self-end",
    iconOnly: true,
    padding: true,
    onClick: handleButtonClick
  }, React.createElement(Media, {
    size: 5,
    variant: "arrow-right"
  }))));
};
SearchList.displayName = 'SearchList';
SearchList.defaultProps = defaultProps$F;

var SocialPlatformsForm = function SocialPlatformsForm(_ref) {
  var className = _ref.className,
    state = _ref.state,
    addSocial = _ref.addSocial,
    handleChange = _ref.handleChange,
    removeSocial = _ref.removeSocial,
    form_data = _ref.form_data;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, state.map(function (item, social_idx) {
    return React.createElement(Card, {
      surface: "two",
      className: "p-5",
      key: "project-social-" + social_idx + "-" + item.type
    }, React.createElement("div", {
      className: "flex space-x-5 items-center"
    }, form_data.map(function (_ref2, idx) {
      var name = _ref2.name,
        label = _ref2.label,
        type = _ref2.type,
        options = _ref2.options,
        placeholder = _ref2.placeholder;
      return type === 'select' && options ? React.createElement("div", {
        key: "project-social-type-" + type + "-" + idx,
        className: "w-1/4"
      }, React.createElement(Select, {
        className: "w-full",
        surface: "zero",
        placeholder: placeholder,
        label: label,
        current: options.find(function (o) {
          return o.id === item.type;
        }),
        setCurrent: function setCurrent(o) {
          return handleChange('type', o.id, social_idx);
        },
        options: options
      })) : React.createElement("div", {
        key: "project-social-type-" + type + "-" + idx,
        className: "flex space-x-5 w-3/4"
      }, React.createElement(Input, {
        containerClasses: "flex-1 w-full",
        label: label,
        value: item.url,
        onChange: function onChange(e) {
          return handleChange('url', e.target.value, social_idx);
        },
        placeholder: placeholder,
        surface: "zero",
        type: type,
        name: name
      }), React.createElement(Button, {
        variant: "custom",
        className: "h-11 w-11 mt-auto bg-surface-level-three hover:bg-surface-level-four",
        onClick: function onClick() {
          return removeSocial(social_idx);
        },
        padding: false
      }, React.createElement(Media, {
        size: 0,
        className: "w-[17px] h-[18px]",
        variant: "bin"
      })));
    })));
  }), state.length < 6 && React.createElement(Button, {
    onClick: addSocial,
    className: "flex w-full items-center font-bold"
  }, React.createElement(Media, {
    size: 5,
    className: "inline-flex mr-3",
    variant: "plus"
  }), React.createElement("span", {
    className: "inline-flex"
  }, "Add new social link")));
};
SocialPlatformsForm.displayName = 'SocialPlatformsForm';

var defaultProps$G = {};
var TokenForm = function TokenForm(_ref) {
  var className = _ref.className,
    state = _ref.state,
    handleChange = _ref.handleChange,
    token_form_data = _ref.token_form_data,
    token_sale_form_data = _ref.token_sale_form_data;
  return React.createElement(Card, {
    className: "p-5 space-y-5 " + className
  }, token_form_data.map(function (_ref2, idx) {
    var name = _ref2.name,
      label = _ref2.label,
      type = _ref2.type,
      placeholder = _ref2.placeholder,
      options = _ref2.options;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options
    };
    return React.createElement(RenderInput, Object.assign({
      key: "token-form-input-" + idx
    }, props));
  }), React.createElement(Card, {
    surface: "two",
    className: "p-5"
  }, React.createElement("div", null, React.createElement(Typography, {
    size: "xl",
    variant: "secondary",
    className: "mb-4"
  }, "Token Sale"), React.createElement("div", {
    className: "space-y-5"
  }, token_sale_form_data.map(function (_ref3, idx) {
    var name = _ref3.name,
      label = _ref3.label,
      type = _ref3.type,
      placeholder = _ref3.placeholder,
      tooltip = _ref3.tooltip;
    var props = {
      value: state[name],
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      tooltip: tooltip
    };
    return React.createElement(RenderInput, Object.assign({
      key: "token-sale-form-input-" + idx
    }, props));
  })))));
};
TokenForm.displayName = 'TokenForm';
TokenForm.defaultProps = defaultProps$G;

var UserInfo = function UserInfo(_ref) {
  var className = _ref.className,
    disableKYCStatus = _ref.disableKYCStatus,
    disableReset2FA = _ref.disableReset2FA,
    disableRoles = _ref.disableRoles,
    options = _ref.options,
    userInfo = _ref.userInfo,
    handleKYCStatus = _ref.handleKYCStatus,
    handleReset2FA = _ref.handleReset2FA,
    dropdown_title = _ref.dropdown_title,
    handleResetKYC = _ref.handleResetKYC,
    disableResetKYC = _ref.disableResetKYC,
    showModal = _ref.showModal,
    setShowModal = _ref.setShowModal,
    handleResetWallet = _ref.handleResetWallet,
    handleChangeWallet = _ref.handleChangeWallet,
    user_email = _ref.user_email,
    wallet_addr = _ref.wallet_addr,
    setWalletAddr = _ref.setWalletAddr,
    wallet_addr_err = _ref.wallet_addr_err,
    disableResetWallet = _ref.disableResetWallet,
    disableChangeWallet = _ref.disableChangeWallet,
    resetWalletLoading = _ref.resetWalletLoading,
    changeWalletLoading = _ref.changeWalletLoading,
    disable_manage_wallet = _ref.disable_manage_wallet,
    is_blocked = _ref.is_blocked,
    setIsBlocked = _ref.setIsBlocked;
  return React.createElement(Card, {
    className: "" + className
  }, React.createElement("div", {
    className: "bg-surface-level-two flex items-center justify-between p-5 rounded"
  }, React.createElement(DataLines, {
    is_top_bold: true,
    label: userInfo[0].label,
    values: userInfo[0].values,
    variant: "verticle"
  }), !disableRoles && React.createElement("div", {
    className: "flex items-center"
  }, React.createElement("div", {
    className: "mr-4"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, "Role")), React.createElement(Dropdown, {
    no_hover: true,
    has_max_height: true,
    width: "w-[180px]",
    dropdown_width: "w-[196px]",
    title: React.createElement("span", {
      className: "mx-3"
    }, dropdown_title),
    surface: "one",
    accent_icon: true,
    options: options
  }))), React.createElement("div", {
    className: "px-4"
  }, React.createElement(Alert, {
    variant: "note",
    className: "w-full mt-3",
    has_icon: true
  }, React.createElement("div", {
    className: "flex items-center gap-2"
  }, React.createElement(Media, {
    variant: "info-outline",
    size: 5,
    className: "text-secondary"
  }), React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Some data may be unavailable and display N/A due to being automatically archived after one year due to data protection.")))), React.createElement("div", {
    className: "gap-5 grid grid-cols-3 px-5 py-8"
  }, userInfo.slice(1).map(function (x, i) {
    return React.createElement(DataLines, {
      key: i,
      label: x.label,
      values: x.values.map(function (val) {
        return _extends({}, val, {
          value: val.value || 'N/A'
        });
      }),
      variant: "verticle"
    });
  }), React.createElement(Toggle, {
    label: "Is blocked from the platform",
    surface_level: "zero",
    active: is_blocked || false,
    onChange: function onChange() {
      return setIsBlocked && setIsBlocked(!is_blocked);
    },
    variant: "checkbox"
  })), React.createElement("div", {
    className: "flex gap-5 items-center pb-5 px-5"
  }, React.createElement(Button, {
    fullwidth: true,
    iconOnly: true,
    padding: true,
    disabled: disableReset2FA,
    onClick: handleReset2FA
  }, "Reset 2FA"), React.createElement(Button, {
    fullwidth: true,
    iconOnly: true,
    padding: true,
    disabled: disableResetKYC,
    onClick: handleResetKYC
  }, "Reset KYC status"), React.createElement(Button, {
    fullwidth: true,
    iconOnly: true,
    padding: true,
    disabled: disableKYCStatus,
    onClick: handleKYCStatus
  }, "Set KYC status complete"), React.createElement(Button, {
    fullwidth: true,
    iconOnly: true,
    padding: true,
    disabled: disable_manage_wallet,
    onClick: function onClick() {
      return setShowModal(true);
    }
  }, "Manage wallet")), React.createElement(Modal, {
    show: showModal,
    onClose: function onClose() {
      return setShowModal(false);
    }
  }, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, user_email), React.createElement(Input, {
    containerClasses: "mt-[32px]",
    surface: "zero",
    error: wallet_addr_err,
    id: "change-wallet-input",
    label: "Verified wallet address",
    type: "text",
    value: wallet_addr,
    onChange: function onChange(e) {
      return setWalletAddr(e.target.value);
    }
  }), React.createElement(Alert, {
    title: "Changing User's Wallet",
    variant: "warning",
    className: "mt-5 text-left"
  }, "By changing verified wallet you will no longer be able to verify the original wallet."), React.createElement("div", {
    className: "flex space-x-5 mt-8"
  }, React.createElement(Button, {
    onClick: handleResetWallet,
    disabled: disableResetWallet,
    variant: "secondary",
    className: "w-full",
    loading: resetWalletLoading
  }, "Reset wallet"), React.createElement(Button, {
    disabled: disableChangeWallet,
    onClick: handleChangeWallet,
    className: "w-full",
    loading: changeWalletLoading
  }, "Save changes"))));
};
UserInfo.displayName = 'UserInfo';

var TokenAllocationType;
(function (TokenAllocationType) {
  TokenAllocationType["Seed"] = "Seed";
  TokenAllocationType["PrivateSale"] = "PrivateSale";
  TokenAllocationType["KOLs"] = "KOLs";
  TokenAllocationType["Public"] = "Public";
  TokenAllocationType["Total"] = "Total";
})(TokenAllocationType || (TokenAllocationType = {}));
var TokenAllocationForm = function TokenAllocationForm(_ref) {
  var className = _ref.className,
    state = _ref.state,
    handleChange = _ref.handleChange,
    title_mapping = _ref.title_mapping,
    form_sections = _ref.form_sections;
  return React.createElement(Card, {
    className: "p-5 space-y-5 " + className
  }, form_sections.map(function (type) {
    var _state$type, _state$type2;
    return React.createElement(Card, {
      key: "token-allocation-row-" + type,
      surface: "two",
      className: "p-5"
    }, React.createElement(Typography, {
      className: "mb-4"
    }, title_mapping[type]), React.createElement("div", {
      className: "flex space-x-4 w-full"
    }, React.createElement("div", {
      className: "w-full"
    }, React.createElement(Input, {
      value: ((_state$type = state[type]) == null ? void 0 : _state$type.amount) !== undefined ? state[type].amount : '',
      onChange: function onChange(e) {
        var value = e.target.valueAsNumber;
        handleChange(type, 'amount', value);
      },
      name: type + "-amount",
      max_btn: false,
      label: "Value",
      unit: "$",
      type: "number",
      placeholder: "Enter value (ex. 200000.00)",
      containerClasses: "w-full",
      surface: "zero"
    })), React.createElement("div", {
      className: "w-full"
    }, React.createElement(Input, {
      value: ((_state$type2 = state[type]) == null ? void 0 : _state$type2.percent) !== undefined ? state[type].percent : '',
      onChange: function onChange(e) {
        var value = e.target.valueAsNumber;
        handleChange(type, 'percent', value);
      },
      name: type + "-percent",
      label: "Percentage",
      type: "number",
      unit: "%",
      placeholder: "Enter percentage (ex. 5.1%)",
      containerClasses: "w-full",
      surface: "zero",
      max_btn: false
    }))));
  }));
};

var ChallengeCard$1 = function ChallengeCard(_ref) {
  var data = _ref.data,
    question_idx = _ref.question_idx,
    answers_state = _ref.answers_state,
    setAnswersState = _ref.setAnswersState,
    handleQuestionChange = _ref.handleQuestionChange,
    handleAnswerChange = _ref.handleAnswerChange,
    handleRemoveQuestion = _ref.handleRemoveQuestion,
    disable_inputs = _ref.disable_inputs,
    handleAddAnswer = _ref.handleAddAnswer,
    handleRemoveAnswer = _ref.handleRemoveAnswer;
  var _useState = useState((data == null ? void 0 : data.question) === ''),
    open = _useState[0],
    setOpen = _useState[1];
  return React.createElement(Card, {
    className: "p-5",
    surface: "two"
  }, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement("div", {
    className: "truncate"
  }, open ? React.createElement(Typography, {
    allBold: true,
    size: "2xl"
  }, 'Question ' + (question_idx + 1)) : React.createElement(DataLines, {
    variant: "verticle",
    verticle_top_truncate: true,
    verticle_bottom_truncate: true,
    top_size: "md",
    bottom_size: "sm",
    label_color: answers_state[question_idx] ? 'text-success' : '',
    label: answers_state[question_idx],
    values: [{
      value: data.question
    }]
  })), React.createElement("div", {
    className: "flex items-center ml-5"
  }, !open && !disable_inputs && React.createElement(Button, {
    iconOnly: true,
    className: "bg-surface-level-three hover:bg-surface-level-four mr-5",
    variant: "custom",
    onClick: function onClick() {
      return handleRemoveQuestion(question_idx);
    }
  }, React.createElement(Media, {
    variant: "bin",
    size: 0,
    className: "w-[18px] h-[17px]"
  })), React.createElement(Button, {
    iconOnly: true,
    className: "bg-surface-level-three hover:bg-surface-level-four",
    variant: "custom",
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, React.createElement(Media, {
    variant: open ? 'tick' : 'chevron-down',
    size: 0,
    className: "w-[18px] h-[17px]"
  })))), open && React.createElement("div", {
    className: "pt-5"
  }, React.createElement(Input, {
    unclickable: disable_inputs,
    className: "mt-2",
    key: "question-" + question_idx,
    type: "text",
    surface: "zero",
    name: "question",
    placeholder: "Enter question",
    label: "Question",
    value: data.question,
    onChange: function onChange(e) {
      return handleQuestionChange(e.target.value, question_idx);
    }
  }), data.answers.map(function (answer, answer_idx) {
    return React.createElement("div", {
      key: "question-" + question_idx + "-answer-" + answer_idx,
      className: "flex items-center justify-between w-full space-x-5 mt-5"
    }, React.createElement(Input, {
      unclickable: disable_inputs,
      key: "challenge-answer-" + answer_idx,
      surface: "zero",
      containerClasses: "w-full",
      type: "text",
      name: "answer",
      placeholder: "Enter answer",
      label: "Answer " + (answer_idx + 1),
      value: answer,
      onChange: function onChange(e) {
        return handleAnswerChange(e.target.value, question_idx, answer_idx);
      }
    }), !disable_inputs && React.createElement("div", {
      className: "flex space-x-5 mt-auto"
    }, React.createElement(Button, {
      variant: "custom",
      className: "w-11 h-11 " + (answers_state[question_idx] === answer && answer !== '' ? 'bg-success' : 'bg-surface-level-zero'),
      onClick: function onClick() {
        var _extends2;
        return setAnswersState(_extends({}, answers_state, (_extends2 = {}, _extends2[question_idx] = answer, _extends2)));
      }
    }, React.createElement(Media, {
      variant: "tick",
      size: 0,
      className: "w-[18px] h-[17px]"
    })), React.createElement(Button, {
      iconOnly: true,
      className: "bg-surface-level-three hover:bg-surface-level-four mr-5",
      variant: "custom",
      disabled: data.answers.length === 3,
      onClick: function onClick() {
        return handleRemoveAnswer(question_idx, answer_idx);
      }
    }, React.createElement(Media, {
      variant: "bin",
      size: 0,
      className: "w-[18px] h-[17px]"
    }))));
  }), !disable_inputs && data.answers.length < 4 && React.createElement("div", {
    className: "mt-5"
  }, addNewButtonCard('Add answer', function () {
    return handleAddAnswer(question_idx);
  }, 'bg-surface-level-three hover:bg-surface-level-four'))));
};

var ContractSetupForm$1 = function ContractSetupForm(_ref) {
  var setup_form_data = _ref.setup_form_data,
    event_idx = _ref.event_idx,
    handleDetailsChange = _ref.handleDetailsChange,
    errors = _ref.errors,
    vesting_form_data = _ref.vesting_form_data,
    handleVestingChange = _ref.handleVestingChange,
    vesting_details_state = _ref.vesting_details_state,
    event_details_state = _ref.event_details_state,
    min_date_input_vals = _ref.min_date_input_vals,
    setChecks = _ref.setChecks,
    checks = _ref.checks,
    checklist_title = _ref.checklist_title,
    disable_inputs = _ref.disable_inputs,
    showChecklist = _ref.showChecklist,
    check_messages = _ref.check_messages;
  return React.createElement("div", null, React.createElement("div", {
    className: "space-y-4"
  }, setup_form_data.map(function (_ref2, idx) {
    var label = _ref2.label,
      name = _ref2.name,
      type = _ref2.type,
      inset = _ref2.inset,
      multiline = _ref2.multiline,
      options = _ref2.options,
      placeholder = _ref2.placeholder,
      tooltip = _ref2.tooltip,
      has_comma_helper = _ref2.has_comma_helper,
      not_editable = _ref2.not_editable,
      helper_text = _ref2.helper_text,
      success_text = _ref2.success_text;
    var props = {
      value: event_details_state[name] || '',
      handleChange: handleDetailsChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      errors: errors,
      has_comma_helper: has_comma_helper,
      disable_input: disable_inputs,
      not_editable: not_editable,
      helper_text: helper_text,
      success_text: success_text
    };
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-request-form-input-" + idx + "-" + name
    }, props));
  }), ' ', vesting_form_data.map(function (_ref3, idx) {
    var label = _ref3.label,
      name = _ref3.name,
      type = _ref3.type,
      inset = _ref3.inset,
      multiline = _ref3.multiline,
      options = _ref3.options,
      placeholder = _ref3.placeholder,
      tooltip = _ref3.tooltip,
      not_editable = _ref3.not_editable,
      helper_text = _ref3.helper_text,
      success_text = _ref3.success_text;
    var props = {
      value: vesting_details_state[name] || '',
      handleChange: handleVestingChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      inset: inset,
      tooltip: tooltip,
      multiline: multiline,
      errors: errors,
      min_date_input_vals: min_date_input_vals,
      disable_input: disable_inputs,
      not_editable: not_editable,
      helper_text: helper_text,
      success_text: success_text
    };
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-vesting-form-input-" + idx + "-" + name
    }, props));
  })), showChecklist && React.createElement(CheckInfoCard, {
    className: "mt-5",
    checks: checks,
    setChecks: setChecks,
    title: checklist_title,
    check_messages: check_messages
  }));
};

var MarketingForm$1 = function MarketingForm(_ref) {
  var handleChange = _ref.handleChange,
    form_data = _ref.form_data,
    button_props = _ref.button_props,
    state = _ref.state,
    handleOpenModal = _ref.handleOpenModal;
  var loading = button_props.loading,
    handleClick = button_props.handleClick,
    text = button_props.text,
    disabled = button_props.disabled;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "space-y-4"
  }, form_data == null ? void 0 : form_data.map(function (_ref2) {
    var label = _ref2.label,
      name = _ref2.name,
      type = _ref2.type,
      placeholder = _ref2.placeholder,
      options = _ref2.options;
    var props = {
      value: (state == null ? void 0 : state[name]) || '',
      handleChange: handleChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      choose_img_btn_color: 'three',
      handleOpenModal: handleOpenModal ? function () {
        return handleOpenModal(name);
      } : undefined
    };
    return React.createElement(RenderInput, Object.assign({
      key: name
    }, props));
  })), React.createElement(Button, {
    loading: loading,
    disabled: disabled,
    onClick: handleClick,
    className: "w-full mt-5"
  }, text));
};

var MarketingEventType$1;
(function (MarketingEventType) {
  MarketingEventType["Telegram"] = "Telegram";
  MarketingEventType["Youtube"] = "Youtube";
})(MarketingEventType$1 || (MarketingEventType$1 = {}));
var EventType$1;
(function (EventType) {
  EventType["Crowdfunding"] = "Crowdfunding";
  EventType["TokenClaim"] = "TokenClaim";
})(EventType$1 || (EventType$1 = {}));
var CrowdfundingType$1;
(function (CrowdfundingType) {
  CrowdfundingType["Private"] = "Private";
  CrowdfundingType["Seed"] = "Seed";
  CrowdfundingType["Public"] = "Public";
  CrowdfundingType["Standard"] = "Standard";
  CrowdfundingType["Exclusive"] = "Exclusive";
  CrowdfundingType["Acceleration"] = "Acceleration";
  CrowdfundingType["Incubation"] = "Incubation";
})(CrowdfundingType$1 || (CrowdfundingType$1 = {}));

var EventSetupForm$1 = function EventSetupForm(_ref) {
  var event_setup_form_data = _ref.event_setup_form_data,
    event_state = _ref.event_state,
    handleEventChange = _ref.handleEventChange,
    handleToggleChange = _ref.handleToggleChange,
    setupErrors = _ref.setupErrors,
    min_date_input_vals = _ref.min_date_input_vals,
    disable_inputs = _ref.disable_inputs,
    event_idx = _ref.event_idx;
  return React.createElement("div", {
    className: "space-y-5"
  }, event_setup_form_data.map(function (_ref2, idx) {
    var type = _ref2.type,
      name = _ref2.name,
      placeholder = _ref2.placeholder,
      label = _ref2.label,
      options = _ref2.options,
      tooltip = _ref2.tooltip,
      not_editable = _ref2.not_editable;
    var props = {
      value: event_state[name],
      handleChange: type === 'switch' && handleToggleChange ? handleToggleChange : handleEventChange,
      name: name,
      label: label,
      type: type,
      placeholder: placeholder,
      options: options,
      tooltip: tooltip,
      errors: setupErrors,
      min_date_input_vals: min_date_input_vals,
      disable_input: disable_inputs,
      not_editable: not_editable
    };
    return React.createElement(RenderInput, Object.assign({
      key: "event-" + event_idx + "-form-input-" + idx + "-" + name
    }, props));
  }));
};

var TestEventsForm = function TestEventsForm(_ref) {
  var _event_state$challeng;
  var event_idx = _ref.event_idx,
    event_state = _ref.event_state,
    handleEventChange = _ref.handleEventChange,
    handleToggleChange = _ref.handleToggleChange,
    event_setup_form_data = _ref.event_setup_form_data,
    setupErrors = _ref.setupErrors,
    min_date_input_vals = _ref.min_date_input_vals,
    disable_inputs = _ref.disable_inputs,
    display_contract = _ref.display_contract,
    vesting_contract_details = _ref.vesting_contract_details,
    contract_setup_form_data = _ref.contract_setup_form_data,
    contractSetupErrors = _ref.contractSetupErrors,
    show_contract_setup_form = _ref.show_contract_setup_form,
    open_contract_setup = _ref.open_contract_setup,
    setOpenContractSetup = _ref.setOpenContractSetup,
    event_details_state = _ref.event_details_state,
    handleDetailsChange = _ref.handleDetailsChange,
    vesting_details_state = _ref.vesting_details_state,
    handleVestingChange = _ref.handleVestingChange,
    vesting_form_data = _ref.vesting_form_data,
    first_half_form_button = _ref.first_half_form_button,
    second_half_form_button = _ref.second_half_form_button,
    answers_obj = _ref.answers_obj,
    setAnswersObj = _ref.setAnswersObj,
    handleQuestionChange = _ref.handleQuestionChange,
    handleAnswerChange = _ref.handleAnswerChange,
    addNewQuestion = _ref.addNewQuestion,
    handleAddAnswer = _ref.handleAddAnswer,
    handleRemoveAnswer = _ref.handleRemoveAnswer,
    removeQuestion = _ref.removeQuestion,
    checks = _ref.checks,
    setChecks = _ref.setChecks,
    showChecklist = _ref.showChecklist,
    check_messages = _ref.check_messages,
    marketing_form_data = _ref.marketing_form_data,
    marketing_button_props = _ref.marketing_button_props,
    marketing_event_state = _ref.marketing_event_state,
    handleMarketingChange = _ref.handleMarketingChange,
    ama_form_data = _ref.ama_form_data,
    handleAmaChange = _ref.handleAmaChange,
    ama_state = _ref.ama_state,
    ama_button_props = _ref.ama_button_props,
    handleOpenMarketingFormModal = _ref.handleOpenMarketingFormModal,
    className = _ref.className,
    has_insufficient_funds = _ref.has_insufficient_funds;
  var _useState = useState(false),
    show_challenge = _useState[0],
    setShowChallenge = _useState[1];
  var _useState2 = useState(false),
    open_marketing_setup = _useState2[0],
    setOpenMarketingSetup = _useState2[1];
  var _useState3 = useState(false),
    open_ama_setup = _useState3[0],
    setOpenAmaSetup = _useState3[1];
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "Marketing event",
    show: open_marketing_setup,
    setShow: setOpenMarketingSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(MarketingForm$1, {
    form_data: marketing_form_data,
    handleChange: handleMarketingChange,
    state: marketing_event_state,
    button_props: marketing_button_props,
    handleOpenModal: handleOpenMarketingFormModal
  })), React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "AMA event",
    show: open_ama_setup,
    setShow: setOpenAmaSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(MarketingForm$1, {
    form_data: ama_form_data,
    handleChange: handleAmaChange,
    state: ama_state,
    button_props: ama_button_props
  })), React.createElement("div", {
    className: "space-y-5"
  }, display_contract && React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mb-4"
  }, "Event contract"), React.createElement(Card, {
    className: "px-5 py-3",
    surface: "two"
  }, React.createElement(DataLines, {
    label: "Address",
    values: [{
      value: display_contract
    }]
  }))), (vesting_contract_details == null ? void 0 : vesting_contract_details.vesting_contract) && React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mb-4"
  }, "Vesting contract"), React.createElement(Card, {
    className: 'px-5 py-3 space-y-2',
    surface: "two"
  }, React.createElement(DataLines, {
    label: "Address",
    values: [{
      value: vesting_contract_details == null ? void 0 : vesting_contract_details.vesting_contract
    }]
  }), vesting_contract_details == null ? void 0 : vesting_contract_details.balances.map(function (_ref2, idx) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      key: label + "-" + value + "-" + idx
    }, value && React.createElement(DataLines, {
      label: label,
      values: [{
        value: value,
        color: idx === 1 && has_insufficient_funds ? 'text-error' : undefined
      }]
    }));
  }), has_insufficient_funds && React.createElement(Alert, {
    variant: "error",
    children_classes: "text-error flex items-center space-x-4",
    has_icon: true
  }, React.createElement(Media, {
    variant: "warning",
    size: 0,
    className: "text-error h-5"
  }), React.createElement("div", {
    className: "text-error"
  }, "insufficient funds")))), React.createElement(EventSetupForm$1, {
    event_setup_form_data: event_setup_form_data,
    event_state: event_state,
    handleEventChange: handleEventChange,
    handleToggleChange: handleToggleChange,
    setupErrors: setupErrors,
    min_date_input_vals: min_date_input_vals,
    disable_inputs: disable_inputs,
    event_idx: event_idx
  })), React.createElement(Button, {
    className: "mt-5 w-full",
    loading: first_half_form_button == null ? void 0 : first_half_form_button.loading,
    onClick: first_half_form_button.handleClick,
    disabled: first_half_form_button.disabled
  }, first_half_form_button.text), event_state.type === EventType$1.TokenClaim && React.createElement("div", {
    className: "mt-5"
  }, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement(Typography, {
    allBold: true,
    size: "2xl"
  }, "Challenge"), React.createElement(Button, {
    className: "w-[144px]",
    onClick: function onClick() {
      return setShowChallenge(!show_challenge);
    }
  }, show_challenge ? 'Hide' : disable_inputs ? 'View' : 'Edit', ' ', "challenge")), show_challenge && handleQuestionChange && handleAnswerChange && answers_obj && setAnswersObj && removeQuestion && handleAddAnswer && handleRemoveAnswer && React.createElement("div", {
    className: "space-y-5 mt-5"
  }, (_event_state$challeng = event_state.challenge) == null ? void 0 : _event_state$challeng.map(function (single_question, idx) {
    return React.createElement("div", {
      key: "challenge-question-" + idx + "-" + single_question
    }, React.createElement(ChallengeCard$1, {
      disable_inputs: disable_inputs,
      data: single_question,
      question_idx: idx,
      handleQuestionChange: handleQuestionChange,
      handleAnswerChange: handleAnswerChange,
      answers_state: answers_obj,
      setAnswersState: setAnswersObj,
      handleRemoveQuestion: removeQuestion,
      handleAddAnswer: handleAddAnswer,
      handleRemoveAnswer: handleRemoveAnswer
    }));
  }), !disable_inputs && addNewQuestion && React.createElement("div", {
    className: "mt-5"
  }, addNewButtonCard('Add another question', addNewQuestion, 'bg-surface-level-three hover:bg-surface-level-four')))), show_contract_setup_form && React.createElement(React.Fragment, null, React.createElement(EditableItem, {
    has_lighter_secondary_btns: true,
    title: "Contract Setup",
    show: open_contract_setup,
    setShow: setOpenContractSetup,
    className: "bg-surface-level-two my-4"
  }, React.createElement(ContractSetupForm$1, {
    setChecks: setChecks,
    checks: checks,
    checklist_title: "Please complete the checklist below to avoid unexpected issues during and after the event.",
    disable_inputs: disable_inputs,
    event_details_state: event_details_state,
    setup_form_data: contract_setup_form_data,
    event_idx: event_idx,
    handleDetailsChange: handleDetailsChange,
    errors: contractSetupErrors,
    vesting_form_data: vesting_form_data,
    handleVestingChange: handleVestingChange,
    vesting_details_state: vesting_details_state,
    min_date_input_vals: min_date_input_vals,
    showChecklist: showChecklist,
    check_messages: check_messages
  }), React.createElement(Button, {
    className: "mt-5 w-full",
    loading: second_half_form_button == null ? void 0 : second_half_form_button.loading,
    onClick: second_half_form_button.handleClick,
    disabled: second_half_form_button.disabled
  }, second_half_form_button.text))));
};
TestEventsForm.displayName = 'TestEventsForm';

// import PropTypes from "prop-types";
var ProductType;
(function (ProductType) {
  ProductType["Farm"] = "farm";
  ProductType["Staking"] = "staking";
  ProductType["Vesting"] = "vesting";
})(ProductType || (ProductType = {}));

var defaultProps$H = {
  as: 'div',
  className: '',
  isEmpty: false,
  isLoading: false,
  product: {
    id: '',
    branding: {
      image: '',
      name: ''
    },
    chain: {
      image: '',
      name: ''
    },
    plan: {
      className: '',
      end_date: '',
      expiry: '',
      name: '',
      start_date: ''
    },
    showButton: false,
    status: {
      className: '',
      subText: '',
      text: 'Active'
    },
    type: ProductType.Farm
  }
};
var ListContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var as = _ref.as,
    className = _ref.className,
    children = _ref.children,
    id = _ref.id,
    isEmpty = _ref.isEmpty,
    isLoading = _ref.isLoading,
    product = _ref.product,
    handleItemClick = _ref.handleItemClick;
  var breakpoint = useBreakpoint();
  return React.createElement(React.Fragment, null, React.createElement(Card, {
    as: as,
    className: ['p-5', 'z-10', 'md:px-5', 'md:py-4', 'relative', !isLoading && !isEmpty ? 'cursor-pointer' : '', className].join(' '),
    id: id,
    ref: ref,
    surface: isEmpty || isLoading || breakpoint > 992 ? 'one' : 'two',
    onClick: handleItemClick
  }, !isEmpty ? !isLoading ? React.createElement(React.Fragment, null, children) : React.createElement(Grid, {
    className: "gap-4 md:gap-0",
    role: "status"
  }, React.createElement(Grid.Item, {
    className: "animate-pulse col-span-4"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-28"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  })), React.createElement(Grid.Item, {
    className: "animate-pulse col-span-2 hidden md:block"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-28"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-14"
  })), React.createElement(Grid.Item, {
    className: "block animate-pulse col-span-2 justify-self-end md:hidden"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-28"
  }))) : React.createElement(Grid, null, React.createElement(Grid.Item, {
    className: "col-span-4 md:col-span-12"
  }, React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, "Looks like you didn\u2019t create any properties yet."), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Start by selecting a property type above. All your properties will be listed here."))))), React.createElement(Card, {
    as: as,
    id: id,
    ref: ref,
    className: "relative -top-5 md:hidden",
    onClick: handleItemClick
  }, !isLoading && !isEmpty ? React.createElement("div", {
    className: "pt-10 px-5 pb-5"
  }, React.createElement(Grid, {
    className: "gap-1"
  }, React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Blockchain")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, product == null ? void 0 : product.chain.name)), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    className: product == null ? void 0 : product.status.className,
    size: "sm",
    variant: "custom"
  }, product == null ? void 0 : product.status.text), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, product == null ? void 0 : product.status.subText)), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2 justify-self-end text-right"
  }, React.createElement(Typography, {
    allBold: true,
    size: "sm"
  }, product == null ? void 0 : product.plan.name), React.createElement(Typography, {
    className: product == null ? void 0 : product.plan.className,
    size: "xs",
    variant: "custom"
  }, product == null ? void 0 : product.plan.expiry))), product != null && product.showButton ? React.createElement(Button, {
    fullwidth: true,
    className: "mt-5"
  }, "Extend plan") : null) : null));
});
ListContainer.displayName = 'ListContainer';
ListContainer.defaultProps = defaultProps$H;

var ListHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    id = _ref.id,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as;
  return React.createElement(Component, {
    className: "hidden px-5 md:block " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Grid, {
    role: "grid"
  }, React.createElement(Grid.Item, {
    className: "col-span-4"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Name")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Blockchain")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2"
  }, React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, ' '))));
});
ListHeader.displayName = 'ListHeader';

var defaultProps$I = {
  as: 'div',
  className: '',
  isLoading: false,
  product: {
    id: '',
    branding: {
      image: '',
      name: ''
    },
    chain: {
      image: '',
      name: ''
    },
    plan: {
      expiry: '',
      end_date: '',
      name: '',
      className: '',
      start_date: ''
    },
    showButton: false,
    status: {
      subText: '',
      text: 'Active',
      className: ''
    },
    type: ProductType.Farm
  }
};
var ProductListItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    isLoading = _ref.isLoading,
    product = _ref.product,
    handleItemClick = _ref.handleItemClick,
    Component = _ref.as;
  var breakpoint = useBreakpoint();
  return React.createElement(Component, {
    className: ['low-border', 'rounded', 'cursor-pointer', 'bg-surface-level-one', 'md:px-5', 'md:py-4', className].join(' '),
    "data-testid": product == null ? void 0 : product.id,
    onClick: handleItemClick,
    ref: ref
  }, React.createElement(Grid, {
    role: "grid"
  }, React.createElement(Grid.Item, {
    className: ['p-5', 'col-span-4', 'rounded', 'inline-flex', 'items-center', 'bg-surface-level-two', 'md:p-0', 'md:rounded-none', 'md:bg-transparent'].join(' ')
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-three h-7 rounded w-28 md:bg-surface-level-two"
  }) : React.createElement(React.Fragment, null, React.createElement(ProductBadge, {
    surface: breakpoint < 992 ? 'three' : 'two',
    variant: product == null ? void 0 : product.type
  }), React.createElement(Typography, {
    allBold: true,
    className: "ml-3"
  }, product == null ? void 0 : product.branding.name))), React.createElement(Grid.Item, {
    className: "col-span-2 mt-5 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Network")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-auto mt-5 mr-5 self-center md:inline-flex md:items-center md:ml-0 md:mr-2 md:mt-0"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  }) : React.createElement(React.Fragment, null, React.createElement("span", {
    className: "hidden mr-2 md:block"
  }, React.createElement("img", {
    alt: "chain-logo",
    src: product == null ? void 0 : product.chain.image
  })), React.createElement(Typography, {
    allBold: breakpoint < 992,
    size: "sm"
  }, product == null ? void 0 : product.chain.name))), React.createElement(Grid.Item, {
    className: "col-span-2 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Status")), React.createElement(Grid.Item, {
    className: "col-span-2 ml-auto mr-5 mt-1 self-center text-right md:ml-2 md:mr-0 md:mt-0 md:text-left"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  }) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: breakpoint < 992,
    className: product == null ? void 0 : product.status.className,
    size: "sm",
    variant: "custom"
  }, product == null ? void 0 : product.status.text), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, product == null ? void 0 : product.status.subText))), React.createElement(Grid.Item, {
    className: "col-span-2 mb-5 ml-5 self-center md:hidden"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-5 rounded w-21"
  }) : React.createElement(Typography, {
    className: "text-left",
    size: "sm",
    variant: "secondary"
  }, "Plan")), React.createElement(Grid.Item, {
    className: "col-span-2 mb-5 ml-auto mr-5 mt-1 self-center text-right md:m-0 md:text-left"
  }, isLoading ? React.createElement("div", {
    className: "bg-surface-level-two h-7 rounded w-14"
  }) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    allBold: breakpoint < 992,
    size: "sm"
  }, product == null ? void 0 : product.plan.name), React.createElement(Typography, {
    className: product == null ? void 0 : product.plan.className,
    size: "xs",
    variant: "custom"
  }, product == null ? void 0 : product.plan.expiry))), React.createElement(Grid.Item, {
    className: "col-span-4 px-5 md:col-span-2 md:ml-auto md:p-0"
  }, !isLoading && product != null && product.showButton ? React.createElement(Button, {
    className: "mb-5 md:mb-0",
    fullwidth: breakpoint < 992
  }, "Extend plan") : null)));
});
var Empty = function Empty(_ref2) {
  var children = _ref2.children;
  return React.createElement("div", {
    className: "low-border p-5 rounded bg-surface-level-one"
  }, children);
};
ProductListItem.displayName = 'ProductListItem';
ProductListItem.defaultProps = defaultProps$I;
var index = /*#__PURE__*/Object.assign(ProductListItem, {
  Empty: Empty
});

var ProductCardList = function ProductCardList(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    product_card_list_arr = _ref.product_card_list_arr;
  return React.createElement("div", {
    id: id,
    className: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 " + className
  }, product_card_list_arr.map(function (_ref2) {
    var handleClick = _ref2.handleClick,
      variant = _ref2.variant,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      chipText = _ref2.chipText;
    return React.createElement(ProductCard, {
      key: JSON.stringify(title),
      chipText: chipText,
      subtitle: subtitle,
      title: title,
      variant: variant,
      handleClick: handleClick
    });
  }));
};
ProductCardList.displayName = 'ProductCardList';

var RefundModal = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? Modal : _ref$as,
    show = _ref.show,
    onClose = _ref.onClose,
    refund_data_arr = _ref.refund_data_arr,
    refund_project_name = _ref.refund_project_name,
    handleCancelClick = _ref.handleCancelClick,
    handleContinueClick = _ref.handleContinueClick,
    handleInfoClick = _ref.handleInfoClick,
    info_text = _ref.info_text,
    label_text = _ref.label_text,
    info_button_text = _ref.info_button_text,
    continue_btn_text = _ref.continue_btn_text,
    loading = _ref.loading;
  return React.createElement(Component, {
    ref: ref,
    title: refund_project_name,
    desc: "Request refund & recover invested funds back to your wallet.",
    show: show,
    onClose: onClose,
    noClose: true,
    is_fixed_height: false
  }, React.createElement(Card, {
    surface: "two",
    className: "p-5 mt-8 space-y-3 text-left"
  }, refund_data_arr.map(function (_ref2, idx) {
    var values = _ref2.values,
      label = _ref2.label,
      tooltip = _ref2.tooltip;
    return React.createElement(DataLines, {
      key: label + idx,
      label: label,
      variant: "default",
      values: values,
      tooltip: tooltip,
      id: label + idx
    });
  })), React.createElement(Card, {
    surface: "two",
    className: "mt-8"
  }, React.createElement(ListItem, {
    label_text: label_text,
    info_text: info_text,
    button_text: info_button_text,
    variant: "button",
    handleClick: handleInfoClick
  })), React.createElement("div", {
    className: "flex flex-row-reverse pt-8"
  }, React.createElement(Button, {
    id: "continue-btn",
    className: "px-4 xs:px-[40px] min-w-[169px]",
    onClick: handleContinueClick,
    loading: loading,
    disabled: loading
  }, continue_btn_text), React.createElement(Button, {
    id: "skip-btn",
    className: "bg-surface-level-two hover:bg-surface-level-three border-none text-secondary pr-5 mr-5",
    variant: "custom",
    onClick: handleCancelClick
  }, "Cancel")));
});
RefundModal.displayName = 'RefundModal';

var VerticleDatalineCentered = function VerticleDatalineCentered(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return React.createElement("div", {
    className: "w-full text-center"
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true
  }, value), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, label));
};
var StatsCards = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
    Component = _ref2$as === void 0 ? 'div' : _ref2$as,
    tier_info = _ref2.tier_info,
    total_stake = _ref2.total_stake,
    handleUpgradeTier = _ref2.handleUpgradeTier,
    total_invested = _ref2.total_invested,
    events_participated = _ref2.events_participated,
    className = _ref2.className;
  return React.createElement("div", {
    className: "overflow-x-auto"
  }, React.createElement(Component, {
    className: "grid grid-cols-3 gap-5 min-w-max " + className,
    ref: ref
  }, React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement(TierLevel, {
    label: true,
    image_url: tier_info.img_url,
    is_max_tier: tier_info.is_max_tier,
    text: tier_info.tier_name,
    tier_color: tier_info.tier_color,
    multiplier: tier_info.multiplier
  }), React.createElement(DataLines, {
    top_size: "2xl",
    is_top_bold: true,
    bottom_size: "xs",
    className: "mt-5",
    variant: "verticle",
    label: "TOTAL STAKE",
    values: [{
      value: total_stake
    }]
  }), React.createElement(Button, {
    className: "w-full mt-5",
    onClick: handleUpgradeTier
  }, "Upgrade tier")), React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement("div", {
    className: "w-full flex justify-center py-[34px]"
  }, React.createElement(Media, {
    size: 15,
    variant: "invested",
    className: "text-accent"
  })), React.createElement(VerticleDatalineCentered, {
    label: "TOTAL INVESTED",
    value: total_invested
  })), React.createElement(Card, {
    className: "w-[320px] md:w-[380px] p-5"
  }, React.createElement("div", {
    className: "w-full flex justify-center py-[34px]"
  }, React.createElement(Media, {
    size: 15,
    variant: "events",
    className: "text-accent"
  })), React.createElement(VerticleDatalineCentered, {
    value: events_participated,
    label: "EVENTS PARTICIPATED IN"
  }))));
});
StatsCards.displayName = 'StatsCards';

var StatsBar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var data = _ref.data,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className;
  return React.createElement(Component, {
    ref: ref,
    className: "flex space-x-5 overflow-x-auto " + className
  }, data && data.map(function (item, index) {
    return React.createElement(Card, {
      key: index,
      className: "min-w-[280px] h-[82px] px-5 py-4 flex space-x-5 items-center"
    }, React.createElement(Media, {
      variant: item.logo,
      className: "text-accent"
    }), React.createElement(DataLines, {
      is_top_bold: true,
      top_size: "2xl",
      bottom_size: "sm",
      variant: "verticle",
      label: item.label,
      values: [{
        value: item.value
      }]
    }));
  }));
});
StatsBar.displayName = 'StatsBar';

var animate_div_classes = 'bg-surface-level-two animate-pulse w-[75%] h-full rounded';
var LoadingPool = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var is_mobile = _ref.is_mobile,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as;
  return is_mobile ? React.createElement(Component, {
    ref: ref,
    className: "border-none rounded bg-surface-level-one"
  }, React.createElement(Card, {
    surface: "two",
    className: "p-5"
  }, React.createElement("div", {
    className: "flex flex-wrap gap-2 mb-4"
  }, React.createElement("div", {
    className: "w-[120px] h-11 animate-pulse bg-surface-level-three rounded"
  }), React.createElement("div", {
    className: "w-[120px] h-11 animate-pulse bg-surface-level-three rounded"
  }), React.createElement("div", {
    className: "w-[120px] h-11 animate-pulse bg-surface-level-three rounded"
  })), React.createElement("div", {
    className: "space-y-1"
  }, React.createElement("div", null, React.createElement(DataLines, {
    variant: "default",
    label: " Reward (APY)",
    values: [{
      value: ''
    }],
    loaded: false,
    loading_surface_level: "bg-surface-level-three"
  })), React.createElement(DataLines, {
    variant: "default",
    label: "Total staked",
    values: [{
      value: ''
    }],
    loaded: false,
    loading_surface_level: "bg-surface-level-three"
  }), React.createElement("div", {
    className: "w-full animate-pulse"
  }))), React.createElement("div", {
    className: "p-5 space-y-1"
  }, React.createElement(DataLines, {
    label: "Unlock",
    values: [{
      value: ''
    }],
    loaded: false
  }), React.createElement(DataLines, {
    label: "User stake",
    values: [{
      value: ''
    }],
    loaded: false
  }), React.createElement(DataLines, {
    label: "User reward",
    values: [{
      value: ''
    }],
    loaded: false
  }))) : React.createElement(Component, {
    ref: ref
  }, React.createElement(Card, {
    className: "px-5 py-4 max-w-[1180px]",
    surface: "one"
  }, React.createElement("div", {
    className: "flex h-11"
  }, React.createElement("div", {
    className: "w-[22%]"
  }, React.createElement("div", {
    className: 'bg-surface-level-two animate-pulse w-[75%] h-full rounded'
  })), React.createElement("div", {
    className: "w-[7%]"
  }, React.createElement("div", {
    className: animate_div_classes
  })), React.createElement("div", {
    className: "w-[9%]"
  }, React.createElement("div", {
    className: animate_div_classes
  })), React.createElement("div", {
    className: "flex space-x-2 w-[19%]"
  }, React.createElement("div", {
    className: "w-[40%] h-full animate-pulse bg-surface-level-two rounded"
  }), React.createElement("div", {
    className: "w-[40%] h-full animate-pulse bg-surface-level-two rounded"
  })), React.createElement("div", {
    className: "w-[10%]"
  }, React.createElement("div", {
    className: animate_div_classes
  })), React.createElement("div", {
    className: "w-[13%]"
  }, React.createElement("div", {
    className: animate_div_classes
  })), React.createElement("div", {
    className: "w-[10%] flex flex-row-reverse"
  }, React.createElement("div", {
    className: animate_div_classes
  })), React.createElement("div", {
    className: "w-[10%] flex flex-row-reverse"
  }, React.createElement("div", {
    className: animate_div_classes
  })))));
});
LoadingPool.displayName = 'LoadingPool';

var renderSwitch$2 = function renderSwitch(handleConnect, variant) {
  switch (variant) {
    case 'conn-none':
      return React.createElement("div", {
        className: "flex items-center justify-between w-full"
      }, React.createElement(Typography, {
        allBold: true,
        size: "md",
        className: "pr-5"
      }, "Connect wallet to see your staked pools"), React.createElement(Button, {
        onClick: handleConnect
      }, "Connect wallet"));
    case 'pool-none':
      return React.createElement("div", null, React.createElement(Typography, {
        allBold: true,
        size: "md"
      }, "It looks like there are no active pools at this time"));
    case 'stake-full':
      return React.createElement("div", {
        className: "col-span-4 md:col-span-12"
      }, React.createElement(Typography, {
        allBold: true,
        size: "sm"
      }, "Looks like you are staking in all active pools"), React.createElement(Typography, {
        variant: "secondary",
        size: "sm"
      }, 'What a whale 🐋'));
    case 'stake-none':
      return React.createElement("div", null, React.createElement(Typography, {
        allBold: true,
        size: "sm"
      }, "Looks like you haven\u2032t staked yet"), React.createElement(Typography, {
        variant: "secondary",
        size: "sm"
      }, "Stake in pools below to get your Investor Tier and start earning passive income"));
    default:
      return React.createElement("div", null);
  }
};
var PoolContainer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    id = _ref.id,
    isEmpty = _ref.isEmpty,
    isLoading = _ref.isLoading,
    variant = _ref.variant,
    handleConnect = _ref.handleConnect,
    handlePoolClick = _ref.handlePoolClick,
    is_mobile = _ref.is_mobile,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as;
  return React.createElement(Component, {
    ref: ref,
    id: id
  }, isLoading ? React.createElement(LoadingPool, {
    is_mobile: is_mobile
  }) : isEmpty ? React.createElement("div", null, React.createElement(Card, {
    onClick: handlePoolClick,
    surface: "one",
    className: "px-5 py-[16px] min-h-[80px] flex items-center"
  }, renderSwitch$2(handleConnect, variant))) : React.createElement("div", null, children));
});
PoolContainer.displayName = 'PoolContainer';

var defaultProps$J = {
  as: 'div'
};
var PoolHeader = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    id = _ref.id,
    Component = _ref.as;
  return React.createElement(Component, {
    className: "flex mb-[24px] px-5 " + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Typography, {
    className: "float-left w-[22%]",
    size: "xs",
    variant: "secondary"
  }, "Composition"), React.createElement(Typography, {
    className: "float-left w-[7%]",
    size: "xs",
    variant: "secondary"
  }, "Network"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[9%]"
  }, "Reward (APY)"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[19%]"
  }, "Boost"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[10%]"
  }, "Lock term"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[13%]"
  }, "Total Staked"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[10%] text-right"
  }, "Your reward"), React.createElement(Typography, {
    variant: "secondary",
    size: "xs",
    className: "w-[10%] text-right"
  }, "Your stake"));
});
PoolHeader.displayName = 'PoolHeader';
PoolHeader.defaultProps = defaultProps$J;

var DesktopPool = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    boosterChip = _ref.boosterChip,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    capacity = _ref.capacity,
    lockTerm = _ref.lockTerm,
    multiplierChip = _ref.multiplierChip,
    reward = _ref.reward,
    stakingChip = _ref.stakingChip,
    userStake = _ref.userStake,
    has_accent_gradient = _ref.has_accent_gradient,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    handlePoolClick = _ref.handlePoolClick,
    rebate = _ref.rebate,
    isEmpty = _ref.isEmpty,
    userReward = _ref.userReward,
    isLoading = _ref.isLoading,
    network_logo = _ref.network_logo;
  var _useState = useState(false),
    insideChip = _useState[0],
    setInsideChip = _useState[1];
  return React.createElement(Component, {
    className: "" + className,
    "data-testid": id,
    ref: ref
  }, React.createElement(Card, {
    className: "px-5 py-4 relative max-w-[1180px] " + (!isEmpty && !isLoading ? 'cursor-pointer' : ''),
    id: id,
    ref: ref,
    surface: "one",
    onClick: handlePoolClick
  }, rebate && React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return setInsideChip(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setInsideChip(true);
    }
  }, React.createElement(Chip, {
    size: "xs",
    variant: "custom",
    className: "px-[12px] text-xs font-bold text-primary bg-gradient-purple absolute left-5 -top-[12px]"
  }, insideChip && React.createElement("div", {
    className: "absolute -left-[55px] -top-[100px] w-[193px]"
  }, React.createElement(HelperBox, {
    helper_text: React.createElement("div", {
      className: "text-secondary font-normal"
    }, React.createElement("span", {
      className: "font-bold  text-primary"
    }, "Get ", rebate, " of each deposit back", ' '), "instantly, every time you stake in this pool.")
  })), rebate, " Rebate")), React.createElement("div", {
    className: "flex"
  }, React.createElement("div", {
    className: "w-[22%] "
  }, React.createElement(StakingChips, Object.assign({}, stakingChip))), React.createElement("div", {
    className: "flex items-center w-[7%] "
  }, React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[29px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[160px]",
    helper_text: React.createElement("div", null, "This pool operates on", ' ', React.createElement("span", {
      className: "font-bold text-primary"
    }, network_logo.name), ' ', "network & requires", ' ', React.createElement("span", {
      className: "font-bold text-primary"
    }, network_logo.symbol), ' ', "to cover network fees.")
  })), React.createElement("img", {
    className: "pl-[7px]",
    src: network_logo.image,
    alt: "network"
  }))), React.createElement("div", {
    className: "w-[9%] "
  }, React.createElement(DataLines, {
    is_top_bold: true,
    top_size: "2xl",
    variant: "verticle",
    label: reward == null ? void 0 : reward.label,
    values: [{
      value: reward == null ? void 0 : reward.value
    }]
  })), React.createElement("div", {
    className: "flex space-x-2 w-[19%]"
  }, multiplierChip && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: multiplierChip != null && multiplierChip.active ? React.createElement("div", {
      className: "text-secondary text-xs"
    }, multiplierChip.name, " NFT boost is", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "active"), ". Enjoy", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "higher APY"), ' ', "on your rewards.") : React.createElement("div", {
      className: "text-secondary text-xs"
    }, React.createElement("span", {
      className: "font-bold text-white"
    }, "Genesis NFT"), ' ', "is required to increase your APY rewards.")
  })), React.createElement(StakingChips, {
    has_accent_zero_gradient: has_accent_gradient,
    multiplier: multiplierChip == null ? void 0 : multiplierChip.active,
    tokens: [{
      parts: [{
        image: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/NFT-circle.svg',
        name: (multiplierChip == null ? void 0 : multiplierChip.amount) || ''
      }]
    }]
  })), (boosterChip == null ? void 0 : boosterChip.active) && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: React.createElement("div", {
      className: "text-secondary text-xs"
    }, "Staking in this pool increases your", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "investor tier"))
  })), React.createElement(StakingChips, {
    has_accent_gradient: has_accent_gradient,
    booster: boosterChip.active,
    tokens: [{
      parts: [{
        image: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/lightning-boost-icon.svg',
        name: (boosterChip == null ? void 0 : boosterChip.amount) || ''
      }]
    }]
  })), !(boosterChip != null && boosterChip.active) && !multiplierChip && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: React.createElement("div", {
      className: "text-secondary text-xs"
    }, "No boost available when you stake in this pool.")
  })), React.createElement(StakingChips, {
    tokens: [{
      parts: [{
        image: '',
        name: 'None'
      }]
    }]
  }))), React.createElement("div", {
    className: "flex items-center w-[10%]"
  }, lockTerm != null && lockTerm.lockEndDate ? React.createElement(React.Fragment, null, React.createElement(DataLines, {
    top_size: "md",
    variant: "verticle",
    label: lockTerm == null ? void 0 : lockTerm.value,
    values: [{
      value: lockTerm == null ? void 0 : lockTerm.lockEndDate
    }]
  })) : React.createElement(Typography, {
    size: "sm"
  }, lockTerm == null ? void 0 : lockTerm.value)), React.createElement("div", {
    className: "w-[13%] my-auto"
  }, capacity == null ? void 0 : capacity.map(function (c, idx) {
    var _capacity$;
    return React.createElement("div", {
      key: JSON.stringify(c) + idx
    }, React.createElement(Typography, {
      className: "text-left",
      size: "sm"
    }, c == null ? void 0 : c.staked), !isNaN((_capacity$ = capacity[0]) == null ? void 0 : _capacity$.percentFilled) && React.createElement("div", {
      className: "w-[135px]"
    }, React.createElement(Progress, {
      label: true,
      percent: c == null ? void 0 : c.percentFilled
    })));
  })), React.createElement("div", {
    className: "space-y-1 w-[10%]  text-right my-auto"
  }, userReward.map(function (_ref2, idx) {
    var amount = _ref2.amount,
      symbol = _ref2.symbol;
    return React.createElement(Typography, {
      key: JSON.stringify(amount) + idx,
      size: "sm"
    }, amount, " ", symbol);
  })), React.createElement("div", {
    className: "space-y-1 w-[10%]  text-right my-auto"
  }, userStake.map(function (_ref3, idx) {
    var amount = _ref3.amount,
      symbol = _ref3.symbol;
    return React.createElement(Typography, {
      key: JSON.stringify(amount) + idx,
      size: "sm"
    }, amount, " ", symbol);
  })))));
});
DesktopPool.displayName = 'DesktopPool';

var MobilePool = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _capacity$, _capacity$2;
  var id = _ref.id,
    boosterChip = _ref.boosterChip,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$capacity = _ref.capacity,
    capacity = _ref$capacity === void 0 ? [] : _ref$capacity,
    lockTerm = _ref.lockTerm,
    multiplierChip = _ref.multiplierChip,
    reward = _ref.reward,
    stakingChip = _ref.stakingChip,
    userStake = _ref.userStake,
    has_accent_gradient = _ref.has_accent_gradient,
    isEmpty = _ref.isEmpty,
    isLoading = _ref.isLoading,
    handlePoolClick = _ref.handlePoolClick,
    rebate = _ref.rebate,
    userReward = _ref.userReward,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    is_always_mobile = _ref.is_always_mobile,
    network_logo = _ref.network_logo,
    user_final_allocation_weight = _ref.user_final_allocation_weight;
  var _useState = useState(false),
    insideChip = _useState[0],
    setInsideChip = _useState[1];
  return React.createElement(Component, {
    className: "" + className,
    "data-testid": id,
    ref: ref
  }, React.createElement("div", {
    className: "border-none rounded  " + (is_always_mobile ? 'bg-surface-level-two' : 'bg-surface-level-one')
  }, React.createElement(Card, {
    className: ['p-5', 'relative', 'z-10', !isEmpty && !isLoading ? 'cursor-pointer' : '', className].join(' '),
    id: id,
    ref: ref,
    surface: is_always_mobile ? 'three' : 'two',
    onClick: handlePoolClick
  }, rebate && React.createElement("div", {
    onMouseLeave: function onMouseLeave() {
      return setInsideChip(false);
    },
    onMouseEnter: function onMouseEnter() {
      return setInsideChip(true);
    }
  }, React.createElement(Chip, {
    size: "xs",
    variant: "custom",
    className: "px-[12px] text-xs font-bold text-primary bg-gradient-purple absolute left-5 -top-[12px]"
  }, insideChip && React.createElement("div", {
    className: "absolute -left-[55px] -top-[100px] w-[193px]"
  }, React.createElement(HelperBox, {
    helper_text: React.createElement("div", {
      className: "text-secondary font-normal"
    }, React.createElement("span", {
      className: "font-bold text-primary"
    }, "Get ", rebate, " of each deposit back", ' '), "instantly, every time you stake in this pool.")
  })), rebate, " Rebate")), React.createElement("div", {
    className: "mb-4 flex flex-wrap gap-2"
  }, React.createElement("div", null, React.createElement(StakingChips, Object.assign({}, stakingChip, {
    is_always_mobile: is_always_mobile,
    is_mobile: true
  }))), React.createElement("div", {
    className: "flex space-x-2"
  }, multiplierChip && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: multiplierChip != null && multiplierChip.active ? React.createElement("div", {
      className: "text-secondary text-xs"
    }, "$", multiplierChip.name, " NFT boost is", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "active"), ". Enjoy", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "higher APY"), ' ', "on your rewards.") : React.createElement("div", {
      className: "text-secondary text-xs"
    }, React.createElement("span", {
      className: "font-bold text-white"
    }, "Genesis NFT"), ' ', "is required to increase your APY rewards.")
  })), React.createElement("div", {
    className: "max-w-[100px]"
  }, React.createElement(StakingChips, {
    is_always_mobile: is_always_mobile,
    is_mobile: true,
    has_accent_zero_gradient: has_accent_gradient,
    multiplier: multiplierChip == null ? void 0 : multiplierChip.active,
    tokens: [{
      parts: [{
        image: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/NFT-circle.svg',
        name: (multiplierChip == null ? void 0 : multiplierChip.amount) || ''
      }]
    }]
  }))), (boosterChip == null ? void 0 : boosterChip.active) && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: React.createElement("div", {
      className: "text-secondary text-xs"
    }, "Staking in this pool increases your", ' ', React.createElement("span", {
      className: "font-bold text-white"
    }, "investor tier"))
  })), React.createElement("div", {
    className: "max-w-[100px]"
  }, React.createElement(StakingChips, {
    is_always_mobile: is_always_mobile,
    is_mobile: true,
    has_accent_gradient: has_accent_gradient,
    booster: boosterChip.active,
    tokens: [{
      parts: [{
        image: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/lightning-boost-icon.svg',
        name: (boosterChip == null ? void 0 : boosterChip.amount) || ''
      }]
    }]
  }))), !(boosterChip != null && boosterChip.active) && !multiplierChip && React.createElement("div", {
    className: "relative group"
  }, React.createElement("div", {
    className: "hidden group-hover:block absolute bottom-[43px] left-1/2 transform -translate-x-1/2"
  }, React.createElement(HelperBox, {
    className: "w-[180px]",
    helper_text: React.createElement("div", {
      className: "text-secondary text-xs"
    }, "No boost available when you stake in this pool.")
  })), React.createElement("div", {
    className: "max-w-min"
  }, React.createElement(StakingChips, {
    is_mobile: true,
    is_always_mobile: is_always_mobile,
    tokens: [{
      parts: [{
        image: '',
        name: 'None'
      }]
    }]
  }))))), React.createElement("div", {
    className: "space-y-1"
  }, React.createElement("div", null, React.createElement(DataLines, {
    variant: "default",
    label: " Network",
    values: [{
      value: network_logo.name
    }]
  })), React.createElement("div", null, React.createElement(DataLines, {
    variant: "default",
    label: " Reward (APY)",
    values: [{
      value: (reward == null ? void 0 : reward.value) + " " + (reward == null ? void 0 : reward.label)
    }]
  })), React.createElement(DataLines, {
    variant: "default",
    label: "Total staked",
    values: capacity == null ? void 0 : capacity.map(function (c) {
      return {
        value: c == null ? void 0 : c.staked
      };
    })
  }), capacity && !isNaN((_capacity$ = capacity[0]) == null ? void 0 : _capacity$.percentFilled) && React.createElement(Progress, {
    label: true,
    className: "w-full",
    percent: (_capacity$2 = capacity[0]) == null ? void 0 : _capacity$2.percentFilled
  }))), React.createElement("div", {
    className: "p-5 space-y-1"
  }, React.createElement(DataLines, {
    label: "Unlock",
    values: [{
      value: "" + (lockTerm != null && lockTerm.lockEndDate ? lockTerm == null ? void 0 : lockTerm.lockEndDate : lockTerm == null ? void 0 : lockTerm.value)
    }]
  }), !is_always_mobile && React.createElement(DataLines, {
    label: "User stake",
    values: userStake.map(function (_ref2) {
      var amount = _ref2.amount,
        symbol = _ref2.symbol;
      return {
        value: amount + " " + symbol
      };
    })
  }), !is_always_mobile && React.createElement(DataLines, {
    label: "User reward",
    values: userReward.map(function (_ref3) {
      var amount = _ref3.amount,
        symbol = _ref3.symbol;
      return {
        value: amount + " " + symbol
      };
    })
  }), user_final_allocation_weight && React.createElement(DataLines, {
    label: "Final allocation weight",
    values: [{
      value: user_final_allocation_weight
    }]
  }))));
});
MobilePool.displayName = 'MobilePool';

var UpgradeTierStage;
(function (UpgradeTierStage) {
  UpgradeTierStage["Tier"] = "tier";
  UpgradeTierStage["Pools"] = "pools";
})(UpgradeTierStage || (UpgradeTierStage = {}));
var UpgradeTierDrawer = function UpgradeTierDrawer(_ref) {
  var show = _ref.show,
    handleClose = _ref.handleClose,
    current_tier_info = _ref.current_tier_info,
    tier_info = _ref.tier_info,
    value = _ref.value,
    setValue = _ref.setValue,
    pool_arr = _ref.pool_arr,
    _ref$stage = _ref.stage,
    stage = _ref$stage === void 0 ? UpgradeTierStage.Tier : _ref$stage,
    setStage = _ref.setStage,
    upgrade_text = _ref.upgrade_text,
    _ref$min_value = _ref.min_value,
    min_value = _ref$min_value === void 0 ? 1 : _ref$min_value,
    token_symbol = _ref.token_symbol;
  return React.createElement(SideDrawer, {
    show: show,
    handleClose: handleClose
  }, stage === UpgradeTierStage.Pools ? React.createElement("button", {
    onClick: function onClick() {
      return setStage(UpgradeTierStage.Tier);
    }
  }, React.createElement(Media, {
    variant: "arrow-left",
    className: "h-[17px] w-[18px] text-primary",
    size: 0
  })) : React.createElement("button", {
    onClick: handleClose
  }, React.createElement(Media, {
    variant: "cross",
    className: "h-[14px] w-[14px] text-primary",
    size: 0
  })), React.createElement(Typography, {
    className: "mt-[30px] mb-[19px]",
    size: "2xl",
    allBold: true
  }, stage === UpgradeTierStage.Pools ? 'Choose a pool to upgrade' : 'Current'), stage === UpgradeTierStage.Pools ? React.createElement("div", {
    className: "space-y-4 pt-[10px]"
  }, pool_arr.map(function (pool) {
    return React.createElement(PoolContainer, {
      key: JSON.stringify(pool),
      is_mobile: true
    }, React.createElement(MobilePool, Object.assign({}, pool, {
      is_always_mobile: true
    })));
  })) : React.createElement("div", null, React.createElement(Card, {
    surface: "two",
    className: "p-5"
  }, React.createElement(TierLevel, {
    variant: "lg",
    image_url: current_tier_info.img_url,
    text: current_tier_info.tier_name,
    is_max_tier: current_tier_info.is_max_tier,
    multiplier: current_tier_info.multiplier,
    tier_color: current_tier_info.tier_color,
    label: true
  }), React.createElement(Typography, {
    className: "mt-5",
    variant: "secondary",
    size: "sm"
  }, upgrade_text)), React.createElement(Typography, {
    className: "mt-8 mb-[19px]",
    size: "2xl",
    allBold: true
  }, "Upgrade"), React.createElement("div", {
    className: "space-y-5"
  }, tier_info.slice(0).reverse().map(function (_ref2) {
    var img_url = _ref2.img_url,
      tier_name = _ref2.tier_name,
      is_max_tier = _ref2.is_max_tier,
      multiplier = _ref2.multiplier,
      tier_color = _ref2.tier_color,
      diff_to_tier = _ref2.diff_to_tier,
      upgrade_refund_info_arr = _ref2.upgrade_refund_info_arr,
      handleClick = _ref2.handleClick;
    return React.createElement(Card, {
      surface: "two",
      key: tier_name + "-" + img_url,
      className: "p-5"
    }, React.createElement(TierLevel, {
      variant: "lg",
      image_url: img_url,
      text: tier_name,
      is_max_tier: is_max_tier,
      multiplier: multiplier,
      tier_color: tier_color,
      label: true
    }), React.createElement("div", {
      className: "space-y-[10px] pt-5 mb-[10px]"
    }, upgrade_refund_info_arr.map(function (info) {
      return React.createElement(Typography, {
        key: info,
        variant: "secondary",
        size: "sm"
      }, info);
    })), is_max_tier && React.createElement("div", {
      className: "w-full pt-[10px]"
    }, React.createElement(Adjust, {
      min: min_value,
      value: value,
      setValue: setValue
    })), React.createElement(Button, {
      has_icon: true,
      onClick: handleClick,
      className: "bg-surface-level-three w-full mt-[10px] h-[42px]",
      variant: "custom",
      id: tier_name + "-btn"
    }, React.createElement(Typography, {
      allBold: true,
      variant: "primary",
      size: "sm"
    }, "Stake ", diff_to_tier, " ", token_symbol, " to upgrade")));
  }))));
};
UpgradeTierDrawer.displayName = 'UpgradeTierDrawer';

var ShareBtn = function ShareBtn(_ref) {
  var name = _ref.name,
    url = _ref.url;
  return React.createElement("a", {
    href: url,
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement(Card, {
    surface: "two",
    className: "flex items-center h-11 sm:w-11 hover:bg-surface-level-three"
  }, React.createElement(Media, {
    className: "text-primary w-[18px] h-[19px] mx-auto",
    variant: name,
    size: 0
  })));
};
var InviteEarn = /*#__PURE__*/React.forwardRef(function (_ref2, ref) {
  var className = _ref2.className,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? 'invite-earn-card' : _ref2$id,
    referral_url = _ref2.referral_url,
    share_options = _ref2.share_options,
    referral_info = _ref2.referral_info,
    handleClick = _ref2.handleClick,
    disabled = _ref2.disabled,
    loading = _ref2.loading,
    button_text = _ref2.button_text,
    _ref2$alert = _ref2.alert,
    alert = _ref2$alert === void 0 ? false : _ref2$alert,
    _ref2$company_name = _ref2.company_name,
    company_name = _ref2$company_name === void 0 ? 'Decubate' : _ref2$company_name;
  var _useState = useState(false),
    show_notification = _useState[0],
    setShowNotification = _useState[1];
  return React.createElement(Card, {
    id: id,
    className: "max-w-[580px] p-5 sm:p-8 " + className,
    ref: ref
  }, React.createElement("div", {
    className: "flex items-center mb-4 space-x-[10px]"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Your referral link"), React.createElement(Tooltip, {
    id: "referral-earn-tooltip",
    "data-testid": "tooltip",
    text: "Use this link to refer new users to " + company_name + " & earn rewards for each complete referral."
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent",
    size: 5
  }))), React.createElement("div", {
    className: "sm:flex sm:space-x-5"
  }, React.createElement(Card, {
    surface: "zero",
    className: "flex-1 flex sm:max-w-[324px] px-5 space-x-4 items-center justify-between py-[10.5px]"
  }, React.createElement(Typography, {
    className: "text-left truncate",
    size: "sm"
  }, referral_url), React.createElement("button", {
    onClick: function onClick() {
      navigator.clipboard.writeText(referral_url);
      setShowNotification(true);
      setTimeout(function () {
        return setShowNotification(false);
      }, 2000);
    },
    className: "text-accent"
  }, React.createElement("div", {
    className: "h-[24px] w-[32px] flex items-center justify-end"
  }, show_notification ? React.createElement(Media, {
    variant: "tick",
    className: "text-accent h-[15px]",
    size: 0
  }) : 'Copy'))), React.createElement("div", {
    className: "grid grid-cols-3 gap-5 sm:pt-0 pt-5"
  }, share_options.map(function (_ref3, idx) {
    var name = _ref3.name,
      url = _ref3.url;
    return React.createElement(ShareBtn, {
      key: name + "-" + idx + "-" + url,
      name: name,
      url: url
    });
  }))), React.createElement(Typography, {
    size: "xs",
    variant: "secondary",
    className: 'mx-2 mt-2'
  }, "To earn rewards, your referree must complete the registration process and ", React.createElement("span", {
    className: 'font-bold'
  }, "claim their rewards.")), React.createElement("div", {
    className: "grid grid-cols-1 sm:grid-cols-3 gap-5 mt-2"
  }, referral_info.map(function (_ref4, idx) {
    var label = _ref4.label,
      value = _ref4.value;
    return React.createElement(Card, {
      key: label + "-" + idx + "-" + value,
      surface: "zero",
      className: "p-5"
    }, React.createElement(DataLines, {
      top_size: "2xl",
      is_top_bold: true,
      variant: "verticle",
      label: label,
      values: [{
        value: value
      }]
    }));
  })), alert && React.createElement(Alert, {
    className: "mt-8",
    title: "Gold or above tier required",
    variant: "warning"
  }, "Please upgrade your investor tier to Gold or above to claim referral rewards. Your referral link is still active and will accumulate rewards for each complete referral."), React.createElement(Button, {
    className: "w-full mt-8",
    loading: loading,
    disabled: disabled,
    onClick: handleClick
  }, button_text));
});
InviteEarn.displayName = 'InviteEarn';

var ReferralBanner = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'referral-banner' : _ref$id,
    bannerImage = _ref.bannerImage;
  return React.createElement(Card, {
    id: id,
    className: "max-w-[350px] h-[285px] sm:h-auto sm:max-w-[580px] p-5 relative " + className,
    ref: ref
  }, React.createElement("img", {
    alt: "referral-banner-present",
    className: "absolute sm:right-[34px] right-[44px] bottom-0",
    src: bannerImage
  }), React.createElement(Typography, {
    size: "2xl",
    allBold: true
  }, "Referral program"), React.createElement(Typography, {
    className: "w-[250px] mt-2",
    size: "md",
    variant: "secondary"
  }, "Invite new investors and claim truly unlimited rewards."));
});
ReferralBanner.displayName = 'ReferralBanner';

var RequirementsCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'requirements-card' : _ref$id,
    button_options = _ref.button_options,
    banner_title = _ref.banner_title,
    continue_btn = _ref.continue_btn,
    handleMoreClick = _ref.handleMoreClick,
    header_image = _ref.header_image,
    is_invite_tab = _ref.is_invite_tab;
  var _ref2 = continue_btn || {},
    handleClick = _ref2.handleClick,
    text = _ref2.text,
    disabled = _ref2.disabled,
    has_success_color = _ref2.has_success_color,
    loading = _ref2.loading;
  return React.createElement(Card, {
    id: id,
    className: "max-w-[580px] " + className,
    ref: ref
  }, React.createElement("div", {
    className: "relative w-full rounded-t max-h-[326px] min-h-[222px]"
  }, React.createElement("div", {
    className: "absolute inset-0 bg-surface-level-zero opacity-70 xs:opacity-0"
  }), React.createElement("img", {
    alt: "requirements-img",
    src: header_image,
    className: "rounded-t max-h-[326px] min-h-[222px]"
  }), React.createElement("div", {
    className: "absolute left-5 sm:left-8 bottom-8"
  }, React.createElement(Typography, {
    className: "max-w-[195px] sm:max-w-[195px]",
    allBold: true,
    size: "2xl"
  }, banner_title), React.createElement("button", {
    onClick: handleMoreClick,
    className: "flex items-center space-x-3 mt-5"
  }, React.createElement(Typography, {
    size: "md"
  }, "Learn more"), React.createElement(Media, {
    size: 0,
    className: "w-[18px] h-[17px] text-primary",
    variant: "new-window-link"
  })))), React.createElement("div", {
    className: "p-5 sm:p-8"
  }, is_invite_tab && React.createElement(Typography, {
    className: "pb-[20px] sm:pb-[18px] ",
    size: "md"
  }, "Complete the requirements below to access your referral link."), React.createElement("div", {
    className: "space-y-[14px]"
  }, button_options == null ? void 0 : button_options.map(function (_ref3, idx) {
    var label = _ref3.label,
      handleClick = _ref3.handleClick,
      loader = _ref3.loader,
      disabled = _ref3.disabled;
    return React.createElement(Card, {
      key: label + "-" + idx,
      onClick: function onClick() {
        disabled ? undefined : handleClick();
      },
      className: "bg-surface-level-two flex items-center justify-between w-full px-5 py-[11px] mx-auto cursor-pointer " + (disabled ? '' : 'hover:bg-surface-level-three')
    }, React.createElement(Typography, {
      size: "sm",
      variant: "secondary"
    }, label), loader ? React.createElement(Media, {
      className: "text-button",
      size: 5,
      variant: "loader"
    }) : React.createElement(Media, {
      size: 0,
      className: "w-[18px] h-[17px] text-primary",
      variant: "arrow-right"
    }));
  })), text && handleClick && React.createElement("div", {
    className: button_options ? "mt-[14px]" : ''
  }, React.createElement(Button, {
    loading: loading,
    className: "w-full",
    onClick: handleClick,
    disabled: disabled,
    variant: has_success_color ? 'success' : 'primary'
  }, text))));
});
RequirementsCard.displayName = 'RequirementsCard';

var ScrollContainer = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement("div", Object.assign({
    ref: ref
  }, props));
});
var TierCarousel = function TierCarousel(_ref) {
  var cards = _ref.cards,
    className = _ref.className;
  var _useState = useState(0),
    scrollPosition = _useState[0],
    setScrollPosition = _useState[1];
  var _useState2 = useState(0),
    maxScrollPosition = _useState2[0],
    setMaxScrollPosition = _useState2[1];
  var breakpoint = useBreakpoint();
  var md = breakpoint < BreakPoint.MD;
  useEffect(function () {
    if (containerRef.current) {
      var containerWidth = containerRef.current.clientWidth;
      var contentWidth = containerRef.current.scrollWidth;
      setMaxScrollPosition(contentWidth - containerWidth);
    }
  }, [cards, breakpoint]);
  var containerRef = useRef(null);
  var scroll = function scroll(scrollOffset) {
    if (containerRef.current) {
      containerRef.current.style.scrollBehavior = 'smooth';
      var newScrollPosition = containerRef.current.scrollLeft + scrollOffset;
      containerRef.current.scrollTo({
        left: newScrollPosition,
        behavior: 'smooth'
      });
      setScrollPosition(newScrollPosition);
    }
  };
  return React.createElement("div", {
    className: "max-w-[1180px] " + className
  }, React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement(Typography, {
    size: md ? '2xl' : '3xl',
    allBold: true
  }, "Choose your reward"), cards.length > 1 && React.createElement("div", {
    className: "space-x-2"
  }, React.createElement(Button, {
    className: "py-[12.5px] px-4 w-11 h-11",
    variant: "secondary",
    onClick: function onClick() {
      scroll(md ? -315 : -400);
    },
    disabled: scrollPosition <= 0
  }, React.createElement(Media, {
    size: 0,
    className: "h-5 w-[11.5px]",
    variant: "chevron-left"
  })), React.createElement(Button, {
    className: "py-[12.5px] w-11 px-4 h-11",
    variant: "secondary",
    onClick: function onClick() {
      scroll(md ? 315 : 400);
    },
    disabled: scrollPosition >= maxScrollPosition
  }, React.createElement(Media, {
    size: 0,
    className: "h-5 w-[11.5px]",
    variant: "chevron-right"
  })))), React.createElement(ScrollContainer, {
    ref: containerRef,
    className: "flex transition-transform duration-300 space-x-5 mt-8 overflow-x-auto"
  }, cards.map(function (_ref2, index) {
    var button_text = _ref2.button_text,
      content = _ref2.content,
      handleClick = _ref2.handleClick,
      src = _ref2.src,
      reward = _ref2.reward,
      handleMinusClick = _ref2.handleMinusClick,
      handlePlusClick = _ref2.handlePlusClick;
    return React.createElement(Card, {
      key: button_text + index + JSON.stringify(content),
      className: "w-[300px] md:w-[380px] px-5 pb-5 pt-8 flex-shrink-0"
    }, React.createElement("img", {
      className: "mx-auto mb-5 max-h-[98px]",
      src: src,
      alt: src
    }), React.createElement("div", {
      className: "flex justify-between items-center"
    }, handleMinusClick && React.createElement(Button, {
      onClick: handleMinusClick,
      variant: "secondary",
      className: "h-11 w-11"
    }, React.createElement(Media, {
      variant: "minus",
      size: 0,
      className: "w-[18px]"
    })), React.createElement(DataLines, {
      className: "text-center mx-auto",
      label: "REWARD",
      is_top_bold: true,
      top_size: "2xl",
      values: [{
        value: reward
      }],
      variant: "verticle"
    }), handlePlusClick && React.createElement(Button, {
      onClick: handlePlusClick,
      className: "h-11 w-11",
      variant: "secondary"
    }, React.createElement(Media, {
      size: 0,
      className: "w-[18px]",
      variant: "plus"
    }))), React.createElement("div", {
      className: "space-y-2 mt-8"
    }, content.map(function (line, i) {
      return React.createElement("div", {
        key: line + i,
        className: "flex space-x-4"
      }, React.createElement(Steps, {
        variant: "secondary"
      }, React.createElement(Media, {
        size: 0,
        className: "w-4 h-[11px] pt-[2px] pr-[1px]",
        variant: "tick"
      })), React.createElement(Typography, {
        size: "sm",
        variant: "secondary",
        className: "flex-1"
      }, line));
    })), React.createElement(Button, {
      variant: "custom",
      className: "w-full mt-8 font-bold text-button  " + (button_text === 'Claim reward' ? 'bg-success' : 'bg-gradient-button'),
      onClick: handleClick
    }, button_text));
  })));
};
TierCarousel.displayName = 'TierCarousel';

var RewardModal = function RewardModal(_ref) {
  var show = _ref.show,
    onClose = _ref.onClose,
    image_url = _ref.image_url,
    reward_amount = _ref.reward_amount;
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  return React.createElement(Transition, {
    show: show,
    onClick: inside_card ? undefined : onClose
  }, React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    className: "z-50"
  }, React.createElement("div", {
    className: "fixed inset-0 bg-black bg-opacity-80"
  })), React.createElement("div", {
    className: "fixed inset-0 overflow-y-auto"
  }, React.createElement("div", {
    className: "flex min-h-full items-center justify-center p-4 text-center"
  }, React.createElement(Transition.Child, {
    enter: "ease-out duration-300",
    enterFrom: "opacity-0 scale-95",
    enterTo: "opacity-100 scale-100",
    leave: "ease-in duration-200",
    leaveFrom: "opacity-100 scale-100",
    leaveTo: "opacity-0 scale-95",
    className: "w-full z-50 "
  }, React.createElement("div", {
    className: ['p-8', 'border', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-one', 'max-w-[320px]', 'transform', 'mx-auto', 'rounded', 'align-middle', 'overflow-auto', 'transition-all', 'corner-gradient-wide'].join(' '),
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    }
  }, React.createElement("div", {
    className: "corner-gradient-content"
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true
  }, "Congratulations"), React.createElement("img", {
    className: "mx-auto mt-10",
    src: image_url,
    alt: image_url
  }), React.createElement("div", {
    className: "text-center mt-10"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "You have received"), React.createElement(Typography, {
    allBold: true,
    size: "2xl",
    className: "text-success"
  }, reward_amount)), React.createElement(Button, {
    className: "mt-8 w-full",
    onClick: onClose
  }, "Done")))))));
};

var VideoButton = function VideoButton(_ref) {
  var handleLightboxToggle = _ref.handleLightboxToggle,
    is_mobile = _ref.is_mobile,
    button_text = _ref.button_text;
  return React.createElement("div", {
    style: {
      backgroundOrigin: 'border-box'
    },
    onClick: handleLightboxToggle,
    id: "video-section",
    className: "cursor-pointer " + (is_mobile ? 'w-[108px] h-[149px] right-0 top-[15%]' : 'h-[158px] w-[158px] right-[20px] rounded-tr-lg rounded-br-lg top-1/2 transform -translate-y-1/2') + " p-5 low-border absolute flex flex-col justify-between rounded-tl-lg rounded-bl-lg bg-gradient-alpha backdrop-filter backdrop-blur-[12px]"
  }, React.createElement("div", {
    className: "flex flex-col items-end w-full"
  }, React.createElement("button", null, React.createElement(Media, {
    variant: "play-btn",
    className: "w-[30px] h-[30px]"
  }))), React.createElement(Typography, {
    className: "w-[78px]",
    size: is_mobile ? 'sm' : 'md',
    allBold: true
  }, button_text));
};
var InfoSection = function InfoSection(_ref2) {
  var buttons = _ref2.buttons,
    has_centered_info = _ref2.has_centered_info,
    secondary_btn_has_outline = _ref2.secondary_btn_has_outline,
    subtitle = _ref2.subtitle,
    title = _ref2.title,
    is_mobile = _ref2.is_mobile;
  return React.createElement("div", {
    className: "absolute max-w-[580px]  w-full " + (is_mobile ? "bottom-[20px] px-5 " + (has_centered_info ? 'left-1/2 transform -translate-x-1/2' : '') : "top-1/2 transform -translate-y-1/2 " + (has_centered_info ? 'left-1/2 -translate-x-1/2' : '')) + "  "
  }, React.createElement(Typography, {
    className: "" + (has_centered_info ? 'text-center' : ''),
    allBold: true,
    size: "4xl"
  }, title), React.createElement(Typography, {
    className: "pt-[10px] " + (has_centered_info ? 'text-center' : ''),
    size: "md",
    variant: "secondary"
  }, subtitle), React.createElement("div", {
    className: "mt-10 flex items-center space-x-5 " + (is_mobile ? 'w-full' : '') + " " + (has_centered_info ? 'justify-center' : '')
  }, React.createElement(Button, {
    padding: false,
    className: "" + (has_centered_info ? 'px-4' : 'px-5'),
    onClick: buttons[0].handleClick
  }, buttons[0].text), secondary_btn_has_outline ? React.createElement("div", null, React.createElement("button", {
    onClick: buttons[1].handleClick,
    className: "text-sm border text-primary border-primary hover:border-opacity-80 hover:text-opacity-80 rounded inline-flex items-center justify-center h-11 focus:outline-none " + (has_centered_info ? 'px-4' : 'px-5')
  }, buttons[1].text)) : React.createElement(Button, {
    padding: false,
    className: "" + (has_centered_info ? 'px-4' : 'px-5'),
    variant: "secondary",
    onClick: buttons[1].handleClick
  }, buttons[1].text)));
};
var LandingPageVideoComp = /*#__PURE__*/React.forwardRef(function (_ref3, forwardedRef) {
  var className = _ref3.className,
    images = _ref3.images,
    title = _ref3.title,
    subtitle = _ref3.subtitle,
    buttons = _ref3.buttons,
    secondary_btn_has_outline = _ref3.secondary_btn_has_outline,
    has_centered_info = _ref3.has_centered_info,
    video_btn = _ref3.video_btn,
    lightboxOpen = _ref3.lightboxOpen,
    setLightboxOpen = _ref3.setLightboxOpen;
  var divRef = useRef(null);
  var mobile_breakpoint = 911;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < mobile_breakpoint;
  var _useState = useState("url('" + (is_mobile ? images.mobile : images.desktop) + "')"),
    background = _useState[0],
    setBackground = _useState[1];
  var _useState2 = useState({}),
    lightboxStyle = _useState2[0],
    setLightboxStyle = _useState2[1];
  var _useState3 = useState(false),
    iframeLoaded = _useState3[0],
    setIframeLoaded = _useState3[1];
  var _useState4 = useState(true),
    showCloseButton = _useState4[0],
    setShowCloseButton = _useState4[1];
  useEffect(function () {
    setBackground("url('" + (is_mobile ? images.mobile : images.desktop) + "')");
  }, [is_mobile, images]);
  var handleLightboxToggle = function handleLightboxToggle() {
    var videoSection = document.getElementById('video-section');
    var container = videoSection == null ? void 0 : videoSection.closest('.max-w-screen-lg');
    if (videoSection && container) {
      var videoSectionRect = videoSection.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      var adjustedLeft = videoSectionRect.left - containerRect.left;
      if (!lightboxOpen) {
        setShowCloseButton(true);
        setLightboxStyle({
          transform: "translate(" + (adjustedLeft - 20) + "px, " + (videoSectionRect.top - 64) + "px)",
          width: videoSectionRect.width,
          height: videoSectionRect.height,
          position: 'fixed',
          opacity: 1,
          transition: 'transform 0.5s ease, width 0.5s ease, height 0.5s ease'
        });
        setLightboxOpen(true);
        // Delay the loading of the iframe
        setTimeout(function () {
          setIframeLoaded(true);
        }, 500); // Adjust this duration to match your transition
        requestAnimationFrame(function () {
          setLightboxStyle({
            transform: 'translate(0, 0)',
            width: '100%',
            height: '100%',
            position: 'fixed',
            opacity: 1,
            transition: 'transform 0.5s ease, width 0.5s ease, height 0.5s ease'
          });
        });
      } else {
        setShowCloseButton(false);
        setIframeLoaded(false);
        setTimeout(function () {
          setLightboxStyle({
            transform: "translate(" + (adjustedLeft - 20) + "px, " + (videoSectionRect.top - 64) + "px)",
            width: videoSectionRect.width,
            height: videoSectionRect.height,
            position: 'fixed',
            opacity: 0,
            transition: 'transform 0.5s ease, width 0.5s ease, height 0.5s ease, opacity 0.5s ease'
          });
          setTimeout(function () {
            setLightboxOpen(false);
            setIframeLoaded(false); // Reset the iframe loading state
          }, 500);
        }, 100);
      }
    }
  };
  useImperativeHandle(forwardedRef, function () {
    return {
      handleLightboxToggle: handleLightboxToggle,
      domRef: divRef
    };
  });
  return React.createElement("div", {
    ref: divRef,
    className: "w-full " + (is_mobile ? 'custom-height' : 'h-[590px]') + " relative bg-surface-level-one " + className
  }, React.createElement("div", {
    key: background,
    style: {
      backgroundImage: background
    },
    className: "w-full h-full object-cover bg-cover bg-center transition-all ease-out duration-500"
  }), video_btn && React.createElement(VideoButton, {
    is_mobile: is_mobile,
    handleLightboxToggle: handleLightboxToggle,
    button_text: video_btn == null ? void 0 : video_btn.button_text
  }), React.createElement(InfoSection, {
    title: title,
    subtitle: subtitle,
    buttons: buttons,
    has_centered_info: has_centered_info,
    secondary_btn_has_outline: secondary_btn_has_outline,
    is_mobile: is_mobile
  }), lightboxOpen && React.createElement("div", {
    style: _extends({}, lightboxStyle, {
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: 50
    }),
    className: "lightbox pt-5 bg-black"
  }, iframeLoaded && React.createElement("iframe", {
    width: "100%",
    height: "100%",
    src: video_btn == null ? void 0 : video_btn.embed_url,
    title: "YouTube video player",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true
  }), lightboxOpen && showCloseButton && React.createElement("button", {
    onClick: handleLightboxToggle,
    className: "absolute top-1 right-1 p-2 z-30"
  }, React.createElement(Media, {
    variant: "cross",
    size: 6
  }))));
});

var CheckInfoCard = function CheckInfoCard(_ref) {
  var title = _ref.title,
    checks = _ref.checks,
    setChecks = _ref.setChecks,
    className = _ref.className,
    check_messages = _ref.check_messages;
  var handleCheckboxChange = function handleCheckboxChange(index) {
    var newChecks = _extends({}, checks);
    newChecks[index] = !newChecks[index];
    setChecks(newChecks);
  };
  return React.createElement(Card, {
    className: "p-5 " + className,
    surface: "three"
  }, React.createElement(Typography, {
    allBold: true,
    size: "md"
  }, title), React.createElement("div", {
    className: "mt-6 space-y-5"
  }, check_messages.map(function (_, idx) {
    return React.createElement("div", {
      className: "flex space-x-5",
      key: title + idx
    }, React.createElement(Toggle, {
      active: checks[idx],
      onChange: function onChange() {
        return handleCheckboxChange(idx);
      },
      variant: "radio"
    }), React.createElement(Typography, {
      variant: "secondary",
      size: "sm"
    }, check_messages[idx]));
  })));
};

var RewhitelistEvent = function RewhitelistEvent(_ref) {
  var current_tier_img = _ref.current_tier_img,
    whitelist_tier_img = _ref.whitelist_tier_img,
    toggle_terms = _ref.toggle_terms,
    setToggleTerms = _ref.setToggleTerms,
    terms_url = _ref.terms_url,
    button_text = _ref.button_text,
    has_qualified = _ref.has_qualified,
    handleClick = _ref.handleClick,
    is_downgrading = _ref.is_downgrading,
    is_upgrading = _ref.is_upgrading,
    whitelist_value = _ref.whitelist_value,
    current_value = _ref.current_value,
    saft_url = _ref.saft_url,
    button_disabled = _ref.button_disabled,
    button_loading = _ref.button_loading,
    token_symbol = _ref.token_symbol;
  var top_tier_icon_is_md = has_qualified && (!is_downgrading || !is_upgrading);
  var has_new_tier_value = is_downgrading || is_upgrading;
  return React.createElement("div", {
    className: "space-y-2"
  }, React.createElement("div", {
    className: "relative"
  }, React.createElement(Card, {
    surface: "two",
    className: "p-5 " + (has_qualified ? '' : 'corner-gradient')
  }, React.createElement("div", {
    className: "corner-gradient-content"
  }, React.createElement(TierPower, {
    className: "z-10",
    image_url: whitelist_tier_img,
    label: has_qualified ? "Whitelisted " + token_symbol + " power" : "Current " + token_symbol + " power",
    value: whitelist_value,
    variant: top_tier_icon_is_md ? 'md' : 'lg'
  }), !has_qualified && React.createElement(TermsSection, {
    button_disabled: button_disabled,
    button_loading: button_loading,
    className: "mt-5",
    toggle_terms: toggle_terms,
    setToggleTerms: setToggleTerms,
    terms_url: terms_url,
    button_text: button_text,
    handleClick: handleClick,
    saft_url: saft_url
  }))), has_new_tier_value && React.createElement("div", {
    className: "rounded-full flex items-center justify-center h-[32px] w-[32px] bg-surface-level-one absolute -bottom-[19px] left-1/2 transform -translate-x-1/2 z-10"
  }, React.createElement(Media, {
    variant: "arrow-down",
    className: "h-[13px] w-[12px]",
    size: 0
  }))), has_new_tier_value && React.createElement("div", {
    className: "space-y-2"
  }, React.createElement(Card, {
    surface: "two",
    className: "p-5 " + (is_upgrading ? 'corner-gradient' : '')
  }, React.createElement("div", {
    className: "corner-gradient-content"
  }, React.createElement(TierPower, {
    className: "z-10",
    image_url: current_tier_img,
    label: "Current " + token_symbol + " power",
    value: current_value,
    variant: is_downgrading || !is_upgrading ? 'md' : 'lg'
  }), !is_downgrading && React.createElement(TermsSection, {
    className: "mt-5",
    terms_url: terms_url,
    saft_url: saft_url,
    button_text: button_text,
    button_disabled: button_disabled,
    button_loading: button_loading,
    toggle_terms: toggle_terms,
    setToggleTerms: setToggleTerms,
    handleClick: handleClick
  }))), is_downgrading && React.createElement(Card, {
    surface: "two",
    className: "p-5"
  }, React.createElement(TermsSection, {
    terms_url: terms_url,
    saft_url: saft_url,
    button_text: button_text,
    button_disabled: button_disabled,
    button_loading: button_loading,
    toggle_terms: toggle_terms,
    setToggleTerms: setToggleTerms,
    handleClick: handleClick
  }))));
};
var TermsSection = function TermsSection(_ref2) {
  var toggle_terms = _ref2.toggle_terms,
    setToggleTerms = _ref2.setToggleTerms,
    terms_url = _ref2.terms_url,
    button_text = _ref2.button_text,
    className = _ref2.className,
    handleClick = _ref2.handleClick,
    saft_url = _ref2.saft_url,
    button_disabled = _ref2.button_disabled,
    button_loading = _ref2.button_loading;
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "flex space-x-5"
  }, React.createElement(Toggle, {
    className: "mt-[2px]",
    id: "accept-terms",
    active: toggle_terms,
    onChange: function onChange() {
      return setToggleTerms(!toggle_terms);
    },
    variant: "radio"
  }), React.createElement(Typography, {
    variant: "secondary"
  }, "I agree to", ' ', React.createElement("a", {
    className: "hover:underline text-accent text-base",
    href: terms_url,
    rel: "noreferrer",
    target: "_blank"
  }, "Terms and conditions"), ' ', "and", ' ', React.createElement("a", {
    className: "hover:underline text-accent text-base",
    href: saft_url,
    rel: "noreferrer",
    target: "_blank"
  }, "SAFT"), ' ', "and fully understand the risks.")), React.createElement(Button, {
    disabled: button_disabled,
    loading: button_loading,
    onClick: handleClick,
    className: "mt-5 w-full"
  }, button_text));
};

var defaultProps$K = {
  label: '',
  if_contract_type: false,
  loading: false,
  options: undefined,
  setSelectCurrent: undefined,
  select_current: undefined
};
var Form$1 = function Form(_ref) {
  var tab_current = _ref.tab_current,
    contract = _ref.contract,
    balance = _ref.balance,
    handleClick = _ref.handleClick,
    value = _ref.value,
    handleChange = _ref.handleChange,
    loading = _ref.loading,
    handleMaxClick = _ref.handleMaxClick,
    token_ticker = _ref.token_ticker,
    options = _ref.options,
    setSelectCurrent = _ref.setSelectCurrent,
    select_current = _ref.select_current,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  return React.createElement("div", {
    className: "pt-5"
  }, options && React.createElement(Select, {
    current: select_current,
    setCurrent: setSelectCurrent,
    surface: "zero",
    placeholder: "Select contract",
    options: options,
    label: "Smart contract"
  }), React.createElement("div", {
    className: "bg-surface-level-two rounded-lg my-5 p-5 border space-y-[2px] border-border border-opacity-[0.03]"
  }, React.createElement(DataLines, {
    variant: "default",
    label: "Address",
    values: [{
      value: breakpoint < 640 ? shortenHex(contract) : contract
    }]
  }), React.createElement(DataLines, {
    variant: "default",
    label: "Balance",
    values: [{
      value: balance
    }]
  })), React.createElement(Input, {
    placeholder: "Enter " + (tab_current === daw_tab_options[0].id ? 'deposit' : 'withdraw') + " amount\n        ",
    min: 0,
    value: value,
    className: "w-full",
    onChange: function onChange(e) {
      return handleChange(e.target.value);
    },
    label: tab_current === daw_tab_options[0].id ? 'Deposit amount' : 'Withdraw amount',
    id: "contract-deposit-withdraw-input",
    type: "number",
    unit: token_ticker,
    surface: "zero",
    handleMaxClick: handleMaxClick
  }), React.createElement(Button, {
    id: "button",
    onClick: handleClick,
    className: "mt-5 w-full",
    disabled: value === '0' || value === '' || loading || disabled,
    loading: loading
  }, tab_current === daw_tab_options[0].id ? 'Deposit' : 'Withdraw'));
};
Form$1.displayName = 'Form';
Form$1.defaultProps = defaultProps$K;

var defaultProps$L = {};
var daw_tab_options = [{
  title: 'Deposit',
  id: '0'
}, {
  title: 'Withdraw',
  id: '1'
}];
var DepositWithdraw = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return React.createElement(Card, {
    ref: ref,
    className: "p-5 " + props.cardClassName
  }, React.createElement(Tabs, {
    variant: "limited",
    options: daw_tab_options,
    current: props.tab_current,
    setCurrent: function setCurrent(id) {
      return props.setTabCurrent(id);
    },
    background_color: "bg-surface-level-zero"
  }), React.createElement(Form$1, Object.assign({}, props)));
});

var PartnerSection = function PartnerSection(_ref) {
  var logos = _ref.logos,
    title = _ref.title,
    className = _ref.className;
  return React.createElement("section", {
    className: "w-full relative space-y-[40px] " + className,
    id: "partner_section",
    "data-testid": "partner_section"
  }, React.createElement(Typography, {
    size: "2xl",
    variant: "primary",
    allBold: true,
    className: "text-center"
  }, title), React.createElement("div", {
    className: "flex group overflow-hidden h-[40px] [mask-image:_linear-gradient(to_right,transparent_0,_black_128px,_black_calc(100%-200px),transparent_100%)] sm:space-x-1 space-x-5"
  }, React.createElement("div", {
    className: "flex loop-scroll sm:group-hover:paused sm:space-x-1 space-x-5"
  }, logos.map(function (_ref2, index) {
    var image = _ref2.image,
      link = _ref2.link;
    return React.createElement("a", {
      key: index + link,
      href: link,
      className: "[&_img]:max-w-none w-[195px] sm:w-[236px] flex items-center justify-center",
      target: "_blank"
    }, React.createElement("img", {
      alt: "partner-section-img-" + index,
      src: image
    }));
  })), React.createElement("div", {
    className: "flex loop-scroll sm:group-hover:paused sm:space-x-1 space-x-5"
  }, logos.map(function (_ref3, index) {
    var image = _ref3.image,
      link = _ref3.link;
    return React.createElement("a", {
      key: index + link,
      href: link,
      className: "[&_img]:max-w-none w-[195px] sm:w-[236px] flex items-center justify-center",
      target: "_blank"
    }, React.createElement("img", {
      alt: "partner-section-img-" + index,
      src: image
    }));
  }))));
};

var VestingAnalytics = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var vesting_period_data = _ref.vesting_period_data,
    vesting_summary_data = _ref.vesting_summary_data,
    button_data = _ref.button_data,
    handleClick = _ref.handleClick,
    loading = _ref.loading,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1200;
  return React.createElement(Component, {
    ref: ref,
    className: " inline w-full space-y-[40px] lg:space-y-0 lg:flex",
    surface: "one"
  }, React.createElement("div", {
    className: "lg:w-[780px]"
  }, React.createElement(Typography, {
    className: "lg:mb-[50px] mb-[30px]",
    size: "lg",
    allBold: true
  }, "Vesting summary"), React.createElement(Card, {
    className: "lg:flex bg-gradient-level-one-to-accent lg:py-[30px] lg:pr-[93px] lg:pl-[30px] p-[20px]"
  }, React.createElement("div", {
    className: "lg:space-y-[34px] space-y-5 w-full mr-[143px]"
  }, vesting_summary_data.map(function (_ref2, index) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      key: index,
      className: "flex justify-between"
    }, React.createElement(Typography, {
      variant: is_mobile ? 'secondary' : 'primary',
      className: "text-sm",
      allBold: !is_mobile
    }, label), React.createElement(Typography, {
      variant: 'primary',
      className: "text-sm",
      allBold: is_mobile
    }, value));
  })), is_mobile && React.createElement("div", {
    className: "border border-border border-opacity-[0.03] mt-[30px] mb-[30px]"
  }), React.createElement("div", {
    className: "justify-between\n          text-center"
  }, React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    className: "text-xs"
  }, button_data.label), React.createElement(Typography, {
    className: "mt-[12px]",
    variant: "primary",
    size: "3xl",
    allBold: true
  }, button_data.value)), React.createElement(Button, {
    onClick: handleClick,
    loading: loading,
    disabled: loading,
    className: "w-full mt-[16px] lg:min-w-[192px]"
  }, "Claim tokens")))), React.createElement("div", {
    className: "lg:w-[380px] lg:ml-[20px]"
  }, React.createElement(Typography, {
    className: "lg:mb-[50px] mb-[30px]",
    size: "lg",
    allBold: true
  }, "Vesting Period"), React.createElement(Card, {
    className: "flex bg-gradient-level-one-to-accent py-[30px] px-[30px]"
  }, ' ', React.createElement("div", {
    className: "space-y-[34px] w-full"
  }, ' ', vesting_period_data.map(function (_ref3, index) {
    var label = _ref3.label,
      value = _ref3.value;
    return React.createElement("div", {
      key: index,
      className: "flex justify-between"
    }, React.createElement(Typography, {
      variant: is_mobile ? 'secondary' : 'primary',
      size: "sm",
      allBold: !is_mobile
    }, label), React.createElement(Typography, {
      variant: "primary",
      size: "sm",
      allBold: is_mobile
    }, ' ', value));
  })))));
});
VestingAnalytics.displayName = 'VestingAnalytics';

var IDOSection = function IDOSection(_ref) {
  var title = _ref.title,
    desc = _ref.desc,
    handleClick = _ref.handleClick,
    className = _ref.className;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 768;
  return React.createElement("div", {
    className: "relative py-[49px] sm:py-[76px] max-w-[1180px] w-full overflow-hidden bg-surface-level-one rounded-lg " + className
  }, React.createElement("div", {
    className: "absolute inset-0 bg-gradient-middle-top"
  }), React.createElement("div", {
    className: "absolute inset-0 bg-gradient-bottom-right"
  }), React.createElement("div", {
    className: "max-w-[273px] sm:max-w-[630px] mx-auto relative z-10"
  }, React.createElement(Typography, {
    variant: "primary",
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, title), React.createElement(Typography, {
    variant: "secondary",
    size: "md",
    className: "mt-2 max-w-[516px]"
  }, desc), React.createElement(Button, {
    className: "w-full mt-6",
    onClick: handleClick
  }, "Apply for IDO")));
};

var EmailSubscription = function EmailSubscription(_ref) {
  var handleClick = _ref.handleClick;
  var _useState = useState(''),
    email = _useState[0],
    setEmail = _useState[1]; // Declare state for email
  var breakpoint = useBreakpoint();
  var first_break = breakpoint < 1100;
  var second_break = breakpoint < 700;
  return React.createElement("div", {
    className: "relative max-w-[1180px] w-full overflow-hidden bg-surface-level-one " + (second_break ? 'px-[43px] py-[60px]' : 'pl-[68px] pr-[156px] py-[102px]')
  }, React.createElement("div", {
    className: "absolute inset-0 bg-gradient-left-pink"
  }), React.createElement("div", {
    className: "relative " + (first_break ? 'flex flex-col items-center space-y-5' : 'flex justify-between items-center')
  }, React.createElement("div", {
    className: "space-y-2"
  }, React.createElement(Typography, {
    size: second_break ? '3xl' : '4xl',
    variant: "primary",
    allBold: true
  }, "Never miss an event"), React.createElement(Typography, {
    size: "md",
    variant: "secondary"
  }, "Get notified as soon as an event whitelist is open.")), React.createElement("div", {
    className: "relative " + (first_break ? 'max-w-[360px] w-full' : 'min-w-[440px]')
  }, React.createElement(Input, {
    placeholder: 'Enter your email',
    value: email,
    surface: "zero",
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    }
  }), React.createElement(Button, {
    onClick: function onClick() {
      return handleClick(email);
    },
    className: "absolute right-0 top-0"
  }, "Notify Me"))));
};

var FAQSection = function FAQSection(_ref) {
  var faqs = _ref.faqs,
    className = _ref.className;
  return React.createElement("section", {
    className: className,
    id: "faq_section",
    "data-testid": "faq_section"
  }, React.createElement(Typography, {
    allBold: true,
    size: '3xl',
    className: "mb-[30px]"
  }, "FAQs"), React.createElement("div", null, faqs.map(function (_ref2, index) {
    var question = _ref2.question,
      answer = _ref2.answer;
    return React.createElement("div", {
      className: "mb-5",
      key: question + "-" + index + "-" + answer
    }, React.createElement(Accordion, {
      subtitle: question
    }, React.createElement("div", {
      className: "text-secondary"
    }, React.createElement(Markdown, {
      options: {
        overrides: {
          a: {
            component: 'a',
            props: {
              className: 'text-accent hover:underline cursor-pointer'
            }
          },
          ul: {
            component: 'ul',
            props: {
              className: 'list-disc ml-5'
            }
          },
          ol: {
            component: 'ol',
            props: {
              className: 'list-decimal ml-5'
            }
          },
          li: {
            component: 'li',
            props: {
              className: 'mb-2'
            }
          }
        }
      }
    }, answer))));
  })));
};

var HomepageStats = function HomepageStats(_ref) {
  var is_mobile = _ref.is_mobile,
    cards_data = _ref.cards_data,
    no_claasses = _ref.no_claasses;
  return React.createElement("div", {
    // no classes was added so I can use it in the completed events section and the justify-start to not effect it
    className: "flex space-x-5 " + (no_claasses ? '' : is_mobile ? ' pl-5 py-2' : 'justify-start'),
    id: "homepage-stats",
    "data-testid": "homepage-stats"
  }, cards_data.map(function (card, index) {
    return React.createElement(Card, {
      key: index,
      className: "px-auto py-4 rounded-lg shadow-purple min-w-[200px] h-[100px] text-center"
    }, React.createElement(VerticleDataLine, {
      values: [{
        value: card.value
      }],
      label: card.label,
      top_size: "3xl",
      bottom_size: "sm",
      is_top_bold: true
    }));
  }), !no_claasses && React.createElement("div", {
    className: "min-w-3"
  }));
};

var HeroSection = function HeroSection(_ref) {
  var className = _ref.className,
    images = _ref.images,
    cards_data = _ref.cards_data,
    title = _ref.title,
    subtitle = _ref.subtitle;
  // Determine current viewport width using the breakpoint hook
  var mobile_breakpoint = 911;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < mobile_breakpoint;
  // State to manage background image
  var _useState = useState(''),
    background = _useState[0],
    setBackground = _useState[1];
  // Effect to update background image based on the breakpoint
  useEffect(function () {
    setBackground("url('" + (is_mobile ? images.mobile : images.desktop) + "')");
  }, [is_mobile, images]);
  return React.createElement("section", {
    id: "hero-section",
    "data-testid": "hero-section",
    className: "relative w-full max-w-[1180px] py-12 " + className
  }, React.createElement("div", {
    className: "absolute inset-0 w-full h-full bg-cover bg-center",
    style: {
      backgroundImage: background
    }
  }), React.createElement("div", {
    className: "absolute " + (is_mobile ? 'bottom-8' : 'top-1/2 transform -translate-y-1/2') + " w-full"
  }, React.createElement(Typography, {
    allBold: true,
    size: is_mobile ? '3xl' : '4xl',
    className: " mb-3 " + (is_mobile ? 'max-w-[260px] pl-4' : 'max-w-[468px]')
  }, title), subtitle && React.createElement(Typography, {
    variant: "secondary",
    size: is_mobile ? 'xl' : '2xl',
    className: " " + (is_mobile ? 'max-w-[260px] pl-4' : 'max-w-[550px]') + " break-words whitespace-normal"
  }, subtitle), React.createElement("div", {
    className: "mt-10 " + (is_mobile ? 'overflow-x-auto' : '') + " w-full"
  }, React.createElement(HomepageStats, {
    cards_data: cards_data,
    is_mobile: is_mobile
  }))));
};

var SecondaryEventCard = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var className = _ref.className,
    chips = _ref.chips,
    card_data = _ref.card_data,
    heading_text = _ref.heading_text,
    image_url = _ref.image_url,
    logo_url = _ref.logo_url,
    network_info = _ref.network_info,
    company_name = _ref.company_name,
    protected_logo = _ref.protected_logo,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'project-card' : _ref$id,
    has_cut_corners = _ref.has_cut_corners,
    _ref$announced = _ref.announced,
    announced = _ref$announced === void 0 ? true : _ref$announced,
    handleBtnClick = _ref.handleBtnClick,
    handleCardClick = _ref.handleCardClick,
    unannounced_btn_text = _ref.unannounced_btn_text,
    company_logo = _ref.company_logo,
    _ref$project_type = _ref.project_type,
    project_type = _ref$project_type === void 0 ? ProjectType.None : _ref$project_type;
  var _useState = useState(true),
    logo_loading = _useState[0],
    setLogoLoading = _useState[1];
  var _useState2 = useState(true),
    image_loading = _useState2[0],
    setImageLoading = _useState2[1];
  var image = useRef(null);
  var logo = useRef(null);
  var display_company_logo = project_type !== ProjectType.None ? company_logo : undefined;
  useEffect(function () {
    var _image$current;
    if ((_image$current = image.current) != null && _image$current.complete) setImageLoading(false);
  }, []);
  useEffect(function () {
    var _logo$current;
    if ((_logo$current = logo.current) != null && _logo$current.complete) setLogoLoading(false);
  }, []);
  return React.createElement("div", {
    onClick: handleCardClick,
    id: id,
    className: "low-border relative rounded cursor-pointer flex-grow flex-shrink basis-0 min-w-[334px]  " + (has_cut_corners ? 'cut-corner-card' : 'bg-surface-level-one hover:bg-surface-level-two') + " " + className,
    ref: ref
  }, React.createElement("div", {
    className: "relative p-[1px] " + (image_loading ? 'bg-surface-level-two aspect-[7/4] animate-pulse' : '')
  }, React.createElement("div", {
    className: "" + (has_cut_corners ? 'cut-image-for-card' : '')
  }, React.createElement("img", {
    ref: image,
    className: "h-full w-full " + (has_cut_corners ? '' : 'rounded-t'),
    src: image_url,
    alt: "card-img",
    onLoad: function onLoad() {
      return setImageLoading(false);
    }
  })), React.createElement("div", {
    className: "flex items-center justify-center w-20 h-20 bg-surface-level-zero low-border rounded absolute left-7 bottom-[-32px] " + (logo_loading ? 'animate-pulse' : '')
  }, React.createElement("img", {
    alt: "logo-img",
    ref: logo,
    src: logo_url,
    className: "h-[52px] w-[52px]",
    onLoad: function onLoad() {
      return setLogoLoading(false);
    }
  }))), React.createElement("div", {
    className: "pb-7 px-7 pt-12"
  }, React.createElement("div", {
    className: "flex items-left space-x-2"
  }, chips.map(function (_ref2) {
    var text = _ref2.text,
      badge_color = _ref2.badge_color;
    return React.createElement(Chip, {
      key: "chip-" + text + "-" + badge_color,
      variant: badge_color
    }, text === 'Now live' ? React.createElement("span", {
      className: "flex space-x-2"
    }, React.createElement("span", {
      className: "relative flex h-3 w-3 my-auto"
    }, React.createElement("span", {
      className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"
    }), React.createElement("span", {
      className: "relative inline-flex rounded-full h-3 w-3 bg-primary"
    })), React.createElement("span", null, text)) : text, ' ');
  })), React.createElement("div", {
    className: "flex flex-col justify-between pt-[30px] sm:flex-row"
  }, React.createElement(Typography, {
    allBold: true,
    className: "mb-4 sm:mb-0",
    as: "h3",
    size: "2xl"
  }, heading_text), React.createElement("div", {
    className: "flex items-center space-x-2"
  }, React.createElement(EventIcons, {
    company_logo: display_company_logo,
    company_name: company_name,
    protected_logo: protected_logo,
    network_info: network_info,
    project_type: project_type
  }))), React.createElement("div", {
    className: "space-y-3 pt-4"
  }, announced && card_data ? card_data.map(function (_ref3, idx) {
    var label = _ref3.label,
      values = _ref3.values;
    return React.createElement(DataLines, {
      key: label + idx,
      label: label,
      values: values,
      variant: "default"
    });
  }) : React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "secondary",
    className: "py-2 w-full",
    size: "sm"
  }, "Join community to guess who."), React.createElement("button", {
    className: "py-2 w-full rounded-lg text-accent border border-accent",
    onClick: handleBtnClick
  }, unannounced_btn_text)))));
});
SecondaryEventCard.displayName = 'SecondaryEventCard';

var CountdownCard = function CountdownCard(_ref) {
  var stage = _ref.stage,
    target_date = _ref.target_date,
    is_mobile = _ref.is_mobile,
    has_accent_countdown = _ref.has_accent_countdown;
  return React.createElement(Card, {
    surface: "two",
    className: "relative overflow-hidden " + (is_mobile ? 'mb-[30px]' : 'mb-auto') + " " + (stage === EventStage.SnapshotPeriod || is_mobile && stage !== EventStage.WhitelistOpen || stage === EventStage.WhitelistOpen ? '' : 'mt-auto')
  }, React.createElement("div", {
    className: "overlay-gradient"
  }), React.createElement("div", {
    className: "w-full h-[123px]"
  }, React.createElement(Countdown, {
    target_date: target_date,
    has_accent_countdown: has_accent_countdown
  })));
};

var TextSection = function TextSection(_ref) {
  var company_logo = _ref.company_logo,
    protected_logo = _ref.protected_logo,
    network_info = _ref.network_info,
    is_mobile = _ref.is_mobile,
    company_name = _ref.company_name,
    description = _ref.description,
    title = _ref.title,
    project_type = _ref.project_type;
  return React.createElement("div", null, React.createElement("div", {
    className: "flex items-center space-x-5 " + (!is_mobile ? 'pb-5' : '')
  }, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, title), !is_mobile && React.createElement(EventIcons, {
    company_logo: company_logo,
    company_name: company_name,
    protected_logo: protected_logo,
    network_info: network_info,
    project_type: project_type
  })), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    style: {
      display: '-webkit-box',
      WebkitLineClamp: 2,
      WebkitBoxOrient: 'vertical',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  }, description), is_mobile && React.createElement(EventIcons, {
    company_logo: company_logo,
    company_name: company_name,
    protected_logo: protected_logo,
    network_info: network_info,
    expanded: true,
    project_type: project_type,
    className: "mt-5 mb-5"
  }));
};

var CompleteCard = function CompleteCard(_ref) {
  var raised_stats = _ref.raised_stats,
    is_mobile = _ref.is_mobile;
  return React.createElement(Card, {
    surface: "two",
    className: "p-5 relative overflow-hidden " + (is_mobile ? 'mb-[30px]' : 'mb-auto')
  }, React.createElement("div", {
    className: "overlay-gradient"
  }), React.createElement("div", {
    className: "relative z-10 space-y-2"
  }, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, raised_stats.total, " Raised"), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, raised_stats.percentage, "% raised")));
};

var EventProgress = function EventProgress(_ref) {
  var raised_stats = _ref.raised_stats,
    is_mobile = _ref.is_mobile;
  return React.createElement(Card, {
    surface: "two",
    className: "w-full py-5 pl-5 pr-14 relative overflow-hidden " + (is_mobile ? 'mb-[30px]' : 'mb-auto')
  }, React.createElement("div", {
    className: "overlay-gradient"
  }), React.createElement("div", {
    className: "relative z-20"
  }, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, raised_stats.total), React.createElement(Typography, {
    size: 'sm',
    variant: "secondary"
  }, raised_stats.percentage + "% of total goal " + raised_stats.target), React.createElement(Progress, {
    height: 'h-4',
    id: 'default',
    className: "mt-4",
    percent: raised_stats.percentage
  })));
};

var PrewhitelistCard = function PrewhitelistCard(_ref) {
  var ama_data = _ref.ama_data,
    is_mobile = _ref.is_mobile;
  var _useState = useState(false),
    card_hover = _useState[0],
    setCardHover = _useState[1];
  return React.createElement(Card, {
    border: false,
    onClick: ama_data != null && ama_data.youtube_url ? function () {
      return window.open(ama_data == null ? void 0 : ama_data.youtube_url, '_blank');
    } : undefined,
    onMouseEnter: function onMouseEnter() {
      return setCardHover(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setCardHover(false);
    },
    className: "p-5 bg-surface-level-two relative overflow-hidden " + (is_mobile ? 'mb-[30px]' : 'mb-auto') + " " + (card_hover && ama_data.show_ama_live ? 'border border-accent border-opacity-[0.3]' : 'low-border') + " " + (ama_data != null && ama_data.youtube_url ? 'cursor-pointer' : '')
  }, React.createElement("div", {
    className: "overlay-gradient"
  }), (ama_data.show_ama_live || ama_data.is_completed) && card_hover && !is_mobile && React.createElement("div", {
    className: "absolute left-[70%] top-1/2 transform -translate-y-1/2 bg-accent h-[64px] w-[64px] rounded-full shadow-accent border border-accent border-opacity-5 flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "play-arrow",
    className: "z-20 h-[22px]"
  })), is_mobile && ama_data.show_ama_live && React.createElement("div", {
    className: "absolute left-[72%] bottom-[80px] bg-accent h-[52px] w-[52px] rounded-full shadow-accent border border-accent border-opacity-5 flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "play-arrow",
    className: "z-20 h-[18px]"
  })), ama_data.show_ama_live && React.createElement("div", {
    className: "flex space-x-[10px] mb-5 relative z-20"
  }, React.createElement("span", {
    className: "relative flex h-4 w-4 my-auto"
  }, React.createElement("span", {
    className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-accent opacity-75"
  }), React.createElement("span", {
    className: "relative inline-flex rounded-full h-4 w-4 bg-accent"
  })), React.createElement(Typography, {
    allBold: true
  }, "Now live")), React.createElement(Typography, {
    className: "mb-5 relative z-10",
    allBold: true,
    size: "3xl"
  }, ama_data.title), React.createElement("div", {
    className: "flex space-x-2 items-center mb-[10px] relative z-20"
  }, React.createElement("div", {
    className: "w-8 h-8 flex iteems-center justify-center rounded-full low-border bg-surface-level-two"
  }, React.createElement(Media, {
    variant: "calendar",
    size: 0,
    className: "w-[14px] text-primary"
  })), React.createElement(Typography, {
    variant: "secondary"
  }, ama_data.date)), React.createElement("div", {
    className: "flex space-x-2 items-center relative z-20"
  }, React.createElement("div", {
    className: "w-8 h-8 flex items-center justify-center rounded-full low-border bg-surface-level-two"
  }, React.createElement(Media, {
    size: 0,
    className: "w-[20px] text-primary",
    variant: "youtube"
  })), React.createElement(Typography, {
    variant: "secondary"
  }, "Youtube")));
};

var TermsSection$1 = function TermsSection(_ref) {
  var saft_url = _ref.saft_url,
    terms_url = _ref.terms_url;
  return React.createElement("div", {
    className: "mb-auto mt-auto"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "By clicking \u2018Whitelist now\u2019 you agree to", ' ', React.createElement("a", {
    className: "hover:underline text-accent",
    href: terms_url,
    rel: "noreferrer",
    target: "_blank"
  }, "Terms and Conditions"), saft_url && React.createElement(React.Fragment, null, ' ', "and", ' ', React.createElement("a", {
    className: "hover:underline text-accent",
    href: saft_url,
    rel: "noreferrer",
    target: "_blank"
  }, "SAFT")), ' ', "and fully understand the risks."), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] mt-[10px]"
  }));
};

var Chips = function Chips(_ref) {
  var chips = _ref.chips,
    className = _ref.className;
  return React.createElement("div", {
    className: "space-x-[10px] flex items-center " + className
  }, chips.map(function (_ref2) {
    var text = _ref2.text,
      badge_color = _ref2.badge_color;
    return React.createElement(Chip, {
      key: "chip-" + text + "-" + badge_color,
      variant: badge_color
    }, text === 'Now live' ? React.createElement("span", {
      className: "flex space-x-2"
    }, React.createElement("span", {
      className: "relative flex h-3 w-3 my-auto"
    }, React.createElement("span", {
      className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"
    }), React.createElement("span", {
      className: "relative inline-flex rounded-full h-3 w-3 bg-primary"
    })), React.createElement("span", null, text)) : text, ' ');
  }));
};

var EventStage;
(function (EventStage) {
  EventStage["PreWhitelist"] = "PreWhitelist";
  EventStage["WhitelistOpen"] = "WhitelistOpen";
  EventStage["SnapshotPeriod"] = "SnapshotPeriod";
  EventStage["GaFcfsOpen"] = "GaFcfsOpen";
  EventStage["Complete"] = "Complete";
})(EventStage || (EventStage = {}));
function mapDataToRows(data, num_per_row) {
  var rows = [];
  for (var i = 0; i < data.length; i += num_per_row) {
    rows.push(data.slice(i, i + num_per_row));
  }
  return rows;
}
function mapDataToColumns(data, num_per_row) {
  // Step 1: Map data into rows using the existing function
  var rows = mapDataToRows(data, num_per_row);
  // Step 2: Determine the maximum number of columns needed
  var num_columns = Math.max.apply(Math, rows.map(function (row) {
    return row.length;
  }));
  // Step 3: Initialize an array for columns
  var columns = Array.from({
    length: num_columns
  }, function () {
    return [];
  });
  // Step 4: Distribute items from rows into their respective columns
  rows.forEach(function (row) {
    row.forEach(function (item, index) {
      columns[index].push(item);
    });
  });
  return columns;
}
// for non mobile the spacing is done with auto, but for mobile we apply specific margins to mostly the bottom of each section
// for example countdown card and raised stats card have margin bottom when in mobile but otherwise it will have margin auto
// most sections will have something like this  ${is_mobile ? 'mb-[30px]' : 'mb-auto'}
var MainEventCard = function MainEventCard(_ref) {
  var className = _ref.className,
    company_logo = _ref.company_logo,
    protected_logo = _ref.protected_logo,
    network_info = _ref.network_info,
    title = _ref.title,
    chips = _ref.chips,
    description = _ref.description,
    data = _ref.data,
    primary_button = _ref.primary_button,
    secondary_button = _ref.secondary_button,
    _ref$terms_url = _ref.terms_url,
    terms_url = _ref$terms_url === void 0 ? '' : _ref$terms_url,
    _ref$saft_url = _ref.saft_url,
    saft_url = _ref$saft_url === void 0 ? '' : _ref$saft_url,
    target_date = _ref.target_date,
    ama_data = _ref.ama_data,
    text = _ref.text,
    raised_stats = _ref.raised_stats,
    stage = _ref.stage,
    show_terms = _ref.show_terms,
    has_accent_countdown = _ref.has_accent_countdown,
    company_name = _ref.company_name,
    image = _ref.image,
    video = _ref.video,
    marketing_event_data = _ref.marketing_event_data,
    socials = _ref.socials,
    whitelisted_participants = _ref.whitelisted_participants,
    event_type = _ref.event_type,
    show_token_claim_terms = _ref.show_token_claim_terms,
    project_type = _ref.project_type;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1150;
  var is_token_claim = event_type === EventType.TokenClaim;
  var mapped_data = useMemo(function () {
    var num_per_row = is_mobile ? 1 : 2;
    return mapDataToColumns(data, num_per_row);
  }, [data, is_mobile]);
  var _useState = useState(false),
    is_video_playing = _useState[0],
    set_is_video_playing = _useState[1];
  var video_ref = useRef(null);
  var toggleVideoPlayback = function toggleVideoPlayback() {
    if (video_ref.current) {
      var _video_ref$current;
      if ((_video_ref$current = video_ref.current) != null && _video_ref$current.paused) {
        var _video_ref$current2;
        (_video_ref$current2 = video_ref.current) == null || _video_ref$current2.play();
        set_is_video_playing(true);
      } else {
        var _video_ref$current3;
        (_video_ref$current3 = video_ref.current) == null || _video_ref$current3.pause();
        set_is_video_playing(false);
      }
    }
  };
  return React.createElement(Card, {
    className: "max-w-[1180px] min-h-[559px] " + (is_mobile ? '' : 'flex') + " " + className
  }, React.createElement("div", {
    className: "relative " + (is_mobile ? 'w-full' : 'max-w-[732px] max-h-[412px]')
  }, video ? React.createElement("div", {
    className: "relative " + (is_mobile ? 'w-full aspect-video' : 'w-full h-[412px]') + " overflow-hidden"
  }, React.createElement("video", {
    poster: image,
    ref: video_ref,
    className: "w-full h-full object-cover " + (is_mobile ? 'rounded-t-lg' : 'rounded-tl-lg'),
    onPlay: function onPlay() {
      return set_is_video_playing(true);
    },
    onPause: function onPause() {
      return set_is_video_playing(false);
    },
    onEnded: function onEnded() {
      return set_is_video_playing(false);
    },
    preload: "metadata",
    style: {
      objectFit: 'cover',
      width: '100%',
      height: '100%'
    }
  }, React.createElement("source", {
    src: video,
    type: "video/mp4"
  }), "Your browser does not support the video tag."), video && React.createElement("button", {
    className: "absolute bottom-3 left-5 z-10",
    onClick: toggleVideoPlayback
  }, React.createElement(Media, {
    variant: is_video_playing ? 'stop-video' : 'play-video',
    size: 25,
    className: "text-white"
  }))) : React.createElement("img", {
    className: "h-full w-full object-cover " + (is_mobile ? 'rounded-t-lg' : 'rounded-tl-lg'),
    src: image,
    alt: "project-image"
  }), !is_mobile && React.createElement("div", {
    className: "absolute top-5 left-5"
  }, React.createElement(Chips, {
    chips: chips
  })), !is_mobile && React.createElement("div", {
    className: "p-5 h-[147px] bg-bottom-zero-top-transparent"
  }, React.createElement(TextSection, {
    title: title,
    company_logo: company_logo,
    protected_logo: protected_logo,
    network_info: network_info,
    is_mobile: is_mobile,
    company_name: company_name,
    description: description,
    project_type: project_type
  }))), React.createElement("div", null, React.createElement(motion.div, {
    key: company_name,
    initial: {
      opacity: 0
    },
    animate: {
      opacity: 1
    },
    exit: {
      opacity: 0
    },
    transition: {
      duration: 0.6
    },
    className: "p-5 flex flex-col " + (is_mobile ? "w-full" : 'w-[448px] h-[559px]')
  }, is_mobile && React.createElement(Chips, {
    chips: chips,
    className: "mb-8"
  }), is_mobile && React.createElement(TextSection, {
    title: title,
    company_logo: company_logo,
    protected_logo: protected_logo,
    network_info: network_info,
    is_mobile: is_mobile,
    company_name: company_name,
    description: description,
    project_type: project_type
  }), (stage === EventStage.GaFcfsOpen || stage === EventStage.Complete || stage === EventStage.SnapshotPeriod || stage === EventStage.WhitelistOpen) && React.createElement(Typography, {
    className: "flex items-center " + (stage === EventStage.SnapshotPeriod || stage == EventStage.GaFcfsOpen || stage === EventStage.Complete || stage === EventStage.WhitelistOpen ? 'mb-5' : ''),
    variant: "secondary"
  }, text), stage === EventStage.Complete && is_token_claim && React.createElement(Card, {
    surface: "two",
    className: "p-5 relative overflow-hidden " + (is_mobile ? 'mb-[30px]' : 'mb-auto')
  }, ' ', React.createElement("div", {
    className: "overlay-gradient"
  }), React.createElement("div", {
    className: "relative z-10 space-y-2"
  }, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, whitelisted_participants), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Whitelisted participants"))), stage === EventStage.Complete && raised_stats && React.createElement(CompleteCard, {
    raised_stats: raised_stats,
    is_mobile: is_mobile
  }), stage === EventStage.GaFcfsOpen && raised_stats && React.createElement(EventProgress, {
    raised_stats: raised_stats,
    is_mobile: is_mobile
  }), (stage === EventStage.SnapshotPeriod || stage === EventStage.WhitelistOpen) && target_date && React.createElement(CountdownCard, {
    has_accent_countdown: has_accent_countdown,
    stage: stage,
    target_date: target_date,
    is_mobile: is_mobile
  }), stage === EventStage.PreWhitelist && ama_data && React.createElement(PrewhitelistCard, {
    ama_data: ama_data,
    is_mobile: is_mobile
  }), stage === EventStage.PreWhitelist && !ama_data && marketing_event_data && React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary"
  }, marketing_event_data.title), React.createElement("a", {
    href: marketing_event_data.link,
    key: JSON.stringify(marketing_event_data.link),
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    className: "rounded-lg mt-5 mx-auto low-border " + (is_mobile ? 'mb-5' : ''),
    src: marketing_event_data.image,
    alt: "marketing-event-image"
  }))), React.createElement("div", {
    className: " flex justify-between my-auto " + (is_mobile ? 'mb-[30px] px-2' : 'mt-auto px-8')
  }, mapped_data.map(function (col_data) {
    return React.createElement("div", {
      className: "space-y-8",
      key: JSON.stringify(col_data)
    }, col_data.map(function (_ref2) {
      var label = _ref2.label,
        value = _ref2.value,
        handleClick = _ref2.handleClick,
        button_text = _ref2.button_text;
      return React.createElement("div", {
        key: JSON.stringify({
          label: label,
          value: value,
          button_text: button_text
        })
      }, React.createElement("div", {
        className: "flex space-x-2"
      }, React.createElement(Typography, {
        size: "xl",
        allBold: true
      }, value), handleClick && button_text && React.createElement("button", {
        onClick: handleClick,
        className: "text-accent underline"
      }, button_text)), React.createElement(Typography, {
        variant: "secondary"
      }, label));
    }));
  })), socials && socials.length > 0 && (stage === EventStage.WhitelistOpen || stage === EventStage.SnapshotPeriod || stage === EventStage.GaFcfsOpen || stage === EventStage.Complete) && !is_mobile && React.createElement("div", {
    className: "flex items-center justify-center space-x-[44px] my-auto"
  }, socials.slice(0, 5).map(function (_ref3) {
    var name = _ref3.name,
      url = _ref3.url;
    return React.createElement("a", {
      href: (name === 'mail' && 'mailto:' || '') + url,
      key: JSON.stringify({
        name: name,
        url: url
      }),
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Media, {
      size: 6,
      className: "text-secondary hover:text-primary",
      variant: name
    }));
  })), socials && socials.length > 0 && stage === EventStage.PreWhitelist && !ama_data && marketing_event_data && React.createElement("div", {
    className: "flex items-center justify-center space-x-[45px] mb-8"
  }, socials.slice(0, 5).map(function (_ref4) {
    var name = _ref4.name,
      url = _ref4.url;
    return React.createElement("a", {
      href: (name === 'mail' && 'mailto:' || '') + url,
      key: JSON.stringify({
        name: name,
        url: url
      }),
      target: "_blank",
      rel: "noopener noreferrer"
    }, React.createElement(Media, {
      size: 6,
      className: "text-secondary hover:text-primary",
      variant: name
    }));
  })), React.createElement("div", {
    className: (!(stage === EventStage.PreWhitelist && !ama_data) ? 'mt-auto' : '') + " space-y-5"
  }, React.createElement(Button, {
    onClick: primary_button.handleClick,
    loading: primary_button.loading,
    disabled: primary_button.disabled,
    className: "w-full"
  }, primary_button.text), stage === EventStage.WhitelistOpen && show_terms && React.createElement(TermsSection$1, {
    saft_url: saft_url,
    terms_url: terms_url
  }), stage === EventStage.Complete && is_token_claim && show_token_claim_terms && React.createElement("div", {
    className: "mb-auto mt-auto"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "xs"
  }, "Accept the token to view and claim the in your portfolio."), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] mt-[10px]"
  })), (stage === EventStage.GaFcfsOpen || stage === EventStage.WhitelistOpen || stage === EventStage.Complete) && secondary_button && React.createElement("div", {
    className: "flex items-center cursor-pointer justify-center space-x-[12px] text-secondary"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    onClick: secondary_button.handleClick
  }, secondary_button.text), React.createElement(Media, {
    variant: "arrow-right",
    size: 0,
    className: "h-[17px]"
  }))))));
};

// note: the id's need to match the enum CompletedEventSortKey in the platform code
var header_values = function header_values(is_mobile, is_crowdfunding) {
  return [{
    id: 'event',
    name: 'Event',
    className: is_mobile ? 'w-[18%]' : 'float-left w-[26%]'
  }, {
    id: 'FDV',
    name: 'FDV',
    className: 'w-[13%]',
    has_chevron: true,
    info: 'some info text'
  }, {
    id: is_crowdfunding ? 'ATH_ROI' : 'ATH',
    name: is_crowdfunding ? 'ATH ROI' : 'ATH',
    className: 'w-[13%]',
    has_chevron: true
  }, {
    id: is_crowdfunding ? 'TOTAL_RAISED' : 'TOTAL_DISTRIBUTED',
    name: is_crowdfunding ? 'Total Raised' : 'Total Distributed',
    className: is_mobile ? 'w-[24%]' : 'w-[16%]',
    has_chevron: true
  }, {
    id: 'NUM_WHITELISTED',
    name: 'Participants',
    className: 'w-[12%]',
    has_chevron: true
  }, {
    id: 'ENDED_DATE',
    name: 'End date',
    className: 'w-[11%]',
    has_chevron: true
  }, {
    id: 'NETWORK_LOGO',
    name: 'Network',
    className: 'w-[8%] text-right'
  }];
};

var EventsHeader = function EventsHeader(_ref) {
  var selected_sort_order = _ref.selected_sort_order,
    className = _ref.className,
    is_mobile = _ref.is_mobile,
    is_crowdfunding = _ref.is_crowdfunding,
    setSelectedSortKey = _ref.setSelectedSortKey,
    setSelectedSortOrder = _ref.setSelectedSortOrder,
    selected_sort_key = _ref.selected_sort_key;
  return React.createElement("div", {
    className: "flex mb-2 px-5 " + className
  }, header_values(is_mobile, is_crowdfunding).map(function (_ref2, idx) {
    var name = _ref2.name,
      className = _ref2.className,
      has_chevron = _ref2.has_chevron,
      id = _ref2.id;
    var sort_order = id === selected_sort_key ? selected_sort_order : SortOrder.DESC;
    return has_chevron ? React.createElement("div", {
      className: className + " flex items-center",
      key: name + "-" + idx + "-" + id
    }, React.createElement(Typography, {
      variant: "secondary"
    }, name), React.createElement("button", {
      onClick: function onClick() {
        setSelectedSortKey(id);
        setSelectedSortOrder(id === selected_sort_key ? selected_sort_order === SortOrder.ASC ? SortOrder.DESC : SortOrder.ASC : SortOrder.DESC);
      }
    }, React.createElement(Media, {
      size: 5,
      variant: sort_order === SortOrder.ASC ? 'chevron-up' : 'chevron-down',
      className: "text-accent ml-2 " + (id === selected_sort_key ? 'text-accent' : 'text-secondary')
    }))) : React.createElement(Typography, {
      className: className,
      variant: "secondary",
      key: name
    }, is_mobile && id === 'event' ? '' : name);
  }));
};

var MAX_VISIBLE_PAGES = 3;
var Pagination = function Pagination(_ref) {
  var current_page = _ref.current_page,
    total_pages = _ref.total_pages,
    onPageChange = _ref.onPageChange,
    is_mobile = _ref.is_mobile;
  var start_pages = Array.from({
    length: Math.min(MAX_VISIBLE_PAGES, total_pages)
  }, function (_, index) {
    return index + 1;
  });
  return React.createElement("div", {
    className: "flex justify-center items-center mt-4 space-x-[30px]"
  }, !is_mobile && React.createElement("button", {
    className: "text-md " + (current_page === 1 ? 'text-secondary' : 'text-primary'),
    onClick: function onClick() {
      return onPageChange(1);
    },
    disabled: current_page === 1
  }, "First"), React.createElement(Button, {
    variant: "custom",
    onClick: function onClick() {
      return onPageChange(current_page - 1);
    },
    disabled: current_page === 1,
    className: "h-[44px] w-[44px] bg-surface-level-three"
  }, React.createElement(Media, {
    size: 0,
    className: "w-[18px] h-[17px] text-primary",
    variant: "chevron-left"
  })), React.createElement("div", {
    className: "flex space-x-[30px]"
  }, start_pages.map(function (page) {
    return React.createElement("div", {
      className: "text-md cursor-pointer " + (current_page === page ? 'text-secondary' : 'text-primary'),
      key: page + "-pagination",
      onClick: function onClick() {
        return onPageChange(page);
      }
    }, page);
  }), total_pages > MAX_VISIBLE_PAGES + 1 && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "text-md text-primary"
  }, ". . ."), React.createElement("div", {
    className: "text-md cursor-pointer " + (current_page === total_pages ? 'text-secondary' : 'text-primary'),
    onClick: function onClick() {
      return onPageChange(total_pages);
    }
  }, total_pages)), total_pages === MAX_VISIBLE_PAGES + 1 && React.createElement("div", {
    className: "text-md cursor-pointer " + (current_page === total_pages ? 'text-secondary' : 'text-primary'),
    onClick: function onClick() {
      return onPageChange(total_pages);
    }
  }, total_pages)), React.createElement(Button, {
    variant: "custom",
    onClick: function onClick() {
      return onPageChange(current_page + 1);
    },
    disabled: current_page === total_pages,
    className: "h-[44px] w-[44px] bg-surface-level-three"
  }, React.createElement(Media, {
    size: 0,
    className: "w-[18px] h-[17px] text-primary",
    variant: "chevron-right"
  })), !is_mobile && React.createElement("button", {
    className: "text-md " + (current_page === total_pages ? 'text-secondary' : 'text-primary'),
    onClick: function onClick() {
      return onPageChange(total_pages);
    },
    disabled: current_page === total_pages
  }, "Last"));
};
Pagination.displayName = 'Pagination';

var LoadingItem = function LoadingItem(_ref) {
  var is_mobile = _ref.is_mobile;
  return React.createElement(Card, {
    className: "p-5 flex"
  }, React.createElement("div", {
    className: is_mobile ? 'w-[18%]' : 'w-[26%]'
  }, !is_mobile && React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: "w-[13%]"
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: "w-[13%]"
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: is_mobile ? 'w-[24%]' : 'w-[16%]'
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: "w-[12%]"
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: "w-[11%]"
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%]"
  })), React.createElement("div", {
    className: "w-[9%]"
  }, React.createElement("div", {
    className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[75%] ml-auto"
  })));
};
var LoadingItems = function LoadingItems(_ref2) {
  var items_arr = _ref2.items_arr,
    is_mobile = _ref2.is_mobile;
  return React.createElement(React.Fragment, null, items_arr.map(function (string) {
    return React.createElement(LoadingItem, {
      key: string,
      is_mobile: is_mobile
    });
  }));
};

var MobileEventOverlay = function MobileEventOverlay(_ref) {
  var is_loading = _ref.is_loading,
    items_to_render = _ref.items_to_render,
    event_list_data = _ref.event_list_data,
    overlay_height = _ref.overlay_height;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "absolute -left-[2px] h-[24px] w-[152px] top-0 bg-surface-level-zero z-30"
  }), React.createElement("div", {
    className: "absolute -left-[2px] w-[152px] bg-surface-level-one space-y-[16px] rounded-tl-lg rounded-bl-lg z-50",
    style: {
      height: overlay_height + "px"
    }
  }, is_loading ? React.createElement(React.Fragment, null, items_to_render.map(function (key, idx) {
    var is_last_item = idx === items_to_render.length - 1;
    return React.createElement("div", {
      key: key + "-" + idx,
      className: "border-y low-border h-[87px] rounded-l-lg flex items-center pl-5 pr-1 " + (idx === 0 ? 'top-right-shadow ' : 'right-shadow') + " " + (is_last_item ? 'bottom-right-shadow' : 'right-shadow')
    }, React.createElement("div", {
      className: "flex items-center w-full"
    }, React.createElement("div", {
      className: "h-[45px] bg-surface-level-two animate-pulse rounded w-[100px]"
    })));
  })) : React.createElement(React.Fragment, null, event_list_data.map(function (_ref2, idx) {
    var name = _ref2.name,
      token_symbol = _ref2.token_symbol;
    var is_last_item = idx === event_list_data.length - 1;
    return React.createElement("div", {
      key: name + "-" + idx + "-" + token_symbol,
      className: "border-y low-border h-[87px] rounded-l-lg flex items-center pl-5 pr-2 " + (idx === 0 ? 'top-right-shadow ' : 'right-shadow') + " " + (is_last_item ? 'bottom-right-shadow' : 'right-shadow')
    }, React.createElement(Typography, {
      style: {
        display: '-webkit-box',
        WebkitLineClamp: 3,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      },
      allBold: true
    }, name));
  }))));
};

var SortOrder;
(function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
// if the width percentage of any of the sections is chnaged it needs to be updated in the LoadingItem and EventsHeader components as well
var CompletedEventsInfoHeader = function CompletedEventsInfoHeader() {
  return React.createElement("div", null, React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, "Completed events"), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-[10px]"
  }, "We bring the best quality projects to our community."));
};
var CompletedEvents = function CompletedEvents(_ref) {
  var className = _ref.className,
    event_list_data = _ref.event_list_data,
    selected_sort_order = _ref.selected_sort_order,
    selected_sort_key = _ref.selected_sort_key,
    setSelectedSortKey = _ref.setSelectedSortKey,
    nav = _ref.nav,
    setNav = _ref.setNav,
    nav_options = _ref.nav_options,
    total_events = _ref.total_events,
    current_page = _ref.current_page,
    setCurrentPage = _ref.setCurrentPage,
    setSelectedSortOrder = _ref.setSelectedSortOrder,
    is_loading = _ref.is_loading,
    scrollToTop = _ref.scrollToTop;
  var _useState = useState(0),
    overlay_height = _useState[0],
    setOverlayHeight = _useState[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1100;
  var items_per_page = 6;
  var total_pages = Math.ceil(total_events / items_per_page);
  var handlePageChange = function handlePageChange(page) {
    setCurrentPage(page);
    scrollToTop();
  };
  var is_crowdfunding = nav === EventType.Crowdfunding;
  var items_to_show = Math.min(items_per_page, total_events - (current_page - 1) * items_per_page);
  var items_to_render = Array.from({
    length: items_to_show
  }, function (_, idx) {
    return "loading-item-" + idx;
  }); // generate array of distinct keys for the mapping
  useEffect(function () {
    var item_height = 86; // px
    var space_between_items = 16; // px
    var height = item_height * items_to_show + space_between_items * (items_to_show - 1);
    setOverlayHeight(height);
  }, [items_to_show]);
  return React.createElement("div", {
    className: "w-full max-w-[1180px] " + className
  }, React.createElement(CompletedEventsInfoHeader, null), React.createElement(Tabs, {
    className: "max-w-[270px] mt-5",
    options: nav_options,
    current: nav,
    setCurrent: setNav
  }), React.createElement("div", {
    className: "relative " + (is_mobile ? 'mt-[20px]' : 'mt-[48px]')
  }, React.createElement("div", {
    className: "" + (is_mobile ? 'overflow-y-scroll' : '')
  }, React.createElement(EventsHeader, {
    is_crowdfunding: is_crowdfunding,
    className: "" + (is_mobile ? 'w-[1170px]' : ''),
    selected_sort_order: selected_sort_order,
    is_mobile: is_mobile,
    selected_sort_key: selected_sort_key,
    setSelectedSortKey: setSelectedSortKey,
    setSelectedSortOrder: setSelectedSortOrder
  }), React.createElement("div", {
    className: (is_mobile ? 'w-[1170px]' : '') + " ",
    id: "completed_events_container",
    "data-testid": "completed_events_container"
  }, is_mobile && React.createElement(MobileEventOverlay, {
    is_loading: is_loading,
    items_to_render: items_to_render,
    event_list_data: event_list_data,
    overlay_height: overlay_height
  }), React.createElement("div", {
    className: "space-y-[16px]"
  }, is_loading ? React.createElement(LoadingItems, {
    items_arr: items_to_render,
    is_mobile: is_mobile
  }) : React.createElement(React.Fragment, null, event_list_data.map(function (event) {
    var network_logo = event.network_logo,
      athroi = event.athroi,
      end_date = event.end_date,
      fvd = event.fvd,
      name = event.name,
      participants = event.participants,
      token_symbol = event.token_symbol,
      total_raised = event.total_raised,
      ath = event.ath,
      total_distributed = event.total_distributed,
      handleEventClick = event.handleEventClick,
      logo = event.logo;
    return React.createElement(Card, {
      className: "p-5 cursor-pointer",
      surface: "one",
      onClick: handleEventClick,
      key: JSON.stringify(event)
    }, React.createElement("div", {
      className: "flex"
    }, React.createElement("div", {
      className: (is_mobile ? 'w-[18%]' : 'w-[26%]') + " flex items-center space-x-5"
    }, React.createElement("img", {
      className: 'h-11 w-11',
      src: logo,
      alt: name + "-" + logo + "-img"
    }), React.createElement("div", null, React.createElement(Typography, null, is_mobile ? '' : name), React.createElement(Typography, {
      size: "xs",
      variant: "secondary"
    }, token_symbol))), React.createElement("div", {
      className: "flex items-center w-[13%]"
    }, React.createElement(Typography, null, fvd)), React.createElement("div", {
      className: "w-[13%] my-auto"
    }, React.createElement(Typography, {
      allBold: true,
      className: "" + (is_crowdfunding ? athroi == null ? void 0 : athroi.color : ath == null ? void 0 : ath.color),
      variant: "custom"
    }, is_crowdfunding ? athroi == null ? void 0 : athroi.value : ath == null ? void 0 : ath.value)), React.createElement("div", {
      className: (is_mobile ? 'w-[24%]' : 'w-[16%]') + " my-auto"
    }, React.createElement(Typography, null, is_crowdfunding && total_raised ? total_raised.top_value : total_distributed), total_raised && React.createElement(Typography, {
      variant: "secondary",
      size: "sm"
    }, total_raised.bottom_value)), React.createElement("div", {
      className: "w-[12%] my-auto"
    }, React.createElement(Typography, null, participants)), React.createElement("div", {
      className: "w-[11%] my-auto"
    }, React.createElement(Typography, null, end_date.top_date), React.createElement(Typography, {
      variant: "secondary",
      size: "sm"
    }, end_date.bottom_time)), React.createElement("div", {
      className: "w-[8%] pr-3 flex justify-end my-auto"
    }, React.createElement("img", {
      className: "",
      src: network_logo,
      alt: "network-" + name
    }))));
  })))))), total_events > items_per_page && React.createElement(Pagination, {
    current_page: current_page,
    total_pages: total_pages,
    onPageChange: handlePageChange,
    is_mobile: is_mobile
  }));
};

var getEstimatedPercentage = function getEstimatedPercentage(actual_percent) {
  if (actual_percent < 5) {
    return actual_percent + 4;
  } else {
    return actual_percent - 4;
  }
};
var AllocationBar = function AllocationBar(_ref) {
  var lower_allocation_multiplier = _ref.lower_allocation_multiplier,
    upper_allocation_multiplier = _ref.upper_allocation_multiplier,
    _ref$progress_percent = _ref.progress_percent,
    progress_percent = _ref$progress_percent === void 0 ? 0 : _ref$progress_percent,
    className = _ref.className;
  // Calculate estimated progress percent
  var estimatedProgressPercent = getEstimatedPercentage(progress_percent);
  return React.createElement("div", {
    className: className + " relative px-[30px]"
  }, React.createElement("div", {
    className: "absolute left-0 top-1/2 transform -translate-y-1/2 flex items-center justify-center z-[20]"
  }, React.createElement(Typography, {
    variant: "primary",
    size: "sm",
    allBold: true,
    className: "px-2 py-1 right-dark-shadow bg-surface-level-one border border-surface-level-three rounded-lg"
  }, lower_allocation_multiplier, "x")), React.createElement("div", {
    className: "absolute right-0 top-1/2 transform -translate-y-1/2 flex items-center justify-center z-[20]"
  }, React.createElement(Typography, {
    variant: "primary",
    size: "sm",
    allBold: true,
    className: "px-2 py-1 left-dark-shadow border bg-surface-level-one border-surface-level-three rounded-lg"
  }, upper_allocation_multiplier, "x")), React.createElement("div", {
    className: "relative mt-[40px]"
  }, React.createElement(Progress, {
    has_lighter_bar: true,
    percent: estimatedProgressPercent,
    className: "bg-surface-level-three",
    height: "h-2",
    surface: "three"
  }), progress_percent !== undefined && React.createElement("div", {
    className: "absolute top-[-4px] transform -translate-x-1/2 flex items-center justify-center w-4 h-4 bg-accent rounded-full",
    style: {
      left: estimatedProgressPercent + "%"
    }
  }, React.createElement(Media, {
    variant: "dcb-power",
    size: 3
  }))));
};

var MyAllocationCard = function MyAllocationCard(_ref) {
  var handleClick = _ref.handleClick,
    message = _ref.message,
    current_allocation = _ref.current_allocation,
    current_tier = _ref.current_tier,
    next_tier = _ref.next_tier,
    lower_allocation_multiplier = _ref.lower_allocation_multiplier,
    upper_allocation_multiplier = _ref.upper_allocation_multiplier,
    progress_percent = _ref.progress_percent;
  return React.createElement("div", {
    className: "w-full"
  }, React.createElement(Accordion, {
    custom_padding: "py-4 px-5",
    subtitle: 'My allocation',
    has_brighter_header: true,
    className: "h-[61px]",
    is_defaulted_to_open: true
  }, !message ? React.createElement("div", {
    className: "pt-[30px]"
  }, React.createElement("div", null, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "My current allocation weight"), React.createElement(Typography, {
    allBold: true,
    size: "3xl"
  }, current_allocation, "x")), React.createElement(AllocationBar, {
    lower_allocation_multiplier: lower_allocation_multiplier,
    upper_allocation_multiplier: upper_allocation_multiplier,
    progress_percent: progress_percent
  }), React.createElement("div", {
    className: "flex justify-between pt-[20px]"
  }, React.createElement(Typography, {
    size: "sm",
    allBold: true
  }, current_tier), React.createElement(Typography, {
    size: "sm",
    allBold: true
  }, next_tier)), React.createElement(Button, {
    variant: "secondary",
    className: "w-full mt-[30px] font-bold",
    onClick: handleClick
  }, "Increase my allocation")) :
  // Message for users who are not logged in
  React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "pt-[30px]"
  }, message)));
};

var MainImage = function MainImage(_ref) {
  var image = _ref.image;
  if (!image) {
    return null;
  }
  return React.createElement("img", {
    src: image,
    alt: "main-image",
    className: "rounded-lg w-full h-auto"
  });
};
var Thumbnail$1 = function Thumbnail(_ref2) {
  var image = _ref2.image,
    onClick = _ref2.onClick,
    is_active = _ref2.is_active;
  if (!image) {
    return null;
  }
  return React.createElement("img", {
    src: image,
    className: "w-[135px] h-[76px] rounded-lg flex-none " + (is_active ? '' : 'opacity-50 hover:opacity-80'),
    onClick: onClick
  });
};
var ImageSlideshow = function ImageSlideshow(_ref3) {
  var _ref3$items = _ref3.items,
    items = _ref3$items === void 0 ? [] : _ref3$items,
    className = _ref3.className;
  var valid_items = items.filter(function (item) {
    return item.image && item.image.trim() !== '';
  });
  var _useState = useState(0),
    current = _useState[0],
    setCurrent = _useState[1];
  var _useState2 = useState(0),
    scrollIndex = _useState2[0],
    setScrollIndex = _useState2[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 911;
  var scrollRef = useRef(null);
  var handleScroll = function handleScroll() {
    if (scrollRef.current) {
      var _scrollRef$current = scrollRef.current,
        scrollLeft = _scrollRef$current.scrollLeft,
        clientWidth = _scrollRef$current.clientWidth;
      var totalWidth = scrollRef.current.scrollWidth;
      var number_of_images = valid_items.length || 1;
      var scrollFraction = scrollLeft / (totalWidth - clientWidth);
      var newIndex = Math.round(scrollFraction * (number_of_images - 1));
      setScrollIndex(newIndex);
    }
  };
  useEffect(function () {
    var scrollElement = scrollRef.current;
    if (!scrollElement) {
      return;
    }
    scrollElement.addEventListener('scroll', handleScroll);
    return function () {
      scrollElement.removeEventListener('scroll', handleScroll);
    };
  }, [valid_items]);
  return React.createElement("div", {
    className: "w-full " + className
  }, valid_items[current] && React.createElement(MainImage, {
    image: valid_items[current].image
  }), valid_items.length > 1 && React.createElement("div", {
    ref: scrollRef,
    className: "flex " + (is_mobile ? 'overflow-x-scroll' : valid_items.length >= 5 ? 'justify-between' : 'justify-start') + " gap-5 mt-5"
  }, valid_items.map(function (item, idx) {
    return React.createElement(Thumbnail$1, {
      key: idx,
      image: item.image,
      onClick: function onClick() {
        setCurrent(idx); // Update the current image
        setScrollIndex(idx); // Sync the scrollIndex to update the dot
      },
      is_active: idx === current
    });
  })), is_mobile && valid_items.length > 1 && React.createElement("div", {
    className: "flex justify-center mt-8 mx-auto"
  }, valid_items.map(function (_, index) {
    return React.createElement("div", {
      key: index,
      className: "w-2 h-2 rounded-full mx-[12px] " + (scrollIndex === index ? 'bg-primary' : 'bg-surface-level-four'),
      onClick: function onClick() {
        setCurrent(index); // When a dot is clicked, update the current image
        if (scrollRef.current) {
          var thumbnailWidth = scrollRef.current.scrollWidth / valid_items.length;
          scrollRef.current.scrollTo({
            left: thumbnailWidth * index,
            behavior: 'smooth'
          });
        }
      }
    });
  })));
};

var Login = function Login(_ref) {
  var setShow = _ref.setShow,
    show = _ref.show,
    loading = _ref.loading,
    state = _ref.state,
    handleChange = _ref.handleChange,
    handleClick = _ref.handleClick,
    handleCreateAccount = _ref.handleCreateAccount,
    handleForgotPassword = _ref.handleForgotPassword,
    is_disabled = _ref.is_disabled,
    errors = _ref.errors;
  var _useState = useState(false),
    show_password = _useState[0],
    setShowPassword = _useState[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false
  }, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, "Whitelist for the event"), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-8"
  }), ' ', (errors == null ? void 0 : errors.form) && React.createElement("div", null, React.createElement(Alert, {
    variant: "error"
  }, React.createElement("span", {
    className: "text-error"
  }, errors == null ? void 0 : errors.form))), state.stage === LoginStage.Login ? React.createElement(React.Fragment, null, React.createElement(Typography, {
    variant: "secondary",
    className: "my-3",
    size: is_mobile ? 'sm' : 'md'
  }, "Log in your account to whitelist for the event."), React.createElement(LoginContents, {
    disabled: is_disabled,
    loading: loading,
    state: state,
    handleChange: handleChange,
    handleClick: handleClick,
    show_password: show_password,
    setShowPassword: setShowPassword,
    has_forgot_password_btn: true,
    handleForgotPassword: handleForgotPassword
  }), React.createElement("button", {
    onClick: function onClick() {
      return setShow(false);
    },
    className: "mt-[32px] text-primary text-sm"
  }, "Cancel"), React.createElement("div", {
    className: "flex h-px flex-col justify-center items-start self-stretch bg-surface-level-two my-8"
  }), React.createElement(Typography, {
    size: "sm",
    variant: "custom",
    className: "text-accent cursor-pointer",
    onClick: handleCreateAccount
  }, "Create account")) : React.createElement(React.Fragment, null, React.createElement("div", {
    className: "w-full"
  }, React.createElement(Typography, {
    className: "mb-[16px] mt-8",
    variant: "secondary",
    size: "sm"
  }, "Enter two-factor authentication code from your authenticator app."), React.createElement(Input, {
    placeholder: "--- ---",
    surface: "zero",
    id: "code",
    type: "code",
    className: "mb-8",
    value: state.code,
    onChange: function onChange(e) {
      return handleChange('code', e.target.value);
    }
  })), React.createElement(Button, {
    loading: loading,
    onClick: handleClick,
    className: "mb-8 w-full bg-accent"
  }, "Verify code"), React.createElement("button", {
    onClick: function onClick() {
      return setShow(false);
    },
    className: " text-primary text-sm"
  }, "Cancel")));
};

var NotKYC = function NotKYC(_ref) {
  var Kyc_form_data = _ref.Kyc_form_data,
    handleVerify = _ref.handleVerify,
    handleChange = _ref.handleChange,
    state = _ref.state,
    loading = _ref.loading,
    show = _ref.show,
    setShow = _ref.setShow,
    disabled = _ref.disabled;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false
  }, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, "Whitelist for the event"), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-3",
    size: is_mobile ? 'sm' : 'md'
  }, "We notice that you haven\u2019t verified your ID yet. Verify it now to whitelist and participate the event."), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-8"
  }), React.createElement(Typography, {
    className: "text-left",
    size: is_mobile ? 'sm' : 'md'
  }, "To verify, you\u2019ll be asked to provide documents (e.g. passport, driving license, ID card). Ensure that the information provided below matches the details on your document."), React.createElement(KYCContents, {
    disabled: disabled,
    handleClick: handleVerify,
    handleChange: handleChange,
    state: state,
    loading: loading,
    Kyc_form_data: Kyc_form_data
  }), React.createElement("button", {
    onClick: function onClick() {
      return setShow(false);
    },
    className: "mt-8 text-primary text-sm"
  }, "Cancel"));
};

var ConnectWallet = function ConnectWallet(_ref) {
  var handleClick = _ref.handleClick,
    loading = _ref.loading,
    show = _ref.show,
    setShow = _ref.setShow,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    wallet_address = _ref.wallet_address,
    is_connected = _ref.is_connected,
    button_text = _ref.button_text;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false,
    className: "max-w-[640px] w-full px-4"
  }, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, title), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-3",
    size: is_mobile ? 'sm' : 'md'
  }, subtitle), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-8"
  }), React.createElement(Typography, {
    variant: "primary",
    className: "mt-5 text-left",
    size: is_mobile ? 'sm' : 'md'
  }, description), React.createElement(Card, {
    className: "mt-8 bg-surface-level-two w-full h-auto my-8"
  }, React.createElement("div", {
    className: "flex w-full " + (is_mobile ? 'flex-col items-start' : 'items-center justify-between')
  }, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement("div", {
    className: "relative rounded-full bg-surface-level-three\n               w-[48px] h-[48px] my-[10px] mx-5"
  }, React.createElement(Media, {
    variant: "wallet",
    size: 5,
    className: "absolute inset-0 m-auto text-primary"
  })), React.createElement("div", {
    className: "sm:flex text-left"
  }, React.createElement(Typography, {
    variant: "primary"
  }, wallet_address), is_connected !== undefined && (is_connected ? React.createElement(Typography, {
    className: "text-success " + (is_mobile ? 'mt-1' : 'hidden')
  }, "Connected") : React.createElement(Typography, {
    className: "text-error " + (is_mobile ? 'mt-1' : 'hidden'),
    variant: "custom"
  }, "Not connected")))), !is_mobile && React.createElement("div", {
    className: "mr-5"
  }, is_connected !== undefined && (is_connected ? React.createElement(Typography, {
    className: "text-success"
  }, "Connected") : React.createElement(Typography, {
    className: "text-error",
    variant: "custom"
  }, "Not connected"))))), React.createElement(Button, {
    loading: loading,
    onClick: handleClick,
    className: "mb-8 w-full bg-accent"
  }, button_text), React.createElement("button", {
    onClick: function onClick() {
      return setShow(false);
    },
    className: " text-primary text-sm"
  }, "Cancel"));
};

var Completed = function Completed(_ref) {
  var show = _ref.show,
    setShow = _ref.setShow,
    data = _ref.data,
    date_and_time = _ref.date_and_time;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false
  }, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    allBold: true,
    className: "mb-8"
  }, "You are whitelisted"), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-8"
  }), React.createElement(Typography, {
    className: "mt-8 text-left",
    size: "sm"
  }, "You are successfully whitelisted for this event.  Return to this page when the Guaranteed Allocation is live on " + date_and_time + " to proceed."), React.createElement(Typography, {
    className: "mt-8 text-left",
    variant: "secondary",
    size: "sm"
  }, "Currency required for the event"), data.map(function (_ref2, idx) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      key: label + "-" + value + "-" + idx,
      className: "text-left flex justify-between items-center md:grid md:grid-cols-2 md:gap-1"
    }, React.createElement(Typography, {
      variant: "secondary",
      size: "sm"
    }, label), React.createElement(Typography, {
      className: "font-bold text-primary",
      size: "sm"
    }, value));
  }), React.createElement(Button, {
    onClick: function onClick() {
      return setShow(false);
    },
    className: "mt-8 w-full bg-accent"
  }, "Got it"));
};

var MultiStepModal = function MultiStepModal(_ref) {
  var handleClick = _ref.handleClick,
    loading = _ref.loading,
    show = _ref.show,
    setShow = _ref.setShow,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    wallet_address = _ref.wallet_address,
    is_connected = _ref.is_connected,
    button_text = _ref.button_text,
    _ref$cancel_btn_text = _ref.cancel_btn_text,
    cancel_btn_text = _ref$cancel_btn_text === void 0 ? ' Cancel' : _ref$cancel_btn_text,
    no_close_btn = _ref.no_close_btn;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    },
    is_fixed_height: false,
    className: "max-w-[640px] w-full px-4"
  }, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    allBold: true
  }, title), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-3",
    size: is_mobile ? 'sm' : 'md'
  }, subtitle), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-8"
  }), React.createElement(Typography, {
    variant: "primary",
    className: "mt-5 mb-8",
    size: is_mobile ? 'sm' : 'md'
  }, description), wallet_address && React.createElement(Card, {
    className: "bg-surface-level-two w-full h-auto my-8"
  }, React.createElement("div", {
    className: "flex w-full " + (is_mobile ? 'flex-col items-start' : 'items-center justify-between')
  }, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement("div", {
    className: "relative rounded-full bg-surface-level-three\n               w-[48px] h-[48px] my-[10px] mx-5"
  }, React.createElement(Media, {
    variant: "wallet",
    size: 5,
    className: "absolute inset-0 m-auto text-primary"
  })), React.createElement("div", {
    className: "sm:flex text-left"
  }, React.createElement(Typography, {
    variant: "primary"
  }, shortenHex(wallet_address)), is_connected !== undefined && (is_connected ? React.createElement(Typography, {
    className: "text-success " + (is_mobile ? 'mt-1' : 'hidden')
  }, "Connected") : React.createElement(Typography, {
    className: "text-error " + (is_mobile ? 'mt-1' : 'hidden'),
    variant: "custom"
  }, "Not connected")))), !is_mobile && React.createElement("div", {
    className: "mr-5"
  }, is_connected !== undefined && (is_connected ? React.createElement(Typography, {
    className: "text-success"
  }, "Connected") : React.createElement(Typography, {
    className: "text-error",
    variant: "custom"
  }, "Not connected"))))), React.createElement(Button, {
    loading: loading,
    onClick: handleClick,
    className: "w-full bg-accent " + (!no_close_btn ? 'mb-8' : '')
  }, button_text), !no_close_btn && React.createElement("button", {
    onClick: function onClick() {
      return setShow(false);
    },
    className: " text-primary text-sm"
  }, cancel_btn_text));
};

var HeroSectionV2 = function HeroSectionV2(_ref) {
  var className = _ref.className,
    images = _ref.images,
    title = _ref.title,
    subtitle = _ref.subtitle,
    buttons = _ref.buttons,
    has_risk_message = _ref.has_risk_message;
  var mobile_breakpoint = 911;
  var text_breakpoint = 768;
  var breakpoint = useBreakpoint();
  var is_text_breakpoint = breakpoint < text_breakpoint;
  var is_mobile = breakpoint < mobile_breakpoint;
  // State to manage background image
  var _useState = useState(''),
    background = _useState[0],
    setBackground = _useState[1];
  useEffect(function () {
    setBackground("url('" + (is_mobile ? images.mobile : images.desktop) + "')");
  }, [is_mobile, images]);
  var first_button = buttons[0];
  var second_button = buttons[1];
  var third_button = buttons[2];
  return React.createElement("div", {
    className: className
  }, React.createElement("section", {
    id: "hero-section-v2",
    "data-testid": "hero-section-v2",
    className: "relative " + (is_mobile ? 'h-[592px]' : 'h-[80vh]') + " " + className
  }, React.createElement("div", {
    className: "h-full w-full bg-cover bg-center object-cover",
    style: {
      backgroundImage: background
    }
  }), React.createElement("div", {
    className: "absolute text-center w-full px-5 " + (is_mobile ? 'left-1/2 transform -translate-x-1/2 top-[27%]' : 'left-1/2 transform -translate-x-1/2 top-[25%]')
  }, React.createElement("p", {
    className: "text-white font-bold mx-auto " + (is_text_breakpoint ? 'mb-3 text-[28px] w-[280px]' : 'mb-5 text-[60px] leading-[62.4px] w-[550px] ')
  }, title), React.createElement(Typography, {
    variant: "secondary",
    size: is_text_breakpoint ? 'sm' : '2xl',
    className: "mx-auto " + (is_text_breakpoint ? 'w-[300px]' : 'w-[682px]')
  }, subtitle), React.createElement("div", {
    className: " " + (is_text_breakpoint ? 'flex flex-col w-full mt-[174px]' : 'flex w-[540px] space-x-5 mx-auto mt-[150px]')
  }, React.createElement("button", {
    className: "rounded inline-flex items-center justify-center h-11 low-border focus:outline-none font-bold text-button bg-gradient-button px-5 " + (is_text_breakpoint ? 'text-[12px]' : 'flex-1 text-[14px]'),
    onClick: first_button.onClick
  }, first_button.label), is_text_breakpoint ? React.createElement("div", {
    className: "flex w-full space-x-5 mt-5"
  }, React.createElement("button", {
    className: "rounded inline-flex items-center justify-center h-11 focus:outline-none bg-transparent border border-secondary text-secondary px-5 w-full text-[12px]",
    onClick: second_button.onClick
  }, second_button.label), React.createElement("button", {
    className: "rounded inline-flex items-center justify-center h-11 focus:outline-none bg-transparent border border-secondary text-secondary px-5 w-full text-[12px]",
    onClick: third_button.onClick
  }, third_button.label)) : React.createElement(React.Fragment, null, React.createElement("button", {
    className: "rounded inline-flex items-center justify-center h-11 focus:outline-none bg-transparent border border-secondary text-secondary px-5 w-full flex-1 text-[14px] hover:text-opacity-75 hover:border-opacity-75",
    onClick: second_button.onClick
  }, second_button.label), React.createElement("button", {
    className: "rounded inline-flex items-center justify-center h-11 focus:outline-none bg-transparent border border-secondary text-secondary px-5 w-full flex-1 text-[14px] hover:text-opacity-75 hover:border-opacity-75",
    onClick: third_button.onClick
  }, third_button.label)), ' '), React.createElement("div", {
    className: "my-5"
  }, has_risk_message && React.createElement(Typography, {
    variant: "secondary",
    className: "italic"
  }, "*Crypto investing involves", ' ', React.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: "https://25442585.fs1.hubspotusercontent-eu1.net/hubfs/25442585/Legal%20Docs/Risk%20Statement.pdf"
  }, React.createElement("span", {
    className: "font-extrabold underline"
  }, " risk")), ". You could lose your entire investment.")), ' ')));
};

// src/organisms/increaseallocationmodal/index.tsx
// Enum for stages
var IncreaseAllocationStage;
(function (IncreaseAllocationStage) {
  IncreaseAllocationStage[IncreaseAllocationStage["AllocationStage"] = 0] = "AllocationStage";
  IncreaseAllocationStage[IncreaseAllocationStage["PoolStage"] = 1] = "PoolStage";
})(IncreaseAllocationStage || (IncreaseAllocationStage = {}));
var IncreaseAllocationModal = function IncreaseAllocationModal(_ref) {
  var show = _ref.show,
    setShow = _ref.setShow,
    balance = _ref.balance,
    token_symbol = _ref.token_symbol,
    insufficient_fund = _ref.insufficient_fund,
    handleOpenBuyModal = _ref.handleOpenBuyModal,
    staking_pools = _ref.staking_pools,
    tiersToUse = _ref.tiersToUse,
    amount_to_stake = _ref.amount_to_stake,
    multiplier_value = _ref.multiplier_value,
    bar_value = _ref.bar_value,
    setIsDragging = _ref.setIsDragging,
    handleIncrement = _ref.handleIncrement,
    handleDecrement = _ref.handleDecrement,
    minBarValue = _ref.minBarValue,
    current_allocation_weight_percent = _ref.current_allocation_weight_percent,
    user_current_alloc_weight = _ref.user_current_alloc_weight,
    stage = _ref.stage,
    setStage = _ref.setStage,
    currentTier = _ref.currentTier,
    availableTiers = _ref.availableTiers,
    handleConnectWallet = _ref.handleConnectWallet,
    button_disabled = _ref.button_disabled,
    loading = _ref.loading,
    onClose = _ref.onClose,
    is_max_tiers = _ref.is_max_tiers;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 500;
  var has_insufficient_fund = insufficient_fund.has_insufficient_fund,
    tooltip = insufficient_fund.tooltip;
  var modalRef = useRef(null);
  useEffect(function () {
    if (modalRef.current) {
      modalRef.current.scrollTop = 0;
    }
  }, [stage]);
  return React.createElement(Modal, {
    no_centered_text: true,
    noClose: true,
    show: show,
    onClose: onClose,
    className: "max-w-[640px] max-h-[912px]",
    is_fixed_height: false,
    contentRef: modalRef
  }, stage === IncreaseAllocationStage.AllocationStage ? React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: is_mobile ? '3xl' : '4xl',
    className: "mb-5 text-center",
    allBold: true
  }, "Increase Allocation"), React.createElement(Typography, {
    variant: "secondary",
    size: "md",
    className: "text-center"
  }, "Simply move the bar below or adjust your desired allocation weight. We will calculate the amount you need to stake to achieve it."), React.createElement("div", {
    className: "my-[30px]"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mb-[10px] text-center"
  }, "Your desired allocation weight"), React.createElement("div", {
    className: "flex items-center justify-center"
  }, React.createElement(Card, {
    className: "bg-surface-level-zero w-[205px] h-[68px] flex items-center justify-center"
  }, React.createElement(Typography, {
    allBold: true,
    size: "4xl"
  }, Math.round(multiplier_value), "x")), React.createElement("div", {
    className: "flex flex-col mx-2 items-center"
  }, React.createElement("button", {
    type: "button",
    onClick: handleIncrement,
    className: "bg-surface-level-two inline-flex items-center justify-center rounded-md h-[28px] w-[28px] mb-1"
  }, React.createElement(Media, {
    variant: "plus",
    size: 4
  })), React.createElement("button", {
    type: "button",
    onClick: handleDecrement,
    className: "bg-surface-level-two inline-flex items-center justify-center rounded-md h-[28px] w-[28px] mt-1 " + (bar_value <= minBarValue ? 'opacity-50 cursor-not-allowed' : ''),
    disabled: bar_value < minBarValue
  }, React.createElement(Media, {
    variant: "minus",
    size: 4
  }))))), React.createElement("div", {
    className: "w-full max-w-[512px] mx-auto mt-10",
    id: "progress-bar"
  }, React.createElement("div", {
    className: "px-4"
  }, React.createElement("div", {
    className: "bg-surface-level-two h-2 w-full rounded-full relative"
  }, React.createElement("div", {
    className: "bg-accent h-2 rounded-full absolute",
    style: {
      width: bar_value + "%"
    }
  }), React.createElement("div", {
    className: "absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center bg-accent rounded-full cursor-pointer z-20 w-9 h-9",
    style: {
      left: bar_value + "%"
    },
    onMouseDown: function onMouseDown() {
      return setIsDragging(true);
    },
    onTouchStart: function onTouchStart() {
      return setIsDragging(true);
    }
  }, React.createElement(Media, {
    variant: "dcb-power",
    size: 4
  })), tooltip && React.createElement(Tooltip, {
    text: 'Current'
  }, React.createElement("div", {
    className: "absolute top-1/2 transform -translate-x-1/2 -translate-y-1/2 flex items-center justify-center w-4 h-4 bg-secondary rounded-full z-10",
    style: {
      left: current_allocation_weight_percent + "%"
    }
  }, React.createElement(Media, {
    variant: "dcb-power",
    size: 3
  }))))), React.createElement("div", {
    className: "flex justify-between items-center mt-[18px] select-none " + (is_mobile ? '' : 'gap-8')
  }, tiersToUse.map(function (tier, index) {
    var isCurrentTier = (tier == null ? void 0 : tier.alloc_multiplier) === (currentTier == null ? void 0 : currentTier.alloc_multiplier);
    var isAvailableTier = availableTiers.some(function (avTier) {
      return (avTier == null ? void 0 : avTier.alloc_multiplier) === (tier == null ? void 0 : tier.alloc_multiplier);
    });
    var isInactiveTier = !isCurrentTier && !isAvailableTier;
    return React.createElement(React.Fragment, {
      key: tier == null ? void 0 : tier.id
    }, React.createElement("div", {
      className: "relative flex flex-col " + (is_mobile ? '' : 'gap-y-2') + " " + (isAvailableTier ? 'text-white' : isInactiveTier ? 'text-primary opacity-60' : 'text-primary' // current tier
      )
    }, React.createElement("div", {
      className: "relative min-w-[35px] rounded-lg shadow-[0_0_10px_rgba(0,0,0,0.8)] flex items-center justify-center " + (isCurrentTier ? 'border border-white' // Current tier: border white
      : isAvailableTier ? 'high-border' : 'high-border opacity-90') + " " + (is_mobile && !is_max_tiers ? 'hidden' : '')
    }, React.createElement(Typography, {
      variant: "primary",
      size: "xs",
      className: "px-2 py-1 " + (isAvailableTier ? 'text-white' : 'text-primary')
    }, tier.alloc_multiplier, "x")), !is_mobile || !is_max_tiers && is_mobile ? React.createElement(Typography, {
      size: "xs",
      className: (isAvailableTier ? 'text-white' : 'text-primary') + " m-0 p-0 " + (is_mobile && isCurrentTier ? 'font-bold' : '') + " " + (is_mobile ? '' : 'absolute -bottom-8')
    }, tier.name) : null), index < tiersToUse.length - 1 && !is_max_tiers && React.createElement(Typography, {
      className: "block mx-0 text-surface-level-three border-none select-none m-0 p-0 " + (is_mobile ? '' : 'hidden mx-2')
    }, '', " | ", ''));
  }))), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] mb-[30px] " + (is_mobile ? 'mt-[30px]' : 'mt-[60px]')
  }), React.createElement("div", {
    className: "flex justify-between items-center"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Your current allocation weight"), React.createElement(Typography, {
    variant: "primary",
    size: "md"
  }, user_current_alloc_weight, "x")), React.createElement("div", {
    className: "flex justify-between items-center mt-5"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Your desired allocation weight"), React.createElement(Typography, {
    variant: "primary",
    size: "md",
    className: "font-bold"
  }, Math.round(multiplier_value), "x")), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] my-[20px]"
  }), React.createElement("div", {
    className: "flex justify-between"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Amount to stake"), React.createElement("div", {
    className: "flex flex-col items-end"
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true
  }, amount_to_stake.token || '0 DCB'), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, amount_to_stake.usd || '(~$0.00)'), has_insufficient_fund && React.createElement("button", {
    onClick: handleOpenBuyModal,
    className: "cursor-pointer"
  }, React.createElement(Typography, {
    size: "sm",
    className: "text-warning inline-flex"
  }, "Insufficient funds", React.createElement(Media, {
    variant: "info-outline",
    size: 0,
    className: "my-auto ml-1 w-[14px] h-[14px]"
  }))))), React.createElement("div", {
    className: "bg-surface-level-three px-5 h-[1px] my-[20px]"
  }), React.createElement("div", {
    className: "" + (is_mobile ? 'space-y-[10px]' : 'flex justify-between items-center')
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Your $", token_symbol, " balance on BNB Chain"), handleConnectWallet ? React.createElement("button", {
    className: "text-accent underline",
    onClick: handleConnectWallet
  }, "Connect verified wallet") : React.createElement(Typography, {
    allBold: true
  }, balance, " ", token_symbol)), React.createElement("div", {
    className: "bg-surface-level-three h-[1px] mt-5 mb-8"
  }), React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "mt-[32px]"
  }, "Your allocation weight may increase depending on the pool you choose to stake in."), React.createElement(Button, {
    disabled: button_disabled,
    loading: loading,
    onClick: function onClick() {
      return setStage(IncreaseAllocationStage.PoolStage);
    },
    className: "w-full mt-5 mb-[32px] flex items-center justify-center"
  }, "Choose a pool to stake", React.createElement(Media, {
    className: "cursor-pointer text-white inline-block ml-3",
    size: 5,
    variant: "arrow-right"
  })), React.createElement("div", {
    className: "flex justify-center"
  }, React.createElement("button", {
    className: "cursor-pointer"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    onClick: function onClick() {
      return setShow(false);
    }
  }, "Maybe later")))) : React.createElement("div", null, React.createElement(Typography, {
    size: "4xl",
    allBold: true,
    className: "mb-[30px]"
  }, "Choose a pool to stake"), React.createElement("div", {
    className: "space-y-[30px]"
  }, staking_pools.map(function (pool) {
    return React.createElement(PoolContainer, {
      key: JSON.stringify(pool),
      is_mobile: true
    }, React.createElement(MobilePool, Object.assign({}, pool, {
      is_always_mobile: true
    })));
  })), React.createElement(Button, {
    onClick: function onClick() {
      return setStage(IncreaseAllocationStage.AllocationStage);
    },
    className: "w-full mt-[30px] mb-[32px] flex items-center mx-auto justify-center",
    variant: "secondary"
  }, React.createElement(Media, {
    className: "cursor-pointer inline-block mr-2 items-center text-secondary",
    size: 5,
    variant: "arrow-left"
  }), "Back to the previous step"), React.createElement("div", {
    className: "flex justify-center"
  }, React.createElement("button", {
    className: "cursor-pointer"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    onClick: function onClick() {
      setShow(false);
      setStage(IncreaseAllocationStage.AllocationStage);
    }
  }, "Maybe later")))));
};

var ChipText;
(function (ChipText) {
  ChipText["disconnected"] = "Disconnected";
  ChipText["notConnected"] = "Not connected";
  ChipText["connected"] = "Connected";
  ChipText["verificationPending"] = "Verification Pending";
  ChipText["none"] = "";
})(ChipText || (ChipText = {}));
var VerificationStatus;
(function (VerificationStatus) {
  VerificationStatus["pending"] = "pending";
  VerificationStatus["verified"] = "verified";
  VerificationStatus["notVerified"] = "not_verified";
})(VerificationStatus || (VerificationStatus = {}));
var WalletCard = function WalletCard(_ref) {
  var _border_color, _connected_text;
  var verified_wallet_address = _ref.verified_wallet_address,
    connected_wallet_address = _ref.connected_wallet_address,
    wallet_props = _ref.wallet_props;
  var _ref2 = wallet_props || {},
    _ref2$chip_type = _ref2.chip_type,
    chip_type = _ref2$chip_type === void 0 ? ChipText.none : _ref2$chip_type,
    verified_wallet = _ref2.verified_wallet,
    wallet_status = _ref2.wallet_status,
    is_connected_to_verified_wallet = _ref2.is_connected_to_verified_wallet;
  var border_color = (_border_color = {}, _border_color[ChipText.connected] = 'border-success', _border_color[ChipText.disconnected] = 'border-warning', _border_color[ChipText.verificationPending] = 'border-warning', _border_color[ChipText.notConnected] = 'border-warning', _border_color[ChipText.none] = '', _border_color);
  var connected_text = (_connected_text = {}, _connected_text[ChipText.connected] = 'Connected', _connected_text[ChipText.disconnected] = 'Disconnected', _connected_text[ChipText.verificationPending] = 'Verification pending', _connected_text[ChipText.notConnected] = 'Not connected', _connected_text[ChipText.none] = '', _connected_text);
  // Determine if we should show the full wallet details view
  var show_full_wallet_details = (chip_type === ChipText.notConnected || chip_type === ChipText.verificationPending && wallet_status === VerificationStatus.verified) && connected_wallet_address;
  return React.createElement("div", null, chip_type === ChipText.none && !is_connected_to_verified_wallet && wallet_status === VerificationStatus.notVerified && React.createElement("div", {
    className: "flex items-center space-x-2 my-6"
  }, React.createElement(Media, {
    variant: "info",
    size: 3,
    className: "w-5 h-5 text-warning"
  }), React.createElement(Typography, {
    size: "sm",
    variant: "primary"
  }, "Not verified")), (chip_type === ChipText.connected || chip_type === ChipText.disconnected) && React.createElement("div", {
    className: "flex items-center space-x-2 mt-[28px]"
  }, React.createElement("div", {
    className: "w-[22px] h-[20px] bg-success rounded-full text-primary flex items-center justify-center"
  }, React.createElement(Media, {
    variant: "tick",
    size: 0,
    className: "w-[15px]"
  })), React.createElement("div", {
    className: "flex items-center justify-between w-full"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "primary",
    allBold: true
  }, verified_wallet), React.createElement("div", {
    className: "px-[10px] py-[3px] rounded-md border bg-surface-level-two " + border_color[chip_type]
  }, React.createElement(Typography, {
    size: "xs",
    variant: "primary"
  }, connected_text[chip_type])))), chip_type === ChipText.verificationPending && wallet_status === VerificationStatus.pending && React.createElement("div", {
    className: "flex items-center space-x-2 mt-[28px]"
  }, React.createElement(Media, {
    variant: "info",
    size: 2,
    className: "w-[22px] h-[22px] rounded-full text-warning"
  }), React.createElement("div", {
    className: "flex items-center justify-between w-full"
  }, React.createElement(Typography, {
    size: "sm",
    variant: "primary",
    allBold: true
  }, verified_wallet), React.createElement("div", {
    className: "px-[10px] py-[3px] rounded-md border bg-surface-level-two " + border_color[chip_type]
  }, React.createElement(Typography, {
    size: "xs",
    variant: "primary"
  }, connected_text[chip_type])))), show_full_wallet_details && React.createElement("div", {
    className: "flex flex-col "
  }, React.createElement("div", {
    className: "flex items-center space-x-2"
  }, React.createElement(Media, {
    variant: "new-wallet",
    size: 4
  }), React.createElement("div", null, React.createElement(Typography, {
    size: "sm",
    variant: "primary"
  }, connected_wallet_address))), React.createElement(Typography, {
    size: "sm",
    variant: "secondary"
  }, "Currently connected"), React.createElement("div", {
    className: "flex flex-col mt-3"
  }, React.createElement("div", {
    className: "flex items-center justify-between"
  }, React.createElement("div", {
    className: "flex items-center space-x-2"
  }, React.createElement("div", {
    className: "w-[22px] h-[22px] flex items-center justify-center bg-success rounded-full text-primary"
  }, React.createElement(Media, {
    variant: "tick",
    size: 0,
    className: "w-[15px]"
  })), React.createElement(Typography, {
    size: "sm",
    variant: "primary"
  }, verified_wallet_address)), React.createElement("div", {
    className: "px-[10px] py-[3px] rounded-md border bg-surface-level-two " + border_color[chip_type]
  }, React.createElement(Typography, {
    size: "xs",
    variant: "primary"
  }, connected_text[chip_type]))), React.createElement("div", {
    className: "flex justify-start"
  }, React.createElement(Typography, {
    variant: "secondary",
    size: "sm"
  }, "Verified wallet")))));
};

var _excluded$h = ["variant", "title", "subtitle", "button_text", "icon", "is_enabled", "handleClick", "wallet_props", "disabled"];
var CardVariant;
(function (CardVariant) {
  CardVariant["Verification"] = "verification";
  CardVariant["Wallet"] = "wallet";
  CardVariant["TwoFactor"] = "twoFactor";
  CardVariant["Referral"] = "referral";
})(CardVariant || (CardVariant = {}));
var ProfileCards = function ProfileCards(_ref) {
  var variant = _ref.variant,
    title = _ref.title,
    subtitle = _ref.subtitle,
    button_text = _ref.button_text,
    icon = _ref.icon,
    is_enabled = _ref.is_enabled,
    handleClick = _ref.handleClick,
    wallet_props = _ref.wallet_props,
    disabled = _ref.disabled,
    props = _objectWithoutPropertiesLoose(_ref, _excluded$h);
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  var card_padding = is_mobile ? 'p-4' : 'p-8';
  var getBackgroundClass = function getBackgroundClass() {
    if (variant === CardVariant.Referral) {
      return is_enabled ? 'bg-top-right-gradient-green' : 'bg-top-right-gradient-primary';
    }
    if (variant === CardVariant.Wallet) {
      if ((wallet_props == null ? void 0 : wallet_props.wallet_status) === VerificationStatus.pending || (wallet_props == null ? void 0 : wallet_props.wallet_status) === VerificationStatus.notVerified) {
        // case for NonVerifiedConnectedVerificationPending
        return 'bg-top-right-gradient-orange';
      }
      return 'bg-top-right-gradient-green';
    }
    if (variant === CardVariant.TwoFactor) {
      return is_enabled ? 'bg-top-right-gradient-green' : 'bg-top-right-gradient-orange';
    }
    if (variant === CardVariant.Verification) {
      var _props$verification_s = props.verification_status,
        verification_status = _props$verification_s === void 0 ? 'not_verified' : _props$verification_s;
      if (verification_status === 'verified') return 'bg-top-right-gradient-green';
      if (verification_status === 'failed') return 'bg-top-right-gradient-red';
      if (verification_status === 'pending') return 'bg-top-right-gradient-orange';
    }
    return 'bg-top-right-gradient-orange';
  };
  var renderStatus = function renderStatus() {
    switch (variant) {
      case CardVariant.Wallet:
        {
          var verified_wallet_address = props.verified_wallet_address;
          var connected_wallet_address = props.connected_wallet_address;
          return React.createElement(WalletCard, {
            verified_wallet_address: verified_wallet_address,
            connected_wallet_address: connected_wallet_address,
            is_enabled: is_enabled,
            wallet_props: wallet_props
          });
        }
      case CardVariant.Referral:
        {
          var referral_link = props.referral_link;
          var handleCopy = function handleCopy() {
            if (referral_link) {
              var textarea = document.createElement('textarea');
              textarea.value = referral_link;
              document.body.appendChild(textarea);
              textarea.select();
              document.execCommand('copy');
              document.body.removeChild(textarea);
              alert('Referral link copied to clipboard!');
            } else {
              console.warn('No referral link provided');
            }
          };
          return is_enabled ? React.createElement(React.Fragment, null, React.createElement("div", {
            className: "flex items-center justify-between"
          }, React.createElement(Typography, {
            size: "sm",
            variant: "primary",
            allBold: true,
            className: "mt-6"
          }, referral_link), React.createElement(Media, {
            variant: "copy",
            size: 6,
            className: "w-5 h-5 text-primary cursor-copy mt-6",
            onClick: handleCopy
          })), React.createElement(Typography, {
            variant: "secondary",
            size: "sm",
            className: "mb-6"
          }, "Your referral link")) : React.createElement("div", {
            className: "flex items-center space-x-2 mt-[45px]"
          }, React.createElement(Media, {
            variant: "info",
            size: 5,
            className: "w-5 h-5 text-secondary"
          }), React.createElement(Typography, {
            variant: "primary",
            size: "sm",
            allBold: true
          }, "Not setup"));
        }
      case CardVariant.TwoFactor:
        return React.createElement("div", {
          className: "flex items-center space-x-2 my-6"
        }, React.createElement("div", {
          className: "w-[22px] h-[22px] flex items-center justify-center " + (is_enabled ? 'bg-success rounded-full text-primary' : 'text-warning')
        }, React.createElement(Media, {
          variant: is_enabled ? 'tick' : 'info',
          size: 6,
          className: is_enabled ? 'w-[15px]' : 'w-[22px]'
        })), React.createElement(Typography, {
          variant: "primary",
          size: "sm",
          allBold: true
        }, is_enabled ? '2FA enabled' : '2FA disabled'));
      case CardVariant.Verification:
        {
          var _props$verification_s2 = props.verification_status,
            verification_status = _props$verification_s2 === void 0 ? 'not_verified' : _props$verification_s2;
          return React.createElement("div", {
            className: "flex items-center space-x-2 my-6"
          }, React.createElement("div", {
            className: "w-5 h-5 flex items-center justify-center " + (verification_status === 'verified' ? 'bg-success rounded-full text-primary' : verification_status === 'failed' ? 'text-accent rounded-full ' : verification_status === 'pending' ? 'text-warning rounded-full' : 'text-warning')
          }, React.createElement(Media, {
            variant: verification_status === 'verified' ? 'tick' : 'info',
            size: 0,
            className: "w-[15px]"
          })), React.createElement(Typography, {
            variant: "primary",
            size: "sm",
            allBold: true
          }, verification_status === 'verified' ? 'Verified' : verification_status === 'failed' ? 'Verification Failed' : verification_status === 'pending' ? 'Verification Pending' : 'Not Verified'));
        }
      default:
        return null;
    }
  };
  return React.createElement(Card, {
    className: "mx-auto min-h-[285px] w-[380px] flex flex-col " + card_padding + " " + getBackgroundClass()
  }, React.createElement("div", {
    className: "flex justify-between"
  }, React.createElement("div", {
    className: "flex flex-col space-y-2"
  }, React.createElement(Typography, {
    variant: "primary",
    allBold: true
  }, title), React.createElement(Typography, {
    variant: "secondary",
    size: "sm",
    className: "max-w-[248px]"
  }, subtitle)), React.createElement(Media, {
    variant: icon,
    className: "w-[52px] h-[52px] z-10"
  })), React.createElement("div", {
    className: "flex-grow"
  }, renderStatus()), React.createElement(Button, {
    className: "w-full mt-auto",
    variant: "secondary",
    onClick: handleClick,
    disabled: disabled
  }, button_text));
};

var YourProfile = function YourProfile(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    image = _ref.image,
    _ref$button_props = _ref.button_props,
    button_text = _ref$button_props.button_text,
    handleClick = _ref$button_props.handleClick,
    disabled = _ref$button_props.disabled,
    _ref$user_data = _ref.user_data,
    full_name = _ref$user_data.full_name,
    email = _ref$user_data.email,
    password = _ref$user_data.password,
    country = _ref$user_data.country,
    _ref$tier_data = _ref.tier_data,
    allocation_weight = _ref$tier_data.allocation_weight,
    dcb_balance = _ref$tier_data.dcb_balance,
    is_wallet_connected = _ref$tier_data.is_wallet_connected;
  var profile_fields = [{
    label: 'NAME',
    value: full_name
  }, {
    label: 'EMAIL',
    value: email
  }, {
    label: 'COUNTRY',
    value: country
  }, {
    label: 'PASSWORD',
    value: password
  }];
  var allocation_data = [{
    label: 'ALLOCATION WEIGHT',
    value: allocation_weight
  }, {
    label: 'DCB BALANCE',
    value: dcb_balance
  }];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  return React.createElement(Card, {
    className: "\n        mx-auto bg-surface-level-one\n        " + (is_mobile ? 'h-[566px] w-[353px]' : ' h-[590px] w-[380px]') + "\n      "
  }, React.createElement("div", {
    className: "" + (is_mobile ? 'm-5' : 'm-8')
  }, React.createElement(Typography, {
    variant: "primary",
    allBold: true,
    size: is_mobile ? 'sm' : 'md'
  }, title), React.createElement("div", {
    className: "grid grid-cols-2 items-center my-6 px-2"
  }, React.createElement("img", {
    src: image,
    alt: (full_name || 'User') + "'s profile",
    className: "rounded-full w-18 h-18 ml-4"
  }), !is_wallet_connected ? React.createElement(Typography, {
    variant: "secondary",
    size: is_mobile ? 'xs' : 'sm'
  }, subtitle) : React.createElement("div", {
    className: "grid grid-cols-1 my-2 px-2"
  }, allocation_data.map(function (_ref2) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement(DataLines, {
      key: label,
      label: label,
      values: [{
        value: value
      }],
      variant: "verticle",
      className: "my-2",
      "bottom-size": "text-xs",
      "top-size": "text-md",
      is_top_bold: true
    });
  }))), is_wallet_connected && React.createElement("div", {
    className: "mb-4"
  }, React.createElement(AllocationBar, {
    lower_allocation_multiplier: is_mobile ? 5 : 10,
    upper_allocation_multiplier: is_mobile ? 15 : 20,
    progress_percent: 55
  })), !is_wallet_connected && React.createElement(Button, {
    onClick: handleClick,
    className: "w-full mt-4",
    disabled: disabled
  }, "Connect wallet"), React.createElement("div", {
    className: "h-px w-full bg-surface-level-two my-9"
  }), React.createElement("div", {
    className: "grid grid-cols-2 my-6 px-2"
  }, profile_fields.map(function (_ref3) {
    var label = _ref3.label,
      value = _ref3.value;
    return React.createElement(DataLines, {
      key: label,
      label: label,
      values: [{
        value: value
      }],
      variant: "verticle",
      className: "my-2",
      "bottom-size": "text-xs",
      "top-size": "text-md",
      is_top_bold: true
    });
  })), React.createElement(Button, {
    onClick: handleClick,
    className: "w-full mt-8",
    variant: "secondary"
  }, button_text)));
};

var _excluded$i = ["as", "className", "mediaClassName", "setMobileNavOpen", "id", "options", "tier_info", "mobile_nav_open", "is_mobile"];
var AccountDropdown = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'div' : _ref$as,
    className = _ref.className,
    _ref$mediaClassName = _ref.mediaClassName,
    mediaClassName = _ref$mediaClassName === void 0 ? '' : _ref$mediaClassName,
    setMobileNavOpen = _ref.setMobileNavOpen,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? 'account-dropdown' : _ref$id,
    options = _ref.options,
    tier_info = _ref.tier_info,
    mobile_nav_open = _ref.mobile_nav_open,
    is_mobile = _ref.is_mobile,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded$i);
  var init = useIntitialised();
  var handleMenuClick = is_mobile ? function () {
    return setMobileNavOpen(!mobile_nav_open);
  } : undefined;
  var mobile_icon = mobile_nav_open ? 'cross' : 'burger';
  var _useState = useState(tier_info == null ? void 0 : tier_info.tier_img_url),
    imgUrlCache = _useState[0],
    setImgUrlCache = _useState[1];
  var _useState2 = useState(tier_info == null ? void 0 : tier_info.tier_img_url),
    imgToRender = _useState2[0],
    setImgToRender = _useState2[1];
  var sleep = function sleep(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  };
  useEffect(function () {
    var fadeinandout = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var e;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              e = document.getElementById('user-tier-img');
              if (!e) {
                _context.next = 9;
                break;
              }
              e.style.opacity = '0';
              _context.next = 5;
              return sleep(200);
            case 5:
              setImgToRender(tier_info == null ? void 0 : tier_info.tier_img_url);
              _context.next = 8;
              return sleep(200);
            case 8:
              e.style.opacity = '1';
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function fadeinandout() {
        return _ref2.apply(this, arguments);
      };
    }();
    if (imgToRender === imgUrlCache) return;
    fadeinandout();
  }, [imgUrlCache]);
  useEffect(function () {
    if ((tier_info == null ? void 0 : tier_info.tier_img_url) !== '') setImgUrlCache(tier_info == null ? void 0 : tier_info.tier_img_url);
  }, [tier_info]);
  return React.createElement(Menu, Object.assign({
    as: as,
    className: "h-11 relative inline-block text-left " + className + " ",
    ref: ref
  }, rest), function (_ref3) {
    var open = _ref3.open;
    return React.createElement(React.Fragment, null, React.createElement(Menu.Button, {
      className: ['h-11', 'border', 'inline-flex', 'items-center', 'text-primary', 'border-border', 'border-opacity-[0.03]', 'bg-surface-level-two', 'hover:bg-surface-level-three', 'rounded-full'].join(' '),
      "data-testid": id,
      onClick: handleMenuClick
    }, tier_info && imgToRender != '' ? React.createElement("img", {
      id: "user-tier-img",
      src: imgToRender,
      alt: "tier",
      className: "w-10 h-10 mr-[9px] ml-[1px] transition-opacity duration-300"
    }) : React.createElement(Avatar, {
      variant: "primary",
      className: "mr-[9px] ml-[1px]"
    }), init && React.createElement(Media, {
      className: "mr-[13px]",
      size: 4,
      variant: "" + (is_mobile ? mobile_icon : open ? 'chevron-up' : 'chevron-down')
    }) || React.createElement("div", {
      className: "w-4"
    })), React.createElement(Transition, {
      as: as,
      enter: "transition ease-out duration-100",
      enterFrom: "transform opacity-0 scale-95",
      enterTo: "transform opacity-100 scale-100",
      leave: "transition ease-in duration-75",
      leaveFrom: "transform opacity-100 scale-100",
      leaveTo: "transform opacity-0 scale-95"
    }, React.createElement(Menu.Items, {
      className: (is_mobile ? 'hidden' : 'inline') + " absolute low-border mt-1 origin-top-right right-0 rounded focus:outline-none bg-surface-level-two " + (tier_info ? 'min-w-[315px]' : 'min-w-[280px]')
    }, tier_info && React.createElement(TierCard, {
      surface: "three",
      className: "m-4",
      tier_info: tier_info
    }), options.map(function (_ref4, idx) {
      var name = _ref4.name,
        icon = _ref4.icon,
        onOptionClick = _ref4.onOptionClick,
        is_mobile = _ref4.is_mobile,
        right_btn_text = _ref4.right_btn_text,
        rightBtnHandleClick = _ref4.rightBtnHandleClick;
      return !is_mobile && React.createElement(Menu.Item, {
        "data-testid": id + "-" + name.split(' ').join('').toLocaleLowerCase(),
        key: name + '-' + idx
      }, function (_ref5) {
        var active = _ref5.active;
        return React.createElement("div", {
          className: "w-full flex justify-between items-center rounded " + (active && 'bg-surface-level-three')
        }, React.createElement("button", {
          onClick: onOptionClick,
          className: "p-4 w-full"
        }, React.createElement("div", {
          className: ['space-x-4', 'flex', 'items-center', 'w-full'].join(' ')
        }, icon && React.createElement(Media, {
          className: "h-[18px] w-[18px] " + mediaClassName,
          variant: icon,
          size: 0
        }), React.createElement(Typography, {
          size: "sm",
          variant: "secondary"
        }, name))), rightBtnHandleClick && React.createElement("button", {
          className: "px-4 text-right",
          onClick: rightBtnHandleClick
        }, React.createElement(Typography, {
          size: "sm",
          variant: "custom",
          className: "text-accent hover:underline cursor-pointer"
        }, right_btn_text)));
      });
    }))));
  });
});
AccountDropdown.displayName = 'AccountDropdown';

var defaultProps$M = {
  as: 'div'
};
var SideDrawer = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    as = _ref.as,
    show = _ref.show,
    className = _ref.className,
    handleClose = _ref.handleClose;
  var _useState = useState(false),
    inside_card = _useState[0],
    setInsideCard = _useState[1];
  return React.createElement(Transition, {
    show: show,
    as: as,
    ref: ref,
    className: "min-w-screen fixed left-0 top-0 flex justify-center items-center inset-0 z-[70] outline-none focus:outline-none overflow-auto bg-surface-level-one bg-opacity-80 " + className,
    enter: "transition-opacity duration-300",
    enterFrom: "opacity-0",
    enterTo: "opacity-100",
    leave: "transition-opacity duration-300",
    leaveFrom: "opacity-100",
    leaveTo: "opacity-0",
    onMouseDown: function onMouseDown() {
      if (!inside_card) {
        handleClose();
      }
    }
  }, React.createElement(Transition.Child, {
    className: "w-full max-w-screen sm:max-w-sm relative ml-auto my-auto shadow-lg bg-surface-level-one min-h-screen border-l-2 border-border border-opacity-5 p-4",
    enter: "transition ease-in-out duration-300 transform",
    enterFrom: "translate-x-full",
    enterTo: "translate-x-0",
    leave: "transition ease-in-out duration-300 transform",
    leaveFrom: "translate-x-0",
    leaveTo: "translate-x-full",
    id: "side-modal",
    onMouseEnter: function onMouseEnter() {
      return setInsideCard(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setInsideCard(false);
    }
  }, children));
});
SideDrawer.displayName = 'SideDrawer';
SideDrawer.defaultProps = defaultProps$M;

var NotificationType;
(function (NotificationType) {
  NotificationType["Default"] = "Default";
  NotificationType["Info"] = "Info";
  NotificationType["Alert"] = "Alert";
  NotificationType["Custom"] = "Custom";
})(NotificationType || (NotificationType = {}));
var defaultProps$N = {
  bg_color: NotificationType.Default
};
var getBackground = function getBackground(type) {
  switch (type) {
    case NotificationType.Alert:
      return 'bg-gradient';
    case NotificationType.Info:
      return 'bg-gradient-purple';
    case NotificationType.Custom:
      return "bg-customNotification-background";
    default:
      return 'bg-surface-level-three';
  }
};
var NotificationBar = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    text = _ref.text,
    bg_color = _ref.bg_color,
    className = _ref.className,
    btn_text = _ref.btn_text,
    handleClick = _ref.handleClick,
    handleClose = _ref.handleClose,
    _ref$has_button = _ref.has_button,
    has_button = _ref$has_button === void 0 ? true : _ref$has_button;
  return React.createElement(Component, {
    ref: ref,
    className: "relative " + getBackground(bg_color) + " " + (className || '')
  }, has_button ? React.createElement("button", {
    className: "flex justify-center py-[12px] px-[20px] mx-auto w-full",
    onClick: handleClick
  }, React.createElement(Typography, {
    variant: "custom",
    size: "md",
    className: (bg_color === NotificationType.Custom ? 'text-customNotification-text-color' : 'text-button') + " pr-10 pb-[1px]"
  }, text), React.createElement("div", {
    className: "lg:flex md:items-center md:justify-center hidden pt-[2px]"
  }, btn_text && React.createElement(Typography, {
    variant: "custom",
    size: "sm",
    className: (bg_color === NotificationType.Custom ? 'text-customNotification-text-color' : 'text-button') + " pr-3"
  }, btn_text), React.createElement(Media, {
    className: (bg_color === NotificationType.Custom ? 'text-customNotification-text-color' : 'text-button') + " h-[17px] w-[18px]",
    variant: "arrow-right"
  }))) : React.createElement(Typography, {
    variant: "custom",
    size: "md",
    className: (bg_color === NotificationType.Custom ? 'text-customNotification-text-color' : 'text-button') + " flex items-center justify-center py-[12px] px-[20px] mx-auto w-full"
  }, text), React.createElement("button", {
    className: "absolute inset-y-0 right-[20px] text-button",
    onClick: handleClose
  }, React.createElement(Media, {
    size: 5,
    className: "text-button",
    variant: "cross"
  })));
});
NotificationBar.displayName = 'NotificationBar';
NotificationBar.defaultProps = defaultProps$N;

var TierPower = function TierPower(_ref) {
  var image_url = _ref.image_url,
    label = _ref.label,
    value = _ref.value,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'md' : _ref$variant,
    className = _ref.className;
  var medium = variant === 'md';
  var large = variant === 'lg';
  return React.createElement("div", {
    className: className
  }, React.createElement("div", {
    className: "flex items-center space-x-5"
  }, React.createElement("img", {
    className: (large ? 'h-[60px] w-[60px]' : medium ? 'w-11 h-11' : '') + " ",
    src: image_url,
    alt: "Tier-" + value
  }), React.createElement("div", null, React.createElement("div", {
    className: "flex items-center space-x-2"
  }, React.createElement("div", {
    className: "h-[22px] w-[22px] rounded-full bg-gradient-alpha flex items-center justify-center"
  }, React.createElement(Media, {
    size: 0,
    className: "h-[14px] w-[12px]",
    variant: "dcb-power"
  })), React.createElement(Typography, {
    size: "md",
    allBold: true
  }, value)), React.createElement(Typography, {
    size: "xs",
    variant: "secondary"
  }, label.toUpperCase()))), large && React.createElement("div", {
    className: "w-[60px] h-[4px] mt-2"
  }, React.createElement(Media, {
    size: 0,
    variant: "under-glow",
    className: "w-full"
  })));
};

var RegStage;
(function (RegStage) {
  RegStage[RegStage["SignUp"] = 0] = "SignUp";
  RegStage[RegStage["VerifyEmail"] = 1] = "VerifyEmail";
  RegStage[RegStage["KYC"] = 2] = "KYC";
})(RegStage || (RegStage = {}));
var RegistrationSteps = function RegistrationSteps(_ref) {
  var className = _ref.className,
    current_step = _ref.current_step;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "w-full flex items-center pl-8 pr-4 " + className
  }, React.createElement("div", {
    className: "w-[25px]"
  }, current_step > RegStage.SignUp ? React.createElement(Steps, {
    variant: current_step > RegStage.SignUp ? 'secondary' : 'primary',
    className: "h-[25px] w-[25px]"
  }, React.createElement(Media, {
    className: "pt-[2px] pr-[1px] w-[17px] text-white",
    variant: 'tick',
    size: 0
  })) : React.createElement(Steps, {
    variant: "primary"
  }, "1")), React.createElement("div", {
    className: "h-[2px] mx-5 w-full " + (current_step >= RegStage.VerifyEmail ? 'bg-accent' : 'bg-surface-level-two')
  }), React.createElement("div", {
    className: "w-[25px]"
  }, current_step > RegStage.VerifyEmail ? React.createElement(Steps, {
    variant: current_step > RegStage.VerifyEmail ? 'secondary' : 'primary',
    className: "h-[25px] w-[25px]"
  }, React.createElement(Media, {
    className: "pt-[2px] pr-[1px] w-[17px] text-white",
    variant: 'tick',
    size: 0
  })) : React.createElement(Steps, {
    variant: "primary"
  }, "2")), React.createElement("div", {
    className: "h-[2px] mx-5 w-full " + (current_step >= RegStage.KYC ? 'bg-accent' : 'bg-surface-level-two')
  }), React.createElement("div", {
    className: "w-[25px]"
  }, current_step > RegStage.KYC ? React.createElement(Steps, {
    variant: current_step > RegStage.KYC ? 'secondary' : 'primary',
    className: "h-[25px] w-[25px]"
  }, React.createElement(Media, {
    className: "pt-[2px] pr-[1px] w-[17px] text-white",
    variant: 'tick',
    size: 0
  })) : React.createElement(Steps, {
    variant: "primary"
  }, "3"))), React.createElement("div", {
    className: "flex items-center justify-between py-[10px] w-full"
  }, React.createElement(Typography, {
    size: "xs",
    allBold: current_step === RegStage.SignUp
  }, "Create account"), React.createElement(Typography, {
    size: "xs",
    className: "pr-8",
    allBold: current_step === RegStage.VerifyEmail
  }, "Verify email"), React.createElement(Typography, {
    size: "xs",
    className: "pr-[2px]",
    allBold: current_step === RegStage.KYC
  }, "Verify ID")));
};

var IndicatorStage;
(function (IndicatorStage) {
  IndicatorStage[IndicatorStage["StageOne"] = 0] = "StageOne";
  IndicatorStage[IndicatorStage["StageTwo"] = 1] = "StageTwo";
  IndicatorStage[IndicatorStage["StageThree"] = 2] = "StageThree";
})(IndicatorStage || (IndicatorStage = {}));
var getStageData = function getStageData(stage) {
  switch (stage) {
    case IndicatorStage.StageOne:
      return {
        title: 'Enjoy free allocation',
        desc: 'Congratulations! Your ID has been successfully verified.',
        button_text: 'Next',
        info_text: React.createElement("span", null, "The tier system offers opportunities to participate in IDOs and airdrop events.", ' ', React.createElement("span", {
          className: "font-bold"
        }, "Higher tiers give access to more exclusive events."))
      };
    case IndicatorStage.StageTwo:
      return {
        title: 'Your Investor Power',
        button_text: 'Next',
        info_text: React.createElement("span", null, ' ', "Investor Power increases your IDO and airdrop events allocations.", ' ', '', React.createElement("span", {
          className: "font-bold"
        }, ' ', "The more you stake, the more investor power, the higher allocation!"))
      };
    case IndicatorStage.StageThree:
      return {
        title: '100% Refund Policy',
        button_text: "Let's do it",
        info_text: React.createElement("span", null, "Our stress and risk-free refund policy guarantees a", ' ', React.createElement("span", {
          className: "font-bold"
        }, "100% refund during a IDO Grace Period, provided the tokens have not been claimed."))
      };
  }
};
var ImageSection = function ImageSection(_ref) {
  var image_data = _ref.image_data,
    current_stage = _ref.current_stage;
  return React.createElement("div", {
    className: "relative flex items-center justify-center"
  }, React.createElement("div", {
    className: "absolute w-full h-full"
  }, React.createElement("img", {
    src: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/content/Bling%20%201.svg',
    alt: "shining",
    className: "z-10 blur-md"
  })), React.createElement("div", {
    className: "absolute inset-0 overlay-center-gradient"
  }), React.createElement("div", {
    className: "relative z-40 pt-8"
  }, ' ', current_stage === IndicatorStage.StageOne && React.createElement("div", null, React.createElement("img", {
    src: (image_data == null ? void 0 : image_data.image_url) || '',
    alt: "Tier Image",
    className: "h-[60px] w-[60px] mx-auto mb-1"
  }), React.createElement(VerticleDataLine, {
    label: image_data == null ? void 0 : image_data.label,
    values: [{
      value: image_data == null ? void 0 : image_data.value
    }],
    className: "relative",
    top_size: "lg",
    bottom_size: "sm",
    is_top_bold: true
  })), current_stage === IndicatorStage.StageTwo && React.createElement("div", null, React.createElement("div", {
    className: "relative bg-gradient h-[60px] w-[60px] flex items-center justify-center rounded-full"
  }, React.createElement(Media, {
    variant: 'dcb-power',
    className: "z-10"
  }))), current_stage === IndicatorStage.StageThree && React.createElement("div", null, React.createElement("img", {
    className: "relative h-[60px] w-[60px]",
    src: 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/Protected-Green.svg',
    alt: "protected icon"
  }))));
};
var ProgressSection = function ProgressSection(_ref2) {
  var progress_percent = _ref2.progress_percent,
    progress_value = _ref2.progress_value;
  return React.createElement("div", {
    className: "w-full mt-6 h-[20px] bg-surface-level-two rounded-full overflow-hidden relative"
  }, React.createElement("div", {
    className: "bg-gradient h-full rounded-full",
    style: {
      width: progress_percent + "%"
    }
  }, React.createElement("div", {
    className: "flex items-center justify-center absolute inset-0 space-x-2 "
  }, React.createElement(Media, {
    variant: "dcb-power",
    size: 0,
    className: "w-[12px]"
  }), React.createElement(Typography, {
    className: "flex items-center justify-center text-white font-bold"
  }, progress_value))));
};
var Indicators = function Indicators(_ref3) {
  var current_stage = _ref3.current_stage;
  var stages = [IndicatorStage.StageOne, IndicatorStage.StageTwo, IndicatorStage.StageThree];
  return React.createElement("div", {
    className: "flex justify-center items-center gap-2 pt-8"
  }, stages.map(function (stage) {
    return React.createElement("div", {
      key: stage,
      className: "w-2 h-2 rounded-full " + (current_stage === stage ? 'bg-white' : 'bg-surface-level-four')
    });
  }));
};
var AllocationPopUp = function AllocationPopUp(_ref4) {
  var setShow = _ref4.setShow,
    show = _ref4.show,
    progress_percent = _ref4.progress_percent,
    progress_value = _ref4.progress_value,
    image_data = _ref4.image_data,
    handleFinalClick = _ref4.handleFinalClick;
  var _useState = useState(IndicatorStage.StageOne),
    current_stage = _useState[0],
    setCurrentStage = _useState[1];
  var handleNextStage = function handleNextStage() {
    if (current_stage === IndicatorStage.StageOne) {
      setCurrentStage(IndicatorStage.StageTwo);
    } else if (current_stage === IndicatorStage.StageTwo) {
      setCurrentStage(IndicatorStage.StageThree);
    } else if (current_stage === IndicatorStage.StageThree) {
      setCurrentStage(IndicatorStage.StageOne);
    }
  };
  return React.createElement(Modal, {
    noClose: true,
    show: show,
    onClose: function onClose() {
      return setShow(false);
    }
  }, React.createElement("div", null, React.createElement(Typography, {
    allBold: true,
    size: "4xl",
    className: "text-center"
  }, getStageData(current_stage).title), current_stage === IndicatorStage.StageOne && React.createElement(Typography, {
    variant: "secondary",
    className: "mt-[10px] text-center"
  }, getStageData(current_stage).desc), React.createElement(ImageSection, {
    image_data: image_data,
    current_stage: current_stage
  }), current_stage === IndicatorStage.StageTwo && React.createElement(ProgressSection, {
    progress_percent: progress_percent,
    progress_value: progress_value
  }), React.createElement(Typography, {
    variant: "secondary",
    className: "my-8"
  }, getStageData(current_stage).info_text), React.createElement(Button, {
    onClick: current_stage === IndicatorStage.StageThree ? function () {
      handleFinalClick();
      console.log('clicked');
      setShow(false);
    } : function () {
      return handleNextStage();
    },
    variant: current_stage === IndicatorStage.StageThree ? 'primary' : 'secondary',
    className: "w-full"
  }, getStageData(current_stage).button_text), React.createElement(Indicators, {
    current_stage: current_stage
  })));
};

var useIsMounted = function useIsMounted() {
  var _useState = useState(false),
    isMounted = _useState[0],
    setIsMounted = _useState[1];
  useEffect(function () {
    setIsMounted(function () {
      return true;
    });
  }, []);
  return isMounted;
};
var getTimeLeft = function getTimeLeft(end_date) {
  var now = dayjs();
  var diff = end_date.diff(now, 'second');
  var days = Math.floor(diff / (24 * 60 * 60));
  var hours = Math.floor(diff % (24 * 60 * 60) / (60 * 60));
  var minutes = Math.floor(diff % (60 * 60) / 60);
  var seconds = diff % 60;
  return {
    days: Math.max(0, days),
    hours: Math.max(0, hours),
    minutes: Math.max(0, minutes),
    seconds: Math.max(0, seconds)
  };
};
var useCountdown = function useCountdown(end_date) {
  var initial = getTimeLeft(end_date);
  var _useState2 = useState({
      current: initial,
      previous: null
    }),
    _useState2$ = _useState2[0],
    current = _useState2$.current,
    previous = _useState2$.previous,
    setCountdown = _useState2[1];
  useEffect(function () {
    var timer = window.setInterval(function () {
      setCountdown(function (_ref) {
        var current = _ref.current;
        return {
          previous: current,
          current: getTimeLeft(end_date)
        };
      });
    }, 1000);
    return function () {
      return clearInterval(timer);
    };
  }, [end_date]);
  return {
    previous: previous,
    current: current
  };
};

var padStart = function padStart(number) {
  return number.toString().padStart(2, '0');
};
var SingleNumberCard = function SingleNumberCard(_ref) {
  var id = _ref.id,
    label = _ref.label,
    current = _ref.current,
    previous = _ref.previous,
    has_accent_countdown = _ref.has_accent_countdown,
    is_smaller = _ref.is_smaller;
  return React.createElement("div", {
    className: "" + (is_smaller ? 'scale-85 transform' : '')
  }, React.createElement("div", {
    className: "perspective"
  }, React.createElement("div", {
    className: "relative rounded-t-lg h-8 sm:w-20 w-16 overflow-hidden brightness-80"
  }, React.createElement("p", {
    className: "absolute top-2 left-0 right-0 text-center text-4xl " + (has_accent_countdown ? 'text-accent' : 'text-primary')
  }, typeof current === 'undefined' ? '' : padStart(current)), React.createElement("svg", {
    width: "100%",
    height: "100%"
  }, React.createElement("defs", null, React.createElement("mask", {
    id: id + "-m",
    fill: "#fff"
  }, React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "0",
    cy: "100%"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "100%",
    cy: "100%"
  }))), React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    className: "text-surface-level-three",
    mask: "url(#" + id + "-m)"
  }))), React.createElement("div", {
    className: "relative rounded-b-lg h-8 sm:w-20 w-16 overflow-hidden"
  }, React.createElement("p", {
    className: "absolute bottom-2 left-0 right-0 text-center text-4xl " + (has_accent_countdown ? 'text-accent' : 'text-primary'),
    "data-testid": id
  }, typeof previous === 'undefined' ? '' : padStart(previous)), React.createElement("svg", {
    width: "100%",
    height: "100%"
  }, React.createElement("defs", null, React.createElement("mask", {
    id: id + "-m2",
    fill: "#fff"
  }, React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "0",
    cy: "0"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "100%",
    cy: "0"
  }))), React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    className: "text-surface-level-three",
    mask: "url(#" + id + "-m2)"
  }))), React.createElement(Typography, {
    size: "sm",
    variant: "secondary",
    className: "text-center tracking-widest pt-2"
  }, label), previous !== current && React.createElement(React.Fragment, null, React.createElement("div", {
    className: "absolute top-0 left-0 rounded-t-lg h-8 sm:w-20 w-16 overflow-hidden brightness-80 animate-flipTop origin-bottom preserve-3d backface-hidden"
  }, React.createElement("div", {
    className: "relative h-8"
  }, React.createElement("p", {
    className: "absolute top-2 left-0 right-0 text-center text-4xl " + (has_accent_countdown ? 'text-accent' : 'text-primary')
  }, typeof previous === 'undefined' ? '' : padStart(previous)), React.createElement("svg", {
    width: "100%",
    height: "100%"
  }, React.createElement("defs", null, React.createElement("mask", {
    id: id + "-mbottom",
    fill: "#fff"
  }, React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "0",
    cy: "100%"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "100%",
    cy: "100%"
  }))), React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    className: "text-surface-level-three",
    mask: "url(#" + id + "-mbottom)"
  })))), React.createElement("div", {
    className: "absolute top-8 left-0 rounded-b-lg h-8 sm:w-20 w-16 overflow-hidden animate-flipBottom origin-top preserve-3d backface-hidden"
  }, React.createElement("div", {
    className: "relative h-8"
  }, React.createElement("p", {
    className: "absolute bottom-2 left-0 right-0 text-center text-4xl " + (has_accent_countdown ? 'text-accent' : 'text-primary')
  }, typeof current === 'undefined' ? '' : padStart(current)), React.createElement("svg", {
    width: "100%",
    height: "100%"
  }, React.createElement("defs", null, React.createElement("mask", {
    id: id + "-m2bottom",
    fill: "#fff"
  }, React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "#fff"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "0",
    cy: "0"
  }), React.createElement("circle", {
    r: "8",
    fill: "#000",
    cx: "100%",
    cy: "0"
  }))), React.createElement("rect", {
    width: "100%",
    height: "100%",
    fill: "currentColor",
    className: "text-surface-level-three",
    mask: "url(#" + id + "-m2bottom)"
  })))))));
};

var Countdown = function Countdown(_ref) {
  var target_date = _ref.target_date,
    has_accent_countdown = _ref.has_accent_countdown,
    is_smaller = _ref.is_smaller;
  var is_mounted = useIsMounted();
  var end_date = useMemo(function () {
    return dayjs.unix(Number(target_date));
  }, [target_date]);
  var _useCountdown = useCountdown(end_date),
    current = _useCountdown.current,
    previous = _useCountdown.previous;
  if (!is_mounted) return React.createElement(React.Fragment, null);
  return React.createElement("div", {
    className: "flex justify-around " + (is_smaller ? 'py-3' : 'py-5')
  }, React.createElement(SingleNumberCard, {
    id: "days" + current.days + "-" + (previous == null ? void 0 : previous.days),
    label: "Days",
    key: "days" + current.days + "-" + (previous == null ? void 0 : previous.days),
    current: current.days,
    previous: previous == null ? void 0 : previous.days,
    is_smaller: is_smaller
  }), React.createElement(SingleNumberCard, {
    id: "hours" + current.hours + "-" + (previous == null ? void 0 : previous.hours),
    label: "Hours",
    key: "hours" + current.hours + "-" + (previous == null ? void 0 : previous.hours),
    current: current.hours,
    previous: previous == null ? void 0 : previous.hours,
    is_smaller: is_smaller
  }), React.createElement(SingleNumberCard, {
    id: "minutes" + current.minutes + "-" + (previous == null ? void 0 : previous.minutes),
    label: "Minutes",
    key: "minutes" + current.minutes + "-" + (previous == null ? void 0 : previous.minutes),
    current: current.minutes,
    previous: previous == null ? void 0 : previous.minutes,
    is_smaller: is_smaller
  }), React.createElement(SingleNumberCard, {
    has_accent_countdown: has_accent_countdown,
    id: "seconds" + current.seconds + "-" + (previous == null ? void 0 : previous.seconds),
    label: "Seconds",
    key: "seconds" + current.seconds + "-" + (previous == null ? void 0 : previous.seconds),
    current: current.seconds,
    previous: previous == null ? void 0 : previous.seconds,
    is_smaller: is_smaller
  }));
};

var LearningSection = function LearningSection(_ref) {
  var className = _ref.className,
    data = _ref.data,
    title = _ref.title,
    cta_button = _ref.cta_button;
  var _useState = useState(0),
    scroll_position = _useState[0],
    setScrollPosition = _useState[1];
  var scrollContainerRef = useRef(null);
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < BreakPoint.SM;
  var show_pagination = breakpoint < 1180;
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (scrollContainerRef.current) {
        var scroll_left = scrollContainerRef.current.scrollLeft;
        var max_scroll_left = scrollContainerRef.current.scrollWidth - scrollContainerRef.current.clientWidth;
        var scroll_ratio = scroll_left / max_scroll_left;
        setScrollPosition(Math.min(Math.round(scroll_ratio * 4), 3)); // 4 segments for 4 dots, ensure max value is 3
      }
    };
    var scroll_container = scrollContainerRef.current;
    if (scroll_container) {
      scroll_container.addEventListener('scroll', handleScroll);
      // Cleanup function
      return function () {
        return scroll_container.removeEventListener('scroll', handleScroll);
      };
    }
    return function () {};
  }, []);
  return React.createElement("section", {
    className: "space-y-8 " + className,
    id: "learning_section",
    "data-testid": "learning_section"
  }, React.createElement("div", {
    className: "flex items-center space-x-4 sm:space-x-[36px]"
  }, React.createElement(Typography, {
    size: '2xl',
    allBold: true
  }, title), cta_button && React.createElement("button", {
    onClick: cta_button.handleClick,
    className: "flex items-center space-x-3 flex-shrink-0 cursor-pointer"
  }, React.createElement(Typography, {
    size: is_mobile ? 'xs' : 'sm',
    variant: "secondary"
  }, cta_button.text), React.createElement(Media, {
    size: 0,
    variant: "chevron-right",
    className: "text-secondary h-[17px]"
  }))), React.createElement("div", {
    className: "overflow-x-auto",
    ref: scrollContainerRef
  }, React.createElement("div", {
    className: "grid grid-cols-4 gap-5 w-[1180px]"
  }, data.map(function (_ref2) {
    var image = _ref2.image,
      text = _ref2.text,
      link = _ref2.link;
    return React.createElement("a", {
      key: image + "-" + text + "-" + link,
      href: link,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "" + (link ? 'cursor-pointer' : '')
    }, React.createElement("div", {
      className: "space-y-2"
    }, React.createElement("img", {
      src: image,
      className: "w-[280px] h-[151px] rounded-lg"
    }), React.createElement(Typography, {
      size: "md",
      allBold: true
    }, text)));
  }))), show_pagination && React.createElement("div", {
    className: "flex justify-center mt-8"
  }, [0, 1, 2, 3].map(function (index) {
    return React.createElement("div", {
      key: JSON.stringify(index),
      className: "w-2 h-2 rounded-full mx-[6px] " + (scroll_position === index ? 'bg-primary' : 'bg-surface-level-four')
    });
  })));
};

var UpcomingEvents = function UpcomingEvents(_ref) {
  var className = _ref.className,
    data = _ref.data;
  var _useState = useState(0),
    scroll_position = _useState[0],
    setScrollPosition = _useState[1];
  var scrollContainerRef = useRef(null);
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1180;
  var num_rows = 3; // Max 3 rows
  var rows = Array.from({
    length: num_rows
  }, function () {
    return [];
  });
  data.forEach(function (item, index) {
    var row_index = index % num_rows;
    rows[row_index].push(item);
  });
  useEffect(function () {
    var handleScroll = function handleScroll() {
      if (scrollContainerRef.current) {
        var scroll_left = scrollContainerRef.current.scrollLeft;
        var max_scroll_left = scrollContainerRef.current.scrollWidth - scrollContainerRef.current.clientWidth;
        var scroll_ratio = scroll_left / max_scroll_left;
        setScrollPosition(Math.min(Math.round(scroll_ratio * 4), 3)); // 4 segments for 4 dots, ensure max value is 3
      }
    };
    var scroll_container = scrollContainerRef.current;
    if (scroll_container) {
      scroll_container.addEventListener('scroll', handleScroll);
      // Cleanup function
      return function () {
        return scroll_container.removeEventListener('scroll', handleScroll);
      };
    }
    return function () {};
  }, [data.length]);
  if (data.length <= 9) {
    // display grid layout if data length is 9 or less
    return React.createElement("div", {
      className: "" + className
    }, React.createElement(Typography, {
      size: '3xl',
      allBold: true,
      className: "mb-3"
    }, "Upcoming events"), React.createElement("div", {
      className: "overflow-x-scroll max-w-[1180px]",
      ref: scrollContainerRef
    }, ' ', React.createElement("div", {
      className: "grid grid-cols-3 gap-5 w-[1180px]"
    }, data.map(function (_ref2) {
      var handleClick = _ref2.handleClick,
        image = _ref2.image,
        name = _ref2.name,
        type = _ref2.type;
      return React.createElement("div", {
        onClick: handleClick,
        key: JSON.stringify(handleClick + image + name + type),
        className: "w-[394px] flex items-center cursor-pointer"
      }, React.createElement("img", {
        src: image,
        className: "w-[192px] h-[109px] object-cover rounded-lg"
      }), React.createElement("div", {
        className: "pl-5 w-[420px]"
      }, React.createElement(Typography, {
        size: "md",
        allBold: true,
        className: "mb-2"
      }, name), React.createElement(Typography, {
        size: "md",
        variant: "secondary"
      }, type)));
    }))), is_mobile && data.length >= 3 && React.createElement("div", {
      className: "flex justify-center mt-8 max-w-[1180px]"
    }, [0, 1, 2, 3].map(function (index) {
      return React.createElement("div", {
        key: index,
        className: "w-2 h-2 rounded-full mx-[6px] " + (scroll_position === index ? 'bg-primary' : 'bg-surface-level-four')
      });
    })));
  }
  // keep left alinged stacking behavior if data length is more than 9
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Typography, {
    size: '3xl',
    allBold: true,
    className: "mb-3"
  }, "Upcoming events"), React.createElement("div", {
    className: "overflow-x-scroll max-w-[1180px]",
    ref: scrollContainerRef
  }, React.createElement("div", {
    className: "w-[1180px]"
  }, rows.map(function (r, idx) {
    return React.createElement("div", {
      className: "flex items-center mt-5",
      key: "upcoming-events-row-" + (idx + 1)
    }, r.map(function (event) {
      return React.createElement("div", {
        onClick: event.handleClick,
        key: JSON.stringify(event),
        className: "w-[394px] flex items-center cursor-pointer"
      }, React.createElement("img", {
        src: event.image,
        className: "w-[192px] h-[109px] object-cover rounded-lg"
      }), React.createElement("div", {
        className: "pl-5 w-[420px]"
      }, React.createElement(Typography, {
        size: "md",
        allBold: true,
        className: "mb-2"
      }, event.name), React.createElement(Typography, {
        size: "md",
        variant: "secondary"
      }, event.type)));
    }));
  }))), (is_mobile && data.length >= 3 || data.length > 9 || is_mobile) && React.createElement("div", {
    className: "flex justify-center mt-8 max-w-[1180px]"
  }, [0, 1, 2, 3].map(function (index) {
    return React.createElement("div", {
      key: index,
      className: "w-2 h-2 rounded-full mx-[6px] " + (scroll_position === index ? 'bg-primary' : 'bg-surface-level-four')
    });
  })));
};

var EventIcons = function EventIcons(_ref) {
  var company_logo = _ref.company_logo,
    company_name = _ref.company_name,
    protected_logo = _ref.protected_logo,
    network_info = _ref.network_info,
    _ref$expanded = _ref.expanded,
    expanded = _ref$expanded === void 0 ? false : _ref$expanded,
    className = _ref.className,
    _ref$project_type = _ref.project_type,
    project_type = _ref$project_type === void 0 ? ProjectType.None : _ref$project_type;
  return React.createElement("div", {
    className: "flex h-8 " + (expanded ? 'space-x-4' : 'gap-2') + " relative " + className
  }, company_logo && project_type !== ProjectType.None && React.createElement("div", {
    className: "relative group"
  }, React.createElement("img", {
    src: company_logo,
    className: "h-full"
  }), company_name && React.createElement("div", {
    className: "absolute bottom-[29px] left-1/2 transform -translate-x-1/2 w-[180px] hidden group-hover:block z-50"
  }, React.createElement(HelperBox, {
    helper_text: project_type + " by " + company_name,
    className: "z-50",
    has_text_center: true
  }))), protected_logo && React.createElement("div", {
    className: "relative group"
  }, React.createElement("img", {
    src: protected_logo,
    className: "h-full"
  }), React.createElement("div", {
    className: "absolute bottom-[29px] left-1/2 transform -translate-x-1/2 w-[200px] hidden group-hover:block z-50"
  }, React.createElement(HelperBox, {
    helper_text: "Get a 100% refund within a set period after the event is completed."
  }))), !network_info.name ? React.createElement("img", {
    src: network_info.logo,
    className: "h-full"
  }) : React.createElement("div", {
    className: "relative group"
  }, React.createElement("img", {
    src: network_info.logo,
    className: "h-full"
  }), React.createElement("div", {
    className: "z-50 absolute bottom-[29px] left-1/2 transform -translate-x-1/2 w-[180px] hidden group-hover:block"
  }, React.createElement(HelperBox, {
    helper_text: "" + network_info.name,
    has_text_center: true
  }))));
};

var Mobile = function Mobile(_ref) {
  var className = _ref.className,
    data = _ref.data;
  var _useState = useState(0),
    scrollPosition = _useState[0],
    setScrollPosition = _useState[1];
  var scrollContainerRef = useRef(null);
  useEffect(function () {
    var scrollContainer = scrollContainerRef.current;
    if (!scrollContainer) return;
    var handleScroll = function handleScroll() {
      var scrollLeft = scrollContainer.scrollLeft;
      var maxScrollLeft = scrollContainer.scrollWidth - scrollContainer.clientWidth;
      if (maxScrollLeft > 0) {
        var scrollRatio = scrollLeft / maxScrollLeft;
        var position = Math.min(Math.round(scrollRatio * 4), 3);
        setScrollPosition(position);
      }
    };
    scrollContainer.addEventListener('scroll', handleScroll);
    return function () {
      scrollContainer.removeEventListener('scroll', handleScroll);
    };
  }, [data.length]);
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Typography, {
    size: '3xl',
    allBold: true,
    className: "mb-8"
  }, "Upcoming events"), React.createElement("div", {
    className: "overflow-x-scroll w-full",
    ref: scrollContainerRef
  }, React.createElement("div", {
    className: "flex space-x-5 min-w-max"
  }, data.map(function (_ref2, idx) {
    var handleClick = _ref2.handleClick,
      name = _ref2.name,
      image = _ref2.image,
      data = _ref2.data;
    return React.createElement(Card, {
      onClick: handleClick,
      className: "w-[280px] h-[323px] flex-shrink-0 cursor-pointer",
      key: JSON.stringify(data) + "-" + idx + "}"
    }, React.createElement("div", null, React.createElement("img", {
      className: "w-full rounded-t-lg",
      src: image,
      alt: "card-" + name
    })), React.createElement("div", {
      className: "px-5 py-5 my-auto w-full"
    }, React.createElement(Typography, {
      size: "2xl",
      allBold: true,
      className: "mb-4"
    }, name), React.createElement("div", {
      className: "space-y-2"
    }, data.map(function (_ref3, index) {
      var label = _ref3.label,
        value = _ref3.value;
      return React.createElement("div", {
        className: "flex justify-between items-center",
        key: label + index
      }, React.createElement(Typography, {
        size: "sm",
        variant: "secondary"
      }, label), React.createElement(Typography, {
        allBold: true,
        size: "sm"
      }, value));
    }))));
  }))), React.createElement("div", {
    className: "flex justify-center mt-8"
  }, [0, 1, 2, 3].map(function (index) {
    return React.createElement("div", {
      key: index,
      className: "w-2 h-2 rounded-full mx-[6px] " + (scrollPosition === index ? 'bg-primary' : 'bg-surface-level-four')
    });
  })));
};

var DesktopEventCard = function DesktopEventCard(_ref) {
  var event_data = _ref.event_data,
    cardClassName = _ref.cardClassName,
    imageClassName = _ref.imageClassName;
  return React.createElement(Card, {
    onClick: event_data.handleClick,
    className: "flex cursor-pointer " + cardClassName
  }, React.createElement("img", {
    src: event_data.image,
    className: "" + imageClassName,
    alt: "card-" + event_data.name
  }), React.createElement("div", {
    className: "px-5 my-auto w-full"
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "mb-4"
  }, event_data.name), React.createElement("div", {
    className: "space-y-2"
  }, event_data.data.map(function (_ref2, index) {
    var label = _ref2.label,
      value = _ref2.value;
    return React.createElement("div", {
      className: "flex items-center justify-between",
      key: label + "-" + index
    }, React.createElement(Typography, {
      size: "sm",
      variant: "secondary"
    }, label), React.createElement(Typography, {
      size: "sm",
      allBold: true
    }, value));
  }))));
};

var UpcomingEventsV2 = function UpcomingEventsV2(_ref) {
  var className = _ref.className,
    data = _ref.data;
  var _useState = useState(0),
    current_page = _useState[0],
    setCurrentPage = _useState[1];
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1180;
  var items_per_page = 6;
  var total_pages = Math.ceil(data.length / items_per_page);
  if (data.length <= 6) {
    // display grid layout if data length is 6 or less
    return React.createElement("div", {
      className: "" + className
    }, React.createElement(SectionHeader, {
      title: "Upcoming events"
    }), React.createElement("div", {
      className: "overflow-x-scroll max-w-[1180px] mt-8"
    }, React.createElement("div", {
      className: "grid grid-cols-2 gap-5 w-[1180px]"
    }, data.map(function (eventData, idx) {
      return React.createElement(DesktopEventCard, {
        key: JSON.stringify(eventData) + "-" + idx,
        event_data: eventData,
        cardClassName: "h-[159px]",
        imageClassName: "h-full object-cover rounded-tl-lg rounded-bl-lg"
      });
    }))));
  }
  // For data length more than 6, display pagination with arrow buttons
  var start_index = current_page * items_per_page;
  var end_index = start_index + items_per_page;
  var items_to_display = data.slice(start_index, end_index);
  return is_mobile ? React.createElement(Mobile, {
    className: className,
    data: data
  }) : React.createElement("div", {
    className: "" + className
  }, React.createElement("div", {
    className: "flex justify-between items-center mb-8"
  }, React.createElement(SectionHeader, {
    title: "Upcoming events"
  }), React.createElement("div", {
    className: "flex space-x-[16px]"
  }, React.createElement("button", {
    onClick: function onClick() {
      return setCurrentPage(function (prev) {
        return Math.max(prev - 1, 0);
      });
    },
    disabled: current_page === 0,
    className: "rounded-lg low-border bg-surface-level-one w-11 h-11 flex items-center justify-center " + (current_page === 0 ? 'opacity-50 ' : '')
  }, React.createElement(Media, {
    variant: "chevron-left",
    className: "h-[20px] w-[11px] text-secondary"
  })), React.createElement("button", {
    onClick: function onClick() {
      return setCurrentPage(function (prev) {
        return Math.min(prev + 1, total_pages - 1);
      });
    },
    disabled: current_page === total_pages - 1,
    className: "rounded-lg low-border bg-surface-level-one w-11 h-11 flex items-center justify-center " + (current_page === total_pages - 1 ? 'opacity-50' : '')
  }, React.createElement(Media, {
    variant: "chevron-right",
    className: "h-[20px] w-[11px] text-secondary"
  })))), React.createElement("div", {
    className: "grid gap-5 w-full grid-cols-2"
  }, items_to_display.map(function (eventData, idx) {
    return React.createElement(DesktopEventCard, {
      key: idx,
      event_data: eventData,
      cardClassName: "h-[159px]",
      imageClassName: "h-full object-cover rounded-tl-lg rounded-bl-lg"
    });
  })));
};
var SectionHeader = function SectionHeader(_ref2) {
  var title = _ref2.title,
    className = _ref2.className;
  return React.createElement(Typography, {
    size: "3xl",
    allBold: true,
    className: "" + className
  }, title);
};

var ApplyForIDO = function ApplyForIDO(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    handleClick = _ref.handleClick,
    className = _ref.className,
    desktop_image = _ref.desktop_image,
    mobile_image = _ref.mobile_image;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  var image = is_mobile ? mobile_image : desktop_image;
  return React.createElement("div", {
    className: "rounded-lg w-full bg-cover relative " + className + " " + (is_mobile ? 'h-[588px] bg-center' : 'h-[325px] bg-cover bg-right'),
    style: {
      backgroundImage: "url(" + image + ")"
    }
  }, React.createElement("div", {
    className: "absolute " + (is_mobile ? 'bottom-8 px-8' : 'left-[80px] top-[56px]')
  }, React.createElement(Typography, {
    variant: "primary",
    size: '3xl',
    allBold: true,
    className: "max-w-[300px]"
  }, title), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-3 max-w-[375px] mx-auto"
  }, subtitle), React.createElement(Button, {
    className: "mt-8 " + (is_mobile ? 'w-full' : 'w-[188px]'),
    onClick: handleClick
  }, "Apply for IDO")));
};

var arrow_down = 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/text-images/arrow-down.png';
var arrow_right = 'https://platform-s3-publicread.s3.eu-central-1.amazonaws.com/text-images/Vector+586.png';
var GetStarted = function GetStarted(_ref) {
  var data = _ref.data,
    title = _ref.title,
    subtitle = _ref.subtitle,
    className = _ref.className,
    custom_arrow_down = _ref.custom_arrow_down,
    custom_arrow_right = _ref.custom_arrow_right;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 1180;
  return React.createElement("div", {
    className: className
  }, React.createElement("div", null, React.createElement(Typography, {
    allBold: true,
    className: "mb-[10px]",
    size: "3xl"
  }, title), React.createElement(Typography, {
    variant: "secondary",
    className: "mb-8"
  }, subtitle)), ' ', React.createElement("div", {
    className: "" + (is_mobile ? 'space-y-5' : 'flex space-x-5')
  }, data.map(function (_ref2, idx) {
    var logo = _ref2.logo,
      title = _ref2.title,
      subtitle = _ref2.subtitle,
      handleClick = _ref2.handleClick;
    return React.createElement("div", {
      onClick: handleClick,
      key: JSON.stringify(logo) + JSON.stringify(title) + JSON.stringify(subtitle),
      className: "bg-gradient-surface-one-to-zero rounded-lg low-border p-8 flex  hover:bottom-corner-shadow-info cursor-pointer " + (is_mobile ? 'w-full h-[196px]' : 'w-[282px] h-[280px] flex-col')
    }, React.createElement("div", {
      className: "relative " + (is_mobile ? 'flex flex-col min-w-[48px]' : 'flex justify-between')
    }, React.createElement("div", {
      className: "absolute left-[30px] top-[8px] w-[18px] h-[18px] bg-info rounded-full blur bg-opacity-60"
    }), React.createElement("img", {
      alt: title + "-image",
      src: logo,
      className: 'w-[48px] h-[48px]'
    }), idx !== data.length - 1 && React.createElement("img", {
      alt: "action",
      className: "" + (is_mobile ? 'min-w-[31px] min-h-[51px] mx-auto mt-auto' : 'min-w-[113px] h-[31px]'),
      src: is_mobile ? custom_arrow_down ? custom_arrow_down : arrow_down : custom_arrow_right ? custom_arrow_right : arrow_right
    })), React.createElement("div", {
      className: "" + (is_mobile ? 'my-auto pl-[33px]' : 'mt-auto space-y-2')
    }, ' ', React.createElement(Typography, {
      variant: "primary",
      size: "2xl",
      allBold: true
    }, title), React.createElement(Typography, {
      variant: "secondary"
    }, subtitle)));
  })));
};

var InformationSection = function InformationSection(_ref) {
  var data = _ref.data,
    className = _ref.className;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 800;
  return React.createElement("div", {
    className: "grid " + (is_mobile ? 'grid-cols-2 gap-y-[60px]' : 'grid-cols-3 gap-y-[120px]') + " " + className
  }, data.map(function (_ref2) {
    var logo = _ref2.logo,
      title = _ref2.title,
      subtitle = _ref2.subtitle;
    return React.createElement("div", {
      className: "space-y-10",
      key: JSON.stringify(logo) + JSON.stringify(logo)
    }, React.createElement("img", {
      src: logo,
      alt: title,
      className: "mx-auto object-contain " + (is_mobile ? 'max-w-[91px] max-h-[91px]' : 'max-w-[118px] max-h-[118px]')
    }), React.createElement("div", {
      className: "mx-auto text-center " + (is_mobile ? 'w-[172px]' : 'w-[222px]')
    }, React.createElement(Typography, {
      allBold: true,
      size: is_mobile ? 'md' : '2xl'
    }, title), React.createElement(Typography, {
      size: is_mobile ? 'sm' : 'md',
      variant: "secondary"
    }, subtitle)));
  }));
};

var ProfileBanners = function ProfileBanners(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    handleClick = _ref.handleClick,
    className = _ref.className,
    desktop_image = _ref.desktop_image,
    mobile_image = _ref.mobile_image,
    btn_text = _ref.btn_text;
  var breakpoint = useBreakpoint();
  var is_mobile = breakpoint < 480;
  var image = is_mobile ? mobile_image : desktop_image;
  return React.createElement("div", {
    className: "max-h-[185px] max-w-[1180px] low-border rounded-lg w-full bg-cover relative " + className + " " + (is_mobile ? 'w-[353px] h-[212px] bg-center' : 'h-[325px] bg-right'),
    style: {
      backgroundImage: "url(" + image + ")"
    }
  }, React.createElement("div", {
    className: "absolute " + (is_mobile ? 'left-[20px] top-[20px]' : 'left-[32px] top-[32px]')
  }, React.createElement(Typography, {
    variant: "primary",
    size: "2xl",
    allBold: true,
    className: "max-w-[500px]"
  }, title), React.createElement(Typography, {
    variant: "secondary",
    className: "mt-1 " + (is_mobile ? 'text-sm max-w-[194px]' : 'text-md max-w-[530px]') + "  mx-auto"
  }, subtitle), React.createElement(Button, {
    className: "px-0 " + (is_mobile ? 'w-[155px] my-2 text-sm' : 'w-[188px] mt-6 text-md'),
    onClick: handleClick
  }, btn_text)));
};

var StepsStage;
(function (StepsStage) {
  StepsStage[StepsStage["SignUp"] = 0] = "SignUp";
  StepsStage[StepsStage["VerifyEmail"] = 1] = "VerifyEmail";
  StepsStage[StepsStage["KYC"] = 2] = "KYC";
  StepsStage[StepsStage["VerifyWallet"] = 3] = "VerifyWallet";
  StepsStage[StepsStage["Enable2fa"] = 4] = "Enable2fa";
})(StepsStage || (StepsStage = {}));
var StepsFlow = function StepsFlow(_ref) {
  var className = _ref.className,
    current_step = _ref.current_step;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "w-full flex items-center pl-8 pr-4 " + className
  }, [StepsStage.SignUp, StepsStage.VerifyEmail, StepsStage.KYC, StepsStage.VerifyWallet, StepsStage.Enable2fa].map(function (step, index) {
    return React.createElement(React.Fragment, {
      key: step
    }, React.createElement("div", {
      className: "w-[25px]"
    }, current_step > step ? React.createElement(Steps, {
      variant: "secondary",
      className: "h-[25px] w-[25px]"
    }, React.createElement(Media, {
      className: "pt-[2px] pr-[1px] w-[17px] text-white",
      variant: 'tick',
      size: 0
    })) : React.createElement(Steps, {
      variant: "primary"
    }, index + 1)), index < StepsStage.Enable2fa && React.createElement("div", {
      className: "h-[2px] mx-5 w-full " + (current_step >= step + 1 ? 'bg-accent' : 'bg-surface-level-two')
    }));
  })), React.createElement("div", {
    className: "flex items-center justify-between py-[10px] w-full"
  }, React.createElement(Typography, {
    size: "xs",
    allBold: current_step === StepsStage.SignUp
  }, "Create account"), React.createElement(Typography, {
    size: "xs",
    allBold: current_step === StepsStage.VerifyEmail
  }, "Verify email"), React.createElement(Typography, {
    size: "xs",
    allBold: current_step === StepsStage.KYC
  }, "Verify ID"), React.createElement(Typography, {
    size: "xs",
    allBold: current_step === StepsStage.VerifyWallet
  }, "Verify Wallet"), React.createElement(Typography, {
    size: "xs",
    allBold: current_step === StepsStage.Enable2fa
  }, "Enable 2FA")));
};

var UserProfile = function UserProfile(_ref) {
  var account_details_arr = _ref.account_details_arr,
    customer_details_arr = _ref.customer_details_arr,
    security_details_arr = _ref.security_details_arr,
    verified_wallet_details_arr = _ref.verified_wallet_details_arr,
    className = _ref.className;
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5"
  }, "Your account"), React.createElement(ListItemUnit, {
    list_item_arr: account_details_arr
  }), customer_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Customer details"), React.createElement(ListItemUnit, {
    list_item_arr: customer_details_arr
  })), verified_wallet_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Verified wallet"), React.createElement(ListItemUnit, {
    list_item_arr: verified_wallet_details_arr
  })), security_details_arr && React.createElement(React.Fragment, null, React.createElement(Typography, {
    size: "2xl",
    allBold: true,
    className: "pb-5 pt-[60px]"
  }, "Security"), React.createElement(ListItemUnit, {
    list_item_arr: security_details_arr
  })));
};
UserProfile.displayName = 'UserProfile';

var ProjectList = function ProjectList(_ref) {
  var className = _ref.className,
    current_option = _ref.current_option,
    disabled = _ref.disabled,
    project_arr = _ref.project_arr,
    sort_options = _ref.sort_options,
    _handleSearch = _ref.handleSearch,
    handleNewProject = _ref.handleNewProject,
    placeholder = _ref.placeholder;
  return React.createElement("div", {
    className: "" + className
  }, React.createElement(Typography, {
    allBold: true,
    size: "4xl"
  }, "Manage projects"), React.createElement(Typography, {
    className: "mt-5",
    variant: "secondary",
    size: "md"
  }, "Create and manage project pages and associated events."), React.createElement("div", {
    className: "flex w-full py-8"
  }, React.createElement("div", {
    className: "flex-1 mr-5"
  }, React.createElement(SortSearch, {
    searchText: placeholder,
    accent_icon: true,
    selectedSortOption: current_option,
    sortOptions: sort_options,
    handleSearch: function handleSearch(val) {
      return _handleSearch(val);
    }
  })), React.createElement(Button, {
    disabled: disabled,
    onClick: handleNewProject
  }, "New project")), project_arr.length !== 0 && React.createElement(ListItemUnit, {
    list_item_arr: project_arr
  }));
};
ProjectList.displayName = 'ProjectList';

var ImagesForm = function ImagesForm(_ref) {
  var state = _ref.state,
    handleChange = _ref.handleChange,
    _handleOpenModal = _ref.handleOpenModal,
    handleRemoveItem = _ref.handleRemoveItem,
    errors = _ref.errors,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    image_form_data = _ref.image_form_data,
    images_slideshow_form_data = _ref.images_slideshow_form_data,
    tooltip = _ref.tooltip;
  return React.createElement("div", {
    className: "space-y-5 " + className
  }, image_form_data == null ? void 0 : image_form_data.map(function (field, idx) {
    var props = {
      value: state[field.name],
      handleChange: handleChange,
      name: field.name,
      label: field.label,
      type: field.type,
      placeholder: field.placeholder,
      options: field.options,
      multiline: field.multiline,
      inset: field.inset,
      tooltip: field.tooltip,
      handleOpenModal: function handleOpenModal() {
        return _handleOpenModal(field.name);
      },
      errors: errors
    };
    if (field.name === 'hero_video') {
      return React.createElement("div", {
        key: "images-form-input-" + idx
      }, React.createElement("div", {
        className: "flex items-end space-x-3"
      }, React.createElement("div", {
        className: "flex-1"
      }, React.createElement(RenderInput, Object.assign({}, props))), React.createElement(Button, {
        variant: "custom",
        className: "h-11 w-11 bg-surface-level-three hover:bg-surface-level-four",
        onClick: function onClick() {
          return handleRemoveItem(field.name);
        },
        padding: false,
        disabled: !state[field.name]
      }, React.createElement(Media, {
        size: 0,
        className: "w-[17px] h-[18px]",
        variant: "bin"
      }))));
    }
    return React.createElement(RenderInput, Object.assign({
      key: "images-form-input-" + idx
    }, props));
  }), React.createElement(Card, {
    className: "p-5",
    surface: "two"
  }, React.createElement("div", {
    className: "flex items-center"
  }, React.createElement(Typography, {
    className: "py-2"
  }, "Images Slideshow"), React.createElement(Tooltip, {
    "data-testid": "tooltip",
    text: tooltip
  }, React.createElement(Media, {
    variant: "info-outline",
    className: "text-accent ml-2",
    size: 5
  }))), React.createElement("div", {
    className: "space-y-5"
  }, images_slideshow_form_data == null ? void 0 : images_slideshow_form_data.map(function (field, idx) {
    var props = {
      value: state[field.name],
      handleChange: handleChange,
      name: field.name,
      label: field.label,
      type: field.type,
      placeholder: field.placeholder,
      options: field.options,
      multiline: field.multiline,
      inset: field.inset,
      tooltip: field.tooltip,
      choose_img_btn_color: 'three',
      handleOpenModal: function handleOpenModal() {
        return _handleOpenModal(field.name);
      },
      errors: errors
    };
    return React.createElement("div", {
      key: "slideshow-form-input-" + idx
    }, React.createElement("div", {
      className: "flex items-end space-x-3"
    }, React.createElement("div", {
      className: "flex-1"
    }, React.createElement(RenderInput, Object.assign({}, props))), React.createElement(Button, {
      variant: "custom",
      className: "h-11 w-11 bg-surface-level-three hover:bg-surface-level-four",
      onClick: function onClick() {
        return handleRemoveItem(field.name);
      },
      padding: false,
      disabled: !state[field.name]
    }, React.createElement(Media, {
      size: 0,
      className: "w-[17px] h-[18px]",
      variant: "bin"
    }))));
  }))));
};

var defaultProps$O = {};
var ProjectDetails = function ProjectDetails(_ref) {
  var overview_props = _ref.overview_props,
    social_props = _ref.social_props,
    resources_props = _ref.resources_props,
    images_props = _ref.images_props;
  return React.createElement("div", {
    className: "w-full"
  }, React.createElement("div", {
    className: "space-y-5"
  }, React.createElement(EditableItem, {
    title: "Project overview"
  }, React.createElement(OverviewForm, Object.assign({
    className: "mt-5"
  }, overview_props))), React.createElement(EditableItem, {
    title: "Project social platforms"
  }, React.createElement(SocialPlatformsForm, Object.assign({
    className: "mt-5"
  }, social_props))), React.createElement(EditableItem, {
    title: "Project resources"
  }, React.createElement(ResourcesForm, Object.assign({
    className: "mt-5"
  }, resources_props))), React.createElement(EditableItem, {
    title: "Project media"
  }, React.createElement(ImagesForm, Object.assign({
    className: "mt-5"
  }, images_props)))));
};
ProjectDetails.displayName = 'ProjectDetails';
ProjectDetails.defaultProps = defaultProps$O;

var SingleFaqForm = function SingleFaqForm(_ref) {
  var data = _ref.data,
    faq_idx = _ref.faq_idx,
    handleAnswerChange = _ref.handleAnswerChange,
    handleQuestionChange = _ref.handleQuestionChange,
    handleAddAnswerParagraph = _ref.handleAddAnswerParagraph;
  return React.createElement("div", {
    key: faq_idx,
    className: "mt-5 space-y-5"
  }, React.createElement(Input, {
    label: "Question",
    surface: "zero",
    value: data.question,
    className: "flex-1",
    placeholder: "Enter question",
    onChange: function onChange(e) {
      return handleQuestionChange(e.target.value, data, faq_idx);
    }
  }), data.answer.map(function (answer, ans_idx) {
    return React.createElement(Input, {
      key: "answer-index-" + faq_idx + "-" + ans_idx,
      surface: "zero",
      multiline: true,
      num_rows: 2,
      label: "Answer paragraph " + (ans_idx + 1),
      value: answer,
      placeholder: "Enter answer",
      className: "flex-1",
      onChange: function onChange(e) {
        return handleAnswerChange(ans_idx, e.target.value, data, faq_idx);
      }
    });
  }), React.createElement(Button, {
    onClick: function onClick() {
      return handleAddAnswerParagraph(data, faq_idx);
    },
    className: "flex w-full items-center font-bold border"
  }, React.createElement(Media, {
    size: 5,
    className: "inline-flex mr-3",
    variant: "plus"
  }), React.createElement("span", {
    className: "inline-flex"
  }, "Add paragraph")));
};
var FaqList = function FaqList(_ref2) {
  var className = _ref2.className,
    state = _ref2.state,
    handleRemoveFAQ = _ref2.handleRemoveFAQ,
    addNewSingleFaqForm = _ref2.addNewSingleFaqForm,
    handleAnswerChange = _ref2.handleAnswerChange,
    handleQuestionChange = _ref2.handleQuestionChange,
    handleAddAnswerParagraph = _ref2.handleAddAnswerParagraph,
    onDragEnd = _ref2.onDragEnd,
    show = _ref2.show,
    _setShow = _ref2.setShow;
  return React.createElement(DragDropContext, {
    onDragEnd: onDragEnd
  }, React.createElement("div", {
    className: "space-y-5 " + className
  }, addNewButtonCard('Add new', function () {
    addNewSingleFaqForm();
    _setShow([true].concat(show));
  }), React.createElement(Droppable, {
    droppableId: 'droppable-1'
  }, function (provided) {
    return React.createElement("div", Object.assign({
      className: "space-y-5",
      ref: provided.innerRef
    }, provided.droppableProps), state == null ? void 0 : state.map(function (d, faq_idx) {
      return React.createElement(Draggable, {
        key: "faq-question-draggable-" + faq_idx,
        isDragDisabled: show && show.some(function (isOpen) {
          return isOpen;
        }),
        index: faq_idx,
        draggableId: "faq-" + faq_idx
      }, function (provided) {
        return React.createElement("div", Object.assign({
          ref: provided.innerRef
        }, provided.draggableProps, provided.dragHandleProps), React.createElement(EditableItem, {
          key: "faq-" + faq_idx,
          show: show[faq_idx],
          setShow: function setShow() {
            var newShow = [].concat(show);
            newShow[faq_idx] = !newShow[faq_idx];
            _setShow(newShow);
          },
          initial_show: d.question === '',
          is_draggable: true,
          show_title_when_open: false,
          handleRemoveItem: function handleRemoveItem() {
            handleRemoveFAQ(faq_idx);
            var newShow = [].concat(show);
            newShow.splice(faq_idx, 1); // remove the show state for the removed FAQ
            _setShow(newShow);
          },
          className: "w-full",
          title: d.question
        }, React.createElement(SingleFaqForm, {
          data: d,
          faq_idx: faq_idx,
          state: state,
          handleAnswerChange: handleAnswerChange,
          handleQuestionChange: handleQuestionChange,
          handleAddAnswerParagraph: handleAddAnswerParagraph
        })));
      });
    }), provided.placeholder);
  })));
};
FaqList.displayName = 'FaqList';

export { Accordion, AccordionBase, AccountDropdown, AccountProgress, Adjust, Alert, AllocationPopUp, AnalyticsComponent, ApplyForIDO, Avatar, Branding, BreakPoint, Button, ButtonStack, Card, CardVariant, Carousel, CarouselForm, Chart, CheckInfoCard, Chip, ChipType, Color, CompleteCard, Completed, CompletedEvents, ComplianceQuestions, Composition, ConnectWallet, ContentAlignment, Countdown, DataLines, Deploy, DepositForm, DepositWithdraw, DesktopPool, DisclosureButton, Drawer, Dropdown, EditableItem, EmailSubscription, EventIcons, EventProgress, EventRequestStatus, EventStage, EventsForm, FAQSection, FaqList, FarmSetup, FeeSetupForm, Footer, Form, FormWrapper, GetStarted, Grid, GridItem, Header, HelperBox, HeroSection, HeroSectionV2, IDOSection, ImageSlideshow, IncreaseAllocationModal, IncreaseAllocationStage, IndicatorStage, InformationSection, Input, Investment, InviteEarn, KYCSteps, LandingPageVideoComp, LearningSection, ListContainer, ListHeader, ListItem, ListItemUnit, LoadingPool, Login, LoginForm, LoginStage, MainEventCard, MainImage, Manage, Media, MediaModal, MediaThumbnail, MediaType, MessageCard, MobilePool, Modal, MultiStepModal, MyAllocationCard, NotKYC, NotificationBar, NotificationType, NotificationsForm, Onboarding, OpenableItem, OverviewForm, ParticipationFees, PartnerSection, PlatformNotificationType, PoolContainer, PoolHeader, PortfolioItem, PrewhitelistCard, ProductBadge, ProductCard, ProductCardList, index as ProductListItem, ProfileBanners, ProfileCards, Progress, ProjectCard, ProjectDetails, ProjectList, ProjectStatus, ProjectType, QuestionStage, ReferralBanner, RefundModal, RegStage, RegisterForm, RegistrationSteps, RenderInput, RequirementsCard, ResetPassword, ResetPasswordStage, ResourcesForm, RewardModal, RewhitelistEvent, SearchList, SecondaryEventCard, Select, Setup, SetupForm, SideDrawer, SingleButton, SocialPlatformsForm, SortOrder, SortSearch, SquareButtons, StakingAnalytics, StakingChips, StatsBar, StatsCards, StatsSummary, Steps, StepsFlow, StepsStage, Summary, Tabs, TestEventsForm, Thumbnail$1 as Thumbnail, TierCard, TierCarousel, TierLevel, TierPower, Toggle, TokenAllocationForm, TokenAllocationType, TokenForm, Tooltip, Typography, UpcomingEvents, UpcomingEventsV2, UpgradeTierDrawer, UpgradeTierStage, UserInfo, UserProfile, VerifyEmail, VerticleDatalineCentered, VestingAnalytics, YourProfile, addNewButtonCard, daw_tab_options, defaultProps$L as defaultProps, formatLargeNumber, setup_tab_options, shortenHex, tier_borders, useBreakpoint, useClasses, useIntitialised };
//# sourceMappingURL=ui.esm.js.map
